interface FelgueirasCoFinancingLogoProps {
    className?: string;
}

export default function FelgueirasCoFinancingLogo({
    className = '',
}: FelgueirasCoFinancingLogoProps) {
    return (
        <svg
            className={className}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 4900 1000"
            // enable-background="new 0 0 4000 1000"
        >
            <path
                fill="#FEFEFE"
                opacity="1.000000"
                stroke="none"
                d="
M3238.000000,1040.000000 
	C2158.666748,1040.000000 1080.333374,1040.000000 2.000000,1040.000000 
	C2.000000,694.000000 2.000000,348.000000 2.000000,2.000000 
	C1634.666626,2.000000 3267.333252,2.000000 4900.000000,2.000000 
	C4900.000000,348.000000 4900.000000,694.000000 4900.000000,1040.000000 
	C4346.333496,1040.000000 3792.666748,1040.000000 3238.000000,1040.000000 
M732.095093,834.073303 
	C732.095093,834.073303 732.255249,834.131958 733.818787,833.704041 
	C736.806213,831.382263 735.962097,828.971924 733.552795,825.555603 
	C733.629883,825.207092 733.707031,824.858582 735.761963,825.313477 
	C737.851074,825.537964 739.940125,825.762512 743.045837,826.689819 
	C744.133728,828.911560 745.221619,831.133362 746.270325,834.862000 
	C750.342224,839.334412 751.721680,839.090820 754.055176,831.976135 
	C754.251892,829.351685 754.448608,826.727234 756.040405,824.074036 
	C757.434875,823.996338 758.829346,823.918640 760.012085,823.971313 
	C760.012085,823.971313 760.184021,823.791626 760.010437,825.297119 
	C760.023376,828.289307 761.121765,830.133057 764.113403,829.926453 
	C764.113403,829.926453 764.454590,829.498962 764.260559,831.042786 
	C768.375977,836.693115 776.234131,839.689209 781.816345,837.335632 
	C782.824768,836.910461 783.073608,834.683716 784.125122,831.688599 
	C784.125122,830.088928 784.125122,828.489197 784.125122,826.666382 
	C782.418945,826.666382 781.130188,826.649780 779.842041,826.669067 
	C771.309509,826.796997 766.334961,822.925232 766.029541,815.909119 
	C765.706726,808.493774 770.442993,804.587463 780.147278,805.932129 
	C781.702820,806.306824 783.258362,806.681519 784.813904,807.056213 
	C784.556030,806.042725 784.298096,805.029236 784.461731,802.862671 
	C784.711792,802.538696 784.961792,802.214722 786.056763,801.303894 
	C787.316162,800.846985 788.575500,800.390015 790.033875,801.802002 
	C789.976929,811.980530 789.919922,822.158997 789.808411,833.795776 
	C790.100647,834.724609 790.340515,836.440674 790.692993,836.464172 
	C795.960449,836.814697 801.243469,837.020508 806.519958,836.968079 
	C806.929688,836.963989 807.317749,834.779846 807.870239,833.842834 
	C807.870239,833.842834 807.624268,833.708618 809.103882,833.766846 
	C810.012085,831.774963 810.920288,829.783081 811.984680,827.987366 
	C811.984680,827.987366 811.789734,827.829651 813.471741,828.025208 
	C816.835999,828.042786 820.200317,828.060364 824.017822,829.327576 
	C824.122437,830.651550 824.227051,831.975464 824.211853,834.735352 
	C825.286865,835.683228 826.361877,836.631042 827.436890,837.578918 
	C828.287781,836.377625 829.138611,835.176270 830.407532,832.141113 
	C830.407532,820.387634 830.407532,808.634094 830.407532,797.505066 
	C824.054688,794.607727 821.938965,798.256653 819.812683,801.657043 
	C813.525391,811.711609 807.304871,821.807922 799.810547,831.878906 
	C798.564453,831.924683 797.318420,831.970459 795.900391,830.153992 
	C795.774719,820.149292 795.649048,810.144592 795.946472,798.873474 
	C794.602356,794.400269 792.305298,796.108276 788.956970,796.840759 
	C786.952515,796.740112 784.948120,796.639465 781.389038,796.499512 
	C770.323303,794.843933 763.262329,799.776001 758.147339,809.906982 
	C756.941223,809.908997 755.735107,809.911072 754.241638,808.211792 
	C752.935791,804.240112 757.028259,798.066345 748.346191,795.794739 
	C747.930298,801.635315 747.565491,806.758057 745.850525,811.949585 
	C744.962646,812.104126 744.074829,812.258606 742.245972,811.486267 
	C739.681091,807.367432 737.286682,803.128418 734.495544,799.169067 
	C732.393616,796.187317 729.662842,794.707458 725.067017,798.143982 
	C724.036133,798.099670 723.005188,798.055359 720.960083,797.037048 
	C720.602966,796.478516 720.088318,795.964844 719.914001,795.354187 
	C718.703369,791.113159 716.636902,788.450989 711.522461,788.774841 
	C706.853333,789.070557 705.229187,792.060120 704.178101,795.623169 
	C703.252869,798.759338 702.505615,802.064270 702.428711,805.312378 
	C702.208923,814.601624 702.370178,823.899780 702.350525,834.872559 
	C703.143799,835.788086 703.870605,837.425964 704.740784,837.505981 
	C712.412781,838.211792 720.293945,839.566467 726.186157,833.380188 
	C726.186157,833.380188 726.646240,833.368164 726.350281,834.755493 
	C727.357300,835.710327 728.364319,836.665161 729.371277,837.619995 
	C730.288879,836.493774 731.206482,835.367554 732.095093,834.073303 
M560.677124,745.958435 
	C560.674194,743.282043 560.671204,740.605713 561.350281,737.012878 
	C558.891907,730.784485 556.209412,737.337341 552.460022,735.836975 
	C538.687927,732.197327 532.091736,735.371399 527.158569,749.494629 
	C527.393127,753.033569 527.627686,756.572449 527.824829,761.518005 
	C530.847961,767.046448 534.480713,771.819946 542.164917,773.672607 
	C548.790527,776.522095 554.797546,773.380310 560.958862,771.732361 
	C560.758850,771.172241 560.558838,770.612122 560.644592,768.561462 
	C560.722351,766.540955 560.800110,764.520386 562.119873,761.994995 
	C562.937561,761.646667 563.755249,761.298340 565.153442,762.140686 
	C567.435303,764.760742 569.717163,767.380798 572.389160,771.327454 
	C581.973938,776.659851 585.012634,776.500793 593.456665,769.577576 
	C594.646912,768.428467 595.969055,767.386536 597.004944,766.112000 
	C602.054016,759.900024 602.775391,750.782166 598.866760,743.774963 
	C594.935974,736.728088 587.051270,733.077393 578.507141,734.614502 
	C570.869202,735.988586 566.453369,741.001343 562.932251,748.337402 
	C562.192444,748.079163 561.452698,747.820923 560.677124,745.958435 
M605.326233,739.763306 
	C605.500305,749.860718 605.674377,759.958130 605.786072,771.074219 
	C607.885010,773.232666 609.115112,773.109375 609.574097,767.995056 
	C609.486816,762.919739 609.399536,757.844360 610.880310,751.769287 
	C618.145630,754.758301 618.952026,762.679871 623.245483,767.935791 
	C624.713013,769.732300 626.340454,771.398193 628.315735,773.591003 
	C632.453430,764.475159 632.355469,741.687134 627.575867,733.066711 
	C626.886597,742.668152 626.345703,750.202026 625.652161,759.861938 
	C620.466553,752.371704 616.591492,746.774536 612.414124,740.161621 
	C611.769348,739.348389 611.124573,738.535095 610.217041,736.546936 
	C607.903625,734.347839 606.144409,733.862000 605.326233,739.763306 
M239.709396,760.051270 
	C241.831558,760.022339 243.953735,759.993408 247.108658,760.821106 
	C248.523819,763.399841 249.551971,766.331055 251.477539,768.444824 
	C252.995895,770.111511 255.619171,770.771606 258.944794,772.024902 
	C259.344330,771.994507 259.743866,771.964111 261.451355,771.955078 
	C263.522064,770.582092 265.592743,769.209106 269.420349,767.966064 
	C273.487823,768.000977 277.555328,768.035889 282.073730,769.355713 
	C283.418640,770.351318 284.763550,771.346863 286.824310,773.242737 
	C289.216980,772.969055 291.609680,772.695374 295.613647,771.366272 
	C296.277039,768.315430 296.940430,765.264648 298.803192,762.201965 
	C301.030731,764.161743 303.258301,766.121521 306.354919,769.220093 
	C308.467285,772.207458 310.862518,773.391418 313.213409,769.652771 
	C315.125305,766.612244 316.606506,763.300842 319.365814,760.117676 
	C320.450500,760.143005 321.535156,760.168274 323.052979,761.948975 
	C323.143219,764.137817 323.065460,766.349854 323.363098,768.510132 
	C323.809174,771.747620 325.844452,771.542969 328.832581,771.309998 
	C329.942413,771.514832 331.052246,771.719727 333.538818,771.995117 
	C335.365112,770.725098 337.191437,769.455139 340.595337,768.134277 
	C343.934082,767.317017 348.410156,769.655334 351.451935,764.514465 
	C351.797852,764.727112 352.143799,764.939758 352.307617,766.233521 
	C352.697662,766.827759 353.087708,767.421936 353.822632,769.256836 
	C354.813049,770.411804 355.803497,771.566833 356.991272,772.951904 
	C360.737701,765.271057 360.509186,741.270081 356.315857,733.481079 
	C353.954285,736.097473 351.587616,738.162659 349.904633,740.684143 
	C343.867767,749.728943 338.062195,758.928162 331.171448,767.677307 
	C330.260345,767.115234 329.349274,766.553223 328.137421,764.147461 
	C327.243286,754.542236 329.441559,744.662048 325.617767,734.909241 
	C318.141815,743.028198 316.800354,754.288391 309.728027,763.402039 
	C308.370544,760.513245 307.384949,758.513000 306.481995,756.476196 
	C303.791199,750.406128 301.090027,744.340027 298.479950,738.235168 
	C297.185059,735.206360 295.390381,734.005615 291.162689,736.354614 
	C290.070160,736.918335 288.977631,737.482056 287.301453,736.950012 
	C283.177155,732.206116 281.127594,736.082458 279.177063,739.076477 
	C272.873383,748.752747 266.714020,758.523071 259.164886,768.083435 
	C258.716766,768.070557 258.268646,768.057739 256.797485,767.104248 
	C254.878540,763.721985 252.959610,760.339722 251.031830,756.941895 
	C252.275421,755.075500 253.281555,753.780701 254.059784,752.360901 
	C257.766296,745.598633 257.474182,740.890381 253.202866,737.159180 
	C248.832123,733.341248 238.738297,733.753052 233.468353,739.781799 
	C233.516495,749.836121 233.564636,759.890381 233.251144,770.659729 
	C234.224625,771.148560 235.198105,771.637451 236.171570,772.126343 
	C236.404388,771.335693 236.637207,770.544983 237.427750,768.203796 
	C237.657852,765.475708 237.887939,762.747559 239.709396,760.051270 
M662.399963,768.257507 
	C662.235229,758.181580 662.070496,748.105713 662.009399,736.693787 
	C657.748108,731.721008 655.716431,736.277222 653.944336,738.952087 
	C647.751770,748.299072 641.804199,757.812805 635.990967,767.401001 
	C635.261963,768.603394 635.891418,770.629333 635.891418,774.427490 
	C642.845398,766.862610 648.669312,760.691956 657.655090,767.501282 
	C657.877686,768.303650 658.100281,769.106018 658.176086,770.792542 
	C659.144836,771.231140 660.113647,771.669800 661.082397,772.108398 
	C661.302551,771.414673 661.522644,770.721008 662.399963,768.257507 
M204.233643,796.677795 
	C201.777802,796.496643 199.659348,796.784668 198.919952,800.832947 
	C199.363998,805.973511 204.848480,804.081665 207.048782,808.458191 
	C207.171005,816.310486 207.293243,824.162781 206.751236,832.765991 
	C208.299988,833.474731 209.848740,834.183533 211.397491,834.892334 
	C211.707047,833.929443 212.016586,832.966614 212.717239,830.197449 
	C212.746048,822.347534 212.774857,814.497559 214.065033,806.058655 
	C217.712631,804.174438 222.668365,803.153809 219.607224,795.810120 
	C215.144699,796.140076 210.356583,796.494141 204.233643,796.677795 
M384.238342,802.021362 
	C384.337646,811.951721 384.436920,821.882019 384.457153,833.256348 
	C389.558441,833.618408 394.692780,834.493958 399.749908,834.168884 
	C403.352539,833.937317 403.109650,830.858032 401.717255,827.795471 
	C398.412140,827.218628 394.963776,826.616760 391.305267,825.978210 
	C390.762268,818.991333 390.259552,812.522705 389.980286,804.580017 
	C389.857819,803.102234 389.735321,801.624451 389.991913,798.744202 
	C388.976410,797.878723 387.960907,797.013245 386.945404,796.147766 
	C386.165375,797.503601 385.385345,798.859375 384.238342,802.021362 
M652.293335,796.516968 
	C649.985352,794.261719 648.406616,794.359985 647.340881,799.438354 
	C647.259521,810.318176 647.178223,821.197937 646.464478,832.963074 
	C648.678284,836.805786 650.690430,836.792786 652.961792,830.741882 
	C652.735657,819.716125 652.509460,808.690308 652.293335,796.516968 
M689.642700,798.654480 
	C689.449829,799.083740 689.256958,799.513062 687.870117,799.906067 
	C686.676208,799.921204 685.482239,799.936340 683.393127,798.722534 
	C673.046204,793.606201 663.067627,797.855469 659.355164,808.823059 
	C656.636719,816.854187 659.300110,823.581909 664.111450,831.394958 
	C667.479553,838.712402 674.048462,838.021118 680.386841,837.892639 
	C684.221497,837.814880 688.055664,837.710144 691.890259,837.628052 
	C695.669373,837.547119 698.723450,836.927551 695.981323,830.153137 
	C696.059143,821.178406 696.150757,812.203674 696.208130,803.228821 
	C696.230896,799.667969 695.637451,796.483887 690.681152,796.097290 
	C690.193359,796.335083 689.902771,796.720154 689.642700,798.654480 
M109.333023,739.387268 
	C109.257545,749.208618 109.164497,759.029907 109.163933,768.851196 
	C109.163910,769.294434 110.000267,769.737732 110.673927,770.406067 
	C114.322159,767.801575 112.532982,763.964844 114.218788,759.814331 
	C117.699432,759.046021 121.267212,758.544739 124.639351,757.444031 
	C129.171997,755.964661 132.068375,752.405579 131.523453,747.765930 
	C131.101730,744.175232 129.742386,739.151917 127.148499,737.684387 
	C121.951004,734.743835 115.628365,733.939026 109.333023,739.387268 
M186.742523,735.291809 
	C169.462448,732.416138 158.123520,744.202820 163.050781,760.073303 
	C165.053482,766.523926 169.377701,771.416260 176.072327,772.518860 
	C181.604797,773.430115 188.231018,775.302673 192.547699,766.996399 
	C194.335602,765.267944 196.123505,763.539490 199.409592,761.219971 
	C201.494949,763.045532 203.849594,764.644348 205.613815,766.740234 
	C210.385162,772.408569 216.436905,774.098999 223.513336,773.297424 
	C226.480591,772.961426 228.695496,771.728943 228.986908,768.548035 
	C229.523743,762.688171 230.852280,756.716125 227.443375,750.737671 
	C225.782043,750.625122 224.075073,750.136963 222.580261,750.506653 
	C220.876373,750.927917 219.361603,752.114075 217.764648,752.967773 
	C218.787277,754.447021 219.487534,756.466492 220.892563,757.305054 
	C225.247604,759.904358 224.334641,762.928162 222.633591,766.299194 
	C213.013672,766.242981 207.210678,761.946350 206.673370,754.774475 
	C206.136429,747.607727 211.692322,742.212097 220.739792,741.154114 
	C221.727448,741.038574 223.014313,741.486694 223.677765,741.005371 
	C225.096283,739.976196 226.197311,738.509399 227.428345,737.221802 
	C226.234970,736.261047 225.169266,734.736145 223.827209,734.432434 
	C215.970734,732.654297 209.362732,736.066772 204.116257,743.125305 
	C202.722473,745.000488 204.245880,750.183411 198.706482,747.406372 
	C195.811096,743.022156 193.618896,737.958557 186.742523,735.291809 
M377.236115,747.659241 
	C377.353882,751.831116 377.471649,756.002930 377.412964,761.644775 
	C380.462860,767.834167 384.820129,772.428284 392.056519,773.320007 
	C403.853088,774.773743 411.036377,768.833130 415.818756,756.836548 
	C416.861664,762.021851 417.904602,767.207153 418.947540,772.392395 
	C419.740814,772.383728 420.534119,772.375061 421.327393,772.366394 
	C422.104462,767.546143 422.881500,762.725891 423.708557,757.595398 
	C426.772858,757.264587 429.381805,757.143555 431.927124,756.676025 
	C437.941895,755.570984 442.033997,750.476868 441.677826,744.770813 
	C441.336456,739.301941 437.333679,735.242554 431.244690,734.763916 
	C427.085785,734.436890 422.880432,734.701294 418.041748,734.701294 
	C417.826080,739.621094 418.011963,743.263000 417.400909,746.765991 
	C416.932068,749.453430 415.458160,751.965576 414.170227,752.780396 
	C413.645081,750.541138 413.381744,748.198792 412.547821,746.081116 
	C409.523712,738.401611 403.215179,734.089172 394.977997,734.125244 
	C386.654755,734.161682 380.263763,737.189148 377.236115,747.659241 
M449.568848,829.852234 
	C448.418488,833.910828 450.874451,834.528076 453.788910,833.743469 
	C455.154633,833.375793 456.500458,831.827087 457.251404,830.477600 
	C460.203125,825.173035 464.520416,824.273010 470.095642,826.050415 
	C471.210938,828.808960 472.350800,831.628235 473.764893,835.125793 
	C475.542389,833.932495 477.420349,833.268433 477.430939,832.575806 
	C477.611298,820.773315 477.560333,808.967285 477.560333,797.341614 
	C472.232483,795.076904 469.852905,797.797119 467.540863,801.518005 
	C461.786102,810.779541 455.778076,819.883789 447.980164,827.588562 
	C448.282471,825.641785 448.456055,823.664673 448.907074,821.752991 
	C453.113403,803.924255 439.078186,791.659729 422.396790,797.680115 
	C422.396790,809.401123 422.396790,821.408020 422.396790,833.277344 
	C432.488922,835.207642 435.459076,834.693604 442.766388,830.293152 
	C445.050293,828.917786 446.974792,825.382080 449.568848,829.852234 
M4336.579590,521.647217 
	C4333.499512,521.949280 4329.761230,520.259216 4328.086914,524.671631 
	C4322.478516,539.450623 4316.822266,554.211609 4310.867188,569.810974 
	C4314.965820,569.810974 4318.011230,569.810974 4320.810547,569.810974 
	C4322.295410,566.208496 4323.534668,563.200806 4324.810547,560.105713 
	C4331.375000,560.105713 4337.586914,560.105713 4343.941895,560.105713 
	C4345.549805,563.612183 4347.045898,566.874390 4348.475098,569.991699 
	C4351.736328,569.991699 4354.621094,569.991699 4358.445801,569.991699 
	C4354.749023,560.460022 4351.451660,551.537109 4347.827637,542.749268 
	C4344.960449,535.797180 4341.692383,529.010681 4338.086914,520.400146 
	C4340.761230,517.527649 4347.030762,517.175293 4344.478027,508.665527 
	C4340.260254,514.788086 4335.971191,512.383789 4331.306641,510.838165 
	C4326.135742,509.124908 4324.069336,511.649841 4324.634766,519.118042 
	C4329.718262,513.786804 4334.449707,517.168091 4339.219238,519.019592 
	C4339.265625,519.037476 4338.547852,521.023682 4336.579590,521.647217 
M846.688782,521.919678 
	C843.586731,521.826050 839.920044,520.720093 839.367004,527.454651 
	C839.512024,541.677551 839.657104,555.900513 840.092224,571.742249 
	C843.166931,572.462402 846.241394,573.809448 849.316284,573.810364 
	C914.844604,573.829407 980.373047,573.732910 1045.901001,573.516663 
	C1050.375732,573.501953 1054.846802,572.369446 1059.979614,571.666443 
	C1060.107910,554.758728 1060.510620,538.995605 1059.813354,521.993652 
	C1055.036865,521.993652 1051.478882,521.993408 1047.920898,521.993591 
	C1001.019287,521.996155 954.117676,522.036072 907.216248,521.946289 
	C902.272095,521.936829 897.321533,520.743530 892.387817,520.836792 
	C882.972473,521.014587 873.358032,518.363953 862.399902,522.224365 
	C857.664490,522.324524 852.929077,522.424744 846.688782,521.919678 
M839.975098,469.868439 
	C843.383362,470.611755 846.790344,471.992371 850.200012,471.999054 
	C881.484924,472.059998 912.770203,471.835968 944.055481,471.787231 
	C979.003540,471.732788 1013.951782,471.792908 1048.899902,471.745361 
	C1052.391113,471.740601 1055.881836,471.335052 1059.984375,471.077026 
	C1060.093384,453.693787 1060.415894,437.548920 1059.944702,420.244354 
	C1055.118042,420.244354 1051.539795,420.253448 1047.961548,420.242981 
	C994.376709,420.086243 940.791870,419.916565 887.207031,419.775574 
	C873.893616,419.740540 860.579102,419.723236 847.266968,419.865814 
	C844.251038,419.898132 840.141602,418.570068 839.205078,425.416962 
	C839.351868,439.688110 839.498596,453.959259 839.975098,469.868439 
M838.932861,671.119873 
	C839.154297,672.146118 839.375732,673.172302 839.957397,675.797729 
	C843.108582,676.425049 846.259766,677.599304 849.410889,677.599121 
	C916.071472,677.594910 982.731995,677.469421 1049.392456,677.314697 
	C1052.621460,677.307190 1055.849243,676.815918 1060.045410,676.470215 
	C1060.224121,659.508423 1060.505493,643.403870 1060.103271,627.560364 
	C1049.239014,625.591370 845.854004,625.789490 838.725464,627.745422 
	C838.381653,641.716492 837.364441,655.909058 838.932861,671.119873 
M1887.672852,753.554321 
	C1890.411865,756.680481 1891.078979,753.970825 1892.972656,751.097900 
	C1906.741577,737.114319 1923.036011,727.062012 1941.183472,719.774536 
	C1963.894165,710.654663 1987.853149,706.684937 2011.672241,701.929626 
	C2032.198853,697.831543 2052.892090,693.937134 2072.866699,687.838806 
	C2111.500977,676.043457 2134.389648,648.986694 2144.208008,610.058655 
	C2150.134033,586.561584 2150.584473,562.601196 2151.410889,538.692200 
	C2152.434326,509.071594 2152.590332,479.420532 2153.061523,449.781677 
	C2153.182129,442.207550 2153.079346,434.629822 2153.079346,426.071594 
	C2100.258545,429.395050 2049.213623,438.167023 1999.075684,455.318481 
	C1999.075684,529.240723 1999.075684,602.391052 1999.075684,675.506958 
	C1996.409912,676.337891 1994.532471,677.013916 1992.608521,677.509155 
	C1968.442505,683.729248 1946.510986,694.601013 1926.493042,709.390808 
	C1910.769043,721.008301 1897.411743,734.770081 1887.672852,753.554321 
M568.488342,462.518646 
	C562.775940,456.939514 557.466614,450.862183 551.286011,445.861847 
	C509.898834,412.378326 452.274200,407.744415 405.044739,433.923981 
	C358.220306,459.879059 333.393280,513.528137 339.537292,563.270996 
	C351.595184,660.893738 460.504913,710.439880 541.434082,656.919556 
	C575.733459,634.236633 595.204712,601.791687 599.465454,561.126526 
	C603.279907,524.720703 592.703125,492.010498 568.488342,462.518646 
M2477.834717,582.772278 
	C2410.034668,630.765869 2402.386719,723.912537 2445.624756,783.325684 
	C2481.775879,833.001099 2544.693115,851.428284 2604.338135,834.613220 
	C2670.282959,816.022217 2712.523438,752.965088 2705.562500,684.452393 
	C2701.195557,641.469177 2681.950684,606.556335 2646.261719,581.453125 
	C2599.422363,548.506592 2528.588135,546.911438 2477.834717,582.772278 
M3230.129395,729.045288 
	C3236.871094,694.546143 3233.155273,661.454529 3216.683838,630.124634 
	C3185.122803,570.092896 3116.247803,543.862793 3051.020508,561.423340 
	C2952.466064,587.956421 2919.822754,697.926392 2967.440674,775.115723 
	C3001.643555,830.559570 3068.588867,852.929810 3131.803467,834.364929 
	C3183.921387,819.058960 3216.385010,783.436157 3230.129395,729.045288 
M1373.436646,676.921631 
	C1387.642456,676.921631 1401.848389,676.921631 1417.189331,676.921631 
	C1417.189331,671.909851 1417.187378,668.335022 1417.189697,664.760132 
	C1417.228027,604.790894 1417.249023,544.821594 1417.343994,484.852386 
	C1417.350586,480.661133 1417.905029,476.470734 1418.300171,470.947083 
	C1437.189453,471.602142 1455.098145,472.034241 1472.979370,472.982605 
	C1477.192993,473.206085 1481.432739,474.857513 1485.457275,476.386780 
	C1501.810425,482.600830 1509.227051,495.432587 1509.467651,512.093140 
	C1509.704590,528.495056 1503.729614,542.088684 1487.521362,549.199402 
	C1477.903076,553.418884 1467.785767,555.080444 1457.355835,555.146667 
	C1452.159790,555.179688 1446.963379,555.152466 1440.823242,555.152466 
	C1440.823242,570.864502 1440.727661,585.104492 1440.945435,599.339783 
	C1440.972290,601.096558 1442.476074,602.968567 1443.622925,604.549622 
	C1459.855225,626.928040 1476.220581,649.210449 1492.347778,671.663879 
	C1495.208252,675.646362 1498.515869,677.056763 1503.274292,677.017639 
	C1523.595703,676.850342 1543.919556,676.987244 1564.242065,676.902161 
	C1565.995728,676.894836 1567.745972,676.073914 1570.258789,675.438416 
	C1568.726807,673.033813 1567.785889,671.321960 1566.626587,669.773438 
	C1550.658569,648.441711 1534.628052,627.156677 1518.706543,605.790344 
	C1516.433594,602.739990 1514.653931,599.322144 1512.447144,595.752930 
	C1515.799072,593.849243 1518.108887,592.582703 1520.375488,591.242920 
	C1543.001709,577.869629 1558.317383,559.070801 1563.406616,532.815247 
	C1569.843262,499.608215 1562.315430,454.158417 1512.866455,431.313965 
	C1496.894531,423.935333 1480.080322,420.259369 1462.567139,420.177124 
	C1431.583984,420.031616 1400.599365,420.202820 1369.615479,420.284882 
	C1367.377808,420.290802 1365.141235,420.648651 1362.273560,420.897614 
	C1362.273560,506.226196 1362.273560,590.993286 1362.273560,676.367676 
	C1365.683838,676.570374 1368.621094,676.744995 1373.436646,676.921631 
M1103.950562,513.000000 
	C1103.933960,539.657166 1103.506470,566.321960 1104.005737,592.969482 
	C1104.616211,625.551941 1118.438354,651.065186 1147.937988,666.044617 
	C1182.678345,683.685120 1218.994263,685.090454 1255.585449,672.208130 
	C1292.619751,659.169983 1313.276855,630.381287 1313.564453,591.055054 
	C1313.959229,537.076965 1313.631348,483.093475 1313.555054,429.112396 
	C1313.551025,426.260590 1313.006348,423.409576 1312.713989,420.563904 
	C1294.176270,420.563904 1276.647461,420.563904 1258.232788,420.563904 
	C1258.004883,424.951691 1257.630859,428.839478 1257.627197,432.727600 
	C1257.580811,481.044098 1257.619019,529.360657 1257.538574,577.677063 
	C1257.529785,582.990845 1257.408569,588.389709 1256.489990,593.599365 
	C1254.416016,605.360291 1248.497925,615.025146 1237.651001,620.394897 
	C1220.052124,629.106934 1201.766113,629.780029 1183.514404,622.335510 
	C1179.613403,620.744446 1175.993042,618.011047 1172.826538,615.156921 
	C1162.701904,606.031250 1159.496948,594.061401 1159.512695,580.878967 
	C1159.572266,531.229614 1159.604736,481.580261 1159.600830,431.930908 
	C1159.600586,428.106506 1159.239746,424.282104 1159.056030,420.646027 
	C1140.171997,420.646027 1122.666992,420.646027 1103.952148,420.646027 
	C1103.952148,451.218048 1103.952148,481.109009 1103.950562,513.000000 
M129.193390,419.952332 
	C124.626541,419.952332 120.059692,419.952332 114.870453,419.952332 
	C114.870453,505.938629 114.870453,590.743164 114.870453,676.243896 
	C133.375305,676.243896 151.467896,676.243896 170.635178,676.243896 
	C170.635178,672.278809 170.635773,669.034424 170.635101,665.790100 
	C170.622513,605.461975 170.591324,545.133850 170.637085,484.805725 
	C170.640259,480.640198 171.216766,476.475098 171.531281,472.247528 
	C173.882935,471.882599 175.159576,471.510803 176.435471,471.513336 
	C189.433304,471.539032 202.433990,471.488800 215.427231,471.768372 
	C220.063950,471.868195 224.755676,472.462067 229.297409,473.421631 
	C255.764908,479.013397 267.819275,497.609558 262.703491,524.267578 
	C260.540771,535.537537 254.644531,543.773987 244.406708,548.940796 
	C235.009521,553.683350 225.011459,555.920471 214.536179,556.082886 
	C208.287598,556.179810 202.036285,556.100647 195.081696,556.100647 
	C195.081696,571.971375 195.081696,586.788574 195.081696,601.915588 
	C197.104523,602.519653 198.950241,603.424194 200.858963,603.586182 
	C219.949371,605.206909 238.865479,604.009949 257.352966,598.859009 
	C279.073669,592.807373 296.428528,580.676086 308.205597,561.075378 
	C317.814514,545.083069 320.841034,527.649231 320.280853,509.273560 
	C319.459930,482.345245 308.925354,460.184174 287.802612,443.447449 
	C266.285614,426.398254 241.167923,419.620636 214.125854,419.520447 
	C186.465164,419.417999 158.802673,419.796875 129.193390,419.952332 
M688.142456,572.657166 
	C695.079224,573.451355 702.010193,574.301819 708.954163,575.026978 
	C720.177368,576.199158 731.872986,575.516663 742.058533,581.239929 
	C746.483521,583.726257 750.978333,587.449890 753.464966,591.753601 
	C759.473877,602.153320 755.078064,614.103821 743.700439,620.478149 
	C731.115051,627.528992 717.508484,627.434631 703.853882,625.137695 
	C690.807983,622.943176 680.635681,616.930420 677.578369,602.750000 
	C677.386719,601.861267 676.554382,601.110657 676.201965,600.573059 
	C657.775330,600.573059 639.669189,600.573059 621.872681,600.573059 
	C621.372681,602.066833 621.011230,602.683655 620.987549,603.313171 
	C620.937866,604.638306 620.962341,605.983582 621.135193,607.297058 
	C624.550903,633.247742 638.013916,652.527893 660.571594,665.331543 
	C680.961975,676.905151 703.328735,679.673523 726.315857,678.220276 
	C745.884583,676.983093 764.467957,672.265991 780.786133,660.716492 
	C816.880859,635.169739 824.561768,588.028381 797.003479,555.855286 
	C790.028625,547.712341 780.727539,541.012695 771.372925,535.583923 
	C756.755981,527.101196 740.295288,524.140808 723.363464,523.866272 
	C711.974976,523.681702 700.739258,522.109131 690.388733,516.984558 
	C675.608948,509.666962 673.425293,492.105927 686.150085,481.683228 
	C689.649536,478.816864 694.031189,476.507385 698.383362,475.330994 
	C704.101807,473.785400 710.180176,473.080414 716.123779,472.954224 
	C732.108887,472.614746 748.104736,472.803925 764.095947,472.712097 
	C767.329529,472.693542 770.561340,472.361816 774.507812,472.133057 
	C774.507812,454.700958 774.507812,437.929382 774.507812,421.203186 
	C772.918274,420.755371 771.988098,420.263275 771.059082,420.265381 
	C750.072510,420.313110 729.069031,419.927887 708.104797,420.659088 
	C690.980469,421.256348 674.591980,425.469421 659.488770,434.129242 
	C612.110962,461.294586 605.136230,527.492065 655.343689,559.296814 
	C665.024048,565.429016 675.389099,569.738953 688.142456,572.657166 
M2725.220459,826.770325 
	C2725.220459,831.048828 2725.220459,835.327393 2725.220459,839.499268 
	C2742.509766,841.404724 2916.390381,840.636169 2923.199219,838.750244 
	C2923.199219,825.523926 2923.199219,812.331116 2923.199219,798.186340 
	C2880.298584,798.186340 2837.895996,798.186340 2792.998535,798.186340 
	C2796.780029,794.968445 2798.679443,793.324829 2800.607422,791.715698 
	C2820.554932,775.068420 2840.698975,758.650208 2860.385010,741.699646 
	C2872.231689,731.499268 2883.900635,720.983276 2894.697266,709.698303 
	C2911.150635,692.500427 2919.893555,671.813904 2920.933350,647.687378 
	C2922.447266,612.566711 2903.257812,582.002319 2870.489258,569.173340 
	C2847.730957,560.263245 2824.339600,559.787720 2800.768311,565.053284 
	C2780.000244,569.692627 2762.594238,580.392944 2748.275146,596.045532 
	C2741.412354,603.547180 2734.454590,611.035706 2729.418945,620.360596 
	C2740.893799,629.257141 2751.828369,637.734680 2762.521484,646.024963 
	C2770.256592,637.849304 2777.130859,630.150940 2784.468506,622.922546 
	C2797.811768,609.777710 2813.916504,604.236511 2832.678711,605.738892 
	C2853.404297,607.398499 2868.669678,622.067749 2870.645752,642.663086 
	C2872.082520,657.637939 2868.540283,671.394836 2859.048096,682.867126 
	C2850.593750,693.085449 2841.504639,702.988037 2831.538574,711.707520 
	C2802.210693,737.367310 2772.300049,762.360840 2742.637451,787.638428 
	C2737.066895,792.385376 2729.422363,796.250977 2726.656982,802.312683 
	C2723.734863,808.717651 2725.501953,817.261841 2725.220459,826.770325 
M2390.473389,620.839478 
	C2383.458984,596.052429 2367.646973,579.132324 2343.984619,569.534851 
	C2320.652588,560.071411 2296.631104,559.700073 2272.395996,565.340881 
	C2240.847412,572.683777 2219.911621,593.825989 2201.875488,620.038696 
	C2213.217529,628.912842 2224.302246,637.585693 2235.052490,645.996948 
	C2243.750732,637.046021 2251.368896,628.680786 2259.549072,620.907471 
	C2272.987305,608.137878 2289.347900,603.977417 2307.492920,605.989258 
	C2327.208252,608.175232 2341.760986,622.943176 2343.601562,642.707642 
	C2344.782471,655.391235 2342.543945,667.610046 2335.074707,677.894653 
	C2328.075195,687.532471 2320.379395,696.934692 2311.649902,704.988220 
	C2294.771240,720.560120 2276.984619,735.151184 2259.509766,750.073059 
	C2239.006348,767.580872 2218.434082,785.008301 2198.379883,802.055359 
	C2198.379883,815.036438 2198.379883,827.253235 2198.379883,839.395996 
	C2213.623779,841.263367 2388.992188,840.657166 2395.719727,838.829346 
	C2395.719727,825.552979 2395.719727,812.337708 2395.719727,797.972534 
	C2352.947510,797.972534 2310.629883,797.972534 2266.319824,797.972534 
	C2270.714844,794.122925 2273.350586,791.718262 2276.086182,789.433228 
	C2293.724121,774.701355 2311.605225,760.250916 2328.964844,745.198730 
	C2342.284180,733.649841 2355.700928,722.054688 2367.754883,709.239258 
	C2390.838867,684.697266 2398.436523,655.419983 2390.473389,620.839478 
M1877.882690,513.044800 
	C1875.953003,518.004761 1873.917236,522.926514 1872.110718,527.930908 
	C1861.028320,558.630981 1856.749634,590.581909 1856.389648,622.948853 
	C1855.812012,674.896484 1856.230835,726.855225 1856.228638,778.809265 
	C1856.228638,780.141418 1856.208984,781.473999 1856.237305,782.805603 
	C1856.258057,783.782288 1856.342651,784.757629 1856.398682,785.733521 
	C1873.878174,726.709167 1905.365479,680.626587 1965.634277,659.327698 
	C1965.634277,581.368713 1965.634277,503.919495 1965.634277,425.620880 
	C1962.768066,426.374756 1960.408081,426.530731 1958.535522,427.567413 
	C1949.815674,432.395172 1940.752930,436.799500 1932.686157,442.574982 
	C1907.973755,460.268402 1890.686401,484.029663 1877.882690,513.044800 
M4052.999756,848.419739 
	C4078.330078,848.419739 4103.660156,848.422546 4128.990723,848.418640 
	C4143.743164,848.416382 4143.749512,848.411621 4143.749512,833.457520 
	C4143.751465,700.139526 4143.751953,566.821594 4143.750000,433.503632 
	C4143.750000,418.247070 4143.743164,418.244110 4128.016602,418.244049 
	C3927.039795,418.243378 3726.062988,418.243622 3525.086182,418.243622 
	C3523.419678,418.243622 3521.752930,418.214996 3520.086914,418.248749 
	C3510.561035,418.441650 3509.784180,419.199066 3509.584961,428.466736 
	C3509.556396,429.799316 3509.580322,431.132996 3509.580322,432.466187 
	C3509.580322,566.450745 3509.579834,700.435303 3509.582520,834.419861 
	C3509.582764,848.410278 3509.593018,848.418274 3524.060303,848.418396 
	C3699.706787,848.420349 3875.353027,848.419739 4052.999756,848.419739 
M1935.239624,828.006226 
	C1952.425293,831.298218 1969.697998,833.569214 1987.577637,833.537964 
	C1987.577637,799.304932 1987.577637,766.163818 1987.577637,733.249146 
	C1986.403931,732.765686 1985.776855,732.248596 1985.219604,732.315125 
	C1960.555786,735.262756 1936.826172,741.335571 1915.435669,754.447144 
	C1904.745239,761.000061 1895.997070,769.618530 1891.332275,781.619385 
	C1888.114868,789.896606 1885.886597,798.570740 1891.899048,806.312073 
	C1895.271729,810.654297 1899.736206,814.875549 1904.637573,817.147095 
	C1913.931396,821.454529 1923.893799,824.319641 1935.239624,828.006226 
M2352.015869,439.606537 
	C2352.015869,455.511810 2352.015869,471.417053 2352.015869,487.035400 
	C2349.067871,488.054932 2346.807373,488.265961 2345.409912,489.474640 
	C2343.905518,490.775940 2342.243408,493.123749 2342.437744,494.808838 
	C2342.626953,496.451324 2345.026367,499.065643 2346.541016,499.126617 
	C2355.365479,499.481842 2364.214844,499.210999 2372.097900,499.158081 
	C2377.003662,490.426636 2369.958252,488.990814 2366.402344,485.998932 
	C2367.118896,479.927979 2364.853271,473.975494 2368.382812,467.518494 
	C2370.261719,470.111511 2371.706787,471.844116 2372.864990,473.750977 
	C2377.010010,480.575989 2380.910156,487.555389 2385.232422,494.264191 
	C2386.552490,496.313293 2388.771484,498.842499 2390.857178,499.129425 
	C2395.973145,499.833344 2401.250977,499.359528 2406.176514,499.359528 
	C2408.263916,493.392273 2408.482910,489.585266 2402.407471,488.117432 
	C2400.921143,487.758362 2399.239014,486.701599 2398.392334,485.458130 
	C2393.940186,478.920319 2389.727051,472.219788 2385.185303,465.195892 
	C2388.445557,463.091705 2391.032715,461.648468 2393.363770,459.869873 
	C2398.008789,456.325714 2401.306152,451.878204 2402.002686,445.836975 
	C2403.587402,432.092682 2395.982422,422.705811 2381.523926,422.046539 
	C2369.244385,421.486664 2356.909912,422.117615 2344.600586,422.283569 
	C2344.033936,422.291229 2343.475830,422.905823 2342.341064,423.575775 
	C2342.446289,425.767853 2342.565918,428.257874 2342.676758,430.562500 
	C2346.479248,432.763916 2352.868164,430.819885 2352.015869,439.606537 
M2336.208252,450.905548 
	C2332.441406,428.046417 2316.104492,416.741821 2294.135010,421.468628 
	C2279.729248,424.568115 2270.284180,433.151947 2266.323242,447.034515 
	C2261.825928,462.796356 2262.945801,478.008820 2274.257080,491.098328 
	C2275.750977,492.827240 2277.665527,494.339355 2279.659912,495.465393 
	C2293.012939,503.004059 2316.931885,503.301697 2329.543457,484.775970 
	C2336.156494,475.061890 2338.500488,464.234100 2336.208252,450.905548 
M2665.090332,479.637054 
	C2668.415771,479.638763 2671.754639,479.831665 2675.063477,479.598755 
	C2680.422607,479.221466 2683.098389,481.512329 2683.204346,487.405396 
	C2679.161133,489.520386 2673.338623,491.149841 2677.739990,498.703918 
	C2686.668213,498.703918 2696.050781,498.703918 2705.491211,498.703918 
	C2706.636963,494.388123 2707.083008,491.268555 2703.122314,488.525269 
	C2700.907715,486.991180 2699.240234,484.111511 2698.233154,481.489807 
	C2694.542725,471.881409 2691.269775,462.113586 2687.769043,452.431366 
	C2684.171387,442.482239 2680.490723,432.563171 2676.789062,422.474701 
	C2670.433594,422.474701 2664.590820,422.474701 2658.576172,422.474701 
	C2657.012207,426.618927 2655.546631,430.311127 2654.219482,434.052338 
	C2648.779297,449.390350 2643.432617,464.761688 2637.929688,480.076996 
	C2636.634033,483.682465 2635.980713,487.624054 2631.290771,489.301453 
	C2629.855225,489.814789 2628.794189,493.792542 2629.120850,495.947388 
	C2629.331543,497.337952 2632.334229,499.201996 2634.163574,499.293488 
	C2641.703613,499.670715 2649.273193,499.451477 2656.301514,499.451477 
	C2658.505371,494.342133 2658.736816,491.304474 2654.475342,488.810028 
	C2653.045654,487.973236 2651.798584,484.802307 2652.284424,483.276123 
	C2652.782959,481.709198 2655.364502,480.425690 2657.288574,479.801849 
	C2659.098145,479.215057 2661.238770,479.650604 2665.090332,479.637054 
M2586.408691,499.501312 
	C2598.378418,500.484497 2610.255127,500.764099 2622.288818,494.769104 
	C2622.288818,488.650269 2622.309814,482.379944 2622.280273,476.109863 
	C2622.263916,472.686890 2622.400635,469.770599 2626.437256,468.001953 
	C2627.970947,467.329956 2629.111084,463.677002 2628.803955,461.626038 
	C2628.603027,460.283752 2625.521973,458.516510 2623.661377,458.429565 
	C2616.358887,458.088318 2609.028076,458.304962 2601.709229,458.410889 
	C2600.784668,458.424286 2599.868164,459.009857 2598.574219,459.460510 
	C2598.574219,461.967529 2598.574219,464.472534 2598.574219,466.883118 
	C2601.761963,468.087402 2604.482910,469.115265 2607.155518,470.124939 
	C2607.155518,475.348175 2607.155518,480.177429 2607.155518,485.729614 
	C2602.927734,485.935242 2599.335938,486.371063 2595.765625,486.236481 
	C2583.062012,485.757629 2574.677734,477.520844 2573.909912,464.910828 
	C2573.748535,462.258759 2573.747070,459.580383 2573.906006,456.928192 
	C2574.700684,443.670319 2583.785156,434.666534 2596.929199,434.011414 
	C2607.352051,433.491943 2607.669922,433.695740 2611.366211,443.468842 
	C2614.428711,443.468842 2617.589355,443.468842 2621.304688,443.468842 
	C2621.304688,436.719910 2621.304688,430.548218 2621.304688,423.553223 
	C2610.685303,421.505585 2600.618896,419.389954 2589.774658,421.662720 
	C2571.359375,425.522217 2558.821045,438.985657 2557.782227,457.373108 
	C2556.458252,480.812347 2564.015137,492.477081 2586.408691,499.501312 
M2499.610352,445.239624 
	C2499.610352,441.315735 2499.610352,437.391876 2499.610352,433.919250 
	C2508.323486,430.044434 2508.323486,430.044434 2505.898438,422.681152 
	C2496.653809,422.681152 2487.505127,422.681152 2476.994385,422.681152 
	C2478.158691,426.371033 2478.338867,430.658936 2479.919922,431.259888 
	C2484.769043,433.102753 2484.171387,436.622589 2484.186523,440.193024 
	C2484.232910,451.172180 2484.044189,462.155334 2484.280518,473.129761 
	C2484.490967,482.908142 2487.404053,491.637024 2496.556641,496.716736 
	C2519.993408,509.723907 2545.804932,494.930084 2545.996582,468.462250 
	C2546.080566,456.857910 2546.010742,445.252441 2546.010742,433.146698 
	C2552.431152,431.926208 2554.995850,428.682648 2552.451416,422.536682 
	C2542.874512,422.536682 2533.713867,422.536682 2524.543945,422.536682 
	C2523.514404,427.143402 2522.342529,430.979034 2528.271729,432.452728 
	C2529.656250,432.796875 2531.464844,435.230988 2531.474609,436.714050 
	C2531.559814,449.668365 2532.028809,462.693115 2530.859375,475.558350 
	C2530.008057,484.922394 2522.847412,488.879242 2512.563721,487.830292 
	C2503.968506,486.953552 2500.070312,482.716431 2499.751709,473.132111 
	C2499.464355,464.490631 2499.638672,455.833832 2499.610352,445.239624 
M2224.517090,498.504822 
	C2231.799316,497.588806 2231.799316,497.588806 2231.270264,490.471558 
	C2228.403076,489.266541 2225.441406,488.021912 2223.005371,486.998077 
	C2223.005371,481.666046 2223.005371,477.162354 2223.005371,473.336060 
	C2229.980957,471.737427 2236.372070,471.052216 2242.138672,468.781006 
	C2252.577881,464.669403 2259.097900,452.609314 2257.547119,442.120483 
	C2255.852783,430.664124 2248.399170,423.017883 2235.986816,422.169800 
	C2223.781982,421.335907 2211.476074,421.988007 2198.712891,421.988007 
	C2198.712891,425.589478 2198.712891,428.296783 2198.712891,430.762390 
	C2202.180908,431.887512 2204.904785,432.771240 2207.415527,433.585846 
	C2207.415527,451.834503 2207.415527,469.436279 2207.415527,486.849365 
	C2197.672607,490.777222 2197.672607,490.777222 2199.940918,498.507690 
	C2207.374512,498.507690 2215.009033,498.507690 2224.517090,498.504822 
M2411.661377,422.027344 
	C2410.504395,423.000793 2408.402832,423.922668 2408.346191,424.956207 
	C2408.024414,430.847076 2408.190186,436.764618 2408.190186,443.024811 
	C2412.148926,443.024811 2415.240967,443.024811 2418.170166,443.024811 
	C2419.483887,439.660187 2420.528320,436.985199 2421.678955,434.037842 
	C2425.009033,434.247375 2427.910645,434.429993 2431.385254,434.648651 
	C2431.385254,452.319489 2431.385254,469.506348 2431.385254,487.047455 
	C2428.456543,488.245514 2425.480957,489.462708 2422.264648,490.778473 
	C2422.426025,493.470367 2422.559326,495.691132 2422.739502,498.695618 
	C2432.946289,500.045319 2442.850098,499.748260 2452.717773,498.898926 
	C2454.032715,498.785736 2455.893799,496.445282 2456.145752,494.913300 
	C2456.409912,493.309143 2455.533203,490.752136 2454.268311,489.836700 
	C2452.249268,488.375183 2449.496826,487.926910 2446.978516,487.022949 
	C2446.978516,469.485260 2446.978516,452.301666 2446.978516,434.755127 
	C2451.053711,434.755127 2454.526367,434.755127 2458.073486,434.755127 
	C2459.262695,438.008362 2460.254395,440.721039 2461.412842,443.890015 
	C2464.636475,443.579468 2467.476807,443.305847 2470.911865,442.974945 
	C2470.911865,435.860046 2470.911865,429.413635 2470.911865,421.938629 
	C2451.359375,421.938629 2432.449707,421.938629 2411.661377,422.027344 
M1507.042725,740.978577 
	C1502.576172,744.333130 1502.401978,738.929565 1500.764771,737.505981 
	C1488.296997,726.663696 1469.711548,732.379700 1466.428711,748.554443 
	C1465.520630,753.028748 1465.524902,757.890015 1466.144775,762.432678 
	C1467.677124,773.662537 1476.752808,780.942871 1487.637207,780.336060 
	C1498.270020,779.743225 1505.798828,772.214783 1506.621460,760.930908 
	C1506.979370,756.022400 1506.681763,751.066162 1506.681763,745.122070 
	C1510.300171,745.345276 1513.400879,745.536560 1517.500244,745.789429 
	C1517.500244,757.138000 1517.500244,767.617920 1517.500244,778.409058 
	C1521.641235,778.409058 1524.722168,778.409058 1528.641846,778.409058 
	C1528.735474,762.827148 1528.977173,748.090942 1528.441772,732.592102 
	C1522.446899,732.592102 1517.816284,732.813965 1513.216309,732.533264 
	C1508.019287,732.216064 1506.978516,735.083191 1507.042725,740.978577 
M108.902863,101.629623 
	C113.867210,122.953529 123.576218,132.119339 142.788422,133.619354 
	C160.915497,135.034637 175.671036,123.865288 177.741882,106.562874 
	C174.689743,106.024986 171.602509,105.480919 168.647507,104.960152 
	C167.712051,107.123535 167.045135,108.647690 166.392563,110.177956 
	C162.074982,120.302475 154.304779,124.714355 143.448074,124.224602 
	C132.834412,123.745811 125.255714,118.391594 121.712509,108.175247 
	C117.986839,97.432800 118.071053,86.567017 121.975777,75.878632 
	C124.659668,68.532021 129.908356,63.807533 137.543182,61.677334 
	C150.863297,57.960880 159.396606,61.993500 167.860168,76.702232 
	C170.683014,76.046333 173.724014,75.339745 177.393524,74.487129 
	C174.662918,65.519043 170.045486,59.424438 162.678452,55.434319 
	C142.736420,44.633362 116.079811,55.392384 110.278885,77.240318 
	C108.362526,84.457870 109.011017,92.356415 108.902863,101.629623 
M636.845093,117.636513 
	C640.092102,124.985558 645.177246,130.111572 653.092651,132.642212 
	C660.906921,135.140549 667.238159,132.166534 673.765076,127.956245 
	C676.319031,132.507004 679.726807,133.774933 683.974731,131.494415 
	C683.974731,105.027634 683.974731,78.928017 683.974731,52.140583 
	C680.595581,52.459312 677.842957,52.718952 674.358582,53.047611 
	C674.358582,62.251545 674.358582,70.706573 674.358582,79.305962 
	C672.961426,78.984634 672.280640,79.003784 671.816956,78.695938 
	C656.812256,68.734535 640.904480,74.483833 635.928528,91.638794 
	C633.540588,99.871483 633.639526,108.029709 636.845093,117.636513 
M831.570984,77.171013 
	C821.153564,70.900215 811.521118,72.874374 802.244751,80.972412 
	C802.338196,73.185402 798.261108,73.597221 793.150024,75.047882 
	C793.150024,101.158516 793.150024,127.299835 793.150024,153.937500 
	C796.282410,153.937500 799.096680,153.937500 802.614014,153.937500 
	C802.614014,149.626495 802.614014,145.685867 802.614014,141.745239 
	C802.614014,137.528198 802.614014,133.311142 802.614014,128.146439 
	C805.078369,129.132233 806.391235,129.367828 807.344360,130.082870 
	C818.180786,138.212524 833.954590,131.079514 839.501099,120.272652 
	C846.430786,106.770790 843.721008,89.025856 831.570984,77.171013 
M592.116882,83.471008 
	C596.051453,83.296921 600.085876,82.487648 603.898987,83.086601 
	C610.914246,84.188530 612.138672,86.300407 612.582581,95.858307 
	C604.602844,97.216728 596.456116,98.414330 588.391785,100.024399 
	C578.369934,102.025276 572.058716,109.131920 572.376465,117.545822 
	C572.713989,126.482185 579.972168,132.978470 590.741577,133.585892 
	C593.665588,133.750793 596.770813,133.378296 599.567688,132.519394 
	C604.193604,131.098785 608.636719,129.082825 613.356995,127.239571 
	C615.277283,134.007706 619.840271,133.053848 623.721375,131.898254 
	C623.346619,117.799225 623.103027,104.549484 622.609009,91.309090 
	C622.193542,80.173096 617.373596,75.011528 606.219238,73.979507 
	C601.625549,73.554504 596.859314,73.519829 592.324036,74.251923 
	C583.498901,75.676498 576.883301,80.163994 574.854858,89.567528 
	C574.747498,90.065079 575.197449,90.682838 575.519043,91.631409 
	C577.947266,91.805984 580.529114,91.991608 583.110962,92.177238 
	C582.727783,91.635818 582.344543,91.094406 581.961365,90.552994 
	C584.792419,88.369133 587.623474,86.185265 592.116882,83.471008 
M2720.033691,443.352783 
	C2720.033691,457.930878 2720.033691,472.508972 2720.033691,487.043579 
	C2717.675781,487.843018 2716.090332,488.280731 2714.589600,488.917480 
	C2713.124268,489.539246 2711.745117,490.364380 2710.728760,490.892242 
	C2709.088867,497.242645 2711.508301,499.546936 2717.161865,499.499664 
	C2730.123291,499.391296 2743.086426,499.516083 2756.046875,499.363037 
	C2757.850342,499.341736 2759.641602,498.284821 2761.349609,497.735840 
	C2761.349609,490.992615 2761.349609,484.819305 2761.349609,478.178650 
	C2757.833740,478.178650 2754.951904,478.178650 2751.800781,478.178650 
	C2750.621826,480.897308 2749.494141,483.497650 2748.576904,485.612671 
	C2743.687500,485.612671 2739.544189,485.612671 2735.111084,485.612671 
	C2735.111084,467.728699 2735.111084,450.614502 2735.111084,433.730896 
	C2745.966064,430.195770 2745.966064,430.195770 2743.688965,422.503601 
	C2732.833008,422.503601 2721.990967,422.503601 2710.655762,422.503601 
	C2710.655762,425.568909 2710.655762,428.048126 2710.655762,430.940277 
	C2713.815186,431.703705 2716.589355,432.374054 2719.604980,433.102722 
	C2719.765869,436.243591 2719.899658,438.853790 2720.033691,443.352783 
M373.415985,104.482491 
	C367.537506,109.778412 366.008240,116.384155 368.927094,123.474365 
	C372.133179,131.262283 379.408203,134.013596 386.910858,133.437637 
	C393.931091,132.898712 400.777466,130.095016 408.463684,128.088806 
	C410.029266,133.471115 414.505188,133.447830 419.243042,131.742050 
	C418.776276,125.281708 418.174866,119.705322 418.017212,114.116417 
	C417.792389,106.147156 418.153412,98.156593 417.783203,90.197502 
	C417.391022,81.765923 413.731323,76.870232 406.004852,74.875397 
	C397.495056,72.678314 388.833740,72.774529 380.600189,76.292496 
	C374.125397,79.058998 370.407227,83.946968 369.931396,91.949333 
	C374.041077,91.415085 377.625702,93.908417 380.209991,89.244209 
	C384.595245,81.329529 392.122040,81.723267 399.479706,83.179649 
	C406.450256,84.559410 407.660065,86.893997 407.086090,95.871552 
	C403.054504,96.617546 398.810303,97.200432 394.671844,98.214706 
	C387.972443,99.856613 381.342468,101.781845 373.415985,104.482491 
M450.139709,772.575256 
	C457.437378,771.865723 464.735046,771.156250 472.483551,770.402893 
	C472.718353,767.875122 472.547180,765.485474 473.243500,763.383179 
	C473.976715,761.169556 475.539062,759.230652 476.739197,757.171753 
	C478.771576,758.613770 481.333008,759.671692 482.720123,761.582153 
	C485.187622,764.980713 486.944061,768.895508 488.724915,772.102661 
	C492.957733,772.102661 496.204407,772.102661 499.730103,772.102661 
	C503.274536,765.107605 508.828857,762.785583 516.243591,765.162659 
	C517.514709,767.500305 518.785889,769.837952 520.451416,772.900879 
	C523.925476,761.757324 523.254028,740.482849 518.979675,733.783752 
	C509.334473,744.854675 503.716064,758.428955 493.876678,770.560486 
	C491.072937,765.295410 488.954224,761.316772 486.871704,757.406067 
	C489.843201,751.072327 496.026642,744.928040 489.062988,738.558533 
	C483.225616,733.219055 476.012268,733.466064 467.936646,737.144348 
	C467.936646,747.928345 467.936646,758.720703 467.936646,768.914795 
	C461.505707,767.841431 456.085724,766.936829 450.073334,765.933350 
	C450.234680,763.121460 450.377808,760.627319 450.444824,759.459839 
	C453.743622,754.905396 460.427551,759.497742 461.628693,752.094971 
	C457.831940,751.355713 454.171753,750.643127 450.425995,749.913818 
	C450.425995,746.877808 450.425995,744.326233 450.425995,742.526672 
	C454.531738,738.264648 461.770782,743.957031 464.622528,736.292358 
	C458.003326,733.920349 452.087708,734.408447 445.018127,736.068237 
	C445.018127,747.066528 444.886078,757.646729 445.173431,768.215515 
	C445.212463,769.650391 447.351868,771.028137 450.139709,772.575256 
M240.747238,94.717621 
	C239.558151,87.823395 236.174576,82.258911 230.447891,78.244194 
	C213.229004,66.172859 189.838425,76.758537 187.732880,97.634399 
	C187.334702,101.582283 187.343231,105.639374 187.743393,109.587357 
	C189.197174,123.930527 199.280869,133.207428 213.612442,133.694427 
	C227.213654,134.156616 238.134552,125.740616 240.620911,112.146103 
	C241.559784,107.012596 241.034119,101.611244 240.747238,94.717621 
M851.601990,98.321709 
	C851.740601,102.971870 851.367737,107.706192 852.116333,112.255989 
	C854.142395,124.569832 863.339722,132.437836 876.334106,133.594406 
	C888.028137,134.635239 900.416077,127.841026 903.291870,117.220650 
	C905.146729,110.370270 905.762573,102.659485 904.727661,95.660484 
	C902.558167,80.987785 892.093750,73.326241 877.356079,73.585213 
	C864.987244,73.802551 853.248108,82.016830 851.601990,98.321709 
M724.684631,73.619263 
	C710.106262,74.395981 701.149475,79.503082 698.373596,90.648766 
	C696.659180,97.532494 696.184692,105.246979 697.356079,112.218407 
	C699.764954,126.553978 711.461609,134.831619 725.356812,133.621780 
	C739.871643,132.358017 749.062866,123.099358 750.253601,108.446861 
	C750.468994,105.796318 750.545898,103.115837 750.431091,100.460236 
	C749.760193,84.941933 741.954712,76.365631 724.684631,73.619263 
M356.073730,99.290382 
	C356.059265,96.959435 356.128662,94.624451 356.016449,92.298218 
	C355.413422,79.800713 348.812164,73.084389 336.245148,73.828110 
	C330.264801,74.182037 324.428986,76.979050 318.367096,78.715370 
	C316.386902,73.941681 316.386902,73.941681 309.159058,75.850388 
	C309.159058,94.347168 309.159058,112.885574 309.159058,131.945969 
	C312.335358,131.945969 315.139984,131.945969 318.673462,131.945969 
	C318.673462,126.992996 318.601929,122.386620 318.689819,117.783287 
	C318.829407,110.470741 318.539703,103.095581 319.412384,95.865288 
	C320.495178,86.894829 326.932251,81.868332 335.011902,82.541557 
	C342.530731,83.168060 345.874878,87.538544 346.010559,97.450676 
	C346.156433,108.104790 346.046509,118.762268 346.121613,129.417755 
	C346.127686,130.278503 346.701355,131.135223 347.188324,132.484268 
	C350.171753,132.284241 352.997040,132.094833 356.075989,131.888412 
	C356.075989,121.179909 356.075989,111.197380 356.073730,99.290382 
M470.059052,126.058357 
	C470.145020,127.947334 470.231018,129.836319 470.326996,131.944107 
	C473.866089,131.944107 476.720490,131.944107 479.973999,131.944107 
	C479.973999,117.806206 480.308380,104.175171 479.863098,90.569649 
	C479.535217,80.551384 473.463837,74.896858 463.478058,73.767578 
	C455.806366,72.899986 448.999725,74.818329 443.322937,80.336983 
	C440.448822,74.110115 440.448822,74.110115 433.431213,75.595131 
	C433.431213,94.396332 433.431213,113.197540 433.431213,132.658981 
	C436.924744,132.306625 439.701782,132.026550 442.673431,131.726837 
	C442.673431,125.944603 442.553284,120.963921 442.701813,115.991257 
	C442.919952,108.687180 442.748810,101.302521 443.816650,94.111542 
	C444.958313,86.423386 451.391724,82.013283 458.825562,82.523308 
	C466.133759,83.024712 469.779968,87.291283 469.986267,96.273361 
	C470.200439,105.596527 470.049957,114.928070 470.059052,126.058357 
M510.971130,122.764130 
	C501.678223,115.240868 498.948975,99.328575 505.283356,89.603111 
	C511.091278,80.685989 523.272034,80.118759 529.731445,88.518837 
	C530.907837,90.048729 531.779053,91.813248 532.807068,93.495384 
	C535.236572,93.130516 537.206116,92.905685 539.137817,92.500458 
	C539.701904,92.382126 540.158081,91.749863 540.662659,91.351776 
	C537.780273,79.783913 532.030090,74.573586 521.200134,73.716408 
	C508.847015,72.738670 499.173767,77.704079 494.921387,87.676041 
	C490.997589,96.877579 490.682495,106.437836 493.655457,115.972687 
	C497.161072,127.215851 506.776367,133.948013 518.555786,133.728363 
	C530.435120,133.506851 538.681824,126.709183 541.848694,114.440620 
	C541.969666,113.971985 541.407776,113.327087 541.016235,112.423050 
	C539.910767,112.282509 538.619568,111.985855 537.328796,111.987907 
	C535.728455,111.990448 534.128540,112.240425 532.763733,112.362480 
	C527.840698,123.769791 525.616943,124.947487 510.971130,122.764130 
M1534.873169,827.782104 
	C1545.553589,839.986084 1561.375854,839.820129 1568.845459,827.131897 
	C1574.279907,817.901001 1574.325806,808.137024 1569.297852,798.687012 
	C1565.033569,790.672424 1556.850464,787.268005 1547.329346,788.906677 
	C1539.710938,790.217834 1533.095581,796.727234 1532.008423,805.070740 
	C1531.071411,812.260742 1530.531006,819.626221 1534.873169,827.782104 
M4266.172852,552.831299 
	C4269.652344,558.479797 4273.131348,564.128357 4276.615234,569.783813 
	C4279.936523,569.783813 4283.087402,569.783813 4286.266602,569.783813 
	C4286.266602,553.578247 4286.266602,537.991211 4286.266602,522.092407 
	C4283.440430,522.092407 4280.954102,522.092407 4277.527832,522.092407 
	C4277.527832,531.917175 4277.527832,541.306458 4277.527832,550.695679 
	C4271.060059,543.270386 4266.053711,535.564819 4261.683105,527.514404 
	C4258.614258,521.862305 4254.700195,520.189819 4248.959961,522.424377 
	C4248.959961,538.448486 4248.959961,554.208679 4248.959961,570.437073 
	C4252.181641,570.212646 4254.674316,570.039001 4257.223633,569.861450 
	C4258.711426,560.307861 4256.494141,551.145142 4258.908691,541.034851 
	C4261.633301,545.377686 4263.557617,548.445618 4266.172852,552.831299 
M1528.182861,833.624268 
	C1528.182861,830.742004 1528.182861,827.859741 1528.182861,824.973633 
	C1524.356567,823.925110 1521.280518,823.082153 1516.583008,821.794861 
	C1519.743042,817.916504 1522.286377,815.051208 1524.540649,811.974304 
	C1528.993652,805.896118 1529.042725,800.126465 1524.922241,794.423767 
	C1520.869629,788.814880 1514.084595,786.791992 1507.102295,789.110718 
	C1501.122925,791.096375 1497.889038,796.001038 1497.657593,804.413513 
	C1500.492188,804.413513 1503.407349,804.877502 1506.089355,804.285828 
	C1508.892090,803.667480 1510.766968,799.076416 1515.572266,803.096313 
	C1513.520752,805.647827 1511.675171,808.227234 1509.536133,810.534668 
	C1506.594971,813.707397 1503.449097,816.692017 1500.359375,819.725220 
	C1495.758911,824.241760 1494.933228,829.343201 1498.171997,836.151672 
	C1507.711792,835.532471 1517.543457,837.683289 1528.182861,833.624268 
M4528.209961,531.270264 
	C4528.209961,544.162048 4528.209961,557.053833 4528.209961,570.635864 
	C4532.200684,570.234680 4534.972168,569.956177 4538.304688,569.621155 
	C4538.304688,562.976013 4538.304688,557.097961 4538.304688,551.428772 
	C4543.423340,549.355469 4546.724609,551.415039 4549.350098,554.698914 
	C4551.628418,557.547791 4553.802734,560.570984 4555.461914,563.804749 
	C4558.693359,570.103088 4563.267578,572.076599 4570.905273,569.157471 
	C4566.232422,562.245728 4561.848633,555.761047 4557.360352,549.122131 
	C4558.183594,548.718140 4559.030762,548.381653 4559.798340,547.913452 
	C4566.395996,543.888245 4569.032715,538.600098 4567.622070,532.288452 
	C4566.173340,525.810242 4561.730469,522.142273 4553.729004,521.800720 
	C4545.518555,521.450195 4537.281738,521.722961 4528.210449,521.722961 
	C4528.210449,524.840576 4528.210449,527.087708 4528.209961,531.270264 
M4597.308105,571.736572 
	C4607.319824,571.601074 4615.624512,568.291382 4619.762207,558.494812 
	C4623.256348,550.218994 4623.243164,541.605408 4619.699219,533.353271 
	C4615.882812,524.467163 4608.249023,520.553101 4599.065430,520.382141 
	C4590.296875,520.218872 4582.909668,523.629517 4578.542969,531.865051 
	C4569.653809,548.627258 4577.448242,566.642944 4597.308105,571.736572 
M4362.589355,541.903992 
	C4363.083984,546.830750 4362.498535,552.223999 4364.368652,556.556946 
	C4366.351562,561.150940 4369.924805,565.936035 4374.108887,568.534302 
	C4385.632324,575.689392 4400.920410,570.776489 4406.449707,559.078918 
	C4413.175781,544.850037 4407.735352,527.157410 4395.097656,522.167358 
	C4394.789062,522.045532 4394.458984,521.979309 4394.146973,521.864258 
	C4381.439453,517.173706 4364.882324,523.462158 4362.589355,541.903992 
M260.982758,132.432968 
	C266.580963,132.417953 264.971527,128.144028 265.000488,125.209381 
	C265.134033,111.664619 265.059387,98.117821 265.059387,84.412567 
	C269.216858,83.886772 272.405548,83.483505 275.618286,83.077194 
	C275.618286,80.134552 275.618286,77.617203 275.618286,74.774773 
	C271.966034,74.394051 268.771545,74.061050 264.536926,73.619629 
	C265.447906,69.595581 265.123169,64.838699 267.261444,63.085155 
	C270.216766,60.661575 275.027679,60.500744 279.292816,59.300823 
	C279.486877,58.163673 279.815460,56.873009 279.893341,55.567390 
	C279.948669,54.639843 279.665863,53.692127 279.541107,52.804199 
	C260.670044,49.503998 256.438507,53.025333 254.883972,73.487915 
	C252.181824,74.047714 249.384277,74.627274 246.521362,75.220367 
	C246.521362,77.966957 246.521362,80.263359 246.521362,82.863884 
	C249.510361,83.517097 252.317337,84.130539 255.355438,84.794487 
	C255.355438,86.849937 255.355209,88.490585 255.355469,90.131233 
	C255.357437,102.451508 255.363266,114.771782 255.358597,127.092056 
	C255.357559,129.810577 255.123718,132.670044 260.982758,132.432968 
M1461.723633,751.105530 
	C1461.851196,748.492920 1462.762573,745.606506 1461.962891,743.317993 
	C1459.339844,735.812134 1455.223999,730.994812 1444.418335,732.416138 
	C1436.163940,733.501831 1432.456543,738.295898 1432.743774,748.971680 
	C1438.326050,747.646729 1443.595093,746.396179 1451.148193,744.603516 
	C1448.508301,748.611328 1447.375610,750.888794 1445.732056,752.703735 
	C1442.832520,755.905701 1439.715210,758.928650 1436.519287,761.840271 
	C1431.177979,766.706543 1430.215454,772.283142 1433.092163,779.194031 
	C1443.154053,779.113098 1452.970459,779.755676 1463.884521,778.781067 
	C1463.157227,774.086609 1462.636475,770.725525 1462.165161,767.682739 
	C1457.824707,767.124023 1454.631104,766.712952 1450.228516,766.146240 
	C1454.294922,760.975037 1457.678711,756.671692 1461.723633,751.105530 
M190.866760,929.429382 
	C172.457428,932.747314 163.762360,957.821411 175.072479,975.492065 
	C181.194031,985.056213 190.670746,988.858948 201.692627,987.376770 
	C218.678085,985.092651 228.586014,970.256775 225.744095,952.338623 
	C223.136017,935.894836 209.812164,926.598389 190.866760,929.429382 
M1727.111938,952.353882 
	C1727.111938,963.561462 1727.111938,974.769104 1727.111938,986.378174 
	C1730.059692,986.178101 1731.906860,986.052734 1734.094971,985.904175 
	C1734.094971,982.626648 1734.094971,980.001587 1734.095093,977.376587 
	C1734.095215,972.388672 1734.012451,967.398987 1734.115967,962.413208 
	C1734.260620,955.435730 1737.350708,951.851807 1743.034912,951.838318 
	C1748.262451,951.825928 1750.132446,954.428467 1750.421143,962.432800 
	C1750.552979,966.085999 1750.450928,969.747620 1750.452515,973.405457 
	C1750.454224,977.581665 1750.452881,981.757874 1750.452881,985.937073 
	C1753.558472,985.937073 1755.424316,985.937073 1757.921997,985.937073 
	C1757.921997,977.889465 1758.364868,970.274292 1757.792114,962.736206 
	C1757.265869,955.810425 1761.563110,951.554565 1766.396118,951.795044 
	C1771.785278,952.063171 1773.889648,954.633179 1774.050659,962.274292 
	C1774.204590,969.586365 1774.115112,976.903442 1774.204102,984.217346 
	C1774.210693,984.757751 1774.794189,985.291199 1775.414062,986.346313 
	C1777.291748,986.067383 1779.389648,985.755737 1780.960205,985.522400 
	C1780.960205,975.529297 1781.816040,966.134949 1780.739014,956.967773 
	C1779.453979,946.031250 1768.875122,942.016602 1759.785278,948.218262 
	C1758.164795,949.323853 1756.836670,950.857788 1755.956787,951.661316 
	C1752.416504,949.504456 1749.321167,946.218750 1745.988770,945.957520 
	C1742.176758,945.658752 1738.153931,948.048157 1733.862427,949.381531 
	C1729.425171,945.436157 1729.425171,945.436157 1727.111938,952.353882 
M1252.741577,947.925293 
	C1250.193970,945.395752 1247.446655,945.383118 1247.321533,949.230164 
	C1246.924683,961.437256 1247.174805,973.665283 1247.174805,985.868408 
	C1249.956055,985.868408 1251.795288,985.868408 1253.863159,985.868408 
	C1253.958618,984.051941 1254.079834,982.762817 1254.085327,981.473206 
	C1254.116821,974.153198 1253.883179,966.822083 1254.219360,959.516846 
	C1254.433716,954.858154 1258.229126,951.897400 1262.951416,951.842346 
	C1267.523315,951.789062 1269.573364,953.817993 1270.227173,959.374451 
	C1270.498047,961.676941 1270.435059,964.023987 1270.444092,966.351074 
	C1270.469238,972.869263 1270.452759,979.387695 1270.452759,985.955627 
	C1273.515503,985.955627 1275.382568,985.955627 1277.921875,985.955627 
	C1277.921875,977.928101 1278.359619,970.314209 1277.795654,962.775269 
	C1277.258667,955.598389 1281.743774,951.569824 1286.367065,951.792053 
	C1291.769287,952.051697 1293.888062,954.617310 1294.050293,962.255005 
	C1294.205688,969.571716 1294.114868,976.893555 1294.203491,984.212280 
	C1294.209961,984.753540 1294.792114,985.287842 1295.410767,986.345276 
	C1297.289795,986.066711 1299.388672,985.755554 1301.492065,985.443726 
	C1301.492065,976.841370 1301.516235,968.857544 1301.467896,960.874084 
	C1301.459961,959.556152 1301.209839,958.224915 1300.944580,956.925659 
	C1298.733887,946.093933 1288.841309,942.011841 1279.754028,948.238281 
	C1278.134155,949.348267 1276.800415,950.875854 1275.334961,952.210266 
	C1267.547607,943.712952 1266.261719,943.556030 1256.050903,949.408325 
	C1255.467041,949.743042 1254.417480,949.265686 1252.741577,947.925293 
M4512.815918,567.967834 
	C4517.337402,564.661255 4518.236816,559.817627 4518.310547,554.702148 
	C4518.455566,544.735840 4518.522461,534.768127 4518.552734,524.800781 
	C4518.555176,523.882385 4518.065430,522.962585 4517.636719,521.452454 
	C4514.799805,521.763184 4512.040527,522.065430 4509.192383,522.377380 
	C4509.192383,526.903381 4509.261230,530.548828 4509.177734,534.190735 
	C4509.010254,541.488953 4508.874512,548.791016 4508.502930,556.080261 
	C4508.259277,560.852966 4505.175293,563.079895 4500.685059,563.528931 
	C4495.970703,564.000305 4491.759766,561.506958 4490.584473,557.242004 
	C4489.979004,555.046997 4490.001953,552.640381 4489.986816,550.327881 
	C4489.926270,541.081848 4489.961426,531.835144 4489.961426,522.424561 
	C4486.342285,522.424561 4483.325684,522.424561 4480.284180,522.424561 
	C4480.284180,533.211975 4480.025879,543.185120 4480.341309,553.140076 
	C4480.876953,570.034729 4492.302246,572.533081 4503.973145,571.295349 
	C4506.534180,571.023743 4508.979492,569.661255 4512.815918,567.967834 
M4470.950195,526.594421 
	C4471.055176,524.187134 4471.170410,521.661621 4467.759277,521.643188 
	C4457.193848,521.586243 4446.627930,521.622375 4436.187500,521.622375 
	C4436.187500,538.389282 4436.187500,554.164978 4436.187500,569.835815 
	C4448.416016,569.835815 4459.952148,569.835815 4471.925781,569.835815 
	C4471.711914,567.103271 4471.545410,564.973938 4471.299316,561.831909 
	C4462.179199,561.831909 4453.742188,561.831909 4445.668945,561.831909 
	C4445.668945,556.888977 4445.668945,553.034363 4445.668945,548.168396 
	C4453.791504,548.168396 4461.295410,548.168396 4469.379395,548.168396 
	C4468.922852,544.932739 4468.622070,542.802368 4468.199707,539.807129 
	C4460.232422,539.807129 4452.748047,539.807129 4444.894531,539.807129 
	C4445.100098,535.990967 4445.253418,533.146729 4445.436523,529.742371 
	C4449.838867,529.742371 4453.467773,529.932434 4457.067871,529.694336 
	C4461.564453,529.396973 4466.036621,528.746948 4470.950195,526.594421 
M4237.857910,538.997925 
	C4237.857910,533.421143 4237.857910,527.844299 4237.857910,521.583069 
	C4234.045898,521.822998 4231.284180,521.996765 4228.043457,522.200745 
	C4228.043457,526.585632 4228.069824,530.205994 4228.037598,533.825806 
	C4227.971680,541.146973 4227.982910,548.471436 4227.746582,555.787537 
	C4227.610840,559.983276 4225.094727,563.120728 4221.061035,563.138428 
	C4217.750000,563.152893 4213.577148,562.114685 4211.368652,559.937744 
	C4209.395020,557.992126 4209.043945,553.872009 4208.923828,550.675720 
	C4208.598633,542.032471 4208.803711,533.369995 4208.713867,524.716003 
	C4208.705078,523.842163 4208.124023,522.974243 4207.646973,521.657593 
	C4204.997070,521.791260 4202.457520,521.919312 4199.849609,522.050842 
	C4199.849609,533.840027 4199.465820,545.140686 4199.973633,556.401062 
	C4200.367676,565.144897 4203.846680,568.966492 4212.523438,570.590576 
	C4216.923340,571.414124 4221.723145,571.124817 4226.180176,570.375488 
	C4232.375977,569.333862 4236.203125,565.228638 4236.807617,558.823853 
	C4237.369141,552.879272 4237.523438,546.896301 4237.857910,538.997925 
M4764.371094,526.683228 
	C4762.609375,519.176270 4757.115234,521.960266 4752.183594,521.887207 
	C4746.050293,537.939148 4740.041016,553.666504 4733.786621,570.034607 
	C4737.649414,570.034607 4740.547852,570.034607 4743.573242,570.034607 
	C4745.117188,566.600586 4746.594238,563.315552 4748.014160,560.158203 
	C4754.675781,560.158203 4760.937988,560.158203 4767.084961,560.158203 
	C4768.549805,563.573425 4769.846680,566.597656 4771.446289,570.327209 
	C4774.387695,570.186523 4777.436035,570.040710 4781.424316,569.849976 
	C4775.634277,555.159729 4770.293457,541.608521 4764.371094,526.683228 
M4709.813477,522.901978 
	C4698.132812,520.076965 4686.458496,522.050049 4674.623047,521.810547 
	C4674.623047,538.432007 4674.623047,553.910034 4674.623047,569.842285 
	C4686.775391,569.842285 4698.499512,569.842285 4710.794434,569.842285 
	C4710.536133,567.061401 4710.335938,564.906494 4710.048340,561.808228 
	C4701.114258,561.808228 4692.662109,561.808228 4683.906738,561.808228 
	C4684.120117,556.922485 4684.289062,553.057373 4684.497559,548.289917 
	C4692.631348,548.289917 4700.131836,548.289917 4708.071289,548.289917 
	C4707.895996,545.168945 4707.776855,543.047180 4707.605957,539.993896 
	C4699.445312,539.993896 4691.958008,539.993896 4684.528809,539.993896 
	C4684.528809,536.189270 4684.528809,533.364929 4684.528809,529.751465 
	C4691.560059,529.751465 4698.142578,529.637695 4704.717773,529.796265 
	C4708.378418,529.884521 4710.496582,528.800720 4709.813477,522.901978 
M1025.766113,1001.560486 
	C1030.601196,1000.753296 1035.692017,1000.636658 1040.207275,998.965271 
	C1045.933838,996.845337 1048.749878,991.328430 1047.999756,986.404114 
	C1047.303467,981.833252 1043.867798,979.192383 1036.851318,978.388733 
	C1032.912109,977.937500 1028.881104,978.281250 1024.944580,977.816345 
	C1022.140259,977.485291 1020.937988,975.697815 1022.901917,972.335571 
	C1025.546143,972.335571 1028.520874,972.594543 1031.434692,972.283203 
	C1038.049927,971.576355 1043.403076,967.284729 1043.649780,961.222351 
	C1043.849609,956.317688 1044.360596,952.131958 1050.552856,948.666992 
	C1042.086060,947.425171 1035.714844,946.178223 1029.284302,945.642151 
	C1023.697937,945.176453 1018.714600,947.045715 1015.721069,952.209900 
	C1012.770874,957.299561 1013.238586,962.341309 1016.588257,967.145508 
	C1017.314331,968.186707 1018.005066,969.252563 1018.868042,970.539612 
	C1014.299927,974.385620 1014.719666,978.736755 1017.215332,983.071045 
	C1009.902954,990.752014 1010.608093,995.877930 1019.384277,999.880188 
	C1020.870728,1000.558044 1022.578613,1000.750244 1025.766113,1001.560486 
M2097.780518,984.983643 
	C2097.780518,972.741516 2097.780518,960.499329 2097.780518,947.344849 
	C2089.563477,947.344849 2082.057373,947.344849 2074.359863,947.344849 
	C2072.706299,933.657654 2083.893799,935.856628 2090.730225,933.249817 
	C2089.710205,927.306030 2085.723145,927.986206 2082.256836,928.427917 
	C2071.598633,929.786072 2066.776611,936.568481 2066.225586,946.512878 
	C2063.928467,947.509277 2062.051758,948.323425 2059.720215,949.334900 
	C2066.623291,954.137451 2066.636963,954.137390 2066.656738,962.407532 
	C2066.675293,970.261658 2066.660889,978.115967 2066.660889,986.371765 
	C2069.806885,986.175415 2071.660400,986.059692 2074.319092,985.893799 
	C2074.319092,974.468811 2074.319092,963.658691 2074.319092,953.023560 
	C2080.018066,953.023560 2084.862305,953.023560 2090.325195,953.023560 
	C2090.325195,964.121887 2090.325195,974.691345 2090.325195,986.101868 
	C2092.847168,986.101868 2094.722656,986.101868 2097.780518,984.983643 
M865.880066,952.869141 
	C868.661316,937.810913 861.096619,931.956238 853.421631,930.424011 
	C845.377136,928.818054 837.127747,928.818115 829.115479,930.346741 
	C829.115479,949.215149 829.115479,967.417358 829.115479,985.830078 
	C831.672180,985.830078 833.770996,985.830078 836.456665,985.830078 
	C836.456665,978.999512 836.456665,972.764038 836.456665,966.315247 
	C847.717041,965.266602 859.601807,966.789368 865.880066,952.869141 
M492.662140,981.386353 
	C492.238953,987.277710 495.667053,986.946716 500.554871,985.581787 
	C500.554871,979.268982 500.554871,972.798523 500.554871,966.653503 
	C507.030792,965.761902 512.737183,965.561523 518.102173,964.104248 
	C526.737122,961.758789 530.864197,955.132812 530.401917,946.003662 
	C529.973999,937.552002 525.203186,931.315735 516.569580,930.287964 
	C508.839478,929.367676 500.913269,930.094360 492.661163,930.094360 
	C492.661163,947.132080 492.661163,963.409302 492.662140,981.386353 
M4506.077148,712.912109 
	C4507.538086,716.225403 4508.518555,719.875061 4510.555664,722.784973 
	C4515.509766,729.861206 4522.863281,731.460266 4530.910645,729.994568 
	C4538.481934,728.615540 4542.995117,723.908752 4544.885742,715.758667 
	C4542.123047,714.764771 4539.782227,713.922424 4537.279297,713.021912 
	C4536.020508,715.078918 4535.187500,716.899353 4533.949707,718.381226 
	C4528.831055,724.508179 4519.989258,723.533386 4516.926270,716.227966 
	C4514.143066,709.589722 4513.984863,702.517517 4516.862305,695.841003 
	C4519.771973,689.088562 4527.945801,687.585388 4533.476562,692.524536 
	C4534.911621,693.806091 4535.918945,695.566833 4537.280273,697.309326 
	C4539.855469,696.494934 4542.236328,695.742188 4544.813477,694.927246 
	C4542.426758,686.067261 4536.718262,682.307068 4528.730957,681.647278 
	C4520.004883,680.926453 4513.123047,684.167480 4508.763672,691.981873 
	C4505.367676,698.068909 4505.345703,704.696594 4506.077148,712.912109 
M4432.592773,696.424133 
	C4422.544922,692.902344 4416.302734,695.646423 4413.211426,704.945496 
	C4409.850098,715.056946 4413.972656,726.966858 4421.890625,729.707642 
	C4423.414062,730.234985 4425.684082,730.944885 4426.687500,730.246155 
	C4432.002930,726.545776 4437.408691,729.737671 4442.728027,729.483276 
	C4443.208008,729.460327 4443.652344,728.699402 4444.043945,728.344360 
	C4444.043945,713.144104 4444.043945,698.012756 4444.043945,682.271545 
	C4441.099121,682.527832 4438.671875,682.739075 4437.061035,682.879272 
	C4435.899902,688.243958 4434.937988,692.690063 4432.592773,696.424133 
M4347.835449,712.863647 
	C4347.835449,702.965698 4347.835449,693.067688 4347.835449,682.715515 
	C4344.525879,682.715515 4342.081543,682.715515 4339.226074,682.715515 
	C4338.843750,687.641541 4338.497070,692.113586 4338.120117,696.975037 
	C4336.284668,696.384460 4334.977051,696.127075 4333.818848,695.563171 
	C4328.118164,692.787964 4323.196777,694.639099 4319.506836,698.899841 
	C4313.669434,705.641296 4314.276855,713.749146 4316.869141,721.514465 
	C4318.504395,726.413574 4322.250977,729.957031 4327.876465,730.291260 
	C4329.792480,730.404968 4332.013672,730.191650 4333.639160,729.297729 
	C4336.495605,727.726318 4338.726562,727.330933 4341.620117,729.433716 
	C4342.784180,730.279541 4345.242188,729.344971 4347.834961,729.172546 
	C4347.834961,723.978638 4347.834961,719.391907 4347.835449,712.863647 
M4629.509766,552.954895 
	C4629.509766,558.528076 4629.509766,564.101257 4629.509766,570.428101 
	C4633.169922,570.139648 4635.868652,569.926941 4639.301270,569.656433 
	C4639.301270,563.659302 4639.301270,558.467041 4639.301270,552.913269 
	C4644.980957,552.522461 4649.959961,552.572388 4654.791504,551.754395 
	C4661.840332,550.561035 4665.844238,545.140808 4666.082031,537.493713 
	C4666.327637,529.622070 4662.748535,523.549744 4656.042969,522.348816 
	C4647.309570,520.784973 4638.470703,521.615601 4629.509766,521.739807 
	C4629.509766,532.375610 4629.509766,541.670288 4629.509766,552.954895 
M257.551392,945.879517 
	C252.247635,946.801025 246.943878,947.722534 240.676865,948.811401 
	C240.676865,942.340210 240.676865,935.519409 240.676865,928.278564 
	C238.047836,928.416504 236.470825,928.499207 234.963760,928.578308 
	C232.994003,941.874023 233.471191,984.908630 236.431946,986.526733 
	C238.022308,985.567017 240.041336,984.348633 242.129639,983.088440 
	C251.755630,987.848755 258.193665,987.430969 263.786652,981.601868 
	C273.234528,971.755310 270.777679,953.674683 257.551392,945.879517 
M1336.357178,985.434021 
	C1345.587891,980.995605 1347.681885,972.688049 1347.348999,963.666321 
	C1346.745361,947.309937 1336.132935,941.605225 1321.636230,949.409241 
	C1321.165405,949.662720 1320.389526,949.349731 1318.769287,949.224670 
	C1318.769287,942.451111 1318.769287,935.605591 1318.769287,928.540955 
	C1316.181274,928.540955 1314.580688,928.540955 1312.698975,928.540955 
	C1312.698975,947.875244 1312.698975,966.944092 1312.698975,987.469666 
	C1315.898193,985.617188 1317.930054,984.440613 1318.364380,984.189148 
	C1324.833130,984.865295 1329.906738,985.395691 1336.357178,985.434021 
M2365.230225,970.084900 
	C2368.286621,988.798340 2378.860596,989.777954 2393.134766,981.550598 
	C2394.252197,984.806885 2395.386475,987.586426 2399.642090,985.514832 
	C2399.642090,966.773438 2399.642090,947.886658 2399.642090,928.499878 
	C2397.406738,928.614136 2395.621094,928.705444 2392.986328,928.840088 
	C2392.986328,935.548706 2392.986328,941.721008 2392.986328,948.638245 
	C2390.764893,947.805786 2389.598389,947.309021 2388.395752,946.927429 
	C2376.856689,943.266785 2367.797852,948.632263 2365.607422,960.562073 
	C2365.131348,963.154236 2365.254883,965.856445 2365.230225,970.084900 
M719.370850,954.199402 
	C712.292114,941.815552 703.011047,944.320312 694.195129,950.223328 
	C691.549561,948.486755 689.542542,947.169373 686.415283,945.116699 
	C686.415283,964.616272 686.415283,982.126038 686.415283,1000.362610 
	C688.969666,999.989624 691.008484,999.691895 693.569580,999.317871 
	C693.569580,993.821167 693.569580,988.952881 693.569580,983.766418 
	C695.167847,984.160034 696.118896,984.316895 697.016968,984.627136 
	C709.406860,988.907410 718.323486,984.217468 720.510986,971.404358 
	C721.375610,966.340271 720.176758,960.923950 719.370850,954.199402 
M1611.999390,995.550232 
	C1611.624512,1001.769043 1614.999878,1000.707336 1619.086548,999.435913 
	C1619.086548,996.707703 1619.037720,994.408142 1619.099487,992.111572 
	C1619.170166,989.488342 1619.339111,986.867737 1619.497192,983.586060 
	C1622.111206,984.520874 1624.143799,985.489929 1626.286011,985.971130 
	C1634.709473,987.863281 1642.678955,983.854980 1645.471558,975.685974 
	C1646.832153,971.706177 1647.497192,967.173950 1647.179199,962.990417 
	C1645.919067,946.413330 1635.372437,941.246277 1621.166870,949.873657 
	C1620.638306,950.194641 1619.908813,950.184509 1619.995728,950.164795 
	C1617.584229,948.535034 1615.574707,947.177063 1611.998779,944.760437 
	C1611.998779,962.628662 1611.998779,978.227783 1611.999390,995.550232 
M1554.155884,751.261475 
	C1555.730225,745.449768 1557.304565,739.638062 1559.239746,732.494202 
	C1554.461914,733.457703 1549.411133,730.430115 1546.804199,735.248596 
	C1542.127808,743.892456 1538.413330,753.056824 1533.638428,763.434753 
	C1542.186768,763.966370 1548.941772,764.386475 1556.086060,764.830811 
	C1556.604248,769.577759 1557.059937,773.751587 1557.581543,778.529907 
	C1561.045654,778.529907 1564.044434,778.529907 1567.227905,778.529907 
	C1567.227905,769.506348 1567.227905,761.361023 1567.227905,752.684326 
	C1562.927002,752.403076 1559.337158,752.168274 1554.155884,751.261475 
M851.616760,799.771973 
	C851.485352,809.752563 851.231384,819.734558 851.351074,829.712158 
	C851.369629,831.259033 853.098267,832.785461 854.036133,834.321350 
	C855.335022,832.786316 857.537109,831.371521 857.760559,829.693359 
	C858.387756,824.982483 858.199280,820.162903 858.332458,815.386230 
	C859.127686,815.190125 859.922913,814.994019 860.718079,814.797974 
	C864.122681,820.271118 867.339905,825.876282 871.045105,831.137756 
	C872.168823,832.733582 874.641479,833.379395 876.496277,834.460388 
	C877.541199,832.587830 879.436401,830.737976 879.487183,828.838806 
	C879.736389,819.531494 879.642273,810.205627 879.302185,800.899719 
	C879.233826,799.028809 877.572144,797.216064 876.645081,795.376526 
	C875.860413,795.440979 875.075684,795.505432 874.291016,795.569885 
	C873.355896,801.889221 872.420715,808.208557 871.144287,816.834351 
	C866.628113,809.624756 863.491760,804.612732 860.349915,799.604126 
	C858.044006,795.928101 855.495605,793.854797 851.616760,799.771973 
M4208.423340,718.217773 
	C4208.550293,715.634949 4208.677734,713.052185 4208.842773,709.698608 
	C4215.072266,709.698608 4220.951172,709.698608 4227.056152,709.698608 
	C4227.056152,706.873962 4227.056152,704.845642 4227.056152,701.999634 
	C4220.512207,701.999634 4214.643066,701.999634 4208.842773,701.999634 
	C4208.842773,697.631531 4208.842773,694.099060 4208.842773,689.720947 
	C4216.049805,689.720947 4222.875000,689.720947 4230.332520,689.720947 
	C4230.084473,686.702881 4229.910645,684.596802 4229.772949,682.919128 
	C4219.350586,682.919128 4209.601562,682.919128 4199.711426,682.919128 
	C4199.711426,698.741577 4199.711426,713.885376 4199.711426,729.316284 
	C4202.702148,729.316284 4205.229980,729.316284 4208.422852,729.316284 
	C4208.422852,725.954956 4208.422852,723.012207 4208.423340,718.217773 
M270.704315,805.453308 
	C270.449738,808.242554 270.195160,811.031799 269.829468,815.038635 
	C262.142059,809.367065 262.039246,798.367798 252.970230,795.686584 
	C251.980881,796.807251 251.185196,797.285522 251.168671,797.789307 
	C250.800797,808.997375 250.434555,820.207764 250.367676,831.419495 
	C250.361816,832.403687 252.418640,834.164978 253.528442,834.173767 
	C254.615585,834.182373 256.535492,832.512878 256.671417,831.405701 
	C257.289795,826.368713 257.407837,821.270325 257.705841,816.193970 
	C261.416199,818.329346 263.196228,820.900879 264.863342,823.543701 
	C266.630798,826.345642 268.021942,829.437866 270.110657,831.962036 
	C271.168793,833.240784 273.704529,834.466003 275.018005,834.033325 
	C276.315155,833.605957 277.658936,831.074707 277.695496,829.437622 
	C277.902863,820.161255 277.892273,810.870056 277.549194,801.598938 
	C277.470734,799.478760 275.792297,797.417786 274.850220,795.329529 
	C274.014984,795.452515 273.179718,795.575439 272.344452,795.698425 
	C271.827972,798.422363 271.311523,801.146240 270.704315,805.453308 
M358.669067,985.342651 
	C359.087982,983.961121 359.506866,982.579529 360.207367,980.269226 
	C357.626373,980.705688 356.091278,980.950928 354.561707,981.226807 
	C350.712494,981.921143 348.686401,979.839600 348.574707,976.415771 
	C348.319397,968.587463 348.494049,960.745239 348.494049,952.944702 
	C356.053772,952.944702 362.253204,952.944702 369.479858,952.944702 
	C369.479858,964.260681 369.479858,975.053528 369.479858,986.052307 
	C372.105988,986.052307 373.695526,986.052307 375.611511,986.052307 
	C375.611511,973.299622 375.611511,960.823486 375.611511,947.239258 
	C366.340271,947.239258 357.562805,947.239258 349.554565,947.239258 
	C347.000427,942.221741 350.563843,937.009521 344.695618,932.138306 
	C343.296600,937.993896 342.202026,942.575378 341.188568,946.817139 
	C339.083221,947.813782 337.199371,948.705505 333.823669,950.303528 
	C337.302185,951.872559 339.209869,952.733032 341.595215,953.809021 
	C341.595215,960.564880 341.492249,967.537109 341.618256,974.505188 
	C341.830078,986.217590 345.830017,989.132874 358.669067,985.342651 
M1007.677002,829.285339 
	C1009.908508,830.688110 1011.974609,832.567200 1014.400635,833.410156 
	C1024.195435,836.813232 1035.000122,830.964294 1038.142334,820.837280 
	C1041.258301,810.794678 1035.663452,799.863098 1025.849976,796.819946 
	C1015.504456,793.611694 1005.334656,799.105042 1002.427490,809.709045 
	C1000.550964,816.553650 1001.517151,822.926880 1007.677002,829.285339 
M927.820129,107.222046 
	C928.091553,102.251717 927.781250,97.162895 928.763977,92.337418 
	C930.453247,84.042961 934.609192,81.889877 943.263916,83.716545 
	C944.160828,83.905861 945.132263,83.741959 946.518188,83.741959 
	C947.236023,81.187637 947.907898,78.797119 948.641113,76.188248 
	C940.664307,71.985390 934.129761,73.075600 928.434021,79.010231 
	C924.773132,74.389847 924.773132,74.389847 918.387817,75.572899 
	C918.387817,94.391869 918.387817,113.210838 918.387817,132.622589 
	C921.804871,132.288193 924.593323,132.015305 927.819275,131.699600 
	C927.819275,123.706078 927.819275,116.427628 927.820129,107.222046 
M4646.933105,729.873962 
	C4648.410156,729.140442 4650.097168,728.658936 4651.329590,727.631897 
	C4658.704590,721.485474 4657.491699,713.417847 4648.632324,709.923706 
	C4645.881348,708.838684 4642.839844,708.506714 4640.047363,707.505188 
	C4638.149414,706.824402 4636.454590,705.578003 4633.559570,703.967346 
	C4638.668457,701.209656 4642.154785,701.046387 4645.693359,703.725159 
	C4648.902344,706.154602 4651.588379,704.952026 4654.321289,702.838318 
	C4648.444336,693.874878 4637.896973,691.518127 4630.317871,697.103271 
	C4624.979980,701.036926 4624.572754,708.511902 4629.834473,712.384705 
	C4632.155762,714.093018 4635.165039,714.927979 4637.943848,715.934570 
	C4640.855957,716.989441 4643.865234,717.774780 4647.680664,718.936218 
	C4643.525391,724.917603 4639.384766,724.624329 4635.916992,721.439697 
	C4632.209473,718.034607 4629.209473,718.483643 4625.450195,720.938049 
	C4629.416504,730.550354 4637.125000,730.997314 4646.933105,729.873962 
M910.062073,946.882812 
	C900.735657,951.149963 898.411804,959.103699 899.037354,968.384277 
	C899.770081,979.255737 906.417725,985.912292 916.654663,986.422974 
	C926.968262,986.937439 934.314331,981.478394 936.288696,971.832397 
	C938.675659,960.170532 934.380066,949.651245 925.174133,946.879333 
	C920.920837,945.598694 916.030396,946.434143 910.062073,946.882812 
M454.510437,948.320801 
	C436.505402,940.997314 423.003326,950.598450 425.097839,969.235718 
	C426.342194,980.308350 433.547363,986.696533 444.510315,986.447021 
	C454.944336,986.209595 461.689819,979.807007 462.650330,968.999817 
	C463.326172,961.395630 462.167725,954.336243 454.510437,948.320801 
M2720.995605,963.667908 
	C2721.220215,966.644104 2721.155518,969.677551 2721.731689,972.584167 
	C2722.829102,978.122864 2726.017334,982.206848 2731.203369,984.659973 
	C2738.031738,987.889893 2747.461914,986.740601 2752.798584,981.975647 
	C2758.552246,976.838379 2760.674805,965.161621 2757.371338,956.819824 
	C2754.537354,949.663696 2748.392822,945.641785 2740.161865,945.555664 
	C2729.723633,945.446472 2724.223389,950.245972 2720.995605,963.667908 
M2424.210693,986.201721 
	C2426.205322,986.257874 2428.224609,986.543030 2430.190430,986.330994 
	C2439.134521,985.366272 2444.799072,980.039001 2446.389160,971.296936 
	C2448.305908,960.761169 2444.914062,951.856689 2437.429443,947.772766 
	C2427.733154,942.481934 2415.349854,946.192566 2410.874023,955.730103 
	C2405.198975,967.822632 2410.141357,980.392700 2424.210693,986.201721 
M1696.307007,945.794006 
	C1682.160400,950.388245 1676.375488,964.812134 1683.589600,977.518311 
	C1687.738892,984.826355 1694.371826,987.017456 1702.248291,986.339722 
	C1710.010742,985.671692 1715.298340,981.499573 1717.740234,974.160767 
	C1722.983032,958.404297 1714.459229,946.340393 1696.307007,945.794006 
M892.497681,799.019287 
	C890.502686,801.219666 888.112793,803.178223 886.588867,805.666992 
	C882.455078,812.418091 883.190796,821.012268 888.005981,827.142151 
	C893.156555,833.698975 900.710449,835.983154 908.418762,833.314514 
	C915.954163,830.705750 920.731934,824.199951 921.222412,816.044678 
	C922.138977,800.804810 906.030334,791.293518 892.497681,799.019287 
M4474.466309,715.787964 
	C4476.730957,715.582153 4478.995117,715.376343 4481.228027,715.173462 
	C4480.972656,701.766846 4476.378906,695.138306 4467.058105,694.294189 
	C4459.370117,693.598022 4453.050293,698.980286 4451.168457,707.827393 
	C4449.032715,717.867981 4452.965820,726.972656 4460.596680,729.650757 
	C4468.938965,732.578613 4475.922363,729.522644 4479.863770,720.988586 
	C4476.331055,719.322998 4473.515137,719.878967 4470.041992,721.981934 
	C4464.737793,725.193298 4462.298340,723.409241 4460.680176,715.788574 
	C4464.753418,715.788574 4468.714355,715.788574 4474.466309,715.787964 
M4611.584473,720.976379 
	C4604.082031,724.551697 4603.743652,724.430847 4599.647949,715.649841 
	C4607.256836,715.649841 4614.317871,715.649841 4621.394531,715.649841 
	C4620.608398,701.219910 4615.949707,694.811646 4606.684082,694.241699 
	C4598.728516,693.752319 4592.384766,699.756653 4590.894043,709.188110 
	C4589.274414,719.428772 4593.818359,727.979309 4601.947754,729.991150 
	C4610.758301,732.171570 4616.695312,729.111572 4619.772461,720.470093 
	C4617.415527,720.267944 4615.166504,720.075073 4611.584473,720.976379 
M1789.923096,966.841125 
	C1791.275269,978.380127 1795.567261,984.186951 1804.098877,986.020264 
	C1812.454712,987.815857 1820.217285,985.058899 1824.454346,978.790833 
	C1829.238647,971.713074 1829.225586,960.395142 1824.424927,953.247498 
	C1820.187134,946.937988 1812.497681,944.192444 1804.099365,945.990173 
	C1795.588989,947.811951 1791.302368,953.612549 1789.923096,966.841125 
M4683.308594,695.310852 
	C4671.484375,693.240173 4668.247070,694.534363 4663.587891,703.596069 
	C4664.804199,704.046326 4666.019043,704.939209 4667.093750,704.794006 
	C4668.878418,704.552917 4670.532227,703.312073 4672.314453,703.094604 
	C4675.084961,702.756470 4677.955078,702.665771 4680.694824,703.068054 
	C4681.333984,703.161926 4681.621094,705.657715 4682.202148,707.457458 
	C4677.070801,708.899841 4672.463379,709.730652 4668.239746,711.484619 
	C4660.815430,714.567505 4659.303223,724.268860 4665.851074,728.078369 
	C4668.903809,729.854248 4673.620117,730.262573 4677.103516,729.386963 
	C4680.598145,728.508850 4683.367188,726.979370 4686.768555,729.526855 
	C4687.754883,730.265503 4689.762695,729.640076 4690.783203,729.640076 
	C4690.783203,721.270020 4690.823242,713.698364 4690.768066,706.127441 
	C4690.735352,701.599365 4689.945312,697.418274 4683.308594,695.310852 
M1173.351440,982.321472 
	C1180.730225,974.872681 1181.695190,966.106201 1178.168335,956.713928 
	C1175.274048,949.005981 1169.187500,945.628723 1161.126099,945.557190 
	C1153.095947,945.485901 1147.089111,948.754272 1143.716309,956.255859 
	C1140.029541,964.456238 1141.678589,975.605225 1147.393799,981.340576 
	C1153.393311,987.361389 1161.827026,988.010132 1173.351440,982.321472 
M1332.988281,798.015930 
	C1331.098999,797.406128 1329.249756,796.496155 1327.313599,796.238525 
	C1318.871094,795.114990 1311.345947,799.463989 1308.011597,807.182556 
	C1304.267700,815.849182 1306.434082,824.848572 1313.624634,830.500183 
	C1320.027710,835.532776 1328.865601,835.544434 1335.862793,830.529419 
	C1343.168091,825.293579 1345.995605,816.815552 1342.218506,808.523438 
	C1340.521484,804.797913 1336.996338,801.905090 1332.988281,798.015930 
M2634.357910,981.032104 
	C2625.071533,981.078674 2622.919434,979.320190 2622.672852,970.640686 
	C2622.448242,962.731628 2622.625244,954.811218 2622.625244,946.904480 
	C2619.903564,946.904480 2618.125000,946.904480 2615.763672,946.904480 
	C2615.763672,955.123779 2615.808350,962.753906 2615.749756,970.383240 
	C2615.701904,976.601196 2616.370117,982.518311 2622.556152,985.902222 
	C2629.050537,989.454651 2634.735352,987.251892 2640.082520,983.109863 
	C2640.483643,982.799011 2641.211182,982.909058 2640.330322,983.040100 
	C2643.424561,984.619202 2645.449219,985.652588 2648.399902,987.158508 
	C2648.399902,972.841125 2648.399902,959.973511 2648.399902,946.793213 
	C2646.271729,946.793213 2644.469727,946.793213 2641.951172,946.793213 
	C2641.951172,954.877197 2641.705566,962.509521 2642.038574,970.116455 
	C2642.255127,975.067810 2640.865723,978.560181 2634.357910,981.032104 
M1975.635742,951.902405 
	C1984.964355,952.980469 1985.531982,953.703491 1984.794678,963.692505 
	C1982.227905,964.180298 1979.619385,964.616821 1977.039307,965.182678 
	C1974.450073,965.750427 1971.772827,966.158752 1969.338013,967.142029 
	C1962.306030,969.981750 1959.585693,975.342957 1961.897339,981.225891 
	C1963.844971,986.183105 1970.292114,989.386902 1976.145752,987.006348 
	C1981.435913,984.855042 1986.317505,983.674072 1992.542603,987.250732 
	C1992.542603,977.568726 1992.517334,969.314636 1992.550659,961.060791 
	C1992.576904,954.578308 1990.738647,948.897095 1984.213989,946.526672 
	C1977.493042,944.084778 1971.035645,945.650818 1965.414185,950.040222 
	C1962.988281,951.934509 1963.226318,953.912598 1966.378662,955.700867 
	C1968.785889,954.582581 1971.426636,953.355713 1975.635742,951.902405 
M2307.447510,983.789185 
	C2311.381836,987.556091 2316.035645,989.199768 2321.045166,986.736877 
	C2325.931641,984.334534 2330.620850,984.086914 2336.278564,987.158386 
	C2336.278564,976.378052 2336.497070,966.866699 2336.194336,957.371948 
	C2336.020264,951.913574 2332.789307,948.110291 2327.645752,946.259583 
	C2320.757568,943.781250 2313.289062,946.387451 2307.770508,952.965088 
	C2311.127197,955.166321 2311.127197,955.166260 2314.858643,953.568359 
	C2324.983643,949.232422 2329.362549,952.284485 2329.005859,963.640747 
	C2324.523682,964.490417 2319.899658,965.014954 2315.486572,966.277405 
	C2306.518799,968.842773 2304.489258,972.826538 2307.447510,983.789185 
M1228.207153,955.015625 
	C1228.825073,957.749939 1229.442993,960.484314 1230.052490,963.181519 
	C1223.877808,964.595459 1218.567871,965.328735 1213.607056,967.061462 
	C1206.359009,969.593018 1203.671631,974.945374 1205.823975,980.945190 
	C1207.761108,986.345459 1214.273560,989.285950 1220.822632,986.788879 
	C1225.795532,984.892700 1230.427368,983.692871 1236.527832,987.538208 
	C1236.527832,977.450378 1236.557861,968.907288 1236.517944,960.364502 
	C1236.487427,953.816345 1234.218506,948.358582 1227.564087,946.302734 
	C1220.750244,944.197632 1214.252319,945.778015 1208.938110,950.522888 
	C1206.585083,952.623779 1207.749756,954.676819 1210.918823,955.682007 
	C1215.962402,953.064880 1221.123413,949.246948 1228.207153,955.015625 
M727.350464,975.644165 
	C728.695618,985.684509 733.904480,990.129333 742.329407,986.860107 
	C747.712463,984.771179 752.529846,984.339783 758.513062,986.886658 
	C758.513062,977.177673 758.538635,968.617371 758.504456,960.057312 
	C758.479980,953.921570 756.192688,949.024353 750.316284,946.477356 
	C744.792969,944.083496 734.724609,946.138123 730.906189,950.638672 
	C730.106750,951.580994 730.789978,953.781189 730.789978,955.779968 
	C747.562866,949.302917 750.510437,950.438904 751.615173,963.456482 
	C747.482422,964.248718 743.258118,964.888794 739.122986,965.895203 
	C734.214294,967.089844 729.559570,968.841919 727.350464,975.644165 
M4551.994141,718.894653 
	C4552.880371,720.669617 4553.486328,722.669922 4554.701172,724.180847 
	C4560.104004,730.902344 4569.993164,732.476257 4577.164062,727.941833 
	C4584.889160,723.057251 4587.512207,711.670715 4582.878906,703.133301 
	C4578.627930,695.300537 4569.937012,692.313477 4561.507812,695.788391 
	C4553.657227,699.024780 4550.881348,705.160278 4551.994141,718.894653 
M4365.605957,729.423096 
	C4368.559082,729.706970 4371.555176,730.451477 4374.457520,730.182983 
	C4381.477051,729.533813 4386.010742,725.336975 4388.091797,718.769836 
	C4390.354980,711.624573 4389.451660,704.735413 4384.022949,699.309143 
	C4379.231934,694.520203 4373.317383,693.032471 4366.610352,695.399353 
	C4360.355469,697.606567 4356.540039,701.884644 4355.629395,708.324890 
	C4354.438965,716.739929 4355.787109,724.333130 4365.605957,729.423096 
M1131.191528,827.475037 
	C1131.166504,828.138550 1131.139648,828.801941 1131.116943,829.465515 
	C1131.029785,832.022583 1131.588013,834.585510 1134.672852,833.994385 
	C1135.851074,833.768555 1137.001587,831.164062 1137.376587,829.469238 
	C1138.046753,826.439331 1138.119019,823.277161 1138.698364,817.690796 
	C1142.272461,820.846924 1144.357300,822.149963 1145.687622,823.996643 
	C1147.415161,826.394592 1148.456665,829.274597 1149.951050,831.855774 
	C1151.539551,834.599182 1153.630737,835.554504 1156.772217,832.748108 
	C1156.239502,831.085876 1155.918213,829.121155 1155.023071,827.466919 
	C1152.065918,822.002625 1150.684326,817.264465 1154.711792,811.029724 
	C1158.511108,805.147888 1153.403442,797.353516 1146.157593,796.560913 
	C1141.618652,796.064392 1136.981323,796.468445 1131.215820,796.468445 
	C1131.215820,806.659973 1131.215820,816.220581 1131.191528,827.475037 
M1084.924561,823.704041 
	C1091.946655,807.402954 1077.927490,791.323120 1058.984619,797.476440 
	C1058.271240,809.214417 1058.648315,821.266357 1058.519409,833.396057 
	C1069.879272,835.897461 1078.230347,833.888794 1084.924561,823.704041 
M1557.537109,965.865479 
	C1565.719971,965.865479 1573.902710,965.865479 1581.919434,965.865479 
	C1583.133667,955.451233 1580.559082,949.953552 1573.682007,946.895203 
	C1566.860718,943.861572 1557.624146,945.804443 1552.676514,951.313416 
	C1545.794556,958.976501 1546.253174,974.219788 1553.582764,981.441162 
	C1560.958984,988.708374 1572.982056,988.073730 1581.903320,979.781921 
	C1579.660278,974.989502 1576.718140,978.133240 1573.944092,979.054077 
	C1562.645020,982.804688 1556.298462,978.376160 1557.537109,965.865479 
M1491.494629,981.364136 
	C1502.543213,988.815125 1510.483521,988.434998 1519.919312,979.823914 
	C1517.714600,975.039673 1514.772095,978.097107 1511.977051,979.031433 
	C1500.644409,982.819641 1494.265625,978.370605 1493.766724,965.521362 
	C1502.606567,965.521362 1511.424927,965.521362 1520.124878,965.521362 
	C1521.005371,954.739258 1517.939575,948.933960 1510.557739,946.351746 
	C1499.433350,942.460327 1487.681274,949.575684 1486.087036,961.382629 
	C1485.174561,968.141357 1486.043335,974.649231 1491.494629,981.364136 
M2177.150146,985.862244 
	C2184.942383,987.211182 2192.177246,986.600952 2198.187012,980.235168 
	C2197.394531,979.102966 2196.789551,977.654053 2196.344482,977.701660 
	C2194.199951,977.930908 2192.048828,978.410950 2189.989990,979.078430 
	C2178.620605,982.763977 2172.250977,978.360901 2171.776367,965.514893 
	C2180.615479,965.514893 2189.434570,965.514893 2198.136719,965.514893 
	C2199.085693,953.556519 2194.837402,947.206604 2185.608398,945.764160 
	C2175.168457,944.132385 2166.160400,950.284546 2164.158203,960.413818 
	C2162.031494,971.175293 2165.883057,979.472107 2177.150146,985.862244 
M4284.324219,729.690979 
	C4285.130859,727.102539 4286.357910,724.560669 4286.650879,721.915344 
	C4287.160156,717.309143 4286.869141,712.616333 4287.338379,708.003052 
	C4287.711914,704.334167 4289.793945,701.788330 4293.868652,701.866638 
	C4299.096680,701.967041 4299.307617,705.998047 4299.415039,709.656372 
	C4299.607422,716.184814 4299.469238,722.723083 4299.469238,729.337280 
	C4302.854980,729.337280 4305.059082,729.337280 4308.055176,729.337280 
	C4308.055176,721.022827 4308.389160,713.075256 4307.965820,705.168213 
	C4307.496582,696.389832 4301.044922,692.426453 4292.621094,695.553894 
	C4289.524902,696.703552 4286.977539,698.196960 4283.637207,695.884644 
	C4282.529785,695.118164 4280.104004,696.257202 4278.041016,696.560181 
	C4278.041016,706.480042 4278.104492,715.771729 4278.007324,725.061707 
	C4277.973145,728.344604 4279.091797,730.119812 4284.324219,729.690979 
M4710.502930,695.205383 
	C4708.185547,696.435852 4705.513184,697.269775 4703.616211,698.969421 
	C4697.346680,704.586670 4696.206543,715.349243 4700.745117,722.836365 
	C4704.653809,729.284302 4713.442871,732.233582 4720.938965,729.612549 
	C4728.299805,727.038879 4732.823242,719.215942 4732.063477,710.371765 
	C4731.162598,699.891418 4724.366699,694.583191 4710.502930,695.205383 
M4268.914062,698.111755 
	C4266.807617,693.768799 4263.671387,695.935669 4259.970703,696.163696 
	C4259.970703,703.391602 4260.133301,709.983643 4259.912598,716.562805 
	C4259.769043,720.825928 4257.057617,723.498352 4252.903809,723.352783 
	C4248.687012,723.204956 4247.902344,719.717468 4247.906738,716.124268 
	C4247.915039,709.548889 4247.909180,702.973511 4247.909180,696.148071 
	C4244.589355,696.148071 4242.137695,696.148071 4239.039062,696.148071 
	C4239.039062,703.927063 4238.763184,711.192261 4239.105469,718.428284 
	C4239.585938,728.594116 4245.768066,732.681946 4255.194824,729.120117 
	C4257.978027,728.068542 4260.093262,726.121826 4262.907227,729.299561 
	C4263.683594,730.176331 4266.458008,729.283020 4269.000488,729.171997 
	C4269.000488,719.081299 4269.000488,709.508362 4268.914062,698.111755 
M340.824463,798.253418 
	C340.590668,804.212097 340.230804,810.169189 340.158905,816.129822 
	C340.088623,821.958923 340.311951,827.791504 340.417114,834.285400 
	C345.873810,834.285400 350.186493,834.736023 354.369263,834.190430 
	C362.757843,833.096313 366.265350,827.542664 364.358551,819.227905 
	C363.774963,816.683228 362.667938,814.156067 362.625488,811.607117 
	C362.408783,798.592651 359.791016,795.903809 346.840698,796.202759 
	C345.209961,796.240417 343.588043,796.660217 340.824463,798.253418 
M485.117004,831.053101 
	C489.361481,837.448669 495.136322,834.312439 500.115234,832.933838 
	C508.914520,830.497559 513.817505,823.110291 513.459473,814.330566 
	C513.111694,805.801208 507.238312,798.625244 498.435303,796.931030 
	C494.670410,796.206421 490.649994,796.809814 485.981140,796.809814 
	C483.801422,807.718445 485.398560,818.612793 485.117004,831.053101 
M993.396057,945.903625 
	C992.074524,945.782288 990.744995,945.500549 989.432678,945.565186 
	C979.917542,946.034119 974.015442,950.445129 971.716309,958.709961 
	C969.109802,968.079773 972.022583,978.410461 978.598999,983.119812 
	C984.889526,987.624451 995.344788,987.717651 1002.065430,982.974365 
	C1003.405823,982.028259 1003.866272,979.835388 1005.281555,977.191650 
	C982.777710,981.474792 979.321350,979.927185 978.600098,965.639404 
	C987.511719,965.639404 996.395630,965.639404 1005.422913,965.639404 
	C1007.180298,955.607910 1003.309082,949.597961 993.396057,945.903625 
M2033.363037,985.635437 
	C2040.092041,987.150757 2046.538818,986.827271 2052.465576,982.818970 
	C2054.872803,981.190979 2055.556885,979.452454 2053.140137,977.290039 
	C2034.233398,982.429810 2028.473511,979.800293 2029.071777,965.410645 
	C2037.858521,965.410645 2046.687134,965.410645 2055.445068,965.410645 
	C2056.030762,953.021423 2051.276855,946.614624 2041.477783,945.642944 
	C2031.113403,944.615112 2023.326416,950.398804 2021.329102,960.607544 
	C2019.197632,971.502014 2022.404785,978.823547 2033.363037,985.635437 
M1896.846802,946.140991 
	C1882.216919,942.129456 1869.906006,953.539978 1873.433838,971.064819 
	C1876.394775,985.774902 1893.830811,991.903625 1905.252563,982.052124 
	C1906.158325,981.270935 1905.764893,978.983398 1906.029419,976.987305 
	C1886.462402,982.575867 1880.261230,979.718628 1881.187866,965.348083 
	C1889.933350,965.348083 1898.743530,965.348083 1907.602295,965.348083 
	C1908.999756,956.116028 1905.620483,950.334900 1896.846802,946.140991 
M1088.070923,961.417297 
	C1085.971680,950.776489 1081.881348,946.402405 1073.303955,945.626099 
	C1064.544556,944.833191 1057.182861,949.178894 1054.240967,956.879150 
	C1050.726074,966.079163 1053.675659,978.192444 1060.637695,983.148438 
	C1067.525391,988.051514 1079.427856,987.525818 1085.655273,981.778442 
	C1086.445190,981.049500 1086.048828,979.035034 1086.227051,977.386169 
	C1064.787231,981.487061 1061.392334,979.971436 1060.565063,965.802734 
	C1067.527832,965.802734 1074.481323,966.015991 1081.407959,965.679749 
	C1083.640625,965.571411 1085.802979,964.017029 1088.070923,961.417297 
M1372.727417,965.114136 
	C1372.965820,967.090576 1373.053955,969.098938 1373.466309,971.038391 
	C1376.609985,985.829468 1393.768799,991.854614 1405.221069,982.075806 
	C1406.140259,981.290894 1405.778320,979.005615 1406.072876,977.001465 
	C1386.363037,982.514160 1380.387085,979.774902 1381.116699,965.393127 
	C1389.885864,965.393127 1398.705078,965.393127 1407.454224,965.393127 
	C1408.146484,950.106323 1397.566772,941.737305 1384.635254,946.590637 
	C1376.922363,949.485352 1373.571289,955.665283 1372.727417,965.114136 
M1255.454102,796.300171 
	C1250.999756,795.629578 1249.494507,797.913086 1249.516113,802.007935 
	C1249.563721,811.006653 1249.438232,820.006714 1249.534668,829.004578 
	C1249.554077,830.813171 1250.244873,832.614624 1250.693237,834.737793 
	C1259.771118,832.565063 1252.556274,823.158997 1258.366821,820.059937 
	C1266.627197,820.942993 1263.690796,834.675232 1274.415771,834.043213 
	C1274.085449,831.938965 1274.257202,830.170837 1273.534912,828.918274 
	C1270.077637,822.923401 1268.095825,817.514343 1272.506836,810.538452 
	C1275.769897,805.378235 1271.304565,798.186157 1265.111938,796.733765 
	C1262.565430,796.136475 1259.810303,796.429199 1255.454102,796.300171 
M2565.581787,983.510925 
	C2567.758789,981.886780 2570.313232,980.364014 2567.251465,977.327698 
	C2547.956787,982.212341 2542.706787,979.837708 2542.946045,965.473816 
	C2551.776611,965.473816 2560.627930,965.473816 2569.406494,965.473816 
	C2569.993896,954.982300 2567.266602,949.594543 2560.400391,946.727417 
	C2553.446777,943.823730 2544.280029,945.953247 2539.417236,951.602051 
	C2534.146484,957.725098 2533.252930,969.177124 2537.433105,977.020020 
	C2541.349609,984.368042 2548.160645,987.513977 2557.715088,986.133179 
	C2559.970947,985.807129 2562.129395,984.807617 2565.581787,983.510925 
M329.397614,964.786926 
	C330.454651,950.086487 319.210022,941.441406 306.020660,946.814270 
	C297.605591,950.242310 293.557709,959.201843 295.254211,970.117798 
	C296.360382,977.235352 299.688293,982.741882 306.581390,985.185120 
	C313.860168,987.765015 321.030701,986.994202 327.223297,982.057617 
	C328.137573,981.328735 327.778198,979.002197 328.067932,977.001648 
	C308.360657,982.515503 302.458221,979.816711 303.067780,965.610840 
	C311.302185,965.610840 319.571533,965.610840 329.397614,964.786926 
M618.226746,965.358154 
	C618.223389,963.696838 618.302917,962.030457 618.203491,960.374939 
	C617.414551,947.239929 608.818115,942.223083 597.063293,948.049500 
	C595.638245,948.755920 594.335083,949.708252 593.240967,950.382874 
	C591.095459,948.774963 589.177185,947.337341 586.982849,945.692810 
	C584.896301,953.220337 584.445007,983.006104 586.198792,985.752441 
	C587.925171,985.752441 589.711060,985.752441 592.034790,985.752441 
	C592.034790,977.582153 591.778809,969.957642 592.173157,962.366882 
	C592.311951,959.695618 593.321594,955.846008 595.210632,954.764221 
	C598.372498,952.953308 602.757263,951.815674 606.265991,952.436584 
	C610.808838,953.240601 611.433044,957.957520 611.471252,962.084900 
	C611.544189,969.965271 611.492432,977.846741 611.492432,986.225708 
	C614.239807,986.078247 616.010498,985.983215 618.227417,985.864197 
	C618.227417,979.148499 618.227417,973.196045 618.226746,965.358154 
M2240.227051,978.638123 
	C2240.180420,971.661804 2240.580811,964.646729 2239.979004,957.718628 
	C2239.143799,948.105042 2230.971191,943.208252 2222.023682,946.582092 
	C2219.572021,947.506409 2217.391602,949.149780 2215.154785,950.424255 
	C2213.289551,948.924377 2211.364990,947.376709 2207.205811,944.031860 
	C2207.211426,959.395508 2207.114502,972.440186 2207.288086,985.896790 
	C2209.695801,985.896790 2211.525391,985.896790 2214.034424,985.896790 
	C2214.034424,977.882812 2213.796875,970.269531 2214.161865,962.685242 
	C2214.291748,959.984863 2215.224609,956.768921 2216.954346,954.821350 
	C2220.054688,951.330505 2225.022949,950.245178 2228.751221,952.684998 
	C2231.244141,954.316467 2233.022217,958.559753 2233.282471,961.782654 
	C2233.919678,969.667664 2233.490479,977.638733 2233.490479,985.329407 
	C2239.467529,987.853821 2240.570068,985.060059 2240.227051,978.638123 
M1417.192383,954.113586 
	C1417.192383,964.649109 1417.192383,975.184631 1417.192383,986.224731 
	C1420.035767,986.072205 1421.811523,985.976990 1424.034790,985.857727 
	C1424.034790,977.471558 1423.770996,969.836731 1424.177856,962.237732 
	C1424.320312,959.576294 1425.405884,955.734253 1427.309448,954.674683 
	C1430.498535,952.899597 1434.851318,951.899902 1438.415649,952.463379 
	C1442.444946,953.100220 1443.384155,957.446289 1443.438965,961.245361 
	C1443.557251,969.433411 1443.475342,977.624268 1443.475342,986.052429 
	C1446.193115,986.052429 1447.782837,986.052429 1450.019531,986.052429 
	C1450.019531,976.246216 1450.591919,966.617493 1449.854614,957.090210 
	C1449.152588,948.017944 1440.945068,943.408875 1432.336914,946.452698 
	C1430.183350,947.214294 1428.299438,948.724670 1426.260010,949.832764 
	C1425.777832,950.094666 1425.167969,950.121338 1425.287598,950.092041 
	C1422.914185,948.533630 1420.966797,947.255005 1417.934570,945.263977 
	C1417.584595,948.629028 1417.388794,950.512390 1417.192383,954.113586 
M1285.544678,817.339661 
	C1288.695557,818.860779 1291.846436,820.381958 1295.181885,821.992126 
	C1290.736328,832.088745 1285.171753,822.340698 1280.156982,824.350708 
	C1279.993530,825.368774 1279.291626,826.796448 1279.688354,827.781738 
	C1281.356201,831.923096 1286.915649,834.752808 1291.998657,834.377563 
	C1297.307495,833.985596 1301.368408,830.351929 1302.272827,825.159607 
	C1303.204956,819.807312 1300.785889,816.182373 1296.220459,813.794495 
	C1292.891602,812.053284 1289.474976,810.479492 1286.306519,808.933105 
	C1287.929443,803.345642 1291.216064,804.912781 1294.005127,804.570557 
	C1295.938110,804.333252 1298.850464,803.209229 1299.334229,801.798584 
	C1300.484375,798.445801 1297.423950,797.439636 1294.797729,796.696228 
	C1288.443970,794.897705 1282.275146,796.801575 1279.770996,801.294312 
	C1276.864136,806.509766 1278.255737,811.375000 1285.544678,817.339661 
M1366.600220,797.528381 
	C1363.349243,797.074768 1360.074707,796.128784 1356.852783,796.283264 
	C1352.044800,796.513794 1349.161255,799.622742 1347.669678,804.151428 
	C1346.073242,808.998718 1347.790039,812.675049 1351.705933,815.367065 
	C1353.858398,816.846863 1356.508545,817.587036 1358.732910,818.981873 
	C1360.706177,820.219116 1362.401367,821.900024 1364.369141,823.507568 
	C1358.673828,829.625122 1353.699585,822.778198 1348.869141,824.390442 
	C1350.044556,831.280884 1352.599121,833.760986 1358.777832,834.286072 
	C1364.250610,834.751221 1369.695190,831.328735 1371.306396,826.410583 
	C1372.894897,821.561829 1370.878174,816.573364 1365.916870,813.855957 
	C1363.608643,812.591736 1360.861450,812.106201 1358.611450,810.766663 
	C1357.188232,809.919250 1356.315430,808.147278 1353.706055,804.984192 
	C1358.499146,804.871948 1361.245972,804.876465 1363.984497,804.727661 
	C1368.329712,804.491638 1370.213379,802.677856 1366.600220,797.528381 
M977.583862,823.953857 
	C972.053406,825.474976 975.249512,828.440491 976.842773,830.434143 
	C979.741638,834.061523 986.545471,835.640198 990.525330,833.734680 
	C994.581909,831.792358 997.560425,828.709229 997.959839,823.924622 
	C998.342834,819.335754 995.252930,815.243103 989.733826,812.793152 
	C986.874146,811.523804 983.986938,810.316711 981.347900,809.182800 
	C982.865784,799.712158 994.939331,809.824646 995.307434,799.728333 
	C991.404358,795.651001 986.622131,795.221130 981.593567,796.602844 
	C975.001587,798.414062 971.088257,806.044800 974.480835,811.442749 
	C976.273315,814.294678 979.711731,816.349915 982.790039,818.085205 
	C985.548584,819.640259 989.159607,819.899048 989.708496,824.320007 
	C985.944092,828.119873 982.397217,826.006775 977.583862,823.953857 
M330.746582,834.214111 
	C331.285553,833.847168 332.283264,833.496399 332.296875,833.110840 
	C332.692780,821.888123 333.244263,810.659790 333.151001,799.437561 
	C333.122559,796.017883 329.720947,795.370422 327.102539,796.877441 
	C325.224854,797.958069 323.773621,800.048889 322.554565,801.958679 
	C317.002838,810.655762 311.553558,819.419678 306.190063,828.234192 
	C305.268677,829.748474 304.941589,831.624451 304.239288,833.619324 
	C310.173981,833.217346 310.614960,833.495483 312.349304,830.745361 
	C315.616547,825.564575 319.903076,824.938965 324.853607,826.409302 
	C326.459320,829.244324 327.863831,831.724060 330.746582,834.214111 
M183.183975,826.327759 
	C179.463303,825.616394 175.742630,824.905029 171.763306,824.144226 
	C172.977310,831.151123 175.840317,833.828552 181.882797,834.297607 
	C187.081039,834.701111 192.252762,831.651794 193.912674,827.204590 
	C195.661972,822.517822 193.834152,816.923828 189.300110,814.281311 
	C185.723907,812.197021 181.884109,810.565002 177.092972,808.206177 
	C179.444534,806.344666 180.496719,804.904541 181.797195,804.626709 
	C183.672180,804.226196 185.870682,805.147217 187.662750,804.609619 
	C189.235184,804.137939 190.944763,802.656555 191.591263,801.181763 
	C191.916351,800.440063 190.294266,798.239929 189.070526,797.526672 
	C183.102768,794.048401 174.892120,796.231140 171.672424,801.904358 
	C168.108231,808.184631 170.504044,813.724915 178.493088,817.678406 
	C180.859055,818.849182 183.454514,819.737549 185.454132,821.359985 
	C186.077271,821.865601 185.088181,824.358093 183.183975,826.327759 
M1236.612183,797.679810 
	C1236.288574,804.626770 1235.987183,811.574951 1235.632690,818.520325 
	C1235.430786,822.475037 1234.249146,825.863159 1229.660278,826.386414 
	C1225.786133,826.828125 1222.803345,823.790771 1222.453247,818.600830 
	C1222.072998,812.963013 1222.424561,807.276428 1222.059814,801.636780 
	C1221.934937,799.706116 1220.609253,797.853027 1219.628662,795.470215 
	C1218.001587,796.801270 1216.646973,797.382385 1216.627686,798.004822 
	C1216.361084,806.601990 1215.471069,815.293030 1216.397827,823.779358 
	C1217.178833,830.932434 1223.390503,834.762817 1230.046143,834.213013 
	C1236.156372,833.708252 1241.278198,829.243225 1241.765991,822.574829 
	C1242.322510,814.968567 1241.968506,807.276733 1241.592041,799.642700 
	C1241.538330,798.555237 1239.129883,797.583862 1236.612183,797.679810 
M128.981934,815.738342 
	C124.704811,813.152527 120.427689,810.566711 116.088531,807.943420 
	C119.082916,802.865906 122.727249,805.345581 125.645653,804.686768 
	C127.013229,804.378052 128.494461,803.128723 129.208847,801.892334 
	C129.664215,801.104248 129.198181,799.189636 128.469635,798.418091 
	C125.826256,795.618164 117.465767,795.409302 113.370552,797.781372 
	C109.485703,800.031738 106.412018,805.748840 108.366104,809.586182 
	C109.998070,812.790833 113.367279,815.305847 116.396538,817.545410 
	C119.068230,819.520447 122.333664,820.692383 125.546425,822.325439 
	C120.270988,831.183777 114.843346,822.196167 109.795349,824.213928 
	C107.641235,829.591675 111.725517,831.311523 115.079407,832.995422 
	C120.282127,835.607666 124.731018,834.710815 128.728851,830.910950 
	C133.317093,826.549866 133.689377,821.843567 128.981934,815.738342 
M537.998718,797.393799 
	C532.189026,796.878479 526.379333,796.363098 519.453430,795.748779 
	C518.637817,809.293884 518.554626,821.610718 519.237427,834.340942 
	C525.288269,834.340942 529.932617,834.629639 534.503052,834.175354 
	C535.989380,834.027710 537.282776,831.938904 538.664368,830.737854 
	C537.374939,829.552185 536.263184,827.949402 534.744324,827.302307 
	C533.327698,826.698669 531.372742,827.449524 529.850708,826.975281 
	C528.486572,826.550171 526.364014,825.232422 526.394409,824.372803 
	C526.452209,822.739624 527.534363,820.890137 528.725891,819.640381 
	C529.491760,818.836975 531.461548,819.280518 532.441101,818.555908 
	C533.628723,817.677368 535.085205,816.133362 535.047485,814.920105 
	C535.010620,813.733948 533.447754,812.208130 532.181030,811.538940 
	C530.324524,810.558105 528.135132,810.207520 526.526978,809.721313 
	C525.638977,805.136780 527.797302,804.216797 530.874878,804.081787 
	C534.568909,803.919800 538.530090,804.060181 537.998718,797.393799 
M968.199707,807.357605 
	C967.363098,803.459229 970.485535,797.884705 962.553772,795.837158 
	C962.195496,799.578247 961.781860,802.748962 961.613831,805.932617 
	C961.385803,810.253174 961.574402,814.606018 961.155945,818.903259 
	C960.792358,822.638428 959.815552,826.524597 954.847961,826.259033 
	C950.419312,826.022339 948.485291,822.884583 948.273499,818.839966 
	C947.995178,813.524841 948.236450,808.182129 947.944092,802.868347 
	C947.817322,800.563293 946.916992,798.300842 946.368042,796.019104 
	C945.607849,795.986816 944.847595,795.954468 944.087402,795.922180 
	C943.276001,797.803284 941.867371,799.651794 941.762634,801.571472 
	C941.418579,807.881775 941.340881,814.224487 941.546570,820.542236 
	C941.803223,828.425964 946.434509,833.657959 953.210693,834.284424 
	C960.301086,834.939941 966.622986,829.947021 967.789246,822.146912 
	C968.423889,817.902100 968.095764,813.513245 968.199707,807.357605 
M164.293808,799.089844 
	C162.073303,794.829224 159.291855,795.272156 158.561096,799.453491 
	C157.599121,804.957947 158.145218,810.719666 157.962494,816.368164 
	C157.730118,823.551697 155.719254,826.380005 151.000534,826.352295 
	C146.687698,826.326965 144.957077,823.896667 144.686279,816.917664 
	C144.479782,811.595947 144.774292,806.246338 144.368683,800.945618 
	C144.234360,799.190369 142.613495,797.548828 141.672302,795.855286 
	C140.925629,796.024780 140.178955,796.194275 139.432281,796.363831 
	C136.824814,804.534668 137.845657,813.148743 138.229233,821.512939 
	C138.583282,829.233398 145.271713,834.629822 152.282394,834.195190 
	C158.848984,833.788086 163.997650,828.332825 164.371674,820.716858 
	C164.697922,814.073608 164.458206,807.402588 164.293808,799.089844 
M2782.012207,970.731384 
	C2784.795654,972.384888 2787.311523,974.834778 2785.319580,977.889160 
	C2783.961670,979.971497 2780.767578,981.665283 2778.220947,981.942627 
	C2775.509033,982.238037 2772.564697,980.751160 2769.774170,979.875183 
	C2766.879150,978.966370 2765.295166,979.801636 2765.023926,983.246887 
	C2771.227783,987.907043 2777.961670,989.211792 2785.302002,985.915710 
	C2789.966553,983.821289 2792.422852,980.117615 2792.515625,974.959045 
	C2792.605957,969.913696 2789.766113,967.019958 2785.317383,965.372375 
	C2783.456787,964.683350 2781.499756,964.210205 2779.717285,963.363586 
	C2776.347412,961.762939 2770.903809,961.342773 2772.537842,955.792908 
	C2773.964111,950.949402 2778.712158,951.552734 2782.689209,952.097595 
	C2784.603027,952.359863 2786.391357,953.610840 2788.299805,953.812256 
	C2789.266846,953.914246 2790.374756,952.679504 2791.492676,952.004700 
	C2785.313965,944.958740 2776.989502,943.508118 2770.427734,948.022644 
	C2763.149658,953.030029 2763.507324,962.436707 2771.319580,966.652527 
	C2774.202148,968.207886 2777.486084,969.018860 2782.012207,970.731384 
M2696.056641,987.415039 
	C2698.990479,987.202026 2702.046143,987.439026 2704.833496,986.684875 
	C2711.149658,984.975769 2714.201660,981.154053 2714.475342,975.557556 
	C2714.735352,970.232056 2712.591064,967.410034 2706.063232,964.769775 
	C2703.301025,963.652649 2700.184570,963.172485 2697.732666,961.611755 
	C2696.104736,960.575500 2694.256592,957.935852 2694.537109,956.380005 
	C2694.839111,954.704041 2697.412598,952.414124 2699.169678,952.248962 
	C2702.293945,951.955383 2705.536133,953.293152 2708.756348,953.482727 
	C2710.319580,953.574585 2711.944824,952.612793 2714.176270,951.935547 
	C2708.701172,944.913696 2702.226807,944.514099 2695.603271,946.443604 
	C2690.923584,947.806885 2687.747803,951.217651 2687.385254,956.594421 
	C2687.016113,962.073181 2689.882080,965.347473 2694.530762,967.347595 
	C2697.262451,968.522949 2700.508301,968.825134 2702.858643,970.469299 
	C2704.990479,971.960571 2707.552490,974.735962 2707.555420,976.948242 
	C2707.560303,980.722107 2704.041260,982.443726 2700.383789,982.086670 
	C2697.507812,981.805908 2694.677002,980.807190 2691.891357,979.922791 
	C2689.085205,979.031982 2687.367920,979.597656 2686.971924,983.626770 
	C2689.373291,984.654907 2692.003662,985.781189 2696.056641,987.415039 
M1853.623047,985.957458 
	C1860.140381,973.460022 1864.689331,960.207336 1870.329956,946.168213 
	C1860.032959,946.178955 1860.983765,954.088745 1858.548340,958.672546 
	C1855.671631,964.086914 1853.825439,970.048828 1850.982178,977.147644 
	C1847.050659,967.349792 1843.613159,959.086365 1840.430542,950.725952 
	C1838.800293,946.443420 1836.350098,945.312073 1831.801880,947.405334 
	C1836.695923,959.505249 1841.485107,971.152222 1846.093018,982.870605 
	C1847.304321,985.951660 1849.338745,986.822205 1853.623047,985.957458 
M1172.536377,796.125916 
	C1169.362427,796.286499 1166.188477,796.447083 1162.746826,796.621277 
	C1162.746826,809.615295 1162.746826,821.638733 1162.746826,834.299194 
	C1168.417969,834.299194 1173.314575,834.508850 1178.166382,834.135010 
	C1179.228638,834.053223 1180.898560,831.883484 1180.885498,830.690430 
	C1180.873291,829.547913 1179.228149,827.841248 1177.958740,827.424561 
	C1175.822510,826.723328 1173.324951,827.164551 1171.145630,826.542664 
	C1168.464233,825.777527 1167.871826,821.710510 1170.248047,820.285095 
	C1171.870605,819.311829 1174.321777,819.622131 1175.803345,818.539124 
	C1177.257935,817.475891 1177.955566,815.377136 1179.563232,812.810425 
	C1175.860107,812.106445 1173.486450,812.044861 1171.507324,811.129822 
	C1170.357666,810.598328 1169.411743,808.759827 1169.209595,807.386475 
	C1169.097168,806.622253 1170.543457,805.280457 1171.569702,804.790283 
	C1172.695190,804.252869 1174.142700,804.299438 1175.454956,804.262024 
	C1178.451904,804.176575 1180.946533,803.119385 1180.884155,799.826599 
	C1180.797607,795.250488 1177.009155,796.371521 1172.536377,796.125916 
M397.416718,983.191101 
	C402.478119,987.651917 404.362640,987.665833 406.547150,982.617249 
	C410.634308,973.171448 414.432404,963.599304 418.255066,954.041382 
	C419.174011,951.743591 419.717987,949.295837 420.699036,946.038574 
	C411.205994,946.465454 412.171356,954.186462 409.562042,958.751709 
	C406.582703,963.964417 405.750671,970.311646 401.388947,975.948547 
	C397.822510,966.858459 394.708923,958.845032 391.531219,950.857178 
	C390.013397,947.041809 387.839661,944.604553 382.938477,947.675110 
	C387.594116,959.195862 392.186188,970.559204 397.416718,983.191101 
M563.569336,834.468811 
	C565.568726,834.456055 567.570923,834.506775 569.566772,834.416077 
	C572.787781,834.269714 577.220459,835.076050 577.292297,830.410767 
	C577.361084,825.951050 572.953735,827.790649 570.336121,827.035278 
	C568.419800,826.482361 566.778503,824.976318 565.014587,823.895142 
	C566.392395,822.371094 567.494263,820.178467 569.208923,819.470703 
	C572.211060,818.231628 574.978149,817.454163 573.503296,813.047791 
	C570.789246,811.742920 567.918274,810.362671 565.260132,809.084717 
	C565.103333,803.930176 568.423950,804.216736 571.393921,804.063232 
	C575.655823,803.842896 578.403503,802.422546 576.914429,796.835022 
	C570.967590,796.835022 565.141602,796.835022 557.911926,796.835022 
	C557.911926,808.406677 557.788757,819.629272 558.086914,830.840698 
	C558.119751,832.072571 560.570068,833.240173 563.569336,834.468811 
M2455.347656,952.751709 
	C2453.755127,960.966797 2454.674805,963.654846 2460.507324,966.763916 
	C2462.532715,967.843506 2464.796631,968.474609 2466.948242,969.318909 
	C2470.864014,970.855347 2475.870117,971.627747 2474.422363,977.697266 
	C2473.455811,981.750488 2468.637207,983.244080 2462.575439,981.673096 
	C2461.319092,981.347534 2460.207764,980.202576 2458.976807,980.105164 
	C2457.368652,979.978027 2455.707520,980.517700 2453.454102,980.865356 
	C2461.120605,989.167236 2471.943115,989.828003 2478.263184,983.165527 
	C2483.909668,977.213074 2482.778076,969.577026 2475.454102,965.899109 
	C2471.925781,964.127136 2467.930176,963.274414 2464.436279,961.450012 
	C2462.946289,960.672119 2461.051025,958.154480 2461.374023,956.993164 
	C2461.895996,955.116028 2463.878418,952.722290 2465.642822,952.327209 
	C2468.375977,951.714966 2471.447510,952.575928 2474.370605,952.861450 
	C2476.119629,953.032227 2477.859131,953.296631 2480.037354,953.574402 
	C2475.813965,943.367554 2465.668457,942.774658 2455.347656,952.751709 
M616.811829,830.809265 
	C615.479492,829.627319 614.327881,827.901489 612.774353,827.385071 
	C610.145325,826.511169 607.262268,826.401794 601.954163,825.578064 
	C605.218201,822.246277 606.703735,820.508240 608.421021,819.041748 
	C610.015076,817.680603 611.856689,816.609314 613.589294,815.410400 
	C611.981567,814.120239 610.409973,812.780151 608.743652,811.570740 
	C608.254761,811.215881 607.204163,811.441101 606.916504,811.038879 
	C606.015808,809.779419 604.672302,808.277405 604.802673,807.002563 
	C604.924500,805.811401 606.524902,804.287903 607.807678,803.815796 
	C609.604065,803.154602 611.787598,803.613708 613.665283,803.090332 
	C617.144775,802.120483 617.213440,799.794006 615.159729,796.272705 
	C611.627380,796.272705 607.711731,796.245422 603.796875,796.286011 
	C602.215698,796.302368 600.635986,796.467102 599.211487,796.554688 
	C596.931396,806.557251 597.077271,827.133057 599.778442,835.192993 
	C605.180481,834.208679 610.798035,833.185120 616.811829,830.809265 
M1111.471191,829.222229 
	C1109.371582,828.550049 1107.312622,827.652405 1105.161743,827.264282 
	C1102.634033,826.808350 1099.435303,827.588440 1098.991455,823.831970 
	C1098.595703,820.484131 1100.684814,819.112915 1103.783691,818.833435 
	C1107.071167,818.537048 1108.547119,816.825378 1107.590454,812.862305 
	C1105.996094,812.491089 1103.928223,812.452026 1102.402466,811.522766 
	C1101.036377,810.690857 1099.687256,808.967651 1099.454712,807.463867 
	C1099.316772,806.570862 1101.174683,804.837402 1102.454590,804.384583 
	C1104.275879,803.740112 1106.645020,804.433472 1108.303345,803.603149 
	C1109.758911,802.874268 1110.936157,800.949585 1111.434814,799.309448 
	C1111.601318,798.761414 1109.341553,796.717346 1108.106323,796.635498 
	C1103.260254,796.314758 1098.380371,796.504333 1092.858765,796.504333 
	C1092.858765,809.616821 1092.858765,821.673157 1092.858765,834.409851 
	C1097.900024,834.409851 1102.231079,834.773987 1106.449707,834.242981 
	C1108.316162,834.007996 1109.954346,831.960327 1111.471191,829.222229 
M1469.796997,939.480530 
	C1469.045288,937.568359 1468.645630,934.311401 1467.473633,934.004700 
	C1464.376343,933.193848 1464.045166,936.051941 1463.886719,938.456421 
	C1463.821289,939.448608 1463.525391,940.447937 1463.600830,941.423340 
	C1463.960693,946.077637 1461.012451,947.721252 1457.223145,948.764709 
	C1456.848511,948.867920 1456.706787,949.816162 1456.181763,950.984558 
	C1458.025635,951.858337 1459.881958,952.737976 1462.240601,953.855774 
	C1462.240601,961.386658 1462.091431,968.990356 1462.297241,976.584473 
	C1462.418335,981.053711 1463.656982,985.148743 1468.575684,986.863098 
	C1473.832520,988.695435 1478.028442,987.385986 1482.931885,981.387695 
	C1479.382080,981.222839 1477.509277,980.834412 1475.743042,981.115723 
	C1471.902466,981.727539 1469.930786,980.122803 1469.870117,976.434692 
	C1469.741577,968.619446 1469.830933,960.800598 1469.830933,953.795898 
	C1474.139771,951.136475 1479.201050,954.726868 1481.610718,948.650818 
	C1477.420898,947.944336 1473.784058,947.331116 1469.798096,946.658997 
	C1469.798096,944.550842 1469.798096,942.910706 1469.796997,939.480530 
M242.384506,803.831970 
	C245.138580,802.310608 246.201355,800.283875 244.084351,796.933228 
	C238.553574,796.933228 232.806137,796.933228 226.405212,796.933228 
	C225.599411,809.670898 225.407715,821.694397 226.343750,834.354492 
	C232.079117,834.354492 236.712265,834.639648 241.270874,834.182129 
	C242.652390,834.043457 243.827759,831.850708 245.097534,830.598877 
	C244.020676,829.517395 243.109085,828.108398 241.815811,827.455750 
	C240.738098,826.911926 238.999893,827.666565 237.932907,827.114380 
	C236.135223,826.184082 234.637604,824.673950 233.013779,823.407654 
	C234.405457,821.932007 235.553665,819.672913 237.240967,819.148621 
	C240.461807,818.147644 243.059280,817.424622 241.440369,812.807495 
	C240.118240,812.451172 238.411728,812.315491 237.072617,811.542969 
	C235.616150,810.702637 233.445435,809.212524 233.506012,808.111389 
	C233.580704,806.754089 235.451569,805.202881 236.901154,804.315125 
	C237.891983,803.708435 239.489655,804.092712 242.384506,803.831970 
M140.159988,767.614929 
	C141.004990,764.085876 138.013947,758.722046 143.554504,757.480225 
	C148.622238,756.344421 149.671417,761.559387 151.668747,764.825500 
	C152.706802,766.523010 153.332428,768.507935 154.538605,770.055725 
	C155.416931,771.182739 156.940552,771.806885 159.135345,773.313416 
	C159.244141,770.867432 159.806854,769.330017 159.271103,768.511963 
	C154.774933,761.646667 153.850601,755.360229 158.528885,747.620300 
	C161.788696,742.227112 156.851364,735.572083 150.100998,734.874329 
	C145.639679,734.413147 141.066467,735.034363 136.785294,735.163635 
	C134.583481,748.686462 135.162827,766.429504 138.071228,772.589783 
	C138.866211,771.165710 139.459503,770.102966 140.159988,767.614929 
M2587.830811,977.246826 
	C2582.691406,970.328613 2582.190918,962.784485 2587.039795,955.963440 
	C2591.449707,949.760071 2597.923828,951.116638 2604.179688,953.766418 
	C2605.126221,954.167236 2606.793213,952.867126 2608.415527,952.242676 
	C2601.740967,945.167236 2594.199951,943.690674 2586.744629,947.514038 
	C2579.087891,951.440613 2575.596191,960.022827 2577.307129,970.711060 
	C2578.710449,979.477478 2583.942627,985.167664 2591.734131,986.228271 
	C2597.211914,986.973877 2602.387451,986.077820 2606.634521,982.318420 
	C2607.604004,981.460022 2607.775391,979.700012 2609.008301,976.620789 
	C2604.433350,978.115112 2601.538574,979.689941 2598.563477,979.859680 
	C2595.434082,980.038208 2592.228271,978.872742 2587.830811,977.246826 
M626.995361,968.351685 
	C627.333252,970.314026 627.423828,972.359192 628.049133,974.225220 
	C632.130798,986.404968 646.165161,990.574646 656.334595,982.538940 
	C657.410217,981.688904 657.501282,979.592834 658.577698,976.610168 
	C655.480469,977.559448 653.987671,977.921448 652.565857,978.467957 
	C641.404541,982.758423 634.144897,977.972168 634.022705,966.211731 
	C633.905701,954.952881 640.514404,949.721191 651.437134,952.688660 
	C653.942383,953.369324 656.279663,955.532593 657.891113,951.656006 
	C648.071350,941.353516 632.156128,944.664551 628.095581,957.938354 
	C627.236328,960.747009 627.275757,963.830627 626.995361,968.351685 
M2271.389893,985.967590 
	C2275.039062,984.345398 2279.920410,984.073059 2280.323242,976.776733 
	C2276.845947,978.015503 2274.370361,979.097656 2271.788574,979.779297 
	C2264.496582,981.704529 2259.072266,978.806946 2256.824951,971.969910 
	C2254.295166,964.273438 2256.917480,954.549927 2262.923340,952.897583 
	C2266.721191,951.852722 2271.194092,953.415283 2275.371338,953.516968 
	C2276.949463,953.555420 2278.547363,952.774170 2280.674316,952.228577 
	C2271.121094,942.851135 2258.017822,943.693970 2252.123291,953.631226 
	C2247.577881,961.293945 2247.617432,969.584900 2251.532227,977.491638 
	C2255.253906,985.008972 2261.935791,987.246887 2271.389893,985.967590 
M2114.019287,983.051392 
	C2125.938232,989.033936 2136.524414,986.644348 2137.286865,977.057129 
	C2135.569092,977.557495 2134.070557,977.880249 2132.656982,978.423584 
	C2121.426270,982.740112 2114.191162,978.047607 2114.022461,966.300293 
	C2113.860352,955.020203 2120.467041,949.733093 2131.366699,952.659180 
	C2133.840088,953.323120 2136.183838,955.565613 2138.066895,951.284912 
	C2133.600830,945.010925 2127.121582,944.756165 2120.476074,946.148376 
	C2113.700684,947.567993 2109.401123,952.191650 2107.879395,958.849731 
	C2105.958008,967.256470 2106.291748,975.401062 2114.019287,983.051392 
M293.909668,99.030434 
	C293.909668,90.883057 293.909668,82.735687 293.909668,74.720139 
	C289.937408,74.720139 287.406158,74.720139 284.658936,74.720139 
	C284.658936,94.173088 284.658936,113.142387 284.658936,132.473495 
	C287.926697,132.317703 290.478455,132.196060 293.909668,132.032471 
	C293.909668,121.406616 293.909668,111.212280 293.909668,99.030434 
M551.141418,120.603683 
	C551.141418,124.222687 551.141418,127.841682 551.141418,132.263016 
	C554.681763,132.090134 557.414124,131.956711 559.815125,131.839462 
	C559.815125,112.158806 559.815125,93.344574 559.815125,74.097969 
	C556.558411,74.433296 554.086792,74.687782 551.141479,74.991043 
	C551.141479,90.088730 551.141479,104.389381 551.141418,120.603683 
M1191.926758,816.585266 
	C1191.614380,804.147766 1201.211792,804.268555 1209.544312,803.457458 
	C1210.993042,797.799133 1208.492310,796.205017 1204.052856,795.996521 
	C1194.676514,795.556091 1187.394653,801.677673 1185.393921,811.802246 
	C1183.487549,821.449463 1189.006958,831.002441 1198.247803,833.641602 
	C1200.415527,834.260681 1202.882202,834.466858 1205.102417,834.134888 
	C1209.621582,833.459167 1210.910156,830.779114 1209.335083,826.537842 
	C1201.202637,827.797913 1194.877930,826.574646 1191.926758,816.585266 
M966.004761,982.486755 
	C964.669495,979.278076 962.489502,980.741882 960.240723,981.230591 
	C957.067139,981.920166 954.810059,980.109680 954.705566,977.101379 
	C954.423584,968.982971 954.609009,960.848267 954.609009,953.846680 
	C959.070618,951.066711 963.982971,954.637329 966.680054,948.620422 
	C962.355774,947.977539 958.699158,947.433960 954.950806,946.876648 
	C954.474976,942.129211 954.048523,937.874390 953.496155,932.363342 
	C949.026367,937.756287 949.026367,937.756287 947.360168,946.623169 
	C945.265076,947.780090 943.229065,948.904358 940.065979,950.651062 
	C943.485962,952.024780 945.457214,952.816589 947.680359,953.709595 
	C947.680359,961.985962 947.349731,969.951538 947.773926,977.876709 
	C948.192566,985.698425 953.169312,989.005127 960.701843,986.938171 
	C962.512085,986.441467 964.087524,985.088806 966.004761,982.486755 
M282.055756,998.923096 
	C283.276855,996.255554 285.489502,993.611633 285.553894,990.916443 
	C285.902283,976.329895 285.719086,961.730530 285.719086,946.856567 
	C282.905579,946.856567 280.851654,946.856567 278.064270,946.856567 
	C278.064270,962.746948 278.064270,977.996948 278.064270,993.291626 
	C274.883942,994.684082 272.308990,995.811523 269.331055,997.115356 
	C272.221802,1004.377258 276.693054,1001.326904 282.055756,998.923096 
M641.085510,799.050659 
	C635.405884,793.457520 629.095337,797.006104 622.183105,797.092834 
	C622.043823,809.834290 621.781555,821.857422 622.249268,834.689392 
	C632.548401,832.487305 625.757263,823.848267 630.220886,819.863770 
	C630.637634,819.680847 631.565979,819.370239 632.395508,818.889221 
	C634.211609,817.836121 637.177673,816.988220 637.530823,815.535461 
	C638.458801,811.718567 634.855347,812.172852 632.466309,811.302185 
	C630.981995,810.761108 629.977112,808.904419 628.757019,807.638184 
	C630.241272,806.236572 631.525024,804.467041 633.258362,803.522522 
	C635.655701,802.216309 638.391541,801.531189 641.085510,799.050659 
M303.273834,796.619995 
	C297.979004,796.457642 292.673431,796.052246 287.396149,796.285950 
	C285.878235,796.353149 283.933990,797.994995 283.173492,799.436340 
	C282.767731,800.205261 284.224884,803.038025 285.264648,803.307861 
	C290.706757,804.720215 290.119598,808.852112 290.140259,812.819519 
	C290.169617,818.460266 290.125275,824.102539 290.249512,829.741150 
	C290.330597,833.421875 291.829102,835.465210 296.700500,833.558228 
	C296.892517,829.283691 297.178711,824.715332 297.280487,820.142944 
	C297.383240,815.525818 297.303101,810.904663 297.303101,807.721069 
	C299.958801,803.108337 307.780884,804.343689 303.273834,796.619995 
M1674.058960,945.526550 
	C1670.525391,946.928284 1666.991821,948.330078 1663.805176,949.594238 
	C1661.730713,948.272095 1659.767334,947.020752 1656.607788,945.007141 
	C1656.607788,959.568359 1656.607788,972.587891 1656.607788,986.295654 
	C1658.811279,986.077148 1660.871216,985.872864 1663.200439,985.641846 
	C1663.200439,979.714050 1663.176270,974.438293 1663.205078,969.162842 
	C1663.276978,956.034607 1665.141846,953.813477 1677.812012,951.725220 
	C1678.515503,949.110657 1679.423340,946.430298 1674.058960,945.526550 
M549.142822,948.120544 
	C547.359741,949.479309 545.802612,951.668091 543.767639,948.050476 
	C543.139526,946.933899 540.707397,946.832092 538.382935,946.012390 
	C538.382935,959.879272 538.382935,972.731140 538.382935,986.300476 
	C540.787659,986.071289 542.857666,985.873962 545.212585,985.649475 
	C545.212585,978.349976 544.993958,971.697083 545.266663,965.064270 
	C545.626770,956.306519 548.492798,953.566101 557.333679,952.609741 
	C558.225586,952.513306 559.075684,952.029846 560.339294,951.588257 
	C560.150208,949.611694 559.978577,947.817566 559.708191,944.990967 
	C556.018982,945.850952 553.223816,946.502563 549.142822,948.120544 
M873.927368,968.882507 
	C873.927368,974.460876 873.927368,980.039246 873.927368,986.344116 
	C876.787598,986.073853 878.853333,985.878662 881.203491,985.656616 
	C881.203491,978.708191 881.059509,972.412415 881.236450,966.125610 
	C881.516785,956.165466 884.164429,953.529907 894.210876,952.584534 
	C894.770203,952.531982 895.278687,951.939270 896.238953,951.323181 
	C896.127563,949.734070 896.001038,947.929688 895.838867,945.617554 
	C892.842224,945.834290 890.427795,945.544495 888.381165,946.279175 
	C886.032959,947.122192 884.010742,948.873291 882.198120,950.009705 
	C879.811707,948.399780 877.870422,947.090088 873.927368,944.429932 
	C873.927368,953.325928 873.927368,960.143433 873.927368,968.882507 
M1118.391357,949.273376 
	C1118.550659,945.999023 1116.271851,945.030762 1113.886353,945.655029 
	C1110.496338,946.542297 1107.319946,948.245972 1103.878662,949.672791 
	C1102.134644,948.521362 1099.947021,947.077148 1096.509033,944.807373 
	C1096.509033,959.660339 1096.509033,972.712830 1096.509033,986.438171 
	C1098.984131,986.083252 1101.043579,985.788025 1103.231812,985.474243 
	C1103.231812,977.877930 1102.934448,970.911499 1103.312500,963.981873 
	C1103.720215,956.510925 1106.722778,953.807190 1114.298462,952.546814 
	C1115.678223,952.317261 1116.923340,951.278015 1118.391357,949.273376 
M2659.927734,963.118042 
	C2659.927734,970.670898 2659.927734,978.223694 2659.927734,986.500061 
	C2662.963867,986.078369 2665.029053,985.791504 2667.233154,985.485413 
	C2667.233154,977.860352 2666.926025,970.868286 2667.316162,963.915283 
	C2667.736816,956.416870 2670.870361,953.571777 2678.439941,952.604614 
	C2679.633057,952.452209 2680.810303,952.175476 2682.071289,951.942017 
	C2682.071289,949.798523 2682.071289,948.204346 2682.071289,946.693298 
	C2676.023438,943.329712 2672.004883,947.838379 2668.602051,949.984863 
	C2665.713135,948.220276 2663.701416,946.991333 2659.927734,944.686218 
	C2659.927734,951.441223 2659.927734,956.320190 2659.927734,963.118042 
M2509.927734,965.041687 
	C2509.927734,971.936462 2509.927734,978.831299 2509.927734,986.443848 
	C2512.907227,986.074890 2514.971680,985.819275 2517.214111,985.541626 
	C2517.214111,978.253601 2516.988770,971.608032 2517.269775,964.983948 
	C2517.640137,956.251404 2520.490479,953.556458 2529.359375,952.608459 
	C2530.246338,952.513611 2531.090332,952.020386 2532.344238,951.572937 
	C2532.151855,949.615295 2531.974854,947.816223 2531.843262,946.478638 
	C2525.508545,943.734558 2521.830811,947.976624 2518.531494,950.045715 
	C2515.726318,948.268860 2513.752686,947.018738 2509.927734,944.595947 
	C2509.927734,952.066284 2509.927734,957.590698 2509.927734,965.041687 
M1928.122803,954.779602 
	C1930.924194,954.022949 1933.904785,953.630798 1936.461182,952.375244 
	C1938.038086,951.600769 1938.968750,949.510254 1940.438721,947.704590 
	C1932.920898,943.418152 1928.849609,947.314880 1925.201050,951.291443 
	C1923.207764,949.325195 1921.364258,947.506775 1917.847656,944.038086 
	C1917.847656,959.751587 1917.847656,972.819336 1917.847656,986.311401 
	C1920.062378,986.133484 1921.906250,985.985352 1924.061523,985.812256 
	C1924.061523,978.898621 1923.732666,972.582458 1924.190796,966.323853 
	C1924.445801,962.839294 1926.011475,959.450684 1928.122803,954.779602 
M666.508057,765.992188 
	C666.339355,770.328613 667.944885,773.065796 672.745544,772.999756 
	C676.732422,772.944946 680.752808,773.225220 684.690674,772.770447 
	C686.226318,772.592957 687.576538,770.810791 691.043396,768.270569 
	C683.797058,767.273071 678.831726,766.589539 672.872009,765.769165 
	C672.872009,760.060669 673.242126,754.792358 672.765564,749.601807 
	C672.309387,744.633301 675.531799,738.547668 668.061340,733.769104 
	C665.131714,744.511230 666.953491,754.451172 666.508057,765.992188 
M4304.929199,570.184448 
	C4305.459473,568.402405 4306.436035,566.623535 4306.448242,564.837952 
	C4306.542480,551.286072 4306.458496,537.732788 4306.380859,524.180237 
	C4306.377441,523.615479 4305.895508,523.053467 4305.312500,521.786377 
	C4302.881836,521.920227 4300.198242,522.067993 4297.363770,522.224060 
	C4297.363770,537.096802 4297.518066,550.981445 4297.273438,564.859009 
	C4297.195312,569.264771 4298.680176,570.965942 4304.929199,570.184448 
M4728.340332,523.191406 
	C4725.413086,520.669556 4722.488770,521.094421 4719.808105,522.756653 
	C4719.808105,538.637756 4719.808105,554.072571 4719.808105,570.244324 
	C4722.996094,570.076782 4725.690430,569.935120 4728.503906,569.787231 
	C4728.503906,554.255615 4728.503906,539.714233 4728.340332,523.191406 
M775.869629,930.017517 
	C774.059265,929.476990 772.248901,928.936523 770.096069,928.293823 
	C770.096069,948.368958 770.096069,967.151855 770.096069,985.881348 
	C772.263000,985.881348 773.787415,985.881348 776.142944,985.881348 
	C776.142944,967.611267 776.142944,949.730225 775.869629,930.017517 
M1363.838501,983.318237 
	C1363.838501,971.151428 1363.838501,958.984558 1363.838501,946.571533 
	C1360.900757,946.571533 1359.036621,946.571533 1356.751465,946.571533 
	C1356.751465,959.942749 1356.751465,972.939453 1356.751465,986.991455 
	C1359.611328,986.166077 1361.657715,985.575500 1363.838501,983.318237 
M566.146973,978.095825 
	C566.146973,980.630554 566.146973,983.165283 566.146973,986.317078 
	C569.221252,986.125732 571.338501,985.993896 573.345215,985.868958 
	C573.345215,972.474670 573.345215,959.708557 573.345215,946.375977 
	C570.747559,946.565918 568.698486,946.715698 566.146973,946.902283 
	C566.146973,957.197144 566.146973,966.746460 566.146973,978.095825 
M414.950897,829.137756 
	C414.813599,818.855164 414.713226,808.571594 414.464813,798.291687 
	C414.446136,797.518738 413.371582,796.771240 412.362915,795.459167 
	C411.082153,796.621033 409.144012,797.520264 409.018799,798.624939 
	C407.684418,810.397339 408.080872,822.158875 408.505707,833.908203 
	C409.314972,834.210144 410.124237,834.512085 410.933533,834.814026 
	C412.228546,833.440430 413.523590,832.066833 414.950897,829.137756 
M370.482849,803.933960 
	C370.461517,812.581543 370.300049,821.232971 370.537750,829.873413 
	C370.584991,831.591064 372.160980,833.266541 373.491913,835.856323 
	C376.537537,829.485657 377.880859,810.315125 376.343445,800.403809 
	C376.094604,798.799622 374.632080,797.383728 372.712921,794.184204 
	C371.631104,798.097961 371.066345,800.141174 370.482849,803.933960 
M667.979492,947.914185 
	C667.979492,960.475708 667.979492,973.037231 667.979492,986.279907 
	C670.349609,986.120117 672.100525,986.002075 674.340881,985.851013 
	C674.340881,973.895569 674.267334,962.614929 674.382019,951.336182 
	C674.420471,947.550781 673.199524,945.627747 667.979492,947.914185 
M2154.346436,961.173828 
	C2154.339355,957.512695 2154.414062,953.849121 2154.303955,950.191040 
	C2154.166504,945.625549 2151.522949,945.962769 2148.181885,946.996155 
	C2148.181885,960.169434 2148.181885,972.974548 2148.181885,986.372192 
	C2150.529785,986.090393 2152.283936,985.879883 2154.346680,985.632324 
	C2154.346680,977.701538 2154.346680,970.409546 2154.346436,961.173828 
M2289.653320,961.178467 
	C2289.653320,969.398376 2289.653320,977.618286 2289.653320,986.453796 
	C2292.560303,986.084534 2294.310303,985.862183 2295.618164,985.696045 
	C2295.618164,972.135742 2295.618164,959.316772 2295.618164,944.148376 
	C2292.606201,946.779053 2290.253174,947.831421 2289.952148,949.303589 
	C2289.297119,952.503357 2289.689209,955.917480 2289.653320,961.178467 
M4670.494629,690.150330 
	C4673.212891,690.342102 4676.017090,690.173645 4678.632324,690.796753 
	C4685.076660,692.332153 4686.435547,691.272095 4686.545410,685.132141 
	C4682.539062,684.768860 4678.716797,684.274658 4674.881348,684.131958 
	C4672.713379,684.051392 4670.208008,683.958069 4668.415527,684.918030 
	C4665.399414,686.533691 4665.967285,689.157104 4670.494629,690.150330 
M2177.417236,939.095886 
	C2178.675537,937.137329 2179.934082,935.178772 2180.642090,934.076660 
	C2186.368408,935.659607 2187.673828,942.246155 2193.625488,939.130310 
	C2190.414795,935.139709 2189.043701,929.278625 2182.504395,929.432556 
	C2176.186523,929.581238 2174.637207,934.957886 2171.378418,939.806946 
	C2173.644287,939.806946 2174.888428,939.806946 2177.417236,939.095886 
M957.762390,128.399124 
	C958.783508,129.731628 959.626831,131.960907 960.863403,132.206024 
	C963.280090,132.685043 965.916443,132.055679 968.915527,131.854813 
	C968.589355,128.296768 968.325684,125.420479 967.989258,121.750053 
	C964.087769,123.722641 958.122314,118.738396 957.762390,128.399124 
M958.187866,75.525291 
	C958.187866,78.339241 958.187866,81.153191 958.187866,84.531097 
	C962.180847,84.321274 965.325134,84.156044 968.944885,83.965836 
	C968.588440,80.250641 968.313293,77.382500 968.032227,74.452477 
	C964.734558,74.452477 962.088440,74.452477 958.187866,75.525291 
M552.405029,62.096970 
	C554.928467,62.096970 557.451904,62.096970 560.239502,62.096970 
	C560.239502,58.763271 560.239502,55.941982 560.239502,52.860054 
	C557.133606,52.860054 554.434021,52.860054 551.324341,52.860054 
	C551.324341,56.020313 551.324341,58.585190 552.405029,62.096970 
M293.523834,53.572250 
	C290.593903,53.096428 287.663940,52.620609 284.315552,52.076832 
	C284.315552,56.136414 284.315552,58.926510 284.315552,62.106602 
	C287.514282,62.106602 290.326202,62.106602 293.578552,62.106602 
	C293.695099,59.546669 293.794769,57.357605 293.523834,53.572250 
M284.868774,929.698364 
	C281.154846,927.085205 278.359406,928.560974 277.655243,932.368103 
	C277.341370,934.065186 279.422302,937.566345 281.014587,937.987732 
	C285.033142,939.050964 286.909668,936.435425 286.524078,932.380188 
	C286.465271,931.761902 286.066040,931.175964 284.868774,929.698364 
M1362.840210,937.464111 
	C1363.474121,936.021667 1364.975586,934.212463 1364.554321,933.216187 
	C1363.771729,931.364929 1362.115112,929.335693 1360.336548,928.661133 
	C1359.292603,928.265137 1356.333252,930.075928 1355.986938,931.364624 
	C1355.495850,933.192566 1356.195068,935.713196 1357.236206,937.418457 
	C1357.737183,938.238953 1360.184570,937.871155 1362.840210,937.464111 
M573.701172,936.560608 
	C573.944580,935.020264 574.922241,932.932495 574.271057,932.059143 
	C573.093567,930.479736 571.004150,928.885132 569.177979,928.735840 
	C568.015381,928.640930 565.646118,931.109985 565.606018,932.481628 
	C565.552551,934.311157 566.887085,936.565613 568.316101,937.895203 
	C569.052673,938.580505 571.283997,937.659241 573.701172,936.560608 
M796.787292,979.789795 
	C793.965881,976.669373 790.748840,976.518066 788.845398,980.157349 
	C788.051331,981.675598 789.163025,985.285522 790.620178,986.650696 
	C793.369080,989.226135 795.539673,987.392395 796.787292,979.789795 
M797.846924,952.583252 
	C796.783813,951.058533 796.017517,948.805481 794.572937,948.216858 
	C793.166748,947.643921 790.469727,948.215332 789.437317,949.314941 
	C788.393799,950.426331 787.851013,953.405090 788.615540,954.478882 
	C789.678955,955.972473 792.117920,956.987976 794.059143,957.156067 
	C795.123230,957.248108 796.374451,955.178833 797.846924,952.583252 
M666.930176,936.315002 
	C668.967834,936.832275 671.258728,938.193665 672.985718,937.675476 
	C675.800232,936.830994 676.930725,934.098633 675.250610,931.331360 
	C673.528625,928.494934 670.868591,926.930176 668.033997,929.790833 
	C666.859741,930.975769 666.744812,933.210388 666.930176,936.315002 
M2295.743896,929.538330 
	C2291.225098,926.966125 2288.620850,929.255981 2288.300293,933.442871 
	C2288.183105,934.974609 2291.340820,938.136047 2293.020752,938.147522 
	C2296.840820,938.173523 2298.861084,935.577881 2297.373779,931.421814 
	C2297.264893,931.117432 2297.051025,930.850708 2295.743896,929.538330 
M2150.964844,928.258179 
	C2149.596436,929.093079 2147.333008,929.705811 2147.058350,930.812317 
	C2146.584473,932.720337 2146.622314,935.710876 2147.793213,936.805420 
	C2148.983398,937.917969 2152.415283,938.134399 2153.732178,937.179749 
	C2155.008789,936.254272 2155.187256,933.336182 2155.155029,931.304138 
	C2155.141113,930.420410 2153.394531,929.564209 2150.964844,928.258179 
M377.216583,930.516418 
	C373.688873,927.148987 370.405640,927.842834 368.850159,932.072083 
	C368.312378,933.534180 370.388306,937.473022 371.927734,937.897705 
	C376.430267,939.139893 378.607697,936.614319 377.216583,930.516418 
M1887.618896,756.903748 
	C1887.213013,756.868652 1886.807129,756.833618 1886.401245,756.798523 
	C1886.584351,757.044434 1886.767334,757.290344 1887.618896,756.903748 
z"
            />
            <path
                fill="#020202"
                opacity="1.000000"
                stroke="none"
                d="
M1888.383057,752.349060 
	C1897.411743,734.770081 1910.769043,721.008301 1926.493042,709.390808 
	C1946.510986,694.601013 1968.442505,683.729248 1992.608521,677.509155 
	C1994.532471,677.013916 1996.409912,676.337891 1999.075684,675.506958 
	C1999.075684,602.391052 1999.075684,529.240723 1999.075684,455.318481 
	C2049.213623,438.167023 2100.258545,429.395050 2153.079346,426.071594 
	C2153.079346,434.629822 2153.182129,442.207550 2153.061523,449.781677 
	C2152.590332,479.420532 2152.434326,509.071594 2151.410889,538.692200 
	C2150.584473,562.601196 2150.134033,586.561584 2144.208008,610.058655 
	C2134.389648,648.986694 2111.500977,676.043457 2072.866699,687.838806 
	C2052.892090,693.937134 2032.198853,697.831543 2011.672241,701.929626 
	C1987.853149,706.684937 1963.894165,710.654663 1941.183472,719.774536 
	C1923.036011,727.062012 1906.741577,737.114319 1891.572632,751.501831 
	C1889.576050,752.053467 1888.979614,752.201294 1888.383057,752.349060 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M568.959595,463.046509 
	C592.703125,492.010498 603.279907,524.720703 599.465454,561.126526 
	C595.204712,601.791687 575.733459,634.236633 541.434082,656.919556 
	C460.504913,710.439880 351.595184,660.893738 339.537292,563.270996 
	C333.393280,513.528137 358.220306,459.879059 405.044739,433.923981 
	C452.274200,407.744415 509.898834,412.378326 551.286011,445.861847 
	C557.466614,450.862183 562.775940,456.939514 568.959595,463.046509 
M542.105896,550.759033 
	C542.870667,538.908508 540.476990,527.632080 536.116699,516.663086 
	C517.873474,470.769775 461.646210,455.128052 424.850159,486.454987 
	C386.982819,518.693970 387.202728,574.258484 421.660309,606.515259 
	C438.003998,621.815125 457.501984,628.775940 480.272430,624.938843 
	C517.707642,618.630676 541.020447,584.147888 542.105896,550.759033 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M2478.429688,582.366577 
	C2528.588135,546.911438 2599.422363,548.506592 2646.261719,581.453125 
	C2681.950684,606.556335 2701.195557,641.469177 2705.562500,684.452393 
	C2712.523438,752.965088 2670.282959,816.022217 2604.338135,834.613220 
	C2544.693115,851.428284 2481.775879,833.001099 2445.624756,783.325684 
	C2402.386719,723.912537 2410.034668,630.765869 2478.429688,582.366577 
M2607.981201,612.782959 
	C2605.317139,611.415527 2602.708496,609.924133 2599.980469,608.699463 
	C2560.513184,590.982849 2509.403320,601.911377 2484.102051,644.524475 
	C2469.814941,668.587097 2466.580322,694.525940 2472.173828,721.612610 
	C2484.781982,782.665405 2551.404297,814.872070 2605.559570,785.812561 
	C2635.844238,769.561951 2651.630371,743.013977 2654.408447,709.273315 
	C2657.721436,669.035461 2644.390869,635.993164 2607.981201,612.782959 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M3229.995605,729.877075 
	C3216.385010,783.436157 3183.921387,819.058960 3131.803467,834.364929 
	C3068.588867,852.929810 3001.643555,830.559570 2967.440674,775.115723 
	C2919.822754,697.926392 2952.466064,587.956421 3051.020508,561.423340 
	C3116.247803,543.862793 3185.122803,570.092896 3216.683838,630.124634 
	C3233.155273,661.454529 3236.871094,694.546143 3229.995605,729.877075 
M3181.578857,684.127991 
	C3179.627441,676.403931 3178.532959,668.334290 3175.580322,661.014099 
	C3160.577148,623.817688 3132.962891,602.647034 3092.758545,600.906006 
	C3055.100098,599.275208 3026.320312,616.094543 3008.729004,649.485901 
	C2993.095703,679.161133 2992.265625,710.398865 3005.999756,740.969727 
	C3022.306641,777.267334 3051.306885,796.259644 3091.113525,795.997192 
	C3130.741699,795.735901 3158.181152,775.589722 3174.331055,739.737366 
	C3182.069336,722.558472 3183.166748,704.404297 3181.578857,684.127991 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M1372.497559,676.920654 
	C1368.621094,676.744995 1365.683838,676.570374 1362.273560,676.367676 
	C1362.273560,590.993286 1362.273560,506.226196 1362.273560,420.897614 
	C1365.141235,420.648651 1367.377808,420.290802 1369.615479,420.284882 
	C1400.599365,420.202820 1431.583984,420.031616 1462.567139,420.177124 
	C1480.080322,420.259369 1496.894531,423.935333 1512.866455,431.313965 
	C1562.315430,454.158417 1569.843262,499.608215 1563.406616,532.815247 
	C1558.317383,559.070801 1543.001709,577.869629 1520.375488,591.242920 
	C1518.108887,592.582703 1515.799072,593.849243 1512.447144,595.752930 
	C1514.653931,599.322144 1516.433594,602.739990 1518.706543,605.790344 
	C1534.628052,627.156677 1550.658569,648.441711 1566.626587,669.773438 
	C1567.785889,671.321960 1568.726807,673.033813 1570.258789,675.438416 
	C1567.745972,676.073914 1565.995728,676.894836 1564.242065,676.902161 
	C1543.919556,676.987244 1523.595703,676.850342 1503.274292,677.017639 
	C1498.515869,677.056763 1495.208252,675.646362 1492.347778,671.663879 
	C1476.220581,649.210449 1459.855225,626.928040 1443.622925,604.549622 
	C1442.476074,602.968567 1440.972290,601.096558 1440.945435,599.339783 
	C1440.727661,585.104492 1440.823242,570.864502 1440.823242,555.152466 
	C1446.963379,555.152466 1452.159790,555.179688 1457.355835,555.146667 
	C1467.785767,555.080444 1477.903076,553.418884 1487.521362,549.199402 
	C1503.729614,542.088684 1509.704590,528.495056 1509.467651,512.093140 
	C1509.227051,495.432587 1501.810425,482.600830 1485.457275,476.386780 
	C1481.432739,474.857513 1477.192993,473.206085 1472.979370,472.982605 
	C1455.098145,472.034241 1437.189453,471.602142 1418.300171,470.947083 
	C1417.905029,476.470734 1417.350586,480.661133 1417.343994,484.852386 
	C1417.249023,544.821594 1417.228027,604.790894 1417.189697,664.760132 
	C1417.187378,668.335022 1417.189331,671.909851 1417.189331,676.921631 
	C1401.848389,676.921631 1387.642456,676.921631 1372.497559,676.920654 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M1103.951416,512.000000 
	C1103.952148,481.109009 1103.952148,451.218048 1103.952148,420.646027 
	C1122.666992,420.646027 1140.171997,420.646027 1159.056030,420.646027 
	C1159.239746,424.282104 1159.600586,428.106506 1159.600830,431.930908 
	C1159.604736,481.580261 1159.572266,531.229614 1159.512695,580.878967 
	C1159.496948,594.061401 1162.701904,606.031250 1172.826538,615.156921 
	C1175.993042,618.011047 1179.613403,620.744446 1183.514404,622.335510 
	C1201.766113,629.780029 1220.052124,629.106934 1237.651001,620.394897 
	C1248.497925,615.025146 1254.416016,605.360291 1256.489990,593.599365 
	C1257.408569,588.389709 1257.529785,582.990845 1257.538574,577.677063 
	C1257.619019,529.360657 1257.580811,481.044098 1257.627197,432.727600 
	C1257.630859,428.839478 1258.004883,424.951691 1258.232788,420.563904 
	C1276.647461,420.563904 1294.176270,420.563904 1312.713989,420.563904 
	C1313.006348,423.409576 1313.551025,426.260590 1313.555054,429.112396 
	C1313.631348,483.093475 1313.959229,537.076965 1313.564453,591.055054 
	C1313.276855,630.381287 1292.619751,659.169983 1255.585449,672.208130 
	C1218.994263,685.090454 1182.678345,683.685120 1147.937988,666.044617 
	C1118.438354,651.065186 1104.616211,625.551941 1104.005737,592.969482 
	C1103.506470,566.321960 1103.933960,539.657166 1103.951416,512.000000 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M130.167175,419.958679 
	C158.802673,419.796875 186.465164,419.417999 214.125854,419.520447 
	C241.167923,419.620636 266.285614,426.398254 287.802612,443.447449 
	C308.925354,460.184174 319.459930,482.345245 320.280853,509.273560 
	C320.841034,527.649231 317.814514,545.083069 308.205597,561.075378 
	C296.428528,580.676086 279.073669,592.807373 257.352966,598.859009 
	C238.865479,604.009949 219.949371,605.206909 200.858963,603.586182 
	C198.950241,603.424194 197.104523,602.519653 195.081696,601.915588 
	C195.081696,586.788574 195.081696,571.971375 195.081696,556.100647 
	C202.036285,556.100647 208.287598,556.179810 214.536179,556.082886 
	C225.011459,555.920471 235.009521,553.683350 244.406708,548.940796 
	C254.644531,543.773987 260.540771,535.537537 262.703491,524.267578 
	C267.819275,497.609558 255.764908,479.013397 229.297409,473.421631 
	C224.755676,472.462067 220.063950,471.868195 215.427231,471.768372 
	C202.433990,471.488800 189.433304,471.539032 176.435471,471.513336 
	C175.159576,471.510803 173.882935,471.882599 171.531281,472.247528 
	C171.216766,476.475098 170.640259,480.640198 170.637085,484.805725 
	C170.591324,545.133850 170.622513,605.461975 170.635101,665.790100 
	C170.635773,669.034424 170.635178,672.278809 170.635178,676.243896 
	C151.467896,676.243896 133.375305,676.243896 114.870453,676.243896 
	C114.870453,590.743164 114.870453,505.938629 114.870453,419.952332 
	C120.059692,419.952332 124.626541,419.952332 130.167175,419.958679 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M687.324097,572.502563 
	C675.389099,569.738953 665.024048,565.429016 655.343689,559.296814 
	C605.136230,527.492065 612.110962,461.294586 659.488770,434.129242 
	C674.591980,425.469421 690.980469,421.256348 708.104797,420.659088 
	C729.069031,419.927887 750.072510,420.313110 771.059082,420.265381 
	C771.988098,420.263275 772.918274,420.755371 774.507812,421.203186 
	C774.507812,437.929382 774.507812,454.700958 774.507812,472.133057 
	C770.561340,472.361816 767.329529,472.693542 764.095947,472.712097 
	C748.104736,472.803925 732.108887,472.614746 716.123779,472.954224 
	C710.180176,473.080414 704.101807,473.785400 698.383362,475.330994 
	C694.031189,476.507385 689.649536,478.816864 686.150085,481.683228 
	C673.425293,492.105927 675.608948,509.666962 690.388733,516.984558 
	C700.739258,522.109131 711.974976,523.681702 723.363464,523.866272 
	C740.295288,524.140808 756.755981,527.101196 771.372925,535.583923 
	C780.727539,541.012695 790.028625,547.712341 797.003479,555.855286 
	C824.561768,588.028381 816.880859,635.169739 780.786133,660.716492 
	C764.467957,672.265991 745.884583,676.983093 726.315857,678.220276 
	C703.328735,679.673523 680.961975,676.905151 660.571594,665.331543 
	C638.013916,652.527893 624.550903,633.247742 621.135193,607.297058 
	C620.962341,605.983582 620.937866,604.638306 620.987549,603.313171 
	C621.011230,602.683655 621.372681,602.066833 621.872681,600.573059 
	C639.669189,600.573059 657.775330,600.573059 676.201965,600.573059 
	C676.554382,601.110657 677.386719,601.861267 677.578369,602.750000 
	C680.635681,616.930420 690.807983,622.943176 703.853882,625.137695 
	C717.508484,627.434631 731.115051,627.528992 743.700439,620.478149 
	C755.078064,614.103821 759.473877,602.153320 753.464966,591.753601 
	C750.978333,587.449890 746.483521,583.726257 742.058533,581.239929 
	C731.872986,575.516663 720.177368,576.199158 708.954163,575.026978 
	C702.010193,574.301819 695.079224,573.451355 687.324097,572.502563 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M2725.220459,825.820923 
	C2725.501953,817.261841 2723.734863,808.717651 2726.656982,802.312683 
	C2729.422363,796.250977 2737.066895,792.385376 2742.637451,787.638428 
	C2772.300049,762.360840 2802.210693,737.367310 2831.538574,711.707520 
	C2841.504639,702.988037 2850.593750,693.085449 2859.048096,682.867126 
	C2868.540283,671.394836 2872.082520,657.637939 2870.645752,642.663086 
	C2868.669678,622.067749 2853.404297,607.398499 2832.678711,605.738892 
	C2813.916504,604.236511 2797.811768,609.777710 2784.468506,622.922546 
	C2777.130859,630.150940 2770.256592,637.849304 2762.521484,646.024963 
	C2751.828369,637.734680 2740.893799,629.257141 2729.418945,620.360596 
	C2734.454590,611.035706 2741.412354,603.547180 2748.275146,596.045532 
	C2762.594238,580.392944 2780.000244,569.692627 2800.768311,565.053284 
	C2824.339600,559.787720 2847.730957,560.263245 2870.489258,569.173340 
	C2903.257812,582.002319 2922.447266,612.566711 2920.933350,647.687378 
	C2919.893555,671.813904 2911.150635,692.500427 2894.697266,709.698303 
	C2883.900635,720.983276 2872.231689,731.499268 2860.385010,741.699646 
	C2840.698975,758.650208 2820.554932,775.068420 2800.607422,791.715698 
	C2798.679443,793.324829 2796.780029,794.968445 2792.998535,798.186340 
	C2837.895996,798.186340 2880.298584,798.186340 2923.199219,798.186340 
	C2923.199219,812.331116 2923.199219,825.523926 2923.199219,838.750244 
	C2916.390381,840.636169 2742.509766,841.404724 2725.220459,839.499268 
	C2725.220459,835.327393 2725.220459,831.048828 2725.220459,825.820923 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M2390.711914,621.625122 
	C2398.436523,655.419983 2390.838867,684.697266 2367.754883,709.239258 
	C2355.700928,722.054688 2342.284180,733.649841 2328.964844,745.198730 
	C2311.605225,760.250916 2293.724121,774.701355 2276.086182,789.433228 
	C2273.350586,791.718262 2270.714844,794.122925 2266.319824,797.972534 
	C2310.629883,797.972534 2352.947510,797.972534 2395.719727,797.972534 
	C2395.719727,812.337708 2395.719727,825.552979 2395.719727,838.829346 
	C2388.992188,840.657166 2213.623779,841.263367 2198.379883,839.395996 
	C2198.379883,827.253235 2198.379883,815.036438 2198.379883,802.055359 
	C2218.434082,785.008301 2239.006348,767.580872 2259.509766,750.073059 
	C2276.984619,735.151184 2294.771240,720.560120 2311.649902,704.988220 
	C2320.379395,696.934692 2328.075195,687.532471 2335.074707,677.894653 
	C2342.543945,667.610046 2344.782471,655.391235 2343.601562,642.707642 
	C2341.760986,622.943176 2327.208252,608.175232 2307.492920,605.989258 
	C2289.347900,603.977417 2272.987305,608.137878 2259.549072,620.907471 
	C2251.368896,628.680786 2243.750732,637.046021 2235.052490,645.996948 
	C2224.302246,637.585693 2213.217529,628.912842 2201.875488,620.038696 
	C2219.911621,593.825989 2240.847412,572.683777 2272.395996,565.340881 
	C2296.631104,559.700073 2320.652588,560.071411 2343.984619,569.534851 
	C2367.646973,579.132324 2383.458984,596.052429 2390.711914,621.625122 
z"
            />
            <path
                fill="#9E9E9D"
                opacity="1.000000"
                stroke="none"
                d="
M1878.129395,512.321411 
	C1890.686401,484.029663 1907.973755,460.268402 1932.686157,442.574982 
	C1940.752930,436.799500 1949.815674,432.395172 1958.535522,427.567413 
	C1960.408081,426.530731 1962.768066,426.374756 1965.634277,425.620880 
	C1965.634277,503.919495 1965.634277,581.368713 1965.634277,659.327698 
	C1905.365479,680.626587 1873.878174,726.709167 1856.398682,785.733521 
	C1856.342651,784.757629 1856.258057,783.782288 1856.237305,782.805603 
	C1856.208984,781.473999 1856.228638,780.141418 1856.228638,778.809265 
	C1856.230835,726.855225 1855.812012,674.896484 1856.389648,622.948853 
	C1856.749634,590.581909 1861.028320,558.630981 1872.110718,527.930908 
	C1873.917236,522.926514 1875.953003,518.004761 1878.129395,512.321411 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4051.999512,848.419739 
	C3875.353027,848.419739 3699.706787,848.420349 3524.060303,848.418396 
	C3509.593018,848.418274 3509.582764,848.410278 3509.582520,834.419861 
	C3509.579834,700.435303 3509.580322,566.450745 3509.580322,432.466187 
	C3509.580322,431.132996 3509.556396,429.799316 3509.584961,428.466736 
	C3509.784180,419.199066 3510.561035,418.441650 3520.086914,418.248749 
	C3521.752930,418.214996 3523.419678,418.243622 3525.086182,418.243622 
	C3726.062988,418.243622 3927.039795,418.243378 4128.016602,418.244049 
	C4143.743164,418.244110 4143.750000,418.247070 4143.750000,433.503632 
	C4143.751953,566.821594 4143.751465,700.139526 4143.749512,833.457520 
	C4143.749512,848.411621 4143.743164,848.416382 4128.990723,848.418640 
	C4103.660156,848.422546 4078.330078,848.419739 4051.999512,848.419739 
M4138.257324,625.000061 
	C4138.257324,558.465149 4138.257324,491.930237 4138.257324,425.683411 
	C3929.956543,425.683411 3722.860352,425.683411 3515.510254,425.683411 
	C3515.510254,564.464478 3515.510254,702.570923 3515.510254,841.137268 
	C3723.172607,841.137268 3930.254395,841.137268 4138.257324,841.137268 
	C4138.257324,769.437134 4138.257324,698.218628 4138.257324,625.000061 
z"
            />
            <path
                fill="#7F7F7F"
                opacity="1.000000"
                stroke="none"
                d="
M839.351440,670.114197 
	C837.364441,655.909058 838.381653,641.716492 838.725464,627.745422 
	C845.854004,625.789490 1049.239014,625.591370 1060.103271,627.560364 
	C1060.505493,643.403870 1060.224121,659.508423 1060.045410,676.470215 
	C1055.849243,676.815918 1052.621460,677.307190 1049.392456,677.314697 
	C982.731995,677.469421 916.071472,677.594910 849.410889,677.599121 
	C846.259766,677.599304 843.108582,676.425049 840.744507,674.942261 
	C858.674194,674.086792 875.816833,674.086792 892.637878,674.086792 
	C894.958923,661.853088 894.513000,637.332581 891.929260,630.002808 
	C875.727478,629.964905 859.305908,629.770264 841.881653,630.123352 
	C841.881653,641.411804 841.990417,651.304504 841.817322,661.192261 
	C841.763245,664.279907 843.278809,668.015320 839.351440,670.114197 
z"
            />
            <path
                fill="#9E9E9D"
                opacity="1.000000"
                stroke="none"
                d="
M839.726868,423.839661 
	C840.141602,418.570068 844.251038,419.898132 847.266968,419.865814 
	C860.579102,419.723236 873.893616,419.740540 887.207031,419.775574 
	C940.791870,419.916565 994.376709,420.086243 1047.961548,420.242981 
	C1051.539795,420.253448 1055.118042,420.244354 1059.944702,420.244354 
	C1060.415894,437.548920 1060.093384,453.693787 1059.984375,471.077026 
	C1055.881836,471.335052 1052.391113,471.740601 1048.899902,471.745361 
	C1013.951782,471.792908 979.003540,471.732788 944.055481,471.787231 
	C912.770203,471.835968 881.484924,472.059998 850.200012,471.999054 
	C846.790344,471.992371 843.383362,470.611755 840.777710,468.988861 
	C858.693542,468.109283 875.806763,468.109283 892.601074,468.109283 
	C894.892761,456.437622 894.524597,431.700714 891.952271,423.839661 
	C874.755798,423.839661 857.241333,423.839661 839.726868,423.839661 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M864.175720,522.502197 
	C873.358032,518.363953 882.972473,521.014587 892.387817,520.836792 
	C897.321533,520.743530 902.272095,521.936829 907.216248,521.946289 
	C954.117676,522.036072 1001.019287,521.996155 1047.920898,521.993591 
	C1051.478882,521.993408 1055.036865,521.993652 1059.813354,521.993652 
	C1060.510620,538.995605 1060.107910,554.758728 1059.979614,571.666443 
	C1054.846802,572.369446 1050.375732,573.501953 1045.901001,573.516663 
	C980.373047,573.732910 914.844604,573.829407 849.316284,573.810364 
	C846.241394,573.809448 843.166931,572.462402 840.900757,570.882812 
	C858.804138,570.023315 875.899048,570.023315 894.062683,570.023315 
	C894.062683,558.042358 894.073120,547.531128 894.059937,537.019897 
	C894.043823,524.171753 894.031799,524.333374 881.562439,524.063416 
	C875.758362,523.937744 869.970764,523.046448 864.175720,522.502197 
z"
            />
            <path
                fill="#9E9E9D"
                opacity="1.000000"
                stroke="none"
                d="
M1934.408936,827.895020 
	C1923.893799,824.319641 1913.931396,821.454529 1904.637573,817.147095 
	C1899.736206,814.875549 1895.271729,810.654297 1891.899048,806.312073 
	C1885.886597,798.570740 1888.114868,789.896606 1891.332275,781.619385 
	C1895.997070,769.618530 1904.745239,761.000061 1915.435669,754.447144 
	C1936.826172,741.335571 1960.555786,735.262756 1985.219604,732.315125 
	C1985.776855,732.248596 1986.403931,732.765686 1987.577637,733.249146 
	C1987.577637,766.163818 1987.577637,799.304932 1987.577637,833.537964 
	C1969.697998,833.569214 1952.425293,831.298218 1934.408936,827.895020 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2352.009766,438.690247 
	C2352.868164,430.819885 2346.479248,432.763916 2342.676758,430.562500 
	C2342.565918,428.257874 2342.446289,425.767853 2342.341064,423.575775 
	C2343.475830,422.905823 2344.033936,422.291229 2344.600586,422.283569 
	C2356.909912,422.117615 2369.244385,421.486664 2381.523926,422.046539 
	C2395.982422,422.705811 2403.587402,432.092682 2402.002686,445.836975 
	C2401.306152,451.878204 2398.008789,456.325714 2393.363770,459.869873 
	C2391.032715,461.648468 2388.445557,463.091705 2385.185303,465.195892 
	C2389.727051,472.219788 2393.940186,478.920319 2398.392334,485.458130 
	C2399.239014,486.701599 2400.921143,487.758362 2402.407471,488.117432 
	C2408.482910,489.585266 2408.263916,493.392273 2406.176514,499.359528 
	C2401.250977,499.359528 2395.973145,499.833344 2390.857178,499.129425 
	C2388.771484,498.842499 2386.552490,496.313293 2385.232422,494.264191 
	C2380.910156,487.555389 2377.010010,480.575989 2372.864990,473.750977 
	C2371.706787,471.844116 2370.261719,470.111511 2368.382812,467.518494 
	C2364.853271,473.975494 2367.118896,479.927979 2366.402344,485.998932 
	C2369.958252,488.990814 2377.003662,490.426636 2372.097900,499.158081 
	C2364.214844,499.210999 2355.365479,499.481842 2346.541016,499.126617 
	C2345.026367,499.065643 2342.626953,496.451324 2342.437744,494.808838 
	C2342.243408,493.123749 2343.905518,490.775940 2345.409912,489.474640 
	C2346.807373,488.265961 2349.067871,488.054932 2352.015869,487.035400 
	C2352.015869,471.417053 2352.015869,455.511810 2352.009766,438.690247 
M2369.326660,455.952148 
	C2371.962891,455.909119 2374.674805,456.249542 2377.220459,455.747040 
	C2383.432373,454.520813 2386.637207,449.953888 2386.276611,443.502167 
	C2385.936035,437.412964 2382.822266,434.365936 2375.971436,433.895508 
	C2373.130371,433.700409 2370.246338,434.132111 2366.944824,434.301147 
	C2366.439453,441.833221 2365.049072,448.594757 2369.326660,455.952148 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2336.274414,451.733978 
	C2338.500488,464.234100 2336.156494,475.061890 2329.543457,484.775970 
	C2316.931885,503.301697 2293.012939,503.004059 2279.659912,495.465393 
	C2277.665527,494.339355 2275.750977,492.827240 2274.257080,491.098328 
	C2262.945801,478.008820 2261.825928,462.796356 2266.323242,447.034515 
	C2270.284180,433.151947 2279.729248,424.568115 2294.135010,421.468628 
	C2316.104492,416.741821 2332.441406,428.046417 2336.274414,451.733978 
M2312.755859,482.066650 
	C2322.008301,473.437042 2321.026367,462.268921 2319.999756,451.316315 
	C2319.143799,442.182709 2312.585693,435.441925 2304.426514,434.204926 
	C2294.854492,432.753784 2285.936768,437.099640 2282.936768,446.419159 
	C2280.862793,452.861938 2279.848389,460.190826 2280.573975,466.883911 
	C2282.479248,484.462067 2295.221924,490.759888 2312.755859,482.066650 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2664.162109,479.636719 
	C2661.238770,479.650604 2659.098145,479.215057 2657.288574,479.801849 
	C2655.364502,480.425690 2652.782959,481.709198 2652.284424,483.276123 
	C2651.798584,484.802307 2653.045654,487.973236 2654.475342,488.810028 
	C2658.736816,491.304474 2658.505371,494.342133 2656.301514,499.451477 
	C2649.273193,499.451477 2641.703613,499.670715 2634.163574,499.293488 
	C2632.334229,499.201996 2629.331543,497.337952 2629.120850,495.947388 
	C2628.794189,493.792542 2629.855225,489.814789 2631.290771,489.301453 
	C2635.980713,487.624054 2636.634033,483.682465 2637.929688,480.076996 
	C2643.432617,464.761688 2648.779297,449.390350 2654.219482,434.052338 
	C2655.546631,430.311127 2657.012207,426.618927 2658.576172,422.474701 
	C2664.590820,422.474701 2670.433594,422.474701 2676.789062,422.474701 
	C2680.490723,432.563171 2684.171387,442.482239 2687.769043,452.431366 
	C2691.269775,462.113586 2694.542725,471.881409 2698.233154,481.489807 
	C2699.240234,484.111511 2700.907715,486.991180 2703.122314,488.525269 
	C2707.083008,491.268555 2706.636963,494.388123 2705.491211,498.703918 
	C2696.050781,498.703918 2686.668213,498.703918 2677.739990,498.703918 
	C2673.338623,491.149841 2679.161133,489.520386 2683.204346,487.405396 
	C2683.098389,481.512329 2680.422607,479.221466 2675.063477,479.598755 
	C2671.754639,479.831665 2668.415771,479.638763 2664.162109,479.636719 
M2660.152832,467.598236 
	C2665.291748,467.598236 2670.430664,467.598236 2676.967285,467.598236 
	C2675.128662,461.787811 2673.860107,457.449371 2672.378418,453.185059 
	C2670.792969,448.623291 2669.007080,444.131348 2666.885742,438.482788 
	C2664.903809,444.332214 2663.157959,448.955902 2661.786377,453.688019 
	C2660.536865,457.999969 2659.692871,462.429535 2660.152832,467.598236 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2585.594727,499.274536 
	C2564.015137,492.477081 2556.458252,480.812347 2557.782227,457.373108 
	C2558.821045,438.985657 2571.359375,425.522217 2589.774658,421.662720 
	C2600.618896,419.389954 2610.685303,421.505585 2621.304688,423.553223 
	C2621.304688,430.548218 2621.304688,436.719910 2621.304688,443.468842 
	C2617.589355,443.468842 2614.428711,443.468842 2611.366211,443.468842 
	C2607.669922,433.695740 2607.352051,433.491943 2596.929199,434.011414 
	C2583.785156,434.666534 2574.700684,443.670319 2573.906006,456.928192 
	C2573.747070,459.580383 2573.748535,462.258759 2573.909912,464.910828 
	C2574.677734,477.520844 2583.062012,485.757629 2595.765625,486.236481 
	C2599.335938,486.371063 2602.927734,485.935242 2607.155518,485.729614 
	C2607.155518,480.177429 2607.155518,475.348175 2607.155518,470.124939 
	C2604.482910,469.115265 2601.761963,468.087402 2598.574219,466.883118 
	C2598.574219,464.472534 2598.574219,461.967529 2598.574219,459.460510 
	C2599.868164,459.009857 2600.784668,458.424286 2601.709229,458.410889 
	C2609.028076,458.304962 2616.358887,458.088318 2623.661377,458.429565 
	C2625.521973,458.516510 2628.603027,460.283752 2628.803955,461.626038 
	C2629.111084,463.677002 2627.970947,467.329956 2626.437256,468.001953 
	C2622.400635,469.770599 2622.263916,472.686890 2622.280273,476.109863 
	C2622.309814,482.379944 2622.288818,488.650269 2622.288818,494.769104 
	C2610.255127,500.764099 2598.378418,500.484497 2585.594727,499.274536 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2499.609863,446.211700 
	C2499.638672,455.833832 2499.464355,464.490631 2499.751709,473.132111 
	C2500.070312,482.716431 2503.968506,486.953552 2512.563721,487.830292 
	C2522.847412,488.879242 2530.008057,484.922394 2530.859375,475.558350 
	C2532.028809,462.693115 2531.559814,449.668365 2531.474609,436.714050 
	C2531.464844,435.230988 2529.656250,432.796875 2528.271729,432.452728 
	C2522.342529,430.979034 2523.514404,427.143402 2524.543945,422.536682 
	C2533.713867,422.536682 2542.874512,422.536682 2552.451416,422.536682 
	C2554.995850,428.682648 2552.431152,431.926208 2546.010742,433.146698 
	C2546.010742,445.252441 2546.080566,456.857910 2545.996582,468.462250 
	C2545.804932,494.930084 2519.993408,509.723907 2496.556641,496.716736 
	C2487.404053,491.637024 2484.490967,482.908142 2484.280518,473.129761 
	C2484.044189,462.155334 2484.232910,451.172180 2484.186523,440.193024 
	C2484.171387,436.622589 2484.769043,433.102753 2479.919922,431.259888 
	C2478.338867,430.658936 2478.158691,426.371033 2476.994385,422.681152 
	C2487.505127,422.681152 2496.653809,422.681152 2505.898438,422.681152 
	C2508.323486,430.044434 2508.323486,430.044434 2499.610352,433.919250 
	C2499.610352,437.391876 2499.610352,441.315735 2499.609863,446.211700 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M863.287842,522.363281 
	C869.970764,523.046448 875.758362,523.937744 881.562439,524.063416 
	C894.031799,524.333374 894.043823,524.171753 894.059937,537.019897 
	C894.073120,547.531128 894.062683,558.042358 894.062683,570.023315 
	C875.899048,570.023315 858.804138,570.023315 840.755737,570.073364 
	C839.657104,555.900513 839.512024,541.677551 840.290527,526.682129 
	C843.965637,525.657898 847.284180,526.575317 848.193665,522.524902 
	C852.929077,522.424744 857.664490,522.324524 863.287842,522.363281 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M839.465942,424.628296 
	C857.241333,423.839661 874.755798,423.839661 891.952271,423.839661 
	C894.524597,431.700714 894.892761,456.437622 892.601074,468.109283 
	C875.806763,468.109283 858.693542,468.109283 840.612793,468.169861 
	C839.498596,453.959259 839.351868,439.688110 839.465942,424.628296 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2223.580078,498.506256 
	C2215.009033,498.507690 2207.374512,498.507690 2199.940918,498.507690 
	C2197.672607,490.777222 2197.672607,490.777222 2207.415527,486.849365 
	C2207.415527,469.436279 2207.415527,451.834503 2207.415527,433.585846 
	C2204.904785,432.771240 2202.180908,431.887512 2198.712891,430.762390 
	C2198.712891,428.296783 2198.712891,425.589478 2198.712891,421.988007 
	C2211.476074,421.988007 2223.781982,421.335907 2235.986816,422.169800 
	C2248.399170,423.017883 2255.852783,430.664124 2257.547119,442.120483 
	C2259.097900,452.609314 2252.577881,464.669403 2242.138672,468.781006 
	C2236.372070,471.052216 2229.980957,471.737427 2223.005371,473.336060 
	C2223.005371,477.162354 2223.005371,481.666046 2223.005371,486.998077 
	C2225.441406,488.021912 2228.403076,489.266541 2231.270264,490.471558 
	C2231.799316,497.588806 2231.799316,497.588806 2223.580078,498.506256 
M2228.624268,433.797821 
	C2225.587891,433.834167 2222.333496,433.624298 2222.303711,438.046082 
	C2222.257568,444.924591 2222.291504,451.803711 2222.291504,458.486908 
	C2233.316650,460.252411 2240.367432,456.553864 2241.858398,448.945312 
	C2243.424805,440.952393 2239.950928,436.405457 2228.624268,433.797821 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M839.142151,670.617065 
	C843.278809,668.015320 841.763245,664.279907 841.817322,661.192261 
	C841.990417,651.304504 841.881653,641.411804 841.881653,630.123352 
	C859.305908,629.770264 875.727478,629.964905 891.929260,630.002808 
	C894.513000,637.332581 894.958923,661.853088 892.637878,674.086792 
	C875.816833,674.086792 858.674194,674.086792 840.564331,674.142639 
	C839.375732,673.172302 839.154297,672.146118 839.142151,670.617065 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2412.600586,421.982971 
	C2432.449707,421.938629 2451.359375,421.938629 2470.911865,421.938629 
	C2470.911865,429.413635 2470.911865,435.860046 2470.911865,442.974945 
	C2467.476807,443.305847 2464.636475,443.579468 2461.412842,443.890015 
	C2460.254395,440.721039 2459.262695,438.008362 2458.073486,434.755127 
	C2454.526367,434.755127 2451.053711,434.755127 2446.978516,434.755127 
	C2446.978516,452.301666 2446.978516,469.485260 2446.978516,487.022949 
	C2449.496826,487.926910 2452.249268,488.375183 2454.268311,489.836700 
	C2455.533203,490.752136 2456.409912,493.309143 2456.145752,494.913300 
	C2455.893799,496.445282 2454.032715,498.785736 2452.717773,498.898926 
	C2442.850098,499.748260 2432.946289,500.045319 2422.739502,498.695618 
	C2422.559326,495.691132 2422.426025,493.470367 2422.264648,490.778473 
	C2425.480957,489.462708 2428.456543,488.245514 2431.385254,487.047455 
	C2431.385254,469.506348 2431.385254,452.319489 2431.385254,434.648651 
	C2427.910645,434.429993 2425.009033,434.247375 2421.678955,434.037842 
	C2420.528320,436.985199 2419.483887,439.660187 2418.170166,443.024811 
	C2415.240967,443.024811 2412.148926,443.024811 2408.190186,443.024811 
	C2408.190186,436.764618 2408.024414,430.847076 2408.346191,424.956207 
	C2408.402832,423.922668 2410.504395,423.000793 2412.600586,421.982971 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1507.158936,740.156738 
	C1506.978516,735.083191 1508.019287,732.216064 1513.216309,732.533264 
	C1517.816284,732.813965 1522.446899,732.592102 1528.441772,732.592102 
	C1528.977173,748.090942 1528.735474,762.827148 1528.641846,778.409058 
	C1524.722168,778.409058 1521.641235,778.409058 1517.500244,778.409058 
	C1517.500244,767.617920 1517.500244,757.138000 1517.500244,745.789429 
	C1513.400879,745.536560 1510.300171,745.345276 1506.681763,745.122070 
	C1506.681763,751.066162 1506.979370,756.022400 1506.621460,760.930908 
	C1505.798828,772.214783 1498.270020,779.743225 1487.637207,780.336060 
	C1476.752808,780.942871 1467.677124,773.662537 1466.144775,762.432678 
	C1465.524902,757.890015 1465.520630,753.028748 1466.428711,748.554443 
	C1469.711548,732.379700 1488.296997,726.663696 1500.764771,737.505981 
	C1502.401978,738.929565 1502.576172,744.333130 1507.158936,740.156738 
M1479.359131,765.163574 
	C1487.633789,771.280396 1494.916260,768.544495 1495.971191,758.681641 
	C1496.275269,755.838135 1495.729248,752.721191 1494.825684,749.975525 
	C1493.598755,746.246826 1490.767090,744.019226 1486.569214,744.052185 
	C1482.504517,744.084045 1479.679443,746.030640 1477.955688,749.642639 
	C1475.637207,754.500549 1476.022827,759.265259 1479.359131,765.163574 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M108.694824,100.786606 
	C109.011017,92.356415 108.362526,84.457870 110.278885,77.240318 
	C116.079811,55.392384 142.736420,44.633362 162.678452,55.434319 
	C170.045486,59.424438 174.662918,65.519043 177.393524,74.487129 
	C173.724014,75.339745 170.683014,76.046333 167.860168,76.702232 
	C159.396606,61.993500 150.863297,57.960880 137.543182,61.677334 
	C129.908356,63.807533 124.659668,68.532021 121.975777,75.878632 
	C118.071053,86.567017 117.986839,97.432800 121.712509,108.175247 
	C125.255714,118.391594 132.834412,123.745811 143.448074,124.224602 
	C154.304779,124.714355 162.074982,120.302475 166.392563,110.177956 
	C167.045135,108.647690 167.712051,107.123535 168.647507,104.960152 
	C171.602509,105.480919 174.689743,106.024986 177.741882,106.562874 
	C175.671036,123.865288 160.915497,135.034637 142.788422,133.619354 
	C123.576218,132.119339 113.867210,122.953529 108.694824,100.786606 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M636.553589,116.905243 
	C633.639526,108.029709 633.540588,99.871483 635.928528,91.638794 
	C640.904480,74.483833 656.812256,68.734535 671.816956,78.695938 
	C672.280640,79.003784 672.961426,78.984634 674.358582,79.305962 
	C674.358582,70.706573 674.358582,62.251545 674.358582,53.047611 
	C677.842957,52.718952 680.595581,52.459312 683.974731,52.140583 
	C683.974731,78.928017 683.974731,105.027634 683.974731,131.494415 
	C679.726807,133.774933 676.319031,132.507004 673.765076,127.956245 
	C667.238159,132.166534 660.906921,135.140549 653.092651,132.642212 
	C645.177246,130.111572 640.092102,124.985558 636.553589,116.905243 
M659.288513,124.251015 
	C665.564331,124.684883 670.527588,122.189888 673.195923,116.610268 
	C677.452332,107.709641 677.339478,98.440994 672.529236,89.847061 
	C667.479370,80.825119 655.513550,79.937386 648.929504,87.585823 
	C639.434326,98.615845 644.183350,118.439194 659.288513,124.251015 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M832.187500,77.580963 
	C843.721008,89.025856 846.430786,106.770790 839.501099,120.272652 
	C833.954590,131.079514 818.180786,138.212524 807.344360,130.082870 
	C806.391235,129.367828 805.078369,129.132233 802.614014,128.146439 
	C802.614014,133.311142 802.614014,137.528198 802.614014,141.745239 
	C802.614014,145.685867 802.614014,149.626495 802.614014,153.937500 
	C799.096680,153.937500 796.282410,153.937500 793.150024,153.937500 
	C793.150024,127.299835 793.150024,101.158516 793.150024,75.047882 
	C798.261108,73.597221 802.338196,73.185402 802.244751,80.972412 
	C811.521118,72.874374 821.153564,70.900215 832.187500,77.580963 
M805.933411,118.848969 
	C817.645447,128.528702 829.636658,124.727928 832.461182,110.111237 
	C833.319519,105.669350 833.201294,100.801659 832.407715,96.328148 
	C830.865967,87.636795 824.947510,82.453651 817.804504,82.481270 
	C810.994934,82.507599 804.376831,88.146690 802.677490,96.192024 
	C801.144775,103.448502 801.105835,110.771873 805.933411,118.848969 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M591.285706,83.736206 
	C587.623474,86.185265 584.792419,88.369133 581.961365,90.552994 
	C582.344543,91.094406 582.727783,91.635818 583.110962,92.177238 
	C580.529114,91.991608 577.947266,91.805984 575.519043,91.631409 
	C575.197449,90.682838 574.747498,90.065079 574.854858,89.567528 
	C576.883301,80.163994 583.498901,75.676498 592.324036,74.251923 
	C596.859314,73.519829 601.625549,73.554504 606.219238,73.979507 
	C617.373596,75.011528 622.193542,80.173096 622.609009,91.309090 
	C623.103027,104.549484 623.346619,117.799225 623.721375,131.898254 
	C619.840271,133.053848 615.277283,134.007706 613.356995,127.239571 
	C608.636719,129.082825 604.193604,131.098785 599.567688,132.519394 
	C596.770813,133.378296 593.665588,133.750793 590.741577,133.585892 
	C579.972168,132.978470 572.713989,126.482185 572.376465,117.545822 
	C572.058716,109.131920 578.369934,102.025276 588.391785,100.024399 
	C596.456116,98.414330 604.602844,97.216728 612.582581,95.858307 
	C612.138672,86.300407 610.914246,84.188530 603.898987,83.086601 
	C600.085876,82.487648 596.051453,83.296921 591.285706,83.736206 
M583.097473,117.047684 
	C587.325012,124.151291 593.983459,126.288551 602.420959,123.250160 
	C610.671753,120.279007 613.582214,114.779106 611.707275,105.382088 
	C605.166199,106.381546 598.584961,107.239357 592.066345,108.437683 
	C588.050415,109.175926 584.309265,110.660187 583.097473,117.047684 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M2720.033691,442.408386 
	C2719.899658,438.853790 2719.765869,436.243591 2719.604980,433.102722 
	C2716.589355,432.374054 2713.815186,431.703705 2710.655762,430.940277 
	C2710.655762,428.048126 2710.655762,425.568909 2710.655762,422.503601 
	C2721.990967,422.503601 2732.833008,422.503601 2743.688965,422.503601 
	C2745.966064,430.195770 2745.966064,430.195770 2735.111084,433.730896 
	C2735.111084,450.614502 2735.111084,467.728699 2735.111084,485.612671 
	C2739.544189,485.612671 2743.687500,485.612671 2748.576904,485.612671 
	C2749.494141,483.497650 2750.621826,480.897308 2751.800781,478.178650 
	C2754.951904,478.178650 2757.833740,478.178650 2761.349609,478.178650 
	C2761.349609,484.819305 2761.349609,490.992615 2761.349609,497.735840 
	C2759.641602,498.284821 2757.850342,499.341736 2756.046875,499.363037 
	C2743.086426,499.516083 2730.123291,499.391296 2717.161865,499.499664 
	C2711.508301,499.546936 2709.088867,497.242645 2710.728760,490.892242 
	C2711.745117,490.364380 2713.124268,489.539246 2714.589600,488.917480 
	C2716.090332,488.280731 2717.675781,487.843018 2720.033691,487.043579 
	C2720.033691,472.508972 2720.033691,457.930878 2720.033691,442.408386 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M374.049591,104.034973 
	C381.342468,101.781845 387.972443,99.856613 394.671844,98.214706 
	C398.810303,97.200432 403.054504,96.617546 407.086090,95.871552 
	C407.660065,86.893997 406.450256,84.559410 399.479706,83.179649 
	C392.122040,81.723267 384.595245,81.329529 380.209991,89.244209 
	C377.625702,93.908417 374.041077,91.415085 369.931396,91.949333 
	C370.407227,83.946968 374.125397,79.058998 380.600189,76.292496 
	C388.833740,72.774529 397.495056,72.678314 406.004852,74.875397 
	C413.731323,76.870232 417.391022,81.765923 417.783203,90.197502 
	C418.153412,98.156593 417.792389,106.147156 418.017212,114.116417 
	C418.174866,119.705322 418.776276,125.281708 419.243042,131.742050 
	C414.505188,133.447830 410.029266,133.471115 408.463684,128.088806 
	C400.777466,130.095016 393.931091,132.898712 386.910858,133.437637 
	C379.408203,134.013596 372.133179,131.262283 368.927094,123.474365 
	C366.008240,116.384155 367.537506,109.778412 374.049591,104.034973 
M387.857239,108.242355 
	C385.983582,108.857559 383.560760,108.950241 382.363281,110.208809 
	C380.504730,112.162262 378.445251,114.902039 378.427002,117.323219 
	C378.412079,119.301819 380.871765,122.360580 382.902710,123.096848 
	C389.355621,125.436234 395.970520,125.000175 401.808960,120.965141 
	C407.225494,117.221649 409.016846,112.004898 407.381439,105.236313 
	C401.128662,106.209152 395.327789,107.111679 387.857239,108.242355 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M449.329224,772.503784 
	C447.351868,771.028137 445.212463,769.650391 445.173431,768.215515 
	C444.886078,757.646729 445.018127,747.066528 445.018127,736.068237 
	C452.087708,734.408447 458.003326,733.920349 464.622528,736.292358 
	C461.770782,743.957031 454.531738,738.264648 450.425995,742.526672 
	C450.425995,744.326233 450.425995,746.877808 450.425995,749.913818 
	C454.171753,750.643127 457.831940,751.355713 461.628693,752.094971 
	C460.427551,759.497742 453.743622,754.905396 450.444824,759.459839 
	C450.377808,760.627319 450.234680,763.121460 450.073334,765.933350 
	C456.085724,766.936829 461.505707,767.841431 467.936646,768.914795 
	C467.936646,758.720703 467.936646,747.928345 467.936646,737.144348 
	C476.012268,733.466064 483.225616,733.219055 489.062988,738.558533 
	C496.026642,744.928040 489.843201,751.072327 486.871704,757.406067 
	C488.954224,761.316772 491.072937,765.295410 493.876678,770.560486 
	C503.716064,758.428955 509.334473,744.854675 518.979675,733.783752 
	C523.254028,740.482849 523.925476,761.757324 520.451416,772.900879 
	C518.785889,769.837952 517.514709,767.500305 516.240967,765.161560 
	C508.828857,762.785583 503.274536,765.107605 499.730103,772.102661 
	C496.204407,772.102661 492.957733,772.102661 488.724915,772.102661 
	C486.944061,768.895508 485.187622,764.980713 482.720123,761.582153 
	C481.333008,759.671692 478.771576,758.613770 476.739197,757.171753 
	C475.539062,759.230652 473.976715,761.169556 473.243500,763.383179 
	C472.547180,765.485474 472.718353,767.875122 472.483551,770.402893 
	C464.735046,771.156250 457.437378,771.865723 449.329224,772.503784 
M473.379242,743.442810 
	C473.195343,746.854126 472.884705,750.688232 477.829559,750.387451 
	C480.469299,750.226807 484.148560,749.441040 485.363159,747.612183 
	C487.309235,744.681946 486.643341,741.107666 481.280273,739.033875 
	C477.939880,737.530212 474.925446,736.962219 473.379242,743.442810 
M510.741028,757.231506 
	C512.869568,757.462158 514.998108,757.692810 517.592102,757.973938 
	C518.168335,753.748962 519.089722,750.209961 516.117004,745.669006 
	C513.820862,749.680664 512.087585,752.708923 510.741028,757.231506 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M240.961639,95.524803 
	C241.034119,101.611244 241.559784,107.012596 240.620911,112.146103 
	C238.134552,125.740616 227.213654,134.156616 213.612442,133.694427 
	C199.280869,133.207428 189.197174,123.930527 187.743393,109.587357 
	C187.343231,105.639374 187.334702,101.582283 187.732880,97.634399 
	C189.838425,76.758537 213.229004,66.172859 230.447891,78.244194 
	C236.174576,82.258911 239.558151,87.823395 240.961639,95.524803 
M224.792725,86.090065 
	C209.796280,78.337662 198.228394,84.910446 197.622986,101.606979 
	C197.515244,104.577957 197.588745,107.620216 198.104126,110.536682 
	C199.524063,118.571983 205.232910,123.706512 212.914520,124.234947 
	C221.524338,124.827225 227.732773,120.762711 230.155609,112.423737 
	C232.777771,103.398773 232.471588,94.695000 224.792725,86.090065 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M851.686707,97.523376 
	C853.248108,82.016830 864.987244,73.802551 877.356079,73.585213 
	C892.093750,73.326241 902.558167,80.987785 904.727661,95.660484 
	C905.762573,102.659485 905.146729,110.370270 903.291870,117.220650 
	C900.416077,127.841026 888.028137,134.635239 876.334106,133.594406 
	C863.339722,132.437836 854.142395,124.569832 852.116333,112.255989 
	C851.367737,107.706192 851.740601,102.971870 851.686707,97.523376 
M866.354004,87.661308 
	C860.051697,95.084595 860.817322,103.795135 862.545654,112.295593 
	C864.051819,119.703232 870.228455,124.027557 877.727112,124.260674 
	C885.488892,124.501984 891.526367,120.822105 893.767944,113.543533 
	C895.011047,109.507141 895.665405,105.036125 895.403992,100.834503 
	C894.391541,84.562347 881.832764,78.271706 866.354004,87.661308 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M725.445312,73.671188 
	C741.954712,76.365631 749.760193,84.941933 750.431091,100.460236 
	C750.545898,103.115837 750.468994,105.796318 750.253601,108.446861 
	C749.062866,123.099358 739.871643,132.358017 725.356812,133.621780 
	C711.461609,134.831619 699.764954,126.553978 697.356079,112.218407 
	C696.184692,105.246979 696.659180,97.532494 698.373596,90.648766 
	C701.149475,79.503082 710.106262,74.395981 725.445312,73.671188 
M739.139343,113.146294 
	C739.374512,107.549324 740.364258,101.856422 739.667725,96.377899 
	C738.626709,88.189072 731.708313,82.663078 723.879272,82.439423 
	C716.245850,82.221352 709.850647,86.672356 707.734802,94.557602 
	C706.642090,98.629669 706.240845,103.085495 706.547668,107.293510 
	C707.181824,115.990791 711.970398,122.074486 718.632935,123.832634 
	C726.932617,126.022781 732.659485,123.353638 739.139343,113.146294 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M356.074860,100.252609 
	C356.075989,111.197380 356.075989,121.179909 356.075989,131.888412 
	C352.997040,132.094833 350.171753,132.284241 347.188324,132.484268 
	C346.701355,131.135223 346.127686,130.278503 346.121613,129.417755 
	C346.046509,118.762268 346.156433,108.104790 346.010559,97.450676 
	C345.874878,87.538544 342.530731,83.168060 335.011902,82.541557 
	C326.932251,81.868332 320.495178,86.894829 319.412384,95.865288 
	C318.539703,103.095581 318.829407,110.470741 318.689819,117.783287 
	C318.601929,122.386620 318.673462,126.992996 318.673462,131.945969 
	C315.139984,131.945969 312.335358,131.945969 309.159058,131.945969 
	C309.159058,112.885574 309.159058,94.347168 309.159058,75.850388 
	C316.386902,73.941681 316.386902,73.941681 318.367096,78.715370 
	C324.428986,76.979050 330.264801,74.182037 336.245148,73.828110 
	C348.812164,73.084389 355.413422,79.800713 356.016449,92.298218 
	C356.128662,94.624451 356.059265,96.959435 356.074860,100.252609 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M470.059021,125.157150 
	C470.049957,114.928070 470.200439,105.596527 469.986267,96.273361 
	C469.779968,87.291283 466.133759,83.024712 458.825562,82.523308 
	C451.391724,82.013283 444.958313,86.423386 443.816650,94.111542 
	C442.748810,101.302521 442.919952,108.687180 442.701813,115.991257 
	C442.553284,120.963921 442.673431,125.944603 442.673431,131.726837 
	C439.701782,132.026550 436.924744,132.306625 433.431213,132.658981 
	C433.431213,113.197540 433.431213,94.396332 433.426086,75.591461 
	C440.448822,74.110115 440.448822,74.110115 443.322937,80.336983 
	C448.999725,74.818329 455.806366,72.899986 463.478058,73.767578 
	C473.463837,74.896858 479.535217,80.551384 479.863098,90.569649 
	C480.308380,104.175171 479.973999,117.806206 479.973999,131.944107 
	C476.720490,131.944107 473.866089,131.944107 470.326996,131.944107 
	C470.231018,129.836319 470.145020,127.947334 470.059021,125.157150 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M511.689148,123.130356 
	C525.616943,124.947487 527.840698,123.769791 532.763733,112.362480 
	C534.128540,112.240425 535.728455,111.990448 537.328796,111.987907 
	C538.619568,111.985855 539.910767,112.282509 541.016235,112.423050 
	C541.407776,113.327087 541.969666,113.971985 541.848694,114.440620 
	C538.681824,126.709183 530.435120,133.506851 518.555786,133.728363 
	C506.776367,133.948013 497.161072,127.215851 493.655457,115.972687 
	C490.682495,106.437836 490.997589,96.877579 494.921387,87.676041 
	C499.173767,77.704079 508.847015,72.738670 521.200134,73.716408 
	C532.030090,74.573586 537.780273,79.783913 540.663208,91.352470 
	C540.158081,91.749863 539.701904,92.382126 539.137817,92.500458 
	C537.206116,92.905685 535.236572,93.130516 532.807068,93.495384 
	C531.779053,91.813248 530.907837,90.048729 529.731445,88.518837 
	C523.272034,80.118759 511.091278,80.685989 505.283356,89.603111 
	C498.948975,99.328575 501.678223,115.240868 511.689148,123.130356 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1534.495117,827.125488 
	C1530.531006,819.626221 1531.071411,812.260742 1532.008423,805.070740 
	C1533.095581,796.727234 1539.710938,790.217834 1547.329346,788.906677 
	C1556.850464,787.268005 1565.033569,790.672424 1569.297852,798.687012 
	C1574.325806,808.137024 1574.279907,817.901001 1568.845459,827.131897 
	C1561.375854,839.820129 1545.553589,839.986084 1534.495117,827.125488 
M1560.291870,818.802429 
	C1560.386108,814.871704 1561.272217,810.753296 1560.395142,807.052795 
	C1558.966553,801.024597 1551.754395,798.466736 1546.830322,801.752136 
	C1542.405151,804.704651 1541.791870,809.368286 1542.135010,814.179077 
	C1542.461182,818.751953 1544.177368,822.682068 1548.771606,824.463440 
	C1553.599365,826.335205 1557.145264,824.340759 1560.291870,818.802429 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4265.827637,552.172363 
	C4263.557617,548.445618 4261.633301,545.377686 4258.908691,541.034851 
	C4256.494141,551.145142 4258.711426,560.307861 4257.223633,569.861450 
	C4254.674316,570.039001 4252.181641,570.212646 4248.959961,570.437073 
	C4248.959961,554.208679 4248.959961,538.448486 4248.959961,522.424377 
	C4254.700195,520.189819 4258.614258,521.862305 4261.683105,527.514404 
	C4266.053711,535.564819 4271.060059,543.270386 4277.527832,550.695679 
	C4277.527832,541.306458 4277.527832,531.917175 4277.527832,522.092407 
	C4280.954102,522.092407 4283.440430,522.092407 4286.266602,522.092407 
	C4286.266602,537.991211 4286.266602,553.578247 4286.266602,569.783813 
	C4283.087402,569.783813 4279.936523,569.783813 4276.615234,569.783813 
	C4273.131348,564.128357 4269.652344,558.479797 4265.827637,552.172363 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1527.761719,834.241699 
	C1517.543457,837.683289 1507.711792,835.532471 1498.171997,836.151672 
	C1494.933228,829.343201 1495.758911,824.241760 1500.359375,819.725220 
	C1503.449097,816.692017 1506.594971,813.707397 1509.536133,810.534668 
	C1511.675171,808.227234 1513.520752,805.647827 1515.572266,803.096313 
	C1510.766968,799.076416 1508.892090,803.667480 1506.089355,804.285828 
	C1503.407349,804.877502 1500.492188,804.413513 1497.657593,804.413513 
	C1497.889038,796.001038 1501.122925,791.096375 1507.102295,789.110718 
	C1514.084595,786.791992 1520.869629,788.814880 1524.922241,794.423767 
	C1529.042725,800.126465 1528.993652,805.896118 1524.540649,811.974304 
	C1522.286377,815.051208 1519.743042,817.916504 1516.583008,821.794861 
	C1521.280518,823.082153 1524.356567,823.925110 1528.182861,824.973633 
	C1528.182861,827.859741 1528.182861,830.742004 1527.761719,834.241699 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4528.209961,530.302551 
	C4528.210449,527.087708 4528.210449,524.840576 4528.210449,521.722961 
	C4537.281738,521.722961 4545.518555,521.450195 4553.729004,521.800720 
	C4561.730469,522.142273 4566.173340,525.810242 4567.622070,532.288452 
	C4569.032715,538.600098 4566.395996,543.888245 4559.798340,547.913452 
	C4559.030762,548.381653 4558.183594,548.718140 4557.360352,549.122131 
	C4561.848633,555.761047 4566.232422,562.245728 4570.905273,569.157471 
	C4563.267578,572.076599 4558.693359,570.103088 4555.461914,563.804749 
	C4553.802734,560.570984 4551.628418,557.547791 4549.350098,554.698914 
	C4546.724609,551.415039 4543.423340,549.355469 4538.304688,551.428772 
	C4538.304688,557.097961 4538.304688,562.976013 4538.304688,569.621155 
	C4534.972168,569.956177 4532.200684,570.234680 4528.209961,570.635864 
	C4528.209961,557.053833 4528.209961,544.162048 4528.209961,530.302551 
M4537.991699,535.071411 
	C4538.133301,537.277405 4538.274902,539.483398 4538.440430,542.059143 
	C4543.616211,542.059143 4548.196777,542.285645 4552.741699,541.986206 
	C4556.270508,541.753723 4557.874512,539.185120 4557.820801,535.832764 
	C4557.766602,532.461853 4556.062500,530.064453 4552.496582,529.911255 
	C4548.220215,529.727417 4543.917480,529.797302 4539.650879,530.105652 
	C4539.030273,530.150513 4538.549805,532.131897 4537.991699,535.071411 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4596.506348,571.642578 
	C4577.448242,566.642944 4569.653809,548.627258 4578.542969,531.865051 
	C4582.909668,523.629517 4590.296875,520.218872 4599.065430,520.382141 
	C4608.249023,520.553101 4615.882812,524.467163 4619.699219,533.353271 
	C4623.243164,541.605408 4623.256348,550.218994 4619.762207,558.494812 
	C4615.624512,568.291382 4607.319824,571.601074 4596.506348,571.642578 
M4595.930664,528.686401 
	C4585.752930,534.002625 4581.985352,549.375366 4588.671387,558.303589 
	C4593.282715,564.460388 4601.656250,565.531738 4607.062988,560.299744 
	C4613.343262,554.221680 4612.948730,546.356079 4611.301270,538.784851 
	C4609.781250,531.797974 4604.860352,528.156250 4595.930664,528.686401 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4362.763184,541.106079 
	C4364.882324,523.462158 4381.439453,517.173706 4394.146973,521.864258 
	C4394.458984,521.979309 4394.789062,522.045532 4395.097656,522.167358 
	C4407.735352,527.157410 4413.175781,544.850037 4406.449707,559.078918 
	C4400.920410,570.776489 4385.632324,575.689392 4374.108887,568.534302 
	C4369.924805,565.936035 4366.351562,561.150940 4364.368652,556.556946 
	C4362.498535,552.223999 4363.083984,546.830750 4362.763184,541.106079 
M4392.491699,561.661438 
	C4400.675293,554.901001 4400.287109,546.140137 4397.811035,537.181519 
	C4396.273926,531.619995 4391.428223,528.417664 4385.932617,528.357422 
	C4380.412109,528.296997 4375.455078,531.266663 4373.995605,536.958069 
	C4372.797363,541.631287 4372.226074,546.831848 4372.953613,551.555786 
	C4374.440918,561.206360 4380.782715,564.595825 4392.491699,561.661438 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M260.095032,132.433044 
	C255.123718,132.670044 255.357559,129.810577 255.358597,127.092056 
	C255.363266,114.771782 255.357437,102.451508 255.355469,90.131233 
	C255.355209,88.490585 255.355438,86.849937 255.355438,84.794487 
	C252.317337,84.130539 249.510361,83.517097 246.521362,82.863884 
	C246.521362,80.263359 246.521362,77.966957 246.521362,75.220367 
	C249.384277,74.627274 252.181824,74.047714 254.883972,73.487915 
	C256.438507,53.025333 260.670044,49.503998 279.541107,52.804199 
	C279.665863,53.692127 279.948669,54.639843 279.893341,55.567390 
	C279.815460,56.873009 279.486877,58.163673 279.292816,59.300823 
	C275.027679,60.500744 270.216766,60.661575 267.261444,63.085155 
	C265.123169,64.838699 265.447906,69.595581 264.536926,73.619629 
	C268.771545,74.061050 271.966034,74.394051 275.618286,74.774773 
	C275.618286,77.617203 275.618286,80.134552 275.618286,83.077194 
	C272.405548,83.483505 269.216858,83.886772 265.059387,84.412567 
	C265.059387,98.117821 265.134033,111.664619 265.000488,125.209381 
	C264.971527,128.144028 266.580963,132.417953 260.095032,132.433044 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1461.393066,751.736938 
	C1457.678711,756.671692 1454.294922,760.975037 1450.228516,766.146240 
	C1454.631104,766.712952 1457.824707,767.124023 1462.165161,767.682739 
	C1462.636475,770.725525 1463.157227,774.086609 1463.884521,778.781067 
	C1452.970459,779.755676 1443.154053,779.113098 1433.092163,779.194031 
	C1430.215454,772.283142 1431.177979,766.706543 1436.519287,761.840271 
	C1439.715210,758.928650 1442.832520,755.905701 1445.732056,752.703735 
	C1447.375610,750.888794 1448.508301,748.611328 1451.148193,744.603516 
	C1443.595093,746.396179 1438.326050,747.646729 1432.743774,748.971680 
	C1432.456543,738.295898 1436.163940,733.501831 1444.418335,732.416138 
	C1455.223999,730.994812 1459.339844,735.812134 1461.962891,743.317993 
	C1462.762573,745.606506 1461.851196,748.492920 1461.393066,751.736938 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M191.656036,929.267334 
	C209.812164,926.598389 223.136017,935.894836 225.744095,952.338623 
	C228.586014,970.256775 218.678085,985.092651 201.692627,987.376770 
	C190.670746,988.858948 181.194031,985.056213 175.072479,975.492065 
	C163.762360,957.821411 172.457428,932.747314 191.656036,929.267334 
M180.258728,946.001709 
	C177.108841,954.079041 176.965652,962.211121 180.394577,970.178589 
	C183.587494,977.597656 189.616226,981.338135 197.570740,981.525391 
	C205.943069,981.722534 212.620255,978.149841 215.650909,970.219421 
	C217.363998,965.736633 217.960556,960.571716 217.915512,955.724609 
	C217.815536,944.969299 212.620895,937.949402 203.802612,935.308228 
	C194.905655,932.643494 187.831024,935.507996 180.258728,946.001709 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1727.114502,951.522522 
	C1729.425171,945.436157 1729.425171,945.436157 1733.862427,949.381531 
	C1738.153931,948.048157 1742.176758,945.658752 1745.988770,945.957520 
	C1749.321167,946.218750 1752.416504,949.504456 1755.956787,951.661316 
	C1756.836670,950.857788 1758.164795,949.323853 1759.785278,948.218262 
	C1768.875122,942.016602 1779.453979,946.031250 1780.739014,956.967773 
	C1781.816040,966.134949 1780.960205,975.529297 1780.960205,985.522400 
	C1779.389648,985.755737 1777.291748,986.067383 1775.414062,986.346313 
	C1774.794189,985.291199 1774.210693,984.757751 1774.204102,984.217346 
	C1774.115112,976.903442 1774.204590,969.586365 1774.050659,962.274292 
	C1773.889648,954.633179 1771.785278,952.063171 1766.396118,951.795044 
	C1761.563110,951.554565 1757.265869,955.810425 1757.792114,962.736206 
	C1758.364868,970.274292 1757.921997,977.889465 1757.921997,985.937073 
	C1755.424316,985.937073 1753.558472,985.937073 1750.452881,985.937073 
	C1750.452881,981.757874 1750.454224,977.581665 1750.452515,973.405457 
	C1750.450928,969.747620 1750.552979,966.085999 1750.421143,962.432800 
	C1750.132446,954.428467 1748.262451,951.825928 1743.034912,951.838318 
	C1737.350708,951.851807 1734.260620,955.435730 1734.115967,962.413208 
	C1734.012451,967.398987 1734.095215,972.388672 1734.095093,977.376587 
	C1734.094971,980.001587 1734.094971,982.626648 1734.094971,985.904175 
	C1731.906860,986.052734 1730.059692,986.178101 1727.111938,986.378174 
	C1727.111938,974.769104 1727.111938,963.561462 1727.114502,951.522522 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1253.163086,948.545776 
	C1254.417480,949.265686 1255.467041,949.743042 1256.050903,949.408325 
	C1266.261719,943.556030 1267.547607,943.712952 1275.334961,952.210266 
	C1276.800415,950.875854 1278.134155,949.348267 1279.754028,948.238281 
	C1288.841309,942.011841 1298.733887,946.093933 1300.944580,956.925659 
	C1301.209839,958.224915 1301.459961,959.556152 1301.467896,960.874084 
	C1301.516235,968.857544 1301.492065,976.841370 1301.492065,985.443726 
	C1299.388672,985.755554 1297.289795,986.066711 1295.410767,986.345276 
	C1294.792114,985.287842 1294.209961,984.753540 1294.203491,984.212280 
	C1294.114868,976.893555 1294.205688,969.571716 1294.050293,962.255005 
	C1293.888062,954.617310 1291.769287,952.051697 1286.367065,951.792053 
	C1281.743774,951.569824 1277.258667,955.598389 1277.795654,962.775269 
	C1278.359619,970.314209 1277.921875,977.928101 1277.921875,985.955627 
	C1275.382568,985.955627 1273.515503,985.955627 1270.452759,985.955627 
	C1270.452759,979.387695 1270.469238,972.869263 1270.444092,966.351074 
	C1270.435059,964.023987 1270.498047,961.676941 1270.227173,959.374451 
	C1269.573364,953.817993 1267.523315,951.789062 1262.951416,951.842346 
	C1258.229126,951.897400 1254.433716,954.858154 1254.219360,959.516846 
	C1253.883179,966.822083 1254.116821,974.153198 1254.085327,981.473206 
	C1254.079834,982.762817 1253.958618,984.051941 1253.863159,985.868408 
	C1251.795288,985.868408 1249.956055,985.868408 1247.174805,985.868408 
	C1247.174805,973.665283 1246.924683,961.437256 1247.321533,949.230164 
	C1247.446655,945.383118 1250.193970,945.395752 1253.163086,948.545776 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4512.146973,568.384521 
	C4508.979492,569.661255 4506.534180,571.023743 4503.973145,571.295349 
	C4492.302246,572.533081 4480.876953,570.034729 4480.341309,553.140076 
	C4480.025879,543.185120 4480.284180,533.211975 4480.284180,522.424561 
	C4483.325684,522.424561 4486.342285,522.424561 4489.961426,522.424561 
	C4489.961426,531.835144 4489.926270,541.081848 4489.986816,550.327881 
	C4490.001953,552.640381 4489.979004,555.046997 4490.584473,557.242004 
	C4491.759766,561.506958 4495.970703,564.000305 4500.685059,563.528931 
	C4505.175293,563.079895 4508.259277,560.852966 4508.502930,556.080261 
	C4508.874512,548.791016 4509.010254,541.488953 4509.177734,534.190735 
	C4509.261230,530.548828 4509.192383,526.903381 4509.192383,522.377380 
	C4512.040527,522.065430 4514.799805,521.763184 4517.636719,521.452454 
	C4518.065430,522.962585 4518.555176,523.882385 4518.552734,524.800781 
	C4518.522461,534.768127 4518.455566,544.735840 4518.310547,554.702148 
	C4518.236816,559.817627 4517.337402,564.661255 4512.146973,568.384521 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4470.734863,527.421875 
	C4466.036621,528.746948 4461.564453,529.396973 4457.067871,529.694336 
	C4453.467773,529.932434 4449.838867,529.742371 4445.436523,529.742371 
	C4445.253418,533.146729 4445.100098,535.990967 4444.894531,539.807129 
	C4452.748047,539.807129 4460.232422,539.807129 4468.199707,539.807129 
	C4468.622070,542.802368 4468.922852,544.932739 4469.379395,548.168396 
	C4461.295410,548.168396 4453.791504,548.168396 4445.668945,548.168396 
	C4445.668945,553.034363 4445.668945,556.888977 4445.668945,561.831909 
	C4453.742188,561.831909 4462.179199,561.831909 4471.299316,561.831909 
	C4471.545410,564.973938 4471.711914,567.103271 4471.925781,569.835815 
	C4459.952148,569.835815 4448.416016,569.835815 4436.187500,569.835815 
	C4436.187500,554.164978 4436.187500,538.389282 4436.187500,521.622375 
	C4446.627930,521.622375 4457.193848,521.586243 4467.759277,521.643188 
	C4471.170410,521.661621 4471.055176,524.187134 4470.734863,527.421875 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4237.857422,539.964111 
	C4237.523438,546.896301 4237.369141,552.879272 4236.807617,558.823853 
	C4236.203125,565.228638 4232.375977,569.333862 4226.180176,570.375488 
	C4221.723145,571.124817 4216.923340,571.414124 4212.523438,570.590576 
	C4203.846680,568.966492 4200.367676,565.144897 4199.973633,556.401062 
	C4199.465820,545.140686 4199.849609,533.840027 4199.849609,522.050842 
	C4202.457520,521.919312 4204.997070,521.791260 4207.646973,521.657593 
	C4208.124023,522.974243 4208.705078,523.842163 4208.713867,524.716003 
	C4208.803711,533.369995 4208.598633,542.032471 4208.923828,550.675720 
	C4209.043945,553.872009 4209.395020,557.992126 4211.368652,559.937744 
	C4213.577148,562.114685 4217.750000,563.152893 4221.061035,563.138428 
	C4225.094727,563.120728 4227.610840,559.983276 4227.746582,555.787537 
	C4227.982910,548.471436 4227.971680,541.146973 4228.037598,533.825806 
	C4228.069824,530.205994 4228.043457,526.585632 4228.043457,522.200745 
	C4231.284180,521.996765 4234.045898,521.822998 4237.857910,521.583069 
	C4237.857910,527.844299 4237.857910,533.421143 4237.857422,539.964111 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4764.662109,527.370239 
	C4770.293457,541.608521 4775.634277,555.159729 4781.424316,569.849976 
	C4777.436035,570.040710 4774.387695,570.186523 4771.446289,570.327209 
	C4769.846680,566.597656 4768.549805,563.573425 4767.084961,560.158203 
	C4760.937988,560.158203 4754.675781,560.158203 4748.014160,560.158203 
	C4746.594238,563.315552 4745.117188,566.600586 4743.573242,570.034607 
	C4740.547852,570.034607 4737.649414,570.034607 4733.786621,570.034607 
	C4740.041016,553.666504 4746.050293,537.939148 4752.183594,521.887207 
	C4757.115234,521.960266 4762.609375,519.176270 4764.662109,527.370239 
M4756.098145,536.162659 
	C4754.440430,541.038574 4752.783203,545.914490 4750.915039,551.410645 
	C4755.742188,551.410645 4759.337891,551.410645 4764.427246,551.410645 
	C4761.679688,545.439148 4759.267090,540.195740 4756.098145,536.162659 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4338.602539,522.150635 
	C4341.692383,529.010681 4344.960449,535.797180 4347.827637,542.749268 
	C4351.451660,551.537109 4354.749023,560.460022 4358.445801,569.991699 
	C4354.621094,569.991699 4351.736328,569.991699 4348.475098,569.991699 
	C4347.045898,566.874390 4345.549805,563.612183 4343.941895,560.105713 
	C4337.586914,560.105713 4331.375000,560.105713 4324.810547,560.105713 
	C4323.534668,563.200806 4322.295410,566.208496 4320.810547,569.810974 
	C4318.011230,569.810974 4314.965820,569.810974 4310.867188,569.810974 
	C4316.822266,554.211609 4322.478516,539.450623 4328.086914,524.671631 
	C4329.761230,520.259216 4333.499512,521.949280 4337.476074,521.960083 
	C4338.372559,522.273010 4338.602539,522.150574 4338.602539,522.150635 
M4332.755371,536.792847 
	C4331.172852,541.430847 4329.590820,546.068848 4327.833496,551.219727 
	C4332.377930,551.219727 4336.140137,551.219727 4341.797363,551.219727 
	C4338.728027,545.329834 4336.243652,540.562134 4332.755371,536.792847 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4709.917480,523.828491 
	C4710.496582,528.800720 4708.378418,529.884521 4704.717773,529.796265 
	C4698.142578,529.637695 4691.560059,529.751465 4684.528809,529.751465 
	C4684.528809,533.364929 4684.528809,536.189270 4684.528809,539.993896 
	C4691.958008,539.993896 4699.445312,539.993896 4707.605957,539.993896 
	C4707.776855,543.047180 4707.895996,545.168945 4708.071289,548.289917 
	C4700.131836,548.289917 4692.631348,548.289917 4684.497559,548.289917 
	C4684.289062,553.057373 4684.120117,556.922485 4683.906738,561.808228 
	C4692.662109,561.808228 4701.114258,561.808228 4710.048340,561.808228 
	C4710.335938,564.906494 4710.536133,567.061401 4710.794434,569.842285 
	C4698.499512,569.842285 4686.775391,569.842285 4674.623047,569.842285 
	C4674.623047,553.910034 4674.623047,538.432007 4674.623047,521.810547 
	C4686.458496,522.050049 4698.132812,520.076965 4709.917480,523.828491 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1024.975098,1001.363647 
	C1022.578613,1000.750244 1020.870728,1000.558044 1019.384277,999.880188 
	C1010.608093,995.877930 1009.902954,990.752014 1017.215332,983.071045 
	C1014.719666,978.736755 1014.299927,974.385620 1018.868042,970.539612 
	C1018.005066,969.252563 1017.314331,968.186707 1016.588257,967.145508 
	C1013.238586,962.341309 1012.770874,957.299561 1015.721069,952.209900 
	C1018.714600,947.045715 1023.697937,945.176453 1029.284302,945.642151 
	C1035.714844,946.178223 1042.086060,947.425171 1050.552856,948.666992 
	C1044.360596,952.131958 1043.849609,956.317688 1043.649780,961.222351 
	C1043.403076,967.284729 1038.049927,971.576355 1031.434692,972.283203 
	C1028.520874,972.594543 1025.546143,972.335571 1022.901917,972.335571 
	C1020.937988,975.697815 1022.140259,977.485291 1024.944580,977.816345 
	C1028.881104,978.281250 1032.912109,977.937500 1036.851318,978.388733 
	C1043.867798,979.192383 1047.303467,981.833252 1047.999756,986.404114 
	C1048.749878,991.328430 1045.933838,996.845337 1040.207275,998.965271 
	C1035.692017,1000.636658 1030.601196,1000.753296 1024.975098,1001.363647 
M1030.521118,950.449219 
	C1028.586792,950.758972 1026.422363,950.618652 1024.762817,951.466431 
	C1020.478149,953.655212 1019.050171,958.182373 1020.869568,962.420715 
	C1022.753906,966.810242 1027.997681,968.821960 1032.577271,966.912292 
	C1036.701660,965.192505 1039.143188,960.443298 1037.283447,956.272766 
	C1036.313599,954.097839 1033.810425,952.606628 1030.521118,950.449219 
M1038.514404,994.351685 
	C1042.548218,988.363647 1042.115356,985.949768 1036.253174,984.859070 
	C1032.430542,984.147766 1028.276245,983.848328 1024.526367,984.615051 
	C1022.175537,985.095825 1020.299072,987.896057 1018.209778,989.655579 
	C1019.980957,991.693115 1021.508484,995.118530 1023.573669,995.480957 
	C1027.950439,996.249023 1032.607666,995.420105 1038.514404,994.351685 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2097.189209,985.542725 
	C2094.722656,986.101868 2092.847168,986.101868 2090.325195,986.101868 
	C2090.325195,974.691345 2090.325195,964.121887 2090.325195,953.023560 
	C2084.862305,953.023560 2080.018066,953.023560 2074.319092,953.023560 
	C2074.319092,963.658691 2074.319092,974.468811 2074.319092,985.893799 
	C2071.660400,986.059692 2069.806885,986.175415 2066.660889,986.371765 
	C2066.660889,978.115967 2066.675293,970.261658 2066.656738,962.407532 
	C2066.636963,954.137390 2066.623291,954.137451 2059.720215,949.334900 
	C2062.051758,948.323425 2063.928467,947.509277 2066.225586,946.512878 
	C2066.776611,936.568481 2071.598633,929.786072 2082.256836,928.427917 
	C2085.723145,927.986206 2089.710205,927.306030 2090.730225,933.249817 
	C2083.893799,935.856628 2072.706299,933.657654 2074.359863,947.344849 
	C2082.057373,947.344849 2089.563477,947.344849 2097.780518,947.344849 
	C2097.780518,960.499329 2097.780518,972.741516 2097.189209,985.542725 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M865.630310,953.558228 
	C859.601807,966.789368 847.717041,965.266602 836.456665,966.315247 
	C836.456665,972.764038 836.456665,978.999512 836.456665,985.830078 
	C833.770996,985.830078 831.672180,985.830078 829.115479,985.830078 
	C829.115479,967.417358 829.115479,949.215149 829.115479,930.346741 
	C837.127747,928.818115 845.377136,928.818054 853.421631,930.424011 
	C861.096619,931.956238 868.661316,937.810913 865.630310,953.558228 
M839.212158,935.783325 
	C838.251465,936.516968 836.480530,937.225159 836.456604,937.988159 
	C836.240356,944.880432 836.329956,951.782288 836.329956,959.008057 
	C841.356201,959.008057 845.678223,959.641052 849.728516,958.861938 
	C856.037354,957.648315 859.221313,952.756348 858.860840,946.489258 
	C858.493469,940.103821 854.976440,936.577637 847.997070,935.842896 
	C845.696167,935.600647 843.352661,935.762573 839.212158,935.783325 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M492.661652,980.536499 
	C492.661163,963.409302 492.661163,947.132080 492.661163,930.094360 
	C500.913269,930.094360 508.839478,929.367676 516.569580,930.287964 
	C525.203186,931.315735 529.973999,937.552002 530.401917,946.003662 
	C530.864197,955.132812 526.737122,961.758789 518.102173,964.104248 
	C512.737183,965.561523 507.030792,965.761902 500.554871,966.653503 
	C500.554871,972.798523 500.554871,979.268982 500.554871,985.581787 
	C495.667053,986.946716 492.238953,987.277710 492.661652,980.536499 
M510.115143,959.589233 
	C511.419434,959.362427 512.801331,959.338806 514.015198,958.875244 
	C521.005859,956.205566 523.712036,951.856934 522.678833,945.188721 
	C521.727905,939.051331 518.118530,936.156433 510.660278,935.779419 
	C507.445831,935.616943 504.216309,935.752258 500.865051,935.752258 
	C500.865051,944.215027 500.865051,951.670776 500.865051,959.601379 
	C503.813812,959.601379 506.117218,959.601379 510.115143,959.589233 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M4506.007324,712.151123 
	C4505.345703,704.696594 4505.367676,698.068909 4508.763672,691.981873 
	C4513.123047,684.167480 4520.004883,680.926453 4528.730957,681.647278 
	C4536.718262,682.307068 4542.426758,686.067261 4544.813477,694.927246 
	C4542.236328,695.742188 4539.855469,696.494934 4537.280273,697.309326 
	C4535.918945,695.566833 4534.911621,693.806091 4533.476562,692.524536 
	C4527.945801,687.585388 4519.771973,689.088562 4516.862305,695.841003 
	C4513.984863,702.517517 4514.143066,709.589722 4516.926270,716.227966 
	C4519.989258,723.533386 4528.831055,724.508179 4533.949707,718.381226 
	C4535.187500,716.899353 4536.020508,715.078918 4537.279297,713.021912 
	C4539.782227,713.922424 4542.123047,714.764771 4544.885742,715.758667 
	C4542.995117,723.908752 4538.481934,728.615540 4530.910645,729.994568 
	C4522.863281,731.460266 4515.509766,729.861206 4510.555664,722.784973 
	C4508.518555,719.875061 4507.538086,716.225403 4506.007324,712.151123 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4433.284180,696.780151 
	C4434.937988,692.690063 4435.899902,688.243958 4437.061035,682.879272 
	C4438.671875,682.739075 4441.099121,682.527832 4444.043945,682.271545 
	C4444.043945,698.012756 4444.043945,713.144104 4444.043945,728.344360 
	C4443.652344,728.699402 4443.208008,729.460327 4442.728027,729.483276 
	C4437.408691,729.737671 4432.002930,726.545776 4426.687500,730.246155 
	C4425.684082,730.944885 4423.414062,730.234985 4421.890625,729.707642 
	C4413.972656,726.966858 4409.850098,715.056946 4413.211426,704.945496 
	C4416.302734,695.646423 4422.544922,692.902344 4433.284180,696.780151 
M4434.885742,706.473877 
	C4433.236328,702.486938 4429.936523,700.311829 4426.270508,702.317505 
	C4423.875000,703.628052 4422.312500,707.166321 4421.284180,710.032166 
	C4420.568848,712.025452 4421.268555,714.588074 4421.561035,716.867554 
	C4422.036621,720.575867 4424.202637,723.154053 4427.911133,723.427734 
	C4432.281738,723.750305 4434.592773,720.664612 4435.325195,716.845215 
	C4435.872070,713.991882 4435.432617,710.949463 4434.885742,706.473877 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M4347.834961,713.834412 
	C4347.834961,719.391907 4347.834961,723.978638 4347.834961,729.172546 
	C4345.242188,729.344971 4342.784180,730.279541 4341.620117,729.433716 
	C4338.726562,727.330933 4336.495605,727.726318 4333.639160,729.297729 
	C4332.013672,730.191650 4329.792480,730.404968 4327.876465,730.291260 
	C4322.250977,729.957031 4318.504395,726.413574 4316.869141,721.514465 
	C4314.276855,713.749146 4313.669434,705.641296 4319.506836,698.899841 
	C4323.196777,694.639099 4328.118164,692.787964 4333.818848,695.563171 
	C4334.977051,696.127075 4336.284668,696.384460 4338.120117,696.975037 
	C4338.497070,692.113586 4338.843750,687.641541 4339.226074,682.715515 
	C4342.081543,682.715515 4344.525879,682.715515 4347.835449,682.715515 
	C4347.835449,693.067688 4347.835449,702.965698 4347.834961,713.834412 
M4335.490234,721.830322 
	C4339.630371,717.408997 4339.217285,712.132141 4337.856934,706.950684 
	C4336.596680,702.154053 4331.616699,700.290771 4327.789062,702.756409 
	C4324.437012,704.915955 4322.722656,711.979797 4324.500488,717.365479 
	C4326.024414,721.977356 4328.771973,724.818420 4335.490234,721.830322 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4629.509766,551.959961 
	C4629.509766,541.670288 4629.509766,532.375610 4629.509766,521.739807 
	C4638.470703,521.615601 4647.309570,520.784973 4656.042969,522.348816 
	C4662.748535,523.549744 4666.327637,529.622070 4666.082031,537.493713 
	C4665.844238,545.140808 4661.840332,550.561035 4654.791504,551.754395 
	C4649.959961,552.572388 4644.980957,552.522461 4639.301270,552.913269 
	C4639.301270,558.467041 4639.301270,563.659302 4639.301270,569.656433 
	C4635.868652,569.926941 4633.169922,570.139648 4629.509766,570.428101 
	C4629.509766,564.101257 4629.509766,558.528076 4629.509766,551.959961 
M4639.873047,543.705078 
	C4643.479004,543.827637 4647.129395,544.351807 4650.679688,543.964478 
	C4654.543945,543.542664 4656.191406,540.599304 4656.164551,536.852722 
	C4656.137695,533.064941 4654.350586,530.334839 4650.464844,529.931030 
	C4646.930664,529.563660 4643.327637,529.853271 4638.976562,529.853271 
	C4638.976562,534.395691 4638.976562,538.301941 4639.873047,543.705078 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M258.260925,946.018677 
	C270.777679,953.674683 273.234528,971.755310 263.786652,981.601868 
	C258.193665,987.430969 251.755630,987.848755 242.129639,983.088440 
	C240.041336,984.348633 238.022308,985.567017 236.431946,986.526733 
	C233.471191,984.908630 232.994003,941.874023 234.963760,928.578308 
	C236.470825,928.499207 238.047836,928.416504 240.676865,928.278564 
	C240.676865,935.519409 240.676865,942.340210 240.676865,948.811401 
	C246.943878,947.722534 252.247635,946.801025 258.260925,946.018677 
M260.922180,973.272034 
	C261.219696,969.036072 262.152893,964.726074 261.670410,960.580872 
	C260.884735,953.831055 256.340851,950.768066 249.806320,951.868225 
	C245.288467,952.628906 240.907501,954.748901 241.238068,959.806458 
	C241.662094,966.293884 237.643127,973.860229 244.789780,979.077332 
	C245.779327,979.799683 247.253784,980.003235 248.537842,980.151001 
	C253.483398,980.720276 257.750336,979.681824 260.922180,973.272034 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M1335.668823,985.680054 
	C1329.906738,985.395691 1324.833130,984.865295 1318.364380,984.189148 
	C1317.930054,984.440613 1315.898193,985.617188 1312.698975,987.469666 
	C1312.698975,966.944092 1312.698975,947.875244 1312.698975,928.540955 
	C1314.580688,928.540955 1316.181274,928.540955 1318.769287,928.540955 
	C1318.769287,935.605591 1318.769287,942.451111 1318.769287,949.224670 
	C1320.389526,949.349731 1321.165405,949.662720 1321.636230,949.409241 
	C1336.132935,941.605225 1346.745361,947.309937 1347.348999,963.666321 
	C1347.681885,972.688049 1345.587891,980.995605 1335.668823,985.680054 
M1318.985474,960.342834 
	C1318.983276,964.302063 1318.782471,968.273682 1319.027344,972.217590 
	C1319.360596,977.585205 1321.672363,979.724976 1327.058960,980.237671 
	C1335.683716,981.058411 1340.288452,975.543030 1340.072754,964.650574 
	C1339.927856,957.330994 1337.659058,952.996155 1332.850708,952.078125 
	C1326.820435,950.926758 1321.676636,952.281982 1318.985474,960.342834 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M2365.166260,969.296387 
	C2365.254883,965.856445 2365.131348,963.154236 2365.607422,960.562073 
	C2367.797852,948.632263 2376.856689,943.266785 2388.395752,946.927429 
	C2389.598389,947.309021 2390.764893,947.805786 2392.986328,948.638245 
	C2392.986328,941.721008 2392.986328,935.548706 2392.986328,928.840088 
	C2395.621094,928.705444 2397.406738,928.614136 2399.642090,928.499878 
	C2399.642090,947.886658 2399.642090,966.773438 2399.642090,985.514832 
	C2395.386475,987.586426 2394.252197,984.806885 2393.134766,981.550598 
	C2378.860596,989.777954 2368.286621,988.798340 2365.166260,969.296387 
M2390.436523,977.539490 
	C2395.502441,972.975525 2392.626709,966.962830 2393.294922,961.607849 
	C2393.777100,957.743286 2392.981201,954.113281 2388.881836,952.620789 
	C2384.723389,951.106750 2380.433350,950.891174 2376.677734,953.929993 
	C2371.868164,957.821411 2370.429443,968.611023 2373.774658,975.191406 
	C2376.534912,980.621155 2379.839111,981.333130 2390.436523,977.539490 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M719.644165,954.933716 
	C720.176758,960.923950 721.375610,966.340271 720.510986,971.404358 
	C718.323486,984.217468 709.406860,988.907410 697.016968,984.627136 
	C696.118896,984.316895 695.167847,984.160034 693.569580,983.766418 
	C693.569580,988.952881 693.569580,993.821167 693.569580,999.317871 
	C691.008484,999.691895 688.969666,999.989624 686.415283,1000.362610 
	C686.415283,982.126038 686.415283,964.616272 686.415283,945.116699 
	C689.542542,947.169373 691.549561,948.486755 694.195129,950.223328 
	C703.011047,944.320312 712.292114,941.815552 719.644165,954.933716 
M692.971741,971.989319 
	C692.836914,977.356567 695.870117,979.723022 700.821716,980.209106 
	C705.823669,980.699951 710.539307,979.621460 712.153076,974.458679 
	C713.484314,970.199402 714.053223,965.411133 713.661682,960.971863 
	C713.069580,954.258728 709.291931,951.449402 703.166931,951.736511 
	C696.566528,952.045959 693.287903,955.433594 692.982300,962.404297 
	C692.866821,965.038574 692.963928,967.682129 692.971741,971.989319 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M1611.999023,994.688599 
	C1611.998779,978.227783 1611.998779,962.628662 1611.998779,944.760437 
	C1615.574707,947.177063 1617.584229,948.535034 1619.995728,950.164795 
	C1619.908813,950.184509 1620.638306,950.194641 1621.166870,949.873657 
	C1635.372437,941.246277 1645.919067,946.413330 1647.179199,962.990417 
	C1647.497192,967.173950 1646.832153,971.706177 1645.471558,975.685974 
	C1642.678955,983.854980 1634.709473,987.863281 1626.286011,985.971130 
	C1624.143799,985.489929 1622.111206,984.520874 1619.497192,983.586060 
	C1619.339111,986.867737 1619.170166,989.488342 1619.099487,992.111572 
	C1619.037720,994.408142 1619.086548,996.707703 1619.086548,999.435913 
	C1614.999878,1000.707336 1611.624512,1001.769043 1611.999023,994.688599 
M1620.018799,976.805420 
	C1631.142334,983.815002 1639.565674,979.654175 1640.026245,966.826233 
	C1640.119751,964.220886 1639.984863,961.492737 1639.307129,958.997253 
	C1637.741333,953.232727 1634.122070,951.074951 1628.124634,951.809875 
	C1622.370483,952.514893 1619.262939,955.594116 1619.030151,961.472290 
	C1618.847900,966.071594 1619.192383,970.691772 1620.018799,976.805420 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1554.951538,751.597534 
	C1559.337158,752.168274 1562.927002,752.403076 1567.227905,752.684326 
	C1567.227905,761.361023 1567.227905,769.506348 1567.227905,778.529907 
	C1564.044434,778.529907 1561.045654,778.529907 1557.581543,778.529907 
	C1557.059937,773.751587 1556.604248,769.577759 1556.086060,764.830811 
	C1548.941772,764.386475 1542.186768,763.966370 1533.638428,763.434753 
	C1538.413330,753.056824 1542.127808,743.892456 1546.804199,735.248596 
	C1549.411133,730.430115 1554.461914,733.457703 1559.239746,732.494202 
	C1557.304565,739.638062 1555.730225,745.449768 1554.951538,751.597534 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M851.798096,799.071228 
	C855.495605,793.854797 858.044006,795.928101 860.349915,799.604126 
	C863.491760,804.612732 866.628113,809.624756 871.144287,816.834351 
	C872.420715,808.208557 873.355896,801.889221 874.291016,795.569885 
	C875.075684,795.505432 875.860413,795.440979 876.645081,795.376526 
	C877.572144,797.216064 879.233826,799.028809 879.302185,800.899719 
	C879.642273,810.205627 879.736389,819.531494 879.487183,828.838806 
	C879.436401,830.737976 877.541199,832.587830 876.496277,834.460388 
	C874.641479,833.379395 872.168823,832.733582 871.045105,831.137756 
	C867.339905,825.876282 864.122681,820.271118 860.718079,814.797974 
	C859.922913,814.994019 859.127686,815.190125 858.332458,815.386230 
	C858.199280,820.162903 858.387756,824.982483 857.760559,829.693359 
	C857.537109,831.371521 855.335022,832.786316 854.036133,834.321350 
	C853.098267,832.785461 851.369629,831.259033 851.351074,829.712158 
	C851.231384,819.734558 851.485352,809.752563 851.798096,799.071228 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4208.422852,719.143677 
	C4208.422852,723.012207 4208.422852,725.954956 4208.422852,729.316284 
	C4205.229980,729.316284 4202.702148,729.316284 4199.711426,729.316284 
	C4199.711426,713.885376 4199.711426,698.741577 4199.711426,682.919128 
	C4209.601562,682.919128 4219.350586,682.919128 4229.772949,682.919128 
	C4229.910645,684.596802 4230.084473,686.702881 4230.332520,689.720947 
	C4222.875000,689.720947 4216.049805,689.720947 4208.842773,689.720947 
	C4208.842773,694.099060 4208.842773,697.631531 4208.842773,701.999634 
	C4214.643066,701.999634 4220.512207,701.999634 4227.056152,701.999634 
	C4227.056152,704.845642 4227.056152,706.873962 4227.056152,709.698608 
	C4220.951172,709.698608 4215.072266,709.698608 4208.842773,709.698608 
	C4208.677734,713.052185 4208.550293,715.634949 4208.422852,719.143677 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M270.749695,804.661743 
	C271.311523,801.146240 271.827972,798.422363 272.344452,795.698425 
	C273.179718,795.575439 274.014984,795.452515 274.850220,795.329529 
	C275.792297,797.417786 277.470734,799.478760 277.549194,801.598938 
	C277.892273,810.870056 277.902863,820.161255 277.695496,829.437622 
	C277.658936,831.074707 276.315155,833.605957 275.018005,834.033325 
	C273.704529,834.466003 271.168793,833.240784 270.110657,831.962036 
	C268.021942,829.437866 266.630798,826.345642 264.863342,823.543701 
	C263.196228,820.900879 261.416199,818.329346 257.705841,816.193970 
	C257.407837,821.270325 257.289795,826.368713 256.671417,831.405701 
	C256.535492,832.512878 254.615585,834.182373 253.528442,834.173767 
	C252.418640,834.164978 250.361816,832.403687 250.367676,831.419495 
	C250.434555,820.207764 250.800797,808.997375 251.168671,797.789307 
	C251.185196,797.285522 251.980881,796.807251 252.970230,795.686584 
	C262.039246,798.367798 262.142059,809.367065 269.829468,815.038635 
	C270.195160,811.031799 270.449738,808.242554 270.749695,804.661743 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M357.947174,985.710693 
	C345.830017,989.132874 341.830078,986.217590 341.618256,974.505188 
	C341.492249,967.537109 341.595215,960.564880 341.595215,953.809021 
	C339.209869,952.733032 337.302185,951.872559 333.823669,950.303528 
	C337.199371,948.705505 339.083221,947.813782 341.188568,946.817139 
	C342.202026,942.575378 343.296600,937.993896 344.695618,932.138306 
	C350.563843,937.009521 347.000427,942.221741 349.554565,947.239258 
	C357.562805,947.239258 366.340271,947.239258 375.611511,947.239258 
	C375.611511,960.823486 375.611511,973.299622 375.611511,986.052307 
	C373.695526,986.052307 372.105988,986.052307 369.479858,986.052307 
	C369.479858,975.053528 369.479858,964.260681 369.479858,952.944702 
	C362.253204,952.944702 356.053772,952.944702 348.494049,952.944702 
	C348.494049,960.745239 348.319397,968.587463 348.574707,976.415771 
	C348.686401,979.839600 350.712494,981.921143 354.561707,981.226807 
	C356.091278,980.950928 357.626373,980.705688 360.207367,980.269226 
	C359.506866,982.579529 359.087982,983.961121 357.947174,985.710693 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1007.188477,828.759766 
	C1001.517151,822.926880 1000.550964,816.553650 1002.427490,809.709045 
	C1005.334656,799.105042 1015.504456,793.611694 1025.849976,796.819946 
	C1035.663452,799.863098 1041.258301,810.794678 1038.142334,820.837280 
	C1035.000122,830.964294 1024.195435,836.813232 1014.400635,833.410156 
	C1011.974609,832.567200 1009.908508,830.688110 1007.188477,828.759766 
M1008.222839,816.507446 
	C1009.156433,818.576172 1009.798462,820.850891 1011.084106,822.670898 
	C1013.789062,826.500000 1017.868652,828.151123 1022.337585,827.213867 
	C1027.116943,826.211365 1030.525269,823.075806 1031.871460,818.163574 
	C1033.255737,813.112366 1031.421387,809.089966 1027.572510,805.884033 
	C1020.137207,799.690918 1011.330444,803.829956 1008.222839,816.507446 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M927.819702,108.185608 
	C927.819275,116.427628 927.819275,123.706078 927.819275,131.699600 
	C924.593323,132.015305 921.804871,132.288193 918.387817,132.622589 
	C918.387817,113.210838 918.387817,94.391869 918.385498,75.570007 
	C924.773132,74.389847 924.773132,74.389847 928.434021,79.010231 
	C934.129761,73.075600 940.664307,71.985390 948.641113,76.188248 
	C947.907898,78.797119 947.236023,81.187637 946.518188,83.741959 
	C945.132263,83.741959 944.160828,83.905861 943.263916,83.716545 
	C934.609192,81.889877 930.453247,84.042961 928.763977,92.337418 
	C927.781250,97.162895 928.091553,102.251717 927.819702,108.185608 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M4646.190430,729.979492 
	C4637.125000,730.997314 4629.416504,730.550354 4625.450195,720.938049 
	C4629.209473,718.483643 4632.209473,718.034607 4635.916992,721.439697 
	C4639.384766,724.624329 4643.525391,724.917603 4647.680664,718.936218 
	C4643.865234,717.774780 4640.855957,716.989441 4637.943848,715.934570 
	C4635.165039,714.927979 4632.155762,714.093018 4629.834473,712.384705 
	C4624.572754,708.511902 4624.979980,701.036926 4630.317871,697.103271 
	C4637.896973,691.518127 4648.444336,693.874878 4654.321289,702.838318 
	C4651.588379,704.952026 4648.902344,706.154602 4645.693359,703.725159 
	C4642.154785,701.046387 4638.668457,701.209656 4633.559570,703.967346 
	C4636.454590,705.578003 4638.149414,706.824402 4640.047363,707.505188 
	C4642.839844,708.506714 4645.881348,708.838684 4648.632324,709.923706 
	C4657.491699,713.417847 4658.704590,721.485474 4651.329590,727.631897 
	C4650.097168,728.658936 4648.410156,729.140442 4646.190430,729.979492 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M910.745483,946.596558 
	C916.030396,946.434143 920.920837,945.598694 925.174133,946.879333 
	C934.380066,949.651245 938.675659,960.170532 936.288696,971.832397 
	C934.314331,981.478394 926.968262,986.937439 916.654663,986.422974 
	C906.417725,985.912292 899.770081,979.255737 899.037354,968.384277 
	C898.411804,959.103699 900.735657,951.149963 910.745483,946.596558 
M926.128906,977.327454 
	C930.503906,971.510986 930.936218,965.116394 928.364563,958.577759 
	C925.258850,950.681152 913.995483,949.051697 908.891113,955.584839 
	C905.077393,960.466064 904.822449,971.443970 908.808899,976.226746 
	C913.374268,981.703979 919.044189,981.287720 926.128906,977.327454 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M455.103760,948.757080 
	C462.167725,954.336243 463.326172,961.395630 462.650330,968.999817 
	C461.689819,979.807007 454.944336,986.209595 444.510315,986.447021 
	C433.547363,986.696533 426.342194,980.308350 425.097839,969.235718 
	C423.003326,950.598450 436.505402,940.997314 455.103760,948.757080 
M432.009155,965.206238 
	C432.261047,967.493042 432.169373,969.884949 432.830200,972.046753 
	C434.703552,978.174927 438.299988,980.525269 444.662354,980.240051 
	C450.314148,979.986755 453.969116,977.442017 454.969574,971.510010 
	C455.655487,967.442810 455.537903,962.866333 454.363617,958.941101 
	C452.256073,951.896484 443.049316,948.870300 437.500763,953.535156 
	C434.798065,955.807495 433.836914,960.151306 432.009155,965.206238 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M2721.091553,962.890137 
	C2724.223389,950.245972 2729.723633,945.446472 2740.161865,945.555664 
	C2748.392822,945.641785 2754.537354,949.663696 2757.371338,956.819824 
	C2760.674805,965.161621 2758.552246,976.838379 2752.798584,981.975647 
	C2747.461914,986.740601 2738.031738,987.889893 2731.203369,984.659973 
	C2726.017334,982.206848 2722.829102,978.122864 2721.731689,972.584167 
	C2721.155518,969.677551 2721.220215,966.644104 2721.091553,962.890137 
M2751.706543,963.572083 
	C2750.810303,958.106995 2749.146729,953.218689 2742.798340,951.941406 
	C2735.875488,950.548645 2730.952637,953.326477 2728.832764,959.789978 
	C2726.334229,967.406494 2728.925537,976.667358 2734.297119,979.319641 
	C2740.605957,982.434814 2748.165527,979.598816 2750.532959,972.947144 
	C2751.395996,970.521362 2751.409180,967.793030 2751.706543,963.572083 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M2423.483398,986.076111 
	C2410.141357,980.392700 2405.198975,967.822632 2410.874023,955.730103 
	C2415.349854,946.192566 2427.733154,942.481934 2437.429443,947.772766 
	C2444.914062,951.856689 2448.305908,960.761169 2446.389160,971.296936 
	C2444.799072,980.039001 2439.134521,985.366272 2430.190430,986.330994 
	C2428.224609,986.543030 2426.205322,986.257874 2423.483398,986.076111 
M2430.386230,951.868042 
	C2424.687500,951.270020 2419.720459,952.274170 2417.431152,958.344849 
	C2415.093750,964.542664 2415.048096,970.793091 2418.932617,976.341614 
	C2423.135986,982.345642 2433.793457,981.590088 2437.599121,975.318237 
	C2442.262939,967.632996 2439.918945,957.922729 2430.386230,951.868042 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M1697.035156,945.710938 
	C1714.459229,946.340393 1722.983032,958.404297 1717.740234,974.160767 
	C1715.298340,981.499573 1710.010742,985.671692 1702.248291,986.339722 
	C1694.371826,987.017456 1687.738892,984.826355 1683.589600,977.518311 
	C1676.375488,964.812134 1682.160400,950.388245 1697.035156,945.710938 
M1702.411743,980.130005 
	C1711.844238,975.714600 1715.059204,963.462341 1708.855225,955.574097 
	C1704.872437,950.510010 1695.295776,950.125854 1691.325928,955.195435 
	C1687.092285,960.602051 1687.134766,966.859985 1689.193604,973.097168 
	C1691.009888,978.599426 1695.207520,980.643372 1702.411743,980.130005 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M893.144409,798.594604 
	C906.030334,791.293518 922.138977,800.804810 921.222412,816.044678 
	C920.731934,824.199951 915.954163,830.705750 908.418762,833.314514 
	C900.710449,835.983154 893.156555,833.698975 888.005981,827.142151 
	C883.190796,821.012268 882.455078,812.418091 886.588867,805.666992 
	C888.112793,803.178223 890.502686,801.219666 893.144409,798.594604 
M891.964966,820.767456 
	C895.432922,825.745667 899.644592,829.202698 906.176758,826.993958 
	C911.996643,825.026184 915.468933,818.699036 914.275391,812.683838 
	C913.192139,807.223938 908.556946,803.205627 903.151184,803.040161 
	C896.861145,802.847656 891.743103,807.023682 890.726868,813.557739 
	C890.436035,815.427856 891.095947,817.445923 891.964966,820.767456 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M4473.571289,715.788269 
	C4468.714355,715.788574 4464.753418,715.788574 4460.680176,715.788574 
	C4462.298340,723.409241 4464.737793,725.193298 4470.041992,721.981934 
	C4473.515137,719.878967 4476.331055,719.322998 4479.863770,720.988586 
	C4475.922363,729.522644 4468.938965,732.578613 4460.596680,729.650757 
	C4452.965820,726.972656 4449.032715,717.867981 4451.168457,707.827393 
	C4453.050293,698.980286 4459.370117,693.598022 4467.058105,694.294189 
	C4476.378906,695.138306 4480.972656,701.766846 4481.228027,715.173462 
	C4478.995117,715.376343 4476.730957,715.582153 4473.571289,715.788269 
M4468.696289,709.658203 
	C4471.780762,709.773560 4473.520996,708.111450 4471.777344,705.527100 
	C4470.541016,703.693909 4467.679199,701.988098 4465.520020,701.960083 
	C4461.708496,701.910522 4459.590332,704.473145 4460.330566,709.127502 
	C4462.525879,709.304993 4464.759766,709.485657 4468.696289,709.658203 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M4612.250977,720.429321 
	C4615.166504,720.075073 4617.415527,720.267944 4619.772461,720.470093 
	C4616.695312,729.111572 4610.758301,732.171570 4601.947754,729.991150 
	C4593.818359,727.979309 4589.274414,719.428772 4590.894043,709.188110 
	C4592.384766,699.756653 4598.728516,693.752319 4606.684082,694.241699 
	C4615.949707,694.811646 4620.608398,701.219910 4621.394531,715.649841 
	C4614.317871,715.649841 4607.256836,715.649841 4599.647949,715.649841 
	C4603.743652,724.430847 4604.082031,724.551697 4612.250977,720.429321 
M4607.001953,709.666199 
	C4608.748535,709.427490 4610.495605,709.188782 4612.528809,708.910889 
	C4612.087402,703.972473 4610.083008,701.435669 4605.729492,701.811279 
	C4601.547852,702.171997 4599.521484,704.583496 4600.397461,709.284607 
	C4602.153320,709.420715 4603.734375,709.543213 4607.001953,709.666199 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M1789.923096,966.006958 
	C1791.302368,953.612549 1795.588989,947.811951 1804.099365,945.990173 
	C1812.497681,944.192444 1820.187134,946.937988 1824.424927,953.247498 
	C1829.225586,960.395142 1829.238647,971.713074 1824.454346,978.790833 
	C1820.217285,985.058899 1812.454712,987.815857 1804.098877,986.020264 
	C1795.567261,984.186951 1791.275269,978.380127 1789.923096,966.006958 
M1800.034668,955.396545 
	C1796.314941,961.098145 1796.274414,967.229797 1798.300781,973.412781 
	C1799.641724,977.503845 1802.657471,979.912109 1807.113159,980.196594 
	C1811.181519,980.456421 1815.029663,980.144592 1817.821167,976.549805 
	C1821.368042,971.982300 1821.522461,960.553162 1818.031860,955.838440 
	C1814.506348,951.076843 1809.626709,950.590759 1800.034668,955.396545 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4684.088379,695.509521 
	C4689.945312,697.418274 4690.735352,701.599365 4690.768066,706.127441 
	C4690.823242,713.698364 4690.783203,721.270020 4690.783203,729.640076 
	C4689.762695,729.640076 4687.754883,730.265503 4686.768555,729.526855 
	C4683.367188,726.979370 4680.598145,728.508850 4677.103516,729.386963 
	C4673.620117,730.262573 4668.903809,729.854248 4665.851074,728.078369 
	C4659.303223,724.268860 4660.815430,714.567505 4668.239746,711.484619 
	C4672.463379,709.730652 4677.070801,708.899841 4682.202148,707.457458 
	C4681.621094,705.657715 4681.333984,703.161926 4680.694824,703.068054 
	C4677.955078,702.665771 4675.084961,702.756470 4672.314453,703.094604 
	C4670.532227,703.312073 4668.878418,704.552917 4667.093750,704.794006 
	C4666.019043,704.939209 4664.804199,704.046326 4663.587891,703.596069 
	C4668.247070,694.534363 4671.484375,693.240173 4684.088379,695.509521 
M4682.080566,715.163757 
	C4677.007812,712.887146 4673.525879,715.159851 4670.405273,718.870483 
	C4676.105957,725.691833 4678.618164,725.169861 4682.080566,715.163757 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M1172.761963,982.784058 
	C1161.827026,988.010132 1153.393311,987.361389 1147.393799,981.340576 
	C1141.678589,975.605225 1140.029541,964.456238 1143.716309,956.255859 
	C1147.089111,948.754272 1153.095947,945.485901 1161.126099,945.557190 
	C1169.187500,945.628723 1175.274048,949.005981 1178.168335,956.713928 
	C1181.695190,966.106201 1180.730225,974.872681 1172.761963,982.784058 
M1149.877441,971.966858 
	C1153.834961,979.454956 1156.865479,981.265137 1163.521729,980.116943 
	C1169.148315,979.146423 1172.070190,975.222656 1172.466919,967.740845 
	C1172.587769,965.461365 1172.459229,963.106079 1172.014404,960.871277 
	C1170.767334,954.607910 1167.282959,951.817444 1161.061768,951.764832 
	C1154.671875,951.710693 1151.239136,954.145630 1149.888062,960.541504 
	C1149.227295,963.669373 1149.623413,967.020508 1149.877441,971.966858 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1333.644531,798.325195 
	C1336.996338,801.905090 1340.521484,804.797913 1342.218506,808.523438 
	C1345.995605,816.815552 1343.168091,825.293579 1335.862793,830.529419 
	C1328.865601,835.544434 1320.027710,835.532776 1313.624634,830.500183 
	C1306.434082,824.848572 1304.267700,815.849182 1308.011597,807.182556 
	C1311.345947,799.463989 1318.871094,795.114990 1327.313599,796.238525 
	C1329.249756,796.496155 1331.098999,797.406128 1333.644531,798.325195 
M1325.007080,827.605164 
	C1327.910645,826.196106 1331.322876,825.345764 1333.612061,823.261841 
	C1338.389893,818.912354 1338.297974,812.259583 1334.102661,807.170715 
	C1330.215210,802.455444 1324.375122,801.435486 1318.876587,804.511780 
	C1313.483765,807.528992 1311.336182,814.185364 1313.695557,819.966187 
	C1315.527832,824.455505 1319.072021,826.486694 1325.007080,827.605164 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M2635.199707,980.662598 
	C2640.865723,978.560181 2642.255127,975.067810 2642.038574,970.116455 
	C2641.705566,962.509521 2641.951172,954.877197 2641.951172,946.793213 
	C2644.469727,946.793213 2646.271729,946.793213 2648.399902,946.793213 
	C2648.399902,959.973511 2648.399902,972.841125 2648.399902,987.158508 
	C2645.449219,985.652588 2643.424561,984.619202 2640.330322,983.040100 
	C2641.211182,982.909058 2640.483643,982.799011 2640.082520,983.109863 
	C2634.735352,987.251892 2629.050537,989.454651 2622.556152,985.902222 
	C2616.370117,982.518311 2615.701904,976.601196 2615.749756,970.383240 
	C2615.808350,962.753906 2615.763672,955.123779 2615.763672,946.904480 
	C2618.125000,946.904480 2619.903564,946.904480 2622.625244,946.904480 
	C2622.625244,954.811218 2622.448242,962.731628 2622.672852,970.640686 
	C2622.919434,979.320190 2625.071533,981.078674 2635.199707,980.662598 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1974.851562,952.015625 
	C1971.426636,953.355713 1968.785889,954.582581 1966.378662,955.700867 
	C1963.226318,953.912598 1962.988281,951.934509 1965.414185,950.040222 
	C1971.035645,945.650818 1977.493042,944.084778 1984.213989,946.526672 
	C1990.738647,948.897095 1992.576904,954.578308 1992.550659,961.060791 
	C1992.517334,969.314636 1992.542603,977.568726 1992.542603,987.250732 
	C1986.317505,983.674072 1981.435913,984.855042 1976.145752,987.006348 
	C1970.292114,989.386902 1963.844971,986.183105 1961.897339,981.225891 
	C1959.585693,975.342957 1962.306030,969.981750 1969.338013,967.142029 
	C1971.772827,966.158752 1974.450073,965.750427 1977.039307,965.182678 
	C1979.619385,964.616821 1982.227905,964.180298 1984.794678,963.692505 
	C1985.531982,953.703491 1984.964355,952.980469 1974.851562,952.015625 
M1985.556396,969.808594 
	C1980.227051,966.596802 1975.382812,969.369385 1970.939453,971.675110 
	C1969.307983,972.521729 1967.924438,976.322205 1968.469482,978.174561 
	C1968.991455,979.948730 1972.045898,981.838257 1974.189575,982.116272 
	C1981.089111,983.010864 1984.983276,979.143738 1985.556396,969.808594 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2306.989014,983.216064 
	C2304.489258,972.826538 2306.518799,968.842773 2315.486572,966.277405 
	C2319.899658,965.014954 2324.523682,964.490417 2329.005859,963.640747 
	C2329.362549,952.284485 2324.983643,949.232422 2314.858643,953.568359 
	C2311.127197,955.166260 2311.127197,955.166321 2307.770508,952.965088 
	C2313.289062,946.387451 2320.757568,943.781250 2327.645752,946.259583 
	C2332.789307,948.110291 2336.020264,951.913574 2336.194336,957.371948 
	C2336.497070,966.866699 2336.278564,976.378052 2336.278564,987.158386 
	C2330.620850,984.086914 2325.931641,984.334534 2321.045166,986.736877 
	C2316.035645,989.199768 2311.381836,987.556091 2306.989014,983.216064 
M2314.624023,971.574036 
	C2311.888672,973.642212 2310.655273,976.776917 2312.795166,979.209595 
	C2314.396240,981.030151 2317.823486,982.181702 2320.364746,982.064087 
	C2328.237549,981.699768 2330.689209,977.267090 2328.404053,968.516235 
	C2327.140137,968.516235 2325.792480,968.302979 2324.541260,968.559204 
	C2321.654541,969.150330 2318.814453,969.969299 2314.624023,971.574036 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1227.714355,954.366821 
	C1221.123413,949.246948 1215.962402,953.064880 1210.918823,955.682007 
	C1207.749756,954.676819 1206.585083,952.623779 1208.938110,950.522888 
	C1214.252319,945.778015 1220.750244,944.197632 1227.564087,946.302734 
	C1234.218506,948.358582 1236.487427,953.816345 1236.517944,960.364502 
	C1236.557861,968.907288 1236.527832,977.450378 1236.527832,987.538208 
	C1230.427368,983.692871 1225.795532,984.892700 1220.822632,986.788879 
	C1214.273560,989.285950 1207.761108,986.345459 1205.823975,980.945190 
	C1203.671631,974.945374 1206.359009,969.593018 1213.607056,967.061462 
	C1218.567871,965.328735 1223.877808,964.595459 1230.052490,963.181519 
	C1229.442993,960.484314 1228.825073,957.749939 1227.714355,954.366821 
M1220.634888,982.222961 
	C1230.688599,978.378845 1231.111694,977.619629 1228.030151,968.056763 
	C1224.597168,968.724487 1221.037964,969.200867 1217.607544,970.145203 
	C1214.214478,971.079163 1211.626465,973.158813 1211.988159,977.135437 
	C1212.366943,981.299316 1215.282715,982.416626 1220.634888,982.222961 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M450.294922,828.685852 
	C446.974792,825.382080 445.050293,828.917786 442.766388,830.293152 
	C435.459076,834.693604 432.488922,835.207642 422.396790,833.277344 
	C422.396790,821.408020 422.396790,809.401123 422.396790,797.680115 
	C439.078186,791.659729 453.113403,803.924255 448.907074,821.752991 
	C448.456055,823.664673 448.282471,825.641785 448.948486,828.245361 
	C449.916840,828.902222 450.294922,828.685852 450.294922,828.685852 
M428.377167,811.325195 
	C429.311401,816.595520 426.152252,822.507568 431.209717,827.986450 
	C433.838684,826.692078 436.769165,825.833130 438.960754,824.060608 
	C445.475861,818.791382 443.510162,807.491028 435.731873,804.300232 
	C431.423615,802.532898 429.814026,803.680908 428.377167,811.325195 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M727.498413,974.945862 
	C729.559570,968.841919 734.214294,967.089844 739.122986,965.895203 
	C743.258118,964.888794 747.482422,964.248718 751.615173,963.456482 
	C750.510437,950.438904 747.562866,949.302917 730.789978,955.779968 
	C730.789978,953.781189 730.106750,951.580994 730.906189,950.638672 
	C734.724609,946.138123 744.792969,944.083496 750.316284,946.477356 
	C756.192688,949.024353 758.479980,953.921570 758.504456,960.057312 
	C758.538635,968.617371 758.513062,977.177673 758.513062,986.886658 
	C752.529846,984.339783 747.712463,984.771179 742.329407,986.860107 
	C733.904480,990.129333 728.695618,985.684509 727.498413,974.945862 
M734.457336,973.930481 
	C734.764465,981.221985 735.917908,982.557739 741.651794,982.261780 
	C749.563843,981.853455 752.159058,978.204712 750.873535,968.594910 
	C745.307800,968.264771 740.024292,968.981079 734.457336,973.930481 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M4551.859863,718.151978 
	C4550.881348,705.160278 4553.657227,699.024780 4561.507812,695.788391 
	C4569.937012,692.313477 4578.627930,695.300537 4582.878906,703.133301 
	C4587.512207,711.670715 4584.889160,723.057251 4577.164062,727.941833 
	C4569.993164,732.476257 4560.104004,730.902344 4554.701172,724.180847 
	C4553.486328,722.669922 4552.880371,720.669617 4551.859863,718.151978 
M4567.246094,701.758667 
	C4560.163086,705.788391 4557.506836,712.602783 4561.332520,718.683411 
	C4562.712402,720.876770 4565.872559,723.202637 4568.208496,723.190308 
	C4570.552734,723.178040 4573.738770,720.836304 4575.053711,718.622925 
	C4578.670410,712.534363 4575.793457,705.478394 4567.246094,701.758667 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M4364.967285,729.072083 
	C4355.787109,724.333130 4354.438965,716.739929 4355.629395,708.324890 
	C4356.540039,701.884644 4360.355469,697.606567 4366.610352,695.399353 
	C4373.317383,693.032471 4379.231934,694.520203 4384.022949,699.309143 
	C4389.451660,704.735413 4390.354980,711.624573 4388.091797,718.769836 
	C4386.010742,725.336975 4381.477051,729.533813 4374.457520,730.182983 
	C4371.555176,730.451477 4368.559082,729.706970 4364.967285,729.072083 
M4378.369629,704.996338 
	C4375.444824,701.270203 4371.810059,700.635010 4367.872559,703.032349 
	C4364.362793,705.169312 4362.822266,711.568420 4364.337402,716.656494 
	C4365.461426,720.432983 4367.748047,723.140930 4371.896973,723.501404 
	C4375.634766,723.826111 4379.370605,720.661682 4379.878906,716.175781 
	C4380.241699,712.972107 4379.530762,709.646790 4378.369629,704.996338 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1131.203613,826.628052 
	C1131.215820,816.220581 1131.215820,806.659973 1131.215820,796.468445 
	C1136.981323,796.468445 1141.618652,796.064392 1146.157593,796.560913 
	C1153.403442,797.353516 1158.511108,805.147888 1154.711792,811.029724 
	C1150.684326,817.264465 1152.065918,822.002625 1155.023071,827.466919 
	C1155.918213,829.121155 1156.239502,831.085876 1156.772217,832.748108 
	C1153.630737,835.554504 1151.539551,834.599182 1149.951050,831.855774 
	C1148.456665,829.274597 1147.415161,826.394592 1145.687622,823.996643 
	C1144.357300,822.149963 1142.272461,820.846924 1138.698364,817.690796 
	C1138.119019,823.277161 1138.046753,826.439331 1137.376587,829.469238 
	C1137.001587,831.164062 1135.851074,833.768555 1134.672852,833.994385 
	C1131.588013,834.585510 1131.029785,832.022583 1131.116943,829.465515 
	C1131.139648,828.801941 1131.166504,828.138550 1131.203613,826.628052 
M1141.157715,802.841309 
	C1136.675659,807.544922 1136.388062,810.227356 1140.392700,811.424805 
	C1143.219849,812.270325 1146.778442,813.059448 1148.055786,809.262939 
	C1149.528564,804.885071 1146.359131,803.461914 1141.157715,802.841309 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M1084.567871,824.343262 
	C1078.230347,833.888794 1069.879272,835.897461 1058.519409,833.396057 
	C1058.648315,821.266357 1058.271240,809.214417 1058.984619,797.476440 
	C1077.927490,791.323120 1091.946655,807.402954 1084.567871,824.343262 
M1069.734985,827.209167 
	C1071.251953,826.553162 1072.933716,826.131531 1074.256836,825.200012 
	C1079.555664,821.469482 1081.473022,816.721802 1079.461548,811.520325 
	C1077.340332,806.035156 1073.341187,803.156311 1065.884155,804.003845 
	C1065.884155,811.319580 1065.831421,818.452454 1065.981201,825.581116 
	C1065.993530,826.170654 1067.378174,826.731445 1069.734985,827.209167 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1556.660889,966.153931 
	C1556.298462,978.376160 1562.645020,982.804688 1573.944092,979.054077 
	C1576.718140,978.133240 1579.660278,974.989502 1581.903320,979.781921 
	C1572.982056,988.073730 1560.958984,988.708374 1553.582764,981.441162 
	C1546.253174,974.219788 1545.794556,958.976501 1552.676514,951.313416 
	C1557.624146,945.804443 1566.860718,943.861572 1573.682007,946.895203 
	C1580.559082,949.953552 1583.133667,955.451233 1581.919434,965.865479 
	C1573.902710,965.865479 1565.719971,965.865479 1556.660889,966.153931 
M1568.697144,961.652222 
	C1571.175903,961.484680 1573.654785,961.317139 1576.221313,961.143616 
	C1574.502930,952.882996 1572.072876,950.389465 1566.402466,950.387207 
	C1560.372803,950.384888 1557.439087,953.407349 1556.124390,961.652344 
	C1559.804810,961.652344 1563.366211,961.652344 1568.697144,961.652222 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1490.981567,980.805908 
	C1486.043335,974.649231 1485.174561,968.141357 1486.087036,961.382629 
	C1487.681274,949.575684 1499.433350,942.460327 1510.557739,946.351746 
	C1517.939575,948.933960 1521.005371,954.739258 1520.124878,965.521362 
	C1511.424927,965.521362 1502.606567,965.521362 1493.766724,965.521362 
	C1494.265625,978.370605 1500.644409,982.819641 1511.977051,979.031433 
	C1514.772095,978.097107 1517.714600,975.039673 1519.919312,979.823914 
	C1510.483521,988.434998 1502.543213,988.815125 1490.981567,980.805908 
M1493.701782,959.699036 
	C1500.367798,963.859192 1507.233643,960.975037 1514.348877,961.193848 
	C1514.456055,954.678955 1511.466431,951.415833 1506.344360,950.597412 
	C1500.420654,949.650940 1495.979736,952.140808 1493.701782,959.699036 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2176.450439,985.624207 
	C2165.883057,979.472107 2162.031494,971.175293 2164.158203,960.413818 
	C2166.160400,950.284546 2175.168457,944.132385 2185.608398,945.764160 
	C2194.837402,947.206604 2199.085693,953.556519 2198.136719,965.514893 
	C2189.434570,965.514893 2180.615479,965.514893 2171.776367,965.514893 
	C2172.250977,978.360901 2178.620605,982.763977 2189.989990,979.078430 
	C2192.048828,978.410950 2194.199951,977.930908 2196.344482,977.701660 
	C2196.789551,977.654053 2197.394531,979.102966 2198.187012,980.235168 
	C2192.177246,986.600952 2184.942383,987.211182 2176.450439,985.624207 
M2191.830566,956.237915 
	C2189.108398,951.032288 2184.678223,949.335022 2179.289795,950.900513 
	C2174.472412,952.300049 2171.288574,955.355652 2172.060059,961.621948 
	C2177.946533,961.621948 2183.551514,961.602539 2189.156738,961.630676 
	C2191.772461,961.643799 2192.648438,960.309326 2191.830566,956.237915 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M4283.461914,729.718262 
	C4279.091797,730.119812 4277.973145,728.344604 4278.007324,725.061707 
	C4278.104492,715.771729 4278.041016,706.480042 4278.041016,696.560181 
	C4280.104004,696.257202 4282.529785,695.118164 4283.637207,695.884644 
	C4286.977539,698.196960 4289.524902,696.703552 4292.621094,695.553894 
	C4301.044922,692.426453 4307.496582,696.389832 4307.965820,705.168213 
	C4308.389160,713.075256 4308.055176,721.022827 4308.055176,729.337280 
	C4305.059082,729.337280 4302.854980,729.337280 4299.469238,729.337280 
	C4299.469238,722.723083 4299.607422,716.184814 4299.415039,709.656372 
	C4299.307617,705.998047 4299.096680,701.967041 4293.868652,701.866638 
	C4289.793945,701.788330 4287.711914,704.334167 4287.338379,708.003052 
	C4286.869141,712.616333 4287.160156,717.309143 4286.650879,721.915344 
	C4286.357910,724.560669 4285.130859,727.102539 4283.461914,729.718262 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M4711.231445,694.937988 
	C4724.366699,694.583191 4731.162598,699.891418 4732.063477,710.371765 
	C4732.823242,719.215942 4728.299805,727.038879 4720.938965,729.612549 
	C4713.442871,732.233582 4704.653809,729.284302 4700.745117,722.836365 
	C4696.206543,715.349243 4697.346680,704.586670 4703.616211,698.969421 
	C4705.513184,697.269775 4708.185547,696.435852 4711.231445,694.937988 
M4706.713867,712.830261 
	C4707.145996,714.745056 4707.223145,716.837585 4708.076660,718.541016 
	C4710.471680,723.322815 4714.604492,724.787292 4718.549805,722.594543 
	C4723.182617,720.019836 4725.006836,712.505554 4722.389648,706.780151 
	C4720.358398,702.336365 4715.875977,700.319214 4711.928711,702.344910 
	C4710.547852,703.053467 4709.209961,704.331543 4708.474121,705.687012 
	C4707.558594,707.375183 4707.286621,709.412476 4706.713867,712.830261 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M4268.957031,699.023560 
	C4269.000488,709.508362 4269.000488,719.081299 4269.000488,729.171997 
	C4266.458008,729.283020 4263.683594,730.176331 4262.907227,729.299561 
	C4260.093262,726.121826 4257.978027,728.068542 4255.194824,729.120117 
	C4245.768066,732.681946 4239.585938,728.594116 4239.105469,718.428284 
	C4238.763184,711.192261 4239.039062,703.927063 4239.039062,696.148071 
	C4242.137695,696.148071 4244.589355,696.148071 4247.909180,696.148071 
	C4247.909180,702.973511 4247.915039,709.548889 4247.906738,716.124268 
	C4247.902344,719.717468 4248.687012,723.204956 4252.903809,723.352783 
	C4257.057617,723.498352 4259.769043,720.825928 4259.912598,716.562805 
	C4260.133301,709.983643 4259.970703,703.391602 4259.970703,696.163696 
	C4263.671387,695.935669 4266.807617,693.768799 4268.957031,699.023560 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M341.393250,797.578247 
	C343.588043,796.660217 345.209961,796.240417 346.840698,796.202759 
	C359.791016,795.903809 362.408783,798.592651 362.625488,811.607117 
	C362.667938,814.156067 363.774963,816.683228 364.358551,819.227905 
	C366.265350,827.542664 362.757843,833.096313 354.369263,834.190430 
	C350.186493,834.736023 345.873810,834.285400 340.417114,834.285400 
	C340.311951,827.791504 340.088623,821.958923 340.158905,816.129822 
	C340.230804,810.169189 340.590668,804.212097 341.393250,797.578247 
M349.873627,827.366760 
	C354.285156,827.845032 358.163666,826.871826 357.340515,821.587219 
	C357.126648,820.214233 352.503693,818.249268 350.372253,818.710693 
	C345.393463,819.788452 345.904633,823.282715 349.873627,827.366760 
M347.021606,808.672974 
	C348.818359,813.616760 352.105103,812.008240 354.577087,809.815979 
	C355.329681,809.148621 354.643646,805.227112 353.451477,804.309326 
	C350.085754,801.718201 347.351990,802.549316 347.021606,808.672974 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M485.044617,830.224487 
	C485.398560,818.612793 483.801422,807.718445 485.981140,796.809814 
	C490.649994,796.809814 494.670410,796.206421 498.435303,796.931030 
	C507.238312,798.625244 513.111694,805.801208 513.459473,814.330566 
	C513.817505,823.110291 508.914520,830.497559 500.115234,832.933838 
	C495.136322,834.312439 489.361481,837.448669 485.044617,830.224487 
M499.724548,804.214966 
	C497.347656,804.029663 494.970795,803.844360 492.347626,803.639832 
	C492.347626,812.159424 492.347626,819.503906 492.347626,827.261597 
	C498.746185,827.044617 503.621521,825.339050 505.734497,819.757324 
	C507.923950,813.973511 506.619293,808.739807 499.724548,804.214966 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M696.153503,832.023132 
	C698.723450,836.927551 695.669373,837.547119 691.890259,837.628052 
	C688.055664,837.710144 684.221497,837.814880 680.386841,837.892639 
	C674.048462,838.021118 667.479553,838.712402 664.804321,830.824036 
	C669.565125,831.395874 673.580933,833.145935 677.716370,833.500732 
	C681.421204,833.818420 683.924866,831.681763 682.406982,827.294983 
	C679.077576,827.111450 675.739380,827.705750 673.083496,826.624268 
	C666.939941,824.122803 664.390747,819.004578 665.377502,813.135132 
	C666.393127,807.093933 669.992981,803.996765 677.251953,803.515564 
	C680.263550,803.316040 683.389404,804.035278 684.288330,799.951477 
	C685.482239,799.936340 686.676208,799.921204 688.629150,800.849854 
	C689.388123,812.252991 689.388123,822.712341 689.388123,834.499329 
	C692.795959,833.252014 694.474731,832.637573 696.153503,832.023132 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M994.122925,946.022522 
	C1003.309082,949.597961 1007.180298,955.607910 1005.422913,965.639404 
	C996.395630,965.639404 987.511719,965.639404 978.600098,965.639404 
	C979.321350,979.927185 982.777710,981.474792 1005.281555,977.191650 
	C1003.866272,979.835388 1003.405823,982.028259 1002.065430,982.974365 
	C995.344788,987.717651 984.889526,987.624451 978.598999,983.119812 
	C972.022583,978.410461 969.109802,968.079773 971.716309,958.709961 
	C974.015442,950.445129 979.917542,946.034119 989.432678,945.565186 
	C990.744995,945.500549 992.074524,945.782288 994.122925,946.022522 
M985.654846,961.652710 
	C990.196899,961.652710 994.738953,961.652710 999.435547,961.652710 
	C997.733398,952.991150 994.869507,950.127014 988.923096,950.393433 
	C982.829956,950.666504 980.197083,953.557251 979.002991,961.413635 
	C980.670227,961.493835 982.321167,961.573242 985.654846,961.652710 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2032.694092,985.330322 
	C2022.404785,978.823547 2019.197632,971.502014 2021.329102,960.607544 
	C2023.326416,950.398804 2031.113403,944.615112 2041.477783,945.642944 
	C2051.276855,946.614624 2056.030762,953.021423 2055.445068,965.410645 
	C2046.687134,965.410645 2037.858521,965.410645 2029.071777,965.410645 
	C2028.473511,979.800293 2034.233398,982.429810 2053.140137,977.290039 
	C2055.556885,979.452454 2054.872803,981.190979 2052.465576,982.818970 
	C2046.538818,986.827271 2040.092041,987.150757 2032.694092,985.330322 
M2035.654785,961.652710 
	C2040.196899,961.652710 2044.739014,961.652710 2049.435547,961.652710 
	C2047.733643,952.992371 2044.868774,950.127258 2038.923218,950.393494 
	C2032.830444,950.666443 2030.197021,953.557800 2029.003052,961.413696 
	C2030.670288,961.493835 2032.321167,961.573242 2035.654785,961.652710 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1897.544189,946.390381 
	C1905.620483,950.334900 1908.999756,956.116028 1907.602295,965.348083 
	C1898.743530,965.348083 1889.933350,965.348083 1881.187866,965.348083 
	C1880.261230,979.718628 1886.462402,982.575867 1906.029419,976.987305 
	C1905.764893,978.983398 1906.158325,981.270935 1905.252563,982.052124 
	C1893.830811,991.903625 1876.394775,985.774902 1873.433838,971.064819 
	C1869.906006,953.539978 1882.216919,942.129456 1897.544189,946.390381 
M1901.637817,959.639648 
	C1898.653442,952.145447 1895.400024,949.637024 1889.754883,950.477417 
	C1884.186035,951.306519 1881.948608,954.136841 1881.219482,961.167969 
	C1887.830811,961.167969 1894.453613,961.167969 1901.637817,959.639648 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1088.034180,962.270752 
	C1085.802979,964.017029 1083.640625,965.571411 1081.407959,965.679749 
	C1074.481323,966.015991 1067.527832,965.802734 1060.565063,965.802734 
	C1061.392334,979.971436 1064.787231,981.487061 1086.227051,977.386169 
	C1086.048828,979.035034 1086.445190,981.049500 1085.655273,981.778442 
	C1079.427856,987.525818 1067.525391,988.051514 1060.637695,983.148438 
	C1053.675659,978.192444 1050.726074,966.079163 1054.240967,956.879150 
	C1057.182861,949.178894 1064.544556,944.833191 1073.303955,945.626099 
	C1081.881348,946.402405 1085.971680,950.776489 1088.034180,962.270752 
M1072.752686,961.652344 
	C1075.612305,961.510132 1078.471924,961.367859 1081.419800,961.221252 
	C1079.592407,952.812378 1076.789795,950.077148 1070.819458,950.401001 
	C1064.765259,950.729370 1062.087036,953.728394 1061.063232,961.652344 
	C1064.418701,961.652344 1067.728760,961.652344 1072.752686,961.652344 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1372.792236,964.332397 
	C1373.571289,955.665283 1376.922363,949.485352 1384.635254,946.590637 
	C1397.566772,941.737305 1408.146484,950.106323 1407.454224,965.393127 
	C1398.705078,965.393127 1389.885864,965.393127 1381.116699,965.393127 
	C1380.387085,979.774902 1386.363037,982.514160 1406.072876,977.001465 
	C1405.778320,979.005615 1406.140259,981.290894 1405.221069,982.075806 
	C1393.768799,991.854614 1376.609985,985.829468 1373.466309,971.038391 
	C1373.053955,969.098938 1372.965820,967.090576 1372.792236,964.332397 
M1400.224365,955.139587 
	C1396.866089,950.362671 1392.336548,949.223999 1387.092163,951.321045 
	C1382.738037,953.062195 1380.246338,956.232422 1380.707153,961.013245 
	C1387.842651,961.013245 1394.628296,961.013245 1401.897827,961.013245 
	C1401.490601,959.040222 1401.231567,957.784973 1400.224365,955.139587 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1256.302002,796.308594 
	C1259.810303,796.429199 1262.565430,796.136475 1265.111938,796.733765 
	C1271.304565,798.186157 1275.769897,805.378235 1272.506836,810.538452 
	C1268.095825,817.514343 1270.077637,822.923401 1273.534912,828.918274 
	C1274.257202,830.170837 1274.085449,831.938965 1274.415771,834.043213 
	C1263.690796,834.675232 1266.627197,820.942993 1258.366821,820.059937 
	C1252.556274,823.158997 1259.771118,832.565063 1250.693237,834.737793 
	C1250.244873,832.614624 1249.554077,830.813171 1249.534668,829.004578 
	C1249.438232,820.006714 1249.563721,811.006653 1249.516113,802.007935 
	C1249.494507,797.913086 1250.999756,795.629578 1256.302002,796.308594 
M1257.657837,811.541931 
	C1258.962646,811.739746 1260.574219,812.511719 1261.507324,812.013489 
	C1263.339355,811.035339 1265.191162,809.584412 1266.215454,807.846313 
	C1266.643921,807.118896 1265.300537,804.372192 1264.206543,803.934692 
	C1262.203369,803.133667 1258.628540,802.399841 1257.805176,803.386658 
	C1256.456055,805.003906 1256.782959,808.019470 1257.657837,811.541931 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2564.957275,983.814453 
	C2562.129395,984.807617 2559.970947,985.807129 2557.715088,986.133179 
	C2548.160645,987.513977 2541.349609,984.368042 2537.433105,977.020020 
	C2533.252930,969.177124 2534.146484,957.725098 2539.417236,951.602051 
	C2544.280029,945.953247 2553.446777,943.823730 2560.400391,946.727417 
	C2567.266602,949.594543 2569.993896,954.982300 2569.406494,965.473816 
	C2560.627930,965.473816 2551.776611,965.473816 2542.946045,965.473816 
	C2542.706787,979.837708 2547.956787,982.212341 2567.251465,977.327698 
	C2570.313232,980.364014 2567.758789,981.886780 2564.957275,983.814453 
M2547.320312,952.072021 
	C2545.460693,954.859619 2543.601074,957.647156 2541.341797,961.033630 
	C2549.805176,961.033630 2556.601562,961.033630 2563.519531,961.033630 
	C2560.928223,950.886780 2559.109863,949.771606 2547.320312,952.072021 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M328.619263,965.198853 
	C319.571533,965.610840 311.302185,965.610840 303.067780,965.610840 
	C302.458221,979.816711 308.360657,982.515503 328.067932,977.001648 
	C327.778198,979.002197 328.137573,981.328735 327.223297,982.057617 
	C321.030701,986.994202 313.860168,987.765015 306.581390,985.185120 
	C299.688293,982.741882 296.360382,977.235352 295.254211,970.117798 
	C293.557709,959.201843 297.605591,950.242310 306.020660,946.814270 
	C319.210022,941.441406 330.454651,950.086487 328.619263,965.198853 
M306.063080,952.958984 
	C304.647125,955.378052 303.231171,957.797058 301.225159,961.224182 
	C309.622955,961.224182 316.413971,961.224182 323.269318,961.224182 
	C321.461792,950.683350 318.290405,948.928589 306.063080,952.958984 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M618.227051,966.300903 
	C618.227417,973.196045 618.227417,979.148499 618.227417,985.864197 
	C616.010498,985.983215 614.239807,986.078247 611.492432,986.225708 
	C611.492432,977.846741 611.544189,969.965271 611.471252,962.084900 
	C611.433044,957.957520 610.808838,953.240601 606.265991,952.436584 
	C602.757263,951.815674 598.372498,952.953308 595.210632,954.764221 
	C593.321594,955.846008 592.311951,959.695618 592.173157,962.366882 
	C591.778809,969.957642 592.034790,977.582153 592.034790,985.752441 
	C589.711060,985.752441 587.925171,985.752441 586.198792,985.752441 
	C584.445007,983.006104 584.896301,953.220337 586.982849,945.692810 
	C589.177185,947.337341 591.095459,948.774963 593.240967,950.382874 
	C594.335083,949.708252 595.638245,948.755920 597.063293,948.049500 
	C608.818115,942.223083 617.414551,947.239929 618.203491,960.374939 
	C618.302917,962.030457 618.223389,963.696838 618.227051,966.300903 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M199.065079,748.651978 
	C204.245880,750.183411 202.722473,745.000488 204.116257,743.125305 
	C209.362732,736.066772 215.970734,732.654297 223.827209,734.432434 
	C225.169266,734.736145 226.234970,736.261047 227.428360,737.221802 
	C226.197311,738.509399 225.096283,739.976196 223.677765,741.005371 
	C223.014313,741.486694 221.727448,741.038574 220.739792,741.154114 
	C211.692322,742.212097 206.136429,747.607727 206.673370,754.774475 
	C207.210678,761.946350 213.013672,766.242981 222.633591,766.299194 
	C224.334641,762.928162 225.247604,759.904358 220.892563,757.305054 
	C219.487534,756.466492 218.787277,754.447021 217.764648,752.967773 
	C219.361603,752.114075 220.876373,750.927917 222.580261,750.506653 
	C224.075073,750.136963 225.782043,750.625122 227.443375,750.737671 
	C230.852280,756.716125 229.523743,762.688171 228.986908,768.548035 
	C228.695496,771.728943 226.480591,772.961426 223.513336,773.297424 
	C216.436905,774.098999 210.385162,772.408569 205.613815,766.740234 
	C203.849594,764.644348 201.494949,763.045532 198.632996,760.586548 
	C198.259277,756.186096 198.662186,752.419006 199.065079,748.651978 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M2240.227051,979.581238 
	C2240.570068,985.060059 2239.467529,987.853821 2233.490479,985.329407 
	C2233.490479,977.638733 2233.919678,969.667664 2233.282471,961.782654 
	C2233.022217,958.559753 2231.244141,954.316467 2228.751221,952.684998 
	C2225.022949,950.245178 2220.054688,951.330505 2216.954346,954.821350 
	C2215.224609,956.768921 2214.291748,959.984863 2214.161865,962.685242 
	C2213.796875,970.269531 2214.034424,977.882812 2214.034424,985.896790 
	C2211.525391,985.896790 2209.695801,985.896790 2207.288086,985.896790 
	C2207.114502,972.440186 2207.211426,959.395508 2207.205811,944.031860 
	C2211.364990,947.376709 2213.289551,948.924377 2215.154785,950.424255 
	C2217.391602,949.149780 2219.572021,947.506409 2222.023682,946.582092 
	C2230.971191,943.208252 2239.143799,948.105042 2239.979004,957.718628 
	C2240.580811,964.646729 2240.180420,971.661804 2240.227051,979.581238 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M1417.192627,953.254639 
	C1417.388794,950.512390 1417.584595,948.629028 1417.934570,945.263977 
	C1420.966797,947.255005 1422.914185,948.533630 1425.287598,950.092041 
	C1425.167969,950.121338 1425.777832,950.094666 1426.260010,949.832764 
	C1428.299438,948.724670 1430.183350,947.214294 1432.336914,946.452698 
	C1440.945068,943.408875 1449.152588,948.017944 1449.854614,957.090210 
	C1450.591919,966.617493 1450.019531,976.246216 1450.019531,986.052429 
	C1447.782837,986.052429 1446.193115,986.052429 1443.475342,986.052429 
	C1443.475342,977.624268 1443.557251,969.433411 1443.438965,961.245361 
	C1443.384155,957.446289 1442.444946,953.100220 1438.415649,952.463379 
	C1434.851318,951.899902 1430.498535,952.899597 1427.309448,954.674683 
	C1425.405884,955.734253 1424.320312,959.576294 1424.177856,962.237732 
	C1423.770996,969.836731 1424.034790,977.471558 1424.034790,985.857727 
	C1421.811523,985.976990 1420.035767,986.072205 1417.192383,986.224731 
	C1417.192383,975.184631 1417.192383,964.649109 1417.192627,953.254639 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M746.309448,833.355103 
	C745.221619,831.133362 744.133728,828.911560 742.466492,825.643982 
	C739.769592,820.791870 737.651978,816.985596 735.534424,813.179321 
	C734.950989,813.436523 734.367554,813.693665 733.784119,813.950867 
	C733.784119,817.470642 733.784119,820.990356 733.784119,824.510132 
	C733.707031,824.858582 733.629883,825.207092 733.359680,826.539734 
	C732.862793,829.726562 732.559021,831.929260 732.255249,834.131958 
	C732.255249,834.131958 732.095093,834.073303 731.408569,834.133179 
	C729.363464,833.918030 728.004883,833.643066 726.646240,833.368164 
	C726.646240,833.368164 726.186157,833.380188 726.470947,832.451538 
	C726.706604,820.446472 726.657532,809.370178 726.608521,798.293823 
	C729.662842,794.707458 732.393616,796.187317 734.495544,799.169067 
	C737.286682,803.128418 739.681091,807.367432 742.893188,812.589355 
	C744.279602,815.184753 745.018860,816.677063 745.758057,818.169373 
	C746.423340,817.610657 747.088562,817.051941 747.753845,816.493164 
	C747.569458,814.955750 747.385010,813.418274 747.200623,811.880798 
	C747.565491,806.758057 747.930298,801.635315 748.346191,795.794739 
	C757.028259,798.066345 752.935791,804.240112 754.166748,809.929688 
	C754.276306,815.799316 754.460815,819.951050 754.645325,824.102783 
	C754.448608,826.727234 754.251892,829.351685 753.165771,832.851074 
	C750.287415,833.602417 748.298401,833.478760 746.309448,833.355103 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M1284.856079,817.002441 
	C1278.255737,811.375000 1276.864136,806.509766 1279.770996,801.294312 
	C1282.275146,796.801575 1288.443970,794.897705 1294.797729,796.696228 
	C1297.423950,797.439636 1300.484375,798.445801 1299.334229,801.798584 
	C1298.850464,803.209229 1295.938110,804.333252 1294.005127,804.570557 
	C1291.216064,804.912781 1287.929443,803.345642 1286.306519,808.933105 
	C1289.474976,810.479492 1292.891602,812.053284 1296.220459,813.794495 
	C1300.785889,816.182373 1303.204956,819.807312 1302.272827,825.159607 
	C1301.368408,830.351929 1297.307495,833.985596 1291.998657,834.377563 
	C1286.915649,834.752808 1281.356201,831.923096 1279.688354,827.781738 
	C1279.291626,826.796448 1279.993530,825.368774 1280.156982,824.350708 
	C1285.171753,822.340698 1290.736328,832.088745 1295.181885,821.992126 
	C1291.846436,820.381958 1288.695557,818.860779 1284.856079,817.002441 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M1367.214844,797.935669 
	C1370.213379,802.677856 1368.329712,804.491638 1363.984497,804.727661 
	C1361.245972,804.876465 1358.499146,804.871948 1353.706055,804.984192 
	C1356.315430,808.147278 1357.188232,809.919250 1358.611450,810.766663 
	C1360.861450,812.106201 1363.608643,812.591736 1365.916870,813.855957 
	C1370.878174,816.573364 1372.894897,821.561829 1371.306396,826.410583 
	C1369.695190,831.328735 1364.250610,834.751221 1358.777832,834.286072 
	C1352.599121,833.760986 1350.044556,831.280884 1348.869141,824.390442 
	C1353.699585,822.778198 1358.673828,829.625122 1364.369141,823.507568 
	C1362.401367,821.900024 1360.706177,820.219116 1358.732910,818.981873 
	C1356.508545,817.587036 1353.858398,816.846863 1351.705933,815.367065 
	C1347.790039,812.675049 1346.073242,808.998718 1347.669678,804.151428 
	C1349.161255,799.622742 1352.044800,796.513794 1356.852783,796.283264 
	C1360.074707,796.128784 1363.349243,797.074768 1367.214844,797.935669 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M978.223145,824.170166 
	C982.397217,826.006775 985.944092,828.119873 989.708496,824.320007 
	C989.159607,819.899048 985.548584,819.640259 982.790039,818.085205 
	C979.711731,816.349915 976.273315,814.294678 974.480835,811.442749 
	C971.088257,806.044800 975.001587,798.414062 981.593567,796.602844 
	C986.622131,795.221130 991.404358,795.651001 995.307434,799.728333 
	C994.939331,809.824646 982.865784,799.712158 981.347900,809.182800 
	C983.986938,810.316711 986.874146,811.523804 989.733826,812.793152 
	C995.252930,815.243103 998.342834,819.335754 997.959839,823.924622 
	C997.560425,828.709229 994.581909,831.792358 990.525330,833.734680 
	C986.545471,835.640198 979.741638,834.061523 976.842773,830.434143 
	C975.249512,828.440491 972.053406,825.474976 978.223145,824.170166 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M330.007446,834.208984 
	C327.863831,831.724060 326.459320,829.244324 324.853607,826.409302 
	C319.903076,824.938965 315.616547,825.564575 312.349304,830.745361 
	C310.614960,833.495483 310.173981,833.217346 304.239288,833.619324 
	C304.941589,831.624451 305.268677,829.748474 306.190063,828.234192 
	C311.553558,819.419678 317.002838,810.655762 322.554565,801.958679 
	C323.773621,800.048889 325.224854,797.958069 327.102539,796.877441 
	C329.720947,795.370422 333.122559,796.017883 333.151001,799.437561 
	C333.244263,810.659790 332.692780,821.888123 332.296875,833.110840 
	C332.283264,833.496399 331.285553,833.847168 330.007446,834.208984 
M326.234070,811.244629 
	C321.663025,811.509521 322.369293,814.850159 321.542999,818.174255 
	C326.819397,818.467651 327.979919,816.310181 326.234070,811.244629 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M184.010559,826.134399 
	C185.088181,824.358093 186.077271,821.865601 185.454132,821.359985 
	C183.454514,819.737549 180.859055,818.849182 178.493088,817.678406 
	C170.504044,813.724915 168.108231,808.184631 171.672424,801.904358 
	C174.892120,796.231140 183.102768,794.048401 189.070526,797.526672 
	C190.294266,798.239929 191.916351,800.440063 191.591263,801.181763 
	C190.944763,802.656555 189.235184,804.137939 187.662750,804.609619 
	C185.870682,805.147217 183.672180,804.226196 181.797195,804.626709 
	C180.496719,804.904541 179.444534,806.344666 177.092972,808.206177 
	C181.884109,810.565002 185.723907,812.197021 189.300110,814.281311 
	C193.834152,816.923828 195.661972,822.517822 193.912674,827.204590 
	C192.252762,831.651794 187.081039,834.701111 181.882797,834.297607 
	C175.840317,833.828552 172.977310,831.151123 171.763306,824.144226 
	C175.742630,824.905029 179.463303,825.616394 184.010559,826.134399 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M1237.211670,797.119263 
	C1239.129883,797.583862 1241.538330,798.555237 1241.592041,799.642700 
	C1241.968506,807.276733 1242.322510,814.968567 1241.765991,822.574829 
	C1241.278198,829.243225 1236.156372,833.708252 1230.046143,834.213013 
	C1223.390503,834.762817 1217.178833,830.932434 1216.397827,823.779358 
	C1215.471069,815.293030 1216.361084,806.601990 1216.627686,798.004822 
	C1216.646973,797.382385 1218.001587,796.801270 1219.628662,795.470215 
	C1220.609253,797.853027 1221.934937,799.706116 1222.059814,801.636780 
	C1222.424561,807.276428 1222.072998,812.963013 1222.453247,818.600830 
	C1222.803345,823.790771 1225.786133,826.828125 1229.660278,826.386414 
	C1234.249146,825.863159 1235.430786,822.475037 1235.632690,818.520325 
	C1235.987183,811.574951 1236.288574,804.626770 1237.211670,797.119263 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M129.504852,816.242493 
	C133.689377,821.843567 133.317093,826.549866 128.728851,830.910950 
	C124.731018,834.710815 120.282127,835.607666 115.079407,832.995422 
	C111.725517,831.311523 107.641235,829.591675 109.795349,824.213928 
	C114.843346,822.196167 120.270988,831.183777 125.546425,822.325439 
	C122.333664,820.692383 119.068230,819.520447 116.396538,817.545410 
	C113.367279,815.305847 109.998070,812.790833 108.366104,809.586182 
	C106.412018,805.748840 109.485703,800.031738 113.370552,797.781372 
	C117.465767,795.409302 125.826256,795.618164 128.469635,798.418091 
	C129.198181,799.189636 129.664215,801.104248 129.208847,801.892334 
	C128.494461,803.128723 127.013229,804.378052 125.645653,804.686768 
	C122.727249,805.345581 119.082916,802.865906 116.088531,807.943420 
	C120.427689,810.566711 124.704811,813.152527 129.504852,816.242493 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M538.320557,798.045288 
	C538.530090,804.060181 534.568909,803.919800 530.874878,804.081787 
	C527.797302,804.216797 525.638977,805.136780 526.526978,809.721313 
	C528.135132,810.207520 530.324524,810.558105 532.181030,811.538940 
	C533.447754,812.208130 535.010620,813.733948 535.047485,814.920105 
	C535.085205,816.133362 533.628723,817.677368 532.441101,818.555908 
	C531.461548,819.280518 529.491760,818.836975 528.725891,819.640381 
	C527.534363,820.890137 526.452209,822.739624 526.394409,824.372803 
	C526.364014,825.232422 528.486572,826.550171 529.850708,826.975281 
	C531.372742,827.449524 533.327698,826.698669 534.744324,827.302307 
	C536.263184,827.949402 537.374939,829.552185 538.664368,830.737854 
	C537.282776,831.938904 535.989380,834.027710 534.503052,834.175354 
	C529.932617,834.629639 525.288269,834.340942 519.237427,834.340942 
	C518.554626,821.610718 518.637817,809.293884 519.453430,795.748779 
	C526.379333,796.363098 532.189026,796.878479 538.320557,798.045288 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M968.200806,808.273499 
	C968.095764,813.513245 968.423889,817.902100 967.789246,822.146912 
	C966.622986,829.947021 960.301086,834.939941 953.210693,834.284424 
	C946.434509,833.657959 941.803223,828.425964 941.546570,820.542236 
	C941.340881,814.224487 941.418579,807.881775 941.762634,801.571472 
	C941.867371,799.651794 943.276001,797.803284 944.087402,795.922180 
	C944.847595,795.954468 945.607849,795.986816 946.368042,796.019104 
	C946.916992,798.300842 947.817322,800.563293 947.944092,802.868347 
	C948.236450,808.182129 947.995178,813.524841 948.273499,818.839966 
	C948.485291,822.884583 950.419312,826.022339 954.847961,826.259033 
	C959.815552,826.524597 960.792358,822.638428 961.155945,818.903259 
	C961.574402,814.606018 961.385803,810.253174 961.613831,805.932617 
	C961.781860,802.748962 962.195496,799.578247 962.553772,795.837158 
	C970.485535,797.884705 967.363098,803.459229 968.200806,808.273499 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M164.381180,799.916870 
	C164.458206,807.402588 164.697922,814.073608 164.371674,820.716858 
	C163.997650,828.332825 158.848984,833.788086 152.282394,834.195190 
	C145.271713,834.629822 138.583282,829.233398 138.229233,821.512939 
	C137.845657,813.148743 136.824814,804.534668 139.432281,796.363831 
	C140.178955,796.194275 140.925629,796.024780 141.672302,795.855286 
	C142.613495,797.548828 144.234360,799.190369 144.368683,800.945618 
	C144.774292,806.246338 144.479782,811.595947 144.686279,816.917664 
	C144.957077,823.896667 146.687698,826.326965 151.000534,826.352295 
	C155.719254,826.380005 157.730118,823.551697 157.962494,816.368164 
	C158.145218,810.719666 157.599121,804.957947 158.561096,799.453491 
	C159.291855,795.272156 162.073303,794.829224 164.381180,799.916870 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M318.278687,760.109497 
	C316.606506,763.300842 315.125305,766.612244 313.213409,769.652771 
	C310.862518,773.391418 308.467285,772.207458 305.957733,767.936157 
	C303.219910,761.539490 300.879242,756.426758 298.538605,751.314026 
	C297.877197,751.537415 297.215759,751.760742 296.554352,751.984131 
	C296.904175,755.394043 297.253998,758.803894 297.603821,762.213806 
	C296.940430,765.264648 296.277039,768.315430 294.301758,771.028015 
	C292.778229,759.138062 292.566559,747.586304 292.354858,736.034607 
	C295.390381,734.005615 297.185059,735.206360 298.479950,738.235168 
	C301.090027,744.340027 303.791199,750.406128 306.481995,756.476196 
	C307.384949,758.513000 308.370544,760.513245 309.728027,763.402039 
	C316.800354,754.288391 318.141815,743.028198 325.617767,734.909241 
	C329.441559,744.662048 327.243286,754.542236 328.104736,765.787903 
	C328.095459,768.415894 328.118896,769.403503 328.142334,770.391052 
	C325.844452,771.542969 323.809174,771.747620 323.363098,768.510132 
	C323.065460,766.349854 323.143219,764.137817 323.113831,760.420776 
	C323.037598,756.653748 322.900513,754.415039 322.763428,752.176270 
	C322.219879,752.143494 321.676300,752.110718 321.132751,752.077942 
	C320.181396,754.755127 319.230042,757.432312 318.278687,760.109497 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2781.299561,970.450317 
	C2777.486084,969.018860 2774.202148,968.207886 2771.319580,966.652527 
	C2763.507324,962.436707 2763.149658,953.030029 2770.427734,948.022644 
	C2776.989502,943.508118 2785.313965,944.958740 2791.492676,952.004700 
	C2790.374756,952.679504 2789.266846,953.914246 2788.299805,953.812256 
	C2786.391357,953.610840 2784.603027,952.359863 2782.689209,952.097595 
	C2778.712158,951.552734 2773.964111,950.949402 2772.537842,955.792908 
	C2770.903809,961.342773 2776.347412,961.762939 2779.717285,963.363586 
	C2781.499756,964.210205 2783.456787,964.683350 2785.317383,965.372375 
	C2789.766113,967.019958 2792.605957,969.913696 2792.515625,974.959045 
	C2792.422852,980.117615 2789.966553,983.821289 2785.302002,985.915710 
	C2777.961670,989.211792 2771.227783,987.907043 2765.023926,983.246887 
	C2765.295166,979.801636 2766.879150,978.966370 2769.774170,979.875183 
	C2772.564697,980.751160 2775.509033,982.238037 2778.220947,981.942627 
	C2780.767578,981.665283 2783.961670,979.971497 2785.319580,977.889160 
	C2787.311523,974.834778 2784.795654,972.384888 2781.299561,970.450317 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2695.345459,987.161255 
	C2692.003662,985.781189 2689.373291,984.654907 2686.971924,983.626770 
	C2687.367920,979.597656 2689.085205,979.031982 2691.891357,979.922791 
	C2694.677002,980.807190 2697.507812,981.805908 2700.383789,982.086670 
	C2704.041260,982.443726 2707.560303,980.722107 2707.555420,976.948242 
	C2707.552490,974.735962 2704.990479,971.960571 2702.858643,970.469299 
	C2700.508301,968.825134 2697.262451,968.522949 2694.530762,967.347595 
	C2689.882080,965.347473 2687.016113,962.073181 2687.385254,956.594421 
	C2687.747803,951.217651 2690.923584,947.806885 2695.603271,946.443604 
	C2702.226807,944.514099 2708.701172,944.913696 2714.176270,951.935547 
	C2711.944824,952.612793 2710.319580,953.574585 2708.756348,953.482727 
	C2705.536133,953.293152 2702.293945,951.955383 2699.169678,952.248962 
	C2697.412598,952.414124 2694.839111,954.704041 2694.537109,956.380005 
	C2694.256592,957.935852 2696.104736,960.575500 2697.732666,961.611755 
	C2700.184570,963.172485 2703.301025,963.652649 2706.063232,964.769775 
	C2712.591064,967.410034 2714.735352,970.232056 2714.475342,975.557556 
	C2714.201660,981.154053 2711.149658,984.975769 2704.833496,986.684875 
	C2702.046143,987.439026 2698.990479,987.202026 2695.345459,987.161255 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1852.973389,986.166626 
	C1849.338745,986.822205 1847.304321,985.951660 1846.093018,982.870605 
	C1841.485107,971.152222 1836.695923,959.505249 1831.801880,947.405334 
	C1836.350098,945.312073 1838.800293,946.443420 1840.430542,950.725952 
	C1843.613159,959.086365 1847.050659,967.349792 1850.982178,977.147644 
	C1853.825439,970.048828 1855.671631,964.086914 1858.548340,958.672546 
	C1860.983765,954.088745 1860.032959,946.178955 1870.329956,946.168213 
	C1864.689331,960.207336 1860.140381,973.460022 1852.973389,986.166626 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M449.931885,829.269043 
	C450.294922,828.685852 449.916840,828.902222 449.894287,828.976685 
	C455.778076,819.883789 461.786102,810.779541 467.540863,801.518005 
	C469.852905,797.797119 472.232483,795.076904 477.560333,797.341614 
	C477.560333,808.967285 477.611298,820.773315 477.430939,832.575806 
	C477.420349,833.268433 475.542389,833.932495 473.764893,835.125793 
	C472.350800,831.628235 471.210938,828.808960 470.095642,826.050415 
	C464.520416,824.273010 460.203125,825.173035 457.251404,830.477600 
	C456.500458,831.827087 455.154633,833.375793 453.788910,833.743469 
	C450.874451,834.528076 448.418488,833.910828 449.931885,829.269043 
M467.596313,818.309143 
	C472.320740,816.169006 472.320740,816.169006 469.006073,809.620422 
	C467.868195,812.890320 467.086456,815.136719 467.596313,818.309143 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M1173.376465,796.127808 
	C1177.009155,796.371521 1180.797607,795.250488 1180.884155,799.826599 
	C1180.946533,803.119385 1178.451904,804.176575 1175.454956,804.262024 
	C1174.142700,804.299438 1172.695190,804.252869 1171.569702,804.790283 
	C1170.543457,805.280457 1169.097168,806.622253 1169.209595,807.386475 
	C1169.411743,808.759827 1170.357666,810.598328 1171.507324,811.129822 
	C1173.486450,812.044861 1175.860107,812.106445 1179.563232,812.810425 
	C1177.955566,815.377136 1177.257935,817.475891 1175.803345,818.539124 
	C1174.321777,819.622131 1171.870605,819.311829 1170.248047,820.285095 
	C1167.871826,821.710510 1168.464233,825.777527 1171.145630,826.542664 
	C1173.324951,827.164551 1175.822510,826.723328 1177.958740,827.424561 
	C1179.228149,827.841248 1180.873291,829.547913 1180.885498,830.690430 
	C1180.898560,831.883484 1179.228638,834.053223 1178.166382,834.135010 
	C1173.314575,834.508850 1168.417969,834.299194 1162.746826,834.299194 
	C1162.746826,821.638733 1162.746826,809.615295 1162.746826,796.621277 
	C1166.188477,796.447083 1169.362427,796.286499 1173.376465,796.127808 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M397.097473,982.556885 
	C392.186188,970.559204 387.594116,959.195862 382.938477,947.675110 
	C387.839661,944.604553 390.013397,947.041809 391.531219,950.857178 
	C394.708923,958.845032 397.822510,966.858459 401.388947,975.948547 
	C405.750671,970.311646 406.582703,963.964417 409.562042,958.751709 
	C412.171356,954.186462 411.205994,946.465454 420.699036,946.038574 
	C419.717987,949.295837 419.174011,951.743591 418.255066,954.041382 
	C414.432404,963.599304 410.634308,973.171448 406.547150,982.617249 
	C404.362640,987.665833 402.478119,987.651917 397.097473,982.556885 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M562.734253,834.453186 
	C560.570068,833.240173 558.119751,832.072571 558.086914,830.840698 
	C557.788757,819.629272 557.911926,808.406677 557.911926,796.835022 
	C565.141602,796.835022 570.967590,796.835022 576.914429,796.835022 
	C578.403503,802.422546 575.655823,803.842896 571.393921,804.063232 
	C568.423950,804.216736 565.103333,803.930176 565.260132,809.084717 
	C567.918274,810.362671 570.789246,811.742920 573.503296,813.047791 
	C574.978149,817.454163 572.211060,818.231628 569.208923,819.470703 
	C567.494263,820.178467 566.392395,822.371094 565.014587,823.895142 
	C566.778503,824.976318 568.419800,826.482361 570.336121,827.035278 
	C572.953735,827.790649 577.361084,825.951050 577.292297,830.410767 
	C577.220459,835.076050 572.787781,834.269714 569.566772,834.416077 
	C567.570923,834.506775 565.568726,834.456055 562.734253,834.453186 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M2455.678223,952.064209 
	C2465.668457,942.774658 2475.813965,943.367554 2480.037354,953.574402 
	C2477.859131,953.296631 2476.119629,953.032227 2474.370605,952.861450 
	C2471.447510,952.575928 2468.375977,951.714966 2465.642822,952.327209 
	C2463.878418,952.722290 2461.895996,955.116028 2461.374023,956.993164 
	C2461.051025,958.154480 2462.946289,960.672119 2464.436279,961.450012 
	C2467.930176,963.274414 2471.925781,964.127136 2475.454102,965.899109 
	C2482.778076,969.577026 2483.909668,977.213074 2478.263184,983.165527 
	C2471.943115,989.828003 2461.120605,989.167236 2453.454102,980.865356 
	C2455.707520,980.517700 2457.368652,979.978027 2458.976807,980.105164 
	C2460.207764,980.202576 2461.319092,981.347534 2462.575439,981.673096 
	C2468.637207,983.244080 2473.455811,981.750488 2474.422363,977.697266 
	C2475.870117,971.627747 2470.864014,970.855347 2466.948242,969.318909 
	C2464.796631,968.474609 2462.532715,967.843506 2460.507324,966.763916 
	C2454.674805,963.654846 2453.755127,960.966797 2455.678223,952.064209 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M616.613770,831.485413 
	C610.798035,833.185120 605.180481,834.208679 599.778442,835.192993 
	C597.077271,827.133057 596.931396,806.557251 599.211487,796.554688 
	C600.635986,796.467102 602.215698,796.302368 603.796875,796.286011 
	C607.711731,796.245422 611.627380,796.272705 615.159729,796.272705 
	C617.213440,799.794006 617.144775,802.120483 613.665283,803.090332 
	C611.787598,803.613708 609.604065,803.154602 607.807678,803.815796 
	C606.524902,804.287903 604.924500,805.811401 604.802673,807.002563 
	C604.672302,808.277405 606.015808,809.779419 606.916504,811.038879 
	C607.204163,811.441101 608.254761,811.215881 608.743652,811.570740 
	C610.409973,812.780151 611.981567,814.120239 613.589294,815.410400 
	C611.856689,816.609314 610.015076,817.680603 608.421021,819.041748 
	C606.703735,820.508240 605.218201,822.246277 601.954163,825.578064 
	C607.262268,826.401794 610.145325,826.511169 612.774353,827.385071 
	C614.327881,827.901489 615.479492,829.627319 616.613770,831.485413 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M1111.583740,829.978882 
	C1109.954346,831.960327 1108.316162,834.007996 1106.449707,834.242981 
	C1102.231079,834.773987 1097.900024,834.409851 1092.858765,834.409851 
	C1092.858765,821.673157 1092.858765,809.616821 1092.858765,796.504333 
	C1098.380371,796.504333 1103.260254,796.314758 1108.106323,796.635498 
	C1109.341553,796.717346 1111.601318,798.761414 1111.434814,799.309448 
	C1110.936157,800.949585 1109.758911,802.874268 1108.303345,803.603149 
	C1106.645020,804.433472 1104.275879,803.740112 1102.454590,804.384583 
	C1101.174683,804.837402 1099.316772,806.570862 1099.454712,807.463867 
	C1099.687256,808.967651 1101.036377,810.690857 1102.402466,811.522766 
	C1103.928223,812.452026 1105.996094,812.491089 1107.590454,812.862305 
	C1108.547119,816.825378 1107.071167,818.537048 1103.783691,818.833435 
	C1100.684814,819.112915 1098.595703,820.484131 1098.991455,823.831970 
	C1099.435303,827.588440 1102.634033,826.808350 1105.161743,827.264282 
	C1107.312622,827.652405 1109.371582,828.550049 1111.583740,829.978882 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1469.797607,940.375488 
	C1469.798096,942.910706 1469.798096,944.550842 1469.798096,946.658997 
	C1473.784058,947.331116 1477.420898,947.944336 1481.610718,948.650818 
	C1479.201050,954.726868 1474.139771,951.136475 1469.830933,953.795898 
	C1469.830933,960.800598 1469.741577,968.619446 1469.870117,976.434692 
	C1469.930786,980.122803 1471.902466,981.727539 1475.743042,981.115723 
	C1477.509277,980.834412 1479.382080,981.222839 1482.931885,981.387695 
	C1478.028442,987.385986 1473.832520,988.695435 1468.575684,986.863098 
	C1463.656982,985.148743 1462.418335,981.053711 1462.297241,976.584473 
	C1462.091431,968.990356 1462.240601,961.386658 1462.240601,953.855774 
	C1459.881958,952.737976 1458.025635,951.858337 1456.181763,950.984558 
	C1456.706787,949.816162 1456.848511,948.867920 1457.223145,948.764709 
	C1461.012451,947.721252 1463.960693,946.077637 1463.600830,941.423340 
	C1463.525391,940.447937 1463.821289,939.448608 1463.886719,938.456421 
	C1464.045166,936.051941 1464.376343,933.193848 1467.473633,934.004700 
	C1468.645630,934.311401 1469.045288,937.568359 1469.797607,940.375488 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M241.600250,803.932983 
	C239.489655,804.092712 237.891983,803.708435 236.901154,804.315125 
	C235.451569,805.202881 233.580704,806.754089 233.506012,808.111389 
	C233.445435,809.212524 235.616150,810.702637 237.072617,811.542969 
	C238.411728,812.315491 240.118240,812.451172 241.440369,812.807495 
	C243.059280,817.424622 240.461807,818.147644 237.240967,819.148621 
	C235.553665,819.672913 234.405457,821.932007 233.013763,823.407715 
	C234.637604,824.673950 236.135223,826.184082 237.932907,827.114380 
	C238.999893,827.666565 240.738098,826.911926 241.815811,827.455750 
	C243.109085,828.108398 244.020676,829.517395 245.097534,830.598877 
	C243.827759,831.850708 242.652390,834.043457 241.270874,834.182129 
	C236.712265,834.639648 232.079117,834.354492 226.343750,834.354492 
	C225.407715,821.694397 225.599411,809.670898 226.405212,796.933228 
	C232.806137,796.933228 238.553574,796.933228 244.084351,796.933228 
	C246.201355,800.283875 245.138580,802.310608 241.600250,803.932983 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M140.106384,768.327515 
	C139.459503,770.102966 138.866211,771.165710 138.071228,772.589783 
	C135.162827,766.429504 134.583481,748.686462 136.785294,735.163635 
	C141.066467,735.034363 145.639679,734.413147 150.100998,734.874329 
	C156.851364,735.572083 161.788696,742.227112 158.528885,747.620300 
	C153.850601,755.360229 154.774933,761.646667 159.271103,768.511963 
	C159.806854,769.330017 159.244141,770.867432 159.135345,773.313416 
	C156.940552,771.806885 155.416931,771.182739 154.538605,770.055725 
	C153.332428,768.507935 152.706802,766.523010 151.668747,764.825500 
	C149.671417,761.559387 148.622238,756.344421 143.554504,757.480225 
	C138.013947,758.722046 141.004990,764.085876 140.106384,768.327515 
M143.257629,739.829651 
	C138.261276,742.255920 139.832855,746.056763 140.745102,750.047485 
	C143.064606,750.451172 145.002579,750.972595 146.964584,751.088928 
	C150.315643,751.287720 152.971176,749.961060 153.627213,746.444580 
	C154.300461,742.835876 152.259384,740.811951 148.868164,740.086365 
	C147.579071,739.810669 146.231216,739.809570 143.257629,739.829651 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M702.381470,833.194458 
	C702.370178,823.899780 702.208923,814.601624 702.428711,805.312378 
	C702.505615,802.064270 703.252869,798.759338 704.178101,795.623169 
	C705.229187,792.060120 706.853333,789.070557 711.522461,788.774841 
	C716.636902,788.450989 718.703369,791.113159 719.914001,795.354187 
	C720.088318,795.964844 720.602966,796.478516 721.332703,798.331726 
	C719.745239,805.502014 713.719849,800.990112 710.442383,804.240417 
	C704.810242,812.940918 717.037354,810.335754 718.060608,814.798706 
	C714.839355,818.470276 706.447571,818.325500 710.583618,825.999023 
	C713.236694,829.711365 721.311951,824.228027 721.423218,833.194458 
	C714.784668,833.194458 708.583069,833.194458 702.381470,833.194458 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M2588.443359,977.770691 
	C2592.228271,978.872742 2595.434082,980.038208 2598.563477,979.859680 
	C2601.538574,979.689941 2604.433350,978.115112 2609.008301,976.620789 
	C2607.775391,979.700012 2607.604004,981.460022 2606.634521,982.318420 
	C2602.387451,986.077820 2597.211914,986.973877 2591.734131,986.228271 
	C2583.942627,985.167664 2578.710449,979.477478 2577.307129,970.711060 
	C2575.596191,960.022827 2579.087891,951.440613 2586.744629,947.514038 
	C2594.199951,943.690674 2601.740967,945.167236 2608.415527,952.242676 
	C2606.793213,952.867126 2605.126221,954.167236 2604.179688,953.766418 
	C2597.923828,951.116638 2591.449707,949.760071 2587.039795,955.963440 
	C2582.190918,962.784485 2582.691406,970.328613 2588.443359,977.770691 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M626.948242,967.569580 
	C627.275757,963.830627 627.236328,960.747009 628.095581,957.938354 
	C632.156128,944.664551 648.071350,941.353516 657.891113,951.656006 
	C656.279663,955.532593 653.942383,953.369324 651.437134,952.688660 
	C640.514404,949.721191 633.905701,954.952881 634.022705,966.211731 
	C634.144897,977.972168 641.404541,982.758423 652.565857,978.467957 
	C653.987671,977.921448 655.480469,977.559448 658.577698,976.610168 
	C657.501282,979.592834 657.410217,981.688904 656.334595,982.538940 
	C646.165161,990.574646 632.130798,986.404968 628.049133,974.225220 
	C627.423828,972.359192 627.333252,970.314026 626.948242,967.569580 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M2270.666992,986.088074 
	C2261.935791,987.246887 2255.253906,985.008972 2251.532227,977.491638 
	C2247.617432,969.584900 2247.577881,961.293945 2252.123291,953.631226 
	C2258.017822,943.693970 2271.121094,942.851135 2280.674316,952.228577 
	C2278.547363,952.774170 2276.949463,953.555420 2275.371338,953.516968 
	C2271.194092,953.415283 2266.721191,951.852722 2262.923340,952.897583 
	C2256.917480,954.549927 2254.295166,964.273438 2256.824951,971.969910 
	C2259.072266,978.806946 2264.496582,981.704529 2271.788574,979.779297 
	C2274.370361,979.097656 2276.845947,978.015503 2280.323242,976.776733 
	C2279.920410,984.073059 2275.039062,984.345398 2270.666992,986.088074 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M2113.454834,982.563843 
	C2106.291748,975.401062 2105.958008,967.256470 2107.879395,958.849731 
	C2109.401123,952.191650 2113.700684,947.567993 2120.476074,946.148376 
	C2127.121582,944.756165 2133.600830,945.010925 2138.066895,951.284912 
	C2136.183838,955.565613 2133.840088,953.323120 2131.366699,952.659180 
	C2120.467041,949.733093 2113.860352,955.020203 2114.022461,966.300293 
	C2114.191162,978.047607 2121.426270,982.740112 2132.656982,978.423584 
	C2134.070557,977.880249 2135.569092,977.557495 2137.286865,977.057129 
	C2136.524414,986.644348 2125.938232,989.033936 2113.454834,982.563843 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M414.422058,754.920410 
	C411.036377,768.833130 403.853088,774.773743 392.056519,773.320007 
	C384.820129,772.428284 380.462860,767.834167 378.848938,761.341553 
	C381.207855,761.233765 382.130768,761.429199 383.486755,761.649963 
	C385.118988,762.817810 386.162079,764.215759 387.543579,765.059937 
	C394.631165,769.390747 401.136505,768.109070 405.856415,761.613708 
	C409.891052,756.061401 409.119659,748.273682 404.062683,743.504578 
	C399.274292,738.988892 391.442261,738.944763 385.891357,743.617310 
	C384.145782,745.086670 382.831696,747.068604 380.862671,748.232361 
	C379.603882,747.099426 378.802612,746.550110 378.001343,746.000793 
	C380.263763,737.189148 386.654755,734.161682 394.977997,734.125244 
	C403.215179,734.089172 409.523712,738.401611 412.547821,746.081116 
	C413.381744,748.198792 413.645081,750.541138 414.346954,753.642334 
	C414.523682,754.504333 414.422058,754.920410 414.422058,754.920410 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M564.091187,748.111084 
	C566.453369,741.001343 570.869202,735.988586 578.507141,734.614502 
	C587.051270,733.077393 594.935974,736.728088 598.866760,743.774963 
	C602.775391,750.782166 602.054016,759.900024 597.004944,766.112000 
	C595.969055,767.386536 594.646912,768.428467 592.072937,769.901978 
	C584.425781,772.914368 578.210449,771.621704 571.999023,770.000793 
	C569.717163,767.380798 567.435303,764.760742 564.851196,760.756348 
	C564.396362,755.618347 564.243774,751.864685 564.091187,748.111084 
M568.552185,756.257324 
	C569.960999,758.796997 570.885864,761.828064 572.870605,763.783081 
	C578.505798,769.333984 587.000122,768.908813 592.297729,763.285156 
	C597.397705,757.871216 597.615234,749.957825 592.815735,744.437866 
	C588.018005,738.919983 579.138062,738.452148 573.173096,743.314697 
	C569.509521,746.301086 568.399536,750.258606 568.552185,756.257324 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M293.909668,100.024193 
	C293.909668,111.212280 293.909668,121.406616 293.909668,132.032471 
	C290.478455,132.196060 287.926697,132.317703 284.658936,132.473495 
	C284.658936,113.142387 284.658936,94.173088 284.658936,74.720139 
	C287.406158,74.720139 289.937408,74.720139 293.909668,74.720139 
	C293.909668,82.735687 293.909668,90.883057 293.909668,100.024193 
z"
            />
            <path
                fill="#020202"
                opacity="1.000000"
                stroke="none"
                d="
M551.141479,119.646858 
	C551.141479,104.389381 551.141479,90.088730 551.141479,74.991043 
	C554.086792,74.687782 556.558411,74.433296 559.815125,74.097969 
	C559.815125,93.344574 559.815125,112.158806 559.815125,131.839462 
	C557.414124,131.956711 554.681763,132.090134 551.141418,132.263016 
	C551.141418,127.841682 551.141418,124.222687 551.141479,119.646858 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M1192.053467,817.401306 
	C1194.877930,826.574646 1201.202637,827.797913 1209.335083,826.537842 
	C1210.910156,830.779114 1209.621582,833.459167 1205.102417,834.134888 
	C1202.882202,834.466858 1200.415527,834.260681 1198.247803,833.641602 
	C1189.006958,831.002441 1183.487549,821.449463 1185.393921,811.802246 
	C1187.394653,801.677673 1194.676514,795.556091 1204.052856,795.996521 
	C1208.492310,796.205017 1210.993042,797.799133 1209.544312,803.457458 
	C1201.211792,804.268555 1191.614380,804.147766 1192.053467,817.401306 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M415.120422,755.878479 
	C414.422058,754.920410 414.523682,754.504333 414.477478,754.530029 
	C415.458160,751.965576 416.932068,749.453430 417.400909,746.765991 
	C418.011963,743.263000 417.826080,739.621094 418.041748,734.701294 
	C422.880432,734.701294 427.085785,734.436890 431.244690,734.763916 
	C437.333679,735.242554 441.336456,739.301941 441.677826,744.770813 
	C442.033997,750.476868 437.941895,755.570984 431.927124,756.676025 
	C429.381805,757.143555 426.772858,757.264587 423.708557,757.595398 
	C422.881500,762.725891 422.104462,767.546143 421.327393,772.366394 
	C420.534119,772.375061 419.740814,772.383728 418.947540,772.392395 
	C417.904602,767.207153 416.861664,762.021851 415.120422,755.878479 
M435.472321,743.296143 
	C432.138580,738.304932 427.842102,739.335876 422.863739,741.037781 
	C422.863739,744.205994 422.863739,747.057373 422.863739,749.833191 
	C432.446960,752.349182 432.489288,752.332214 435.472321,743.296143 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M801.058228,831.888000 
	C807.304871,821.807922 813.525391,811.711609 819.812683,801.657043 
	C821.938965,798.256653 824.054688,794.607727 830.407532,797.505066 
	C830.407532,808.634094 830.407532,820.387634 829.484741,833.014526 
	C827.151794,833.691772 825.741760,833.495605 824.331665,833.299438 
	C824.227051,831.975464 824.122437,830.651550 823.804138,827.996155 
	C819.302002,823.458313 815.331482,823.471863 811.789734,827.829651 
	C811.789734,827.829651 811.984680,827.987366 811.319885,828.123596 
	C809.644836,830.076111 808.634583,831.892395 807.624268,833.708618 
	C807.624268,833.708618 807.870239,833.842834 807.053223,833.746033 
	C804.510193,833.062134 802.784241,832.475098 801.058228,831.888000 
M818.532043,817.385925 
	C825.150146,817.874023 825.205627,817.782776 822.169006,810.203003 
	C820.733398,812.322144 819.539612,814.084473 818.532043,817.385925 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M339.017731,768.185120 
	C337.191437,769.455139 335.365112,770.725098 332.904785,771.318359 
	C332.236908,769.784058 332.203033,768.926575 332.169128,768.069031 
	C338.062195,758.928162 343.867767,749.728943 349.904633,740.684143 
	C351.587616,738.162659 353.954285,736.097473 356.315857,733.481079 
	C360.509186,741.270081 360.737701,765.271057 356.991272,772.951904 
	C355.803497,771.566833 354.813049,770.411804 353.733765,768.080566 
	C353.259857,766.320312 352.874786,765.736328 352.489746,765.152405 
	C352.143799,764.939758 351.797852,764.727112 350.287720,764.165466 
	C344.956604,763.426025 340.489410,762.340881 339.017731,768.185120 
M354.441711,750.220398 
	C354.189270,749.146790 353.936859,748.073181 353.195099,744.918213 
	C349.989655,749.976013 347.917267,753.245911 345.702484,756.740540 
	C352.244659,759.262024 355.068573,757.880066 354.441711,750.220398 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M965.887817,983.308350 
	C964.087524,985.088806 962.512085,986.441467 960.701843,986.938171 
	C953.169312,989.005127 948.192566,985.698425 947.773926,977.876709 
	C947.349731,969.951538 947.680359,961.985962 947.680359,953.709595 
	C945.457214,952.816589 943.485962,952.024780 940.065979,950.651062 
	C943.229065,948.904358 945.265076,947.780090 947.360168,946.623169 
	C949.026367,937.756287 949.026367,937.756287 953.496155,932.363342 
	C954.048523,937.874390 954.474976,942.129211 954.950806,946.876648 
	C958.699158,947.433960 962.355774,947.977539 966.680054,948.620422 
	C963.982971,954.637329 959.070618,951.066711 954.609009,953.846680 
	C954.609009,960.848267 954.423584,968.982971 954.705566,977.101379 
	C954.810059,980.109680 957.067139,981.920166 960.240723,981.230591 
	C962.489502,980.741882 964.669495,979.278076 965.887817,983.308350 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M702.366028,834.033508 
	C708.583069,833.194458 714.784668,833.194458 721.423218,833.194458 
	C721.311951,824.228027 713.236694,829.711365 710.583618,825.999023 
	C706.447571,818.325500 714.839355,818.470276 718.060608,814.798706 
	C717.037354,810.335754 704.810242,812.940918 710.442383,804.240417 
	C713.719849,800.990112 719.745239,805.502014 721.839844,798.818726 
	C723.005188,798.055359 724.036133,798.099670 725.837769,798.218872 
	C726.657532,809.370178 726.706604,820.446472 726.694702,832.397888 
	C720.293945,839.566467 712.412781,838.211792 704.740784,837.505981 
	C703.870605,837.425964 703.143799,835.788086 702.366028,834.033508 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M260.499023,768.257141 
	C266.714020,758.523071 272.873383,748.752747 279.177063,739.076477 
	C281.127594,736.082458 283.177155,732.206116 287.420258,738.414551 
	C287.552185,743.511536 287.730652,747.152649 287.543488,750.774780 
	C287.171692,757.969482 286.598450,765.153809 286.108459,772.342407 
	C284.763550,771.346863 283.418640,770.351318 281.966858,767.965210 
	C275.936127,761.418640 272.065094,761.762573 267.663452,767.836182 
	C265.592743,769.209106 263.522064,770.582092 260.923645,771.339478 
	C260.430298,769.901611 260.464661,769.079407 260.499023,768.257141 
M278.294861,749.581726 
	C276.930237,752.001831 275.565643,754.421997 273.026184,758.925659 
	C277.438324,757.698486 281.050568,757.443726 281.240356,756.500427 
	C281.810303,753.667419 281.045044,750.565735 280.800781,747.568970 
	C280.239746,747.853333 279.678711,748.137695 278.294861,749.581726 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M281.426514,999.417297 
	C276.693054,1001.326904 272.221802,1004.377258 269.331055,997.115356 
	C272.308990,995.811523 274.883942,994.684082 278.064270,993.291626 
	C278.064270,977.996948 278.064270,962.746948 278.064270,946.856567 
	C280.851654,946.856567 282.905579,946.856567 285.719086,946.856567 
	C285.719086,961.730530 285.902283,976.329895 285.553894,990.916443 
	C285.489502,993.611633 283.276855,996.255554 281.426514,999.417297 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M641.033936,799.815369 
	C638.391541,801.531189 635.655701,802.216309 633.258362,803.522522 
	C631.525024,804.467041 630.241272,806.236572 628.757019,807.638184 
	C629.977112,808.904419 630.981995,810.761108 632.466309,811.302185 
	C634.855347,812.172852 638.458801,811.718567 637.530823,815.535461 
	C637.177673,816.988220 634.211609,817.836121 632.395508,818.889221 
	C631.565979,819.370239 630.637634,819.680847 630.220886,819.863770 
	C625.757263,823.848267 632.548401,832.487305 622.249268,834.689392 
	C621.781555,821.857422 622.043823,809.834290 622.183105,797.092834 
	C629.095337,797.006104 635.405884,793.457520 641.033936,799.815369 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M303.945312,797.051392 
	C307.780884,804.343689 299.958801,803.108337 297.303101,807.721069 
	C297.303101,810.904663 297.383240,815.525818 297.280487,820.142944 
	C297.178711,824.715332 296.892517,829.283691 296.700500,833.558228 
	C291.829102,835.465210 290.330597,833.421875 290.249512,829.741150 
	C290.125275,824.102539 290.169617,818.460266 290.140259,812.819519 
	C290.119598,808.852112 290.706757,804.720215 285.264648,803.307861 
	C284.224884,803.038025 282.767731,800.205261 283.173492,799.436340 
	C283.933990,797.994995 285.878235,796.353149 287.396149,796.285950 
	C292.673431,796.052246 297.979004,796.457642 303.945312,797.051392 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M759.354370,809.894775 
	C763.262329,799.776001 770.323303,794.843933 782.474731,797.179077 
	C784.110901,799.202698 784.661316,800.546753 785.211792,801.890747 
	C784.961792,802.214722 784.711792,802.538696 783.701904,803.381104 
	C781.890686,804.120239 780.839294,804.341003 779.787842,804.561768 
	C770.442993,804.587463 765.706726,808.493774 766.029541,815.909119 
	C766.334961,822.925232 771.309509,826.796997 779.842041,826.669067 
	C781.130188,826.649780 782.418945,826.666382 784.125122,826.666382 
	C784.125122,828.489197 784.125122,830.088928 783.083740,832.544556 
	C775.564880,834.871887 769.877563,832.781189 764.454590,829.498962 
	C764.454590,829.498962 764.113403,829.926453 764.152649,829.148682 
	C762.855957,826.844482 761.520020,825.318054 760.184021,823.791626 
	C760.184021,823.791626 760.012085,823.971313 760.081848,823.034424 
	C759.885864,818.029907 759.620117,813.962341 759.354370,809.894775 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M612.716492,741.177429 
	C616.591492,746.774536 620.466553,752.371704 625.652161,759.861938 
	C626.345703,750.202026 626.886597,742.668152 627.575867,733.066711 
	C632.355469,741.687134 632.453430,764.475159 628.315735,773.591003 
	C626.340454,771.398193 624.713013,769.732300 623.245483,767.935791 
	C618.952026,762.679871 618.145630,754.758301 609.744080,751.728516 
	C606.350830,746.766663 610.189697,744.228516 612.716492,741.177429 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M1674.740967,945.574951 
	C1679.423340,946.430298 1678.515503,949.110657 1677.812012,951.725220 
	C1665.141846,953.813477 1663.276978,956.034607 1663.205078,969.162842 
	C1663.176270,974.438293 1663.200439,979.714050 1663.200439,985.641846 
	C1660.871216,985.872864 1658.811279,986.077148 1656.607788,986.295654 
	C1656.607788,972.587891 1656.607788,959.568359 1656.607788,945.007141 
	C1659.767334,947.020752 1661.730713,948.272095 1663.805176,949.594238 
	C1666.991821,948.330078 1670.525391,946.928284 1674.740967,945.574951 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M549.785767,947.637329 
	C553.223816,946.502563 556.018982,945.850952 559.708191,944.990967 
	C559.978577,947.817566 560.150208,949.611694 560.339294,951.588257 
	C559.075684,952.029846 558.225586,952.513306 557.333679,952.609741 
	C548.492798,953.566101 545.626770,956.306519 545.266663,965.064270 
	C544.993958,971.697083 545.212585,978.349976 545.212585,985.649475 
	C542.857666,985.873962 540.787659,986.071289 538.382935,986.300476 
	C538.382935,972.731140 538.382935,959.879272 538.382935,946.012390 
	C540.707397,946.832092 543.139526,946.933899 543.767639,948.050476 
	C545.802612,951.668091 547.359741,949.479309 549.785767,947.637329 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M873.927368,967.921753 
	C873.927368,960.143433 873.927368,953.325928 873.927368,944.429932 
	C877.870422,947.090088 879.811707,948.399780 882.198120,950.009705 
	C884.010742,948.873291 886.032959,947.122192 888.381165,946.279175 
	C890.427795,945.544495 892.842224,945.834290 895.838867,945.617554 
	C896.001038,947.929688 896.127563,949.734070 896.238953,951.323181 
	C895.278687,951.939270 894.770203,952.531982 894.210876,952.584534 
	C884.164429,953.529907 881.516785,956.165466 881.236450,966.125610 
	C881.059509,972.412415 881.203491,978.708191 881.203491,985.656616 
	C878.853333,985.878662 876.787598,986.073853 873.927368,986.344116 
	C873.927368,980.039246 873.927368,974.460876 873.927368,967.921753 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M1118.311035,949.942993 
	C1116.923340,951.278015 1115.678223,952.317261 1114.298462,952.546814 
	C1106.722778,953.807190 1103.720215,956.510925 1103.312500,963.981873 
	C1102.934448,970.911499 1103.231812,977.877930 1103.231812,985.474243 
	C1101.043579,985.788025 1098.984131,986.083252 1096.509033,986.438171 
	C1096.509033,972.712830 1096.509033,959.660339 1096.509033,944.807373 
	C1099.947021,947.077148 1102.134644,948.521362 1103.878662,949.672791 
	C1107.319946,948.245972 1110.496338,946.542297 1113.886353,945.655029 
	C1116.271851,945.030762 1118.550659,945.999023 1118.311035,949.942993 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M2659.927734,962.158569 
	C2659.927734,956.320190 2659.927734,951.441223 2659.927734,944.686218 
	C2663.701416,946.991333 2665.713135,948.220276 2668.602051,949.984863 
	C2672.004883,947.838379 2676.023438,943.329712 2682.071289,946.693298 
	C2682.071289,948.204346 2682.071289,949.798523 2682.071289,951.942017 
	C2680.810303,952.175476 2679.633057,952.452209 2678.439941,952.604614 
	C2670.870361,953.571777 2667.736816,956.416870 2667.316162,963.915283 
	C2666.926025,970.868286 2667.233154,977.860352 2667.233154,985.485413 
	C2665.029053,985.791504 2662.963867,986.078369 2659.927734,986.500061 
	C2659.927734,978.223694 2659.927734,970.670898 2659.927734,962.158569 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M2509.927734,964.078369 
	C2509.927734,957.590698 2509.927734,952.066284 2509.927734,944.595947 
	C2513.752686,947.018738 2515.726318,948.268860 2518.531494,950.045715 
	C2521.830811,947.976624 2525.508545,943.734558 2531.843262,946.478638 
	C2531.974854,947.816223 2532.151855,949.615295 2532.344238,951.572937 
	C2531.090332,952.020386 2530.246338,952.513611 2529.359375,952.608459 
	C2520.490479,953.556458 2517.640137,956.251404 2517.269775,964.983948 
	C2516.988770,971.608032 2517.214111,978.253601 2517.214111,985.541626 
	C2514.971680,985.819275 2512.907227,986.074890 2509.927734,986.443848 
	C2509.927734,978.831299 2509.927734,971.936462 2509.927734,964.078369 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M1927.554688,955.399231 
	C1926.011475,959.450684 1924.445801,962.839294 1924.190796,966.323853 
	C1923.732666,972.582458 1924.061523,978.898621 1924.061523,985.812256 
	C1921.906250,985.985352 1920.062378,986.133484 1917.847656,986.311401 
	C1917.847656,972.819336 1917.847656,959.751587 1917.847656,944.038086 
	C1921.364258,947.506775 1923.207764,949.325195 1925.201050,951.291443 
	C1928.849609,947.314880 1932.920898,943.418152 1940.438721,947.704590 
	C1938.968750,949.510254 1938.038086,951.600769 1936.461182,952.375244 
	C1933.904785,953.630798 1930.924194,954.022949 1927.554688,955.399231 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M191.692398,767.947144 
	C188.231018,775.302673 181.604797,773.430115 176.072327,772.518860 
	C169.377701,771.416260 165.053482,766.523926 163.050781,760.073303 
	C158.123520,744.202820 169.462448,732.416138 187.356476,736.519531 
	C187.861496,738.730225 187.752548,739.713135 186.836334,740.547363 
	C183.410843,740.353149 180.709213,739.865601 178.189316,740.341125 
	C168.830612,742.107239 164.207230,751.622986 168.371094,760.090576 
	C171.689911,766.839722 178.397720,768.791626 188.211273,766.268188 
	C189.575531,767.156677 190.633957,767.551880 191.692398,767.947144 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M683.840698,799.337036 
	C683.389404,804.035278 680.263550,803.316040 677.251953,803.515564 
	C669.992981,803.996765 666.393127,807.093933 665.377502,813.135132 
	C664.390747,819.004578 666.939941,824.122803 673.083496,826.624268 
	C675.739380,827.705750 679.077576,827.111450 682.406982,827.294983 
	C683.924866,831.681763 681.421204,833.818420 677.716370,833.500732 
	C673.580933,833.145935 669.565125,831.395874 664.769287,830.076355 
	C659.300110,823.581909 656.636719,816.854187 659.355164,808.823059 
	C663.067627,797.855469 673.046204,793.606201 683.840698,799.337036 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M666.502747,765.091553 
	C666.953491,754.451172 665.131714,744.511230 668.061340,733.769104 
	C675.531799,738.547668 672.309387,744.633301 672.765564,749.601807 
	C673.242126,754.792358 672.872009,760.060669 672.872009,765.769165 
	C678.831726,766.589539 683.797058,767.273071 691.043396,768.270569 
	C687.576538,770.810791 686.226318,772.592957 684.690674,772.770447 
	C680.752808,773.225220 676.732422,772.944946 672.745544,772.999756 
	C667.944885,773.065796 666.339355,770.328613 666.502747,765.091553 
z"
            />
            <path
                fill="#020202"
                opacity="1.000000"
                stroke="none"
                d="
M4303.940430,570.254028 
	C4298.680176,570.965942 4297.195312,569.264771 4297.273438,564.859009 
	C4297.518066,550.981445 4297.363770,537.096802 4297.363770,522.224060 
	C4300.198242,522.067993 4302.881836,521.920227 4305.312500,521.786377 
	C4305.895508,523.053467 4306.377441,523.615479 4306.380859,524.180237 
	C4306.458496,537.732788 4306.542480,551.286072 4306.448242,564.837952 
	C4306.436035,566.623535 4305.459473,568.402405 4303.940430,570.254028 
z"
            />
            <path
                fill="#020202"
                opacity="1.000000"
                stroke="none"
                d="
M4728.421875,524.182129 
	C4728.503906,539.714233 4728.503906,554.255615 4728.503906,569.787231 
	C4725.690430,569.935120 4722.996094,570.076782 4719.808105,570.244324 
	C4719.808105,554.072571 4719.808105,538.637756 4719.808105,522.756653 
	C4722.488770,521.094421 4725.413086,520.669556 4728.421875,524.182129 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M657.847656,766.243958 
	C648.669312,760.691956 642.845398,766.862610 635.891418,774.427490 
	C635.891418,770.629333 635.261963,768.603394 635.990967,767.401001 
	C641.804199,757.812805 647.751770,748.299072 653.944336,738.952087 
	C655.716431,736.277222 657.748108,731.721008 661.218262,737.494385 
	C659.555847,740.962952 658.684448,743.630920 657.126953,746.332153 
	C653.947449,749.602051 651.454041,752.838684 647.769958,757.620789 
	C652.666138,757.620789 655.208435,757.620789 657.821167,758.485107 
	C657.876953,761.647583 657.862305,763.945740 657.847656,766.243958 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M776.006287,930.933350 
	C776.142944,949.730225 776.142944,967.611267 776.142944,985.881348 
	C773.787415,985.881348 772.263000,985.881348 770.096069,985.881348 
	C770.096069,967.151855 770.096069,948.368958 770.096069,928.293823 
	C772.248901,928.936523 774.059265,929.476990 776.006287,930.933350 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M233.885330,737.947266 
	C238.738297,733.753052 248.832123,733.341248 253.202866,737.159180 
	C257.474182,740.890381 257.766296,745.598633 254.059784,752.360901 
	C253.281555,753.780701 252.275421,755.075500 251.031830,756.941895 
	C252.959610,760.339722 254.878540,763.721985 257.255341,768.213013 
	C257.726013,770.174072 257.738861,771.026489 257.751678,771.878845 
	C255.619171,770.771606 252.995895,770.111511 251.477539,768.444824 
	C249.551971,766.331055 248.523819,763.399841 246.478317,759.678833 
	C243.270844,757.758118 240.693710,756.979736 238.030273,755.409790 
	C238.078720,753.566528 238.213486,752.514832 239.116180,751.384155 
	C242.144531,751.224487 244.942459,751.939819 246.532532,750.866272 
	C248.633804,749.447388 250.672028,746.746094 250.993744,744.360901 
	C251.165558,743.086914 247.891434,740.624512 245.776123,739.959717 
	C243.436508,739.224426 240.643860,739.930542 237.514740,739.772400 
	C235.949066,739.006348 234.917206,738.476807 233.885330,737.947266 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M1363.771240,984.151611 
	C1361.657715,985.575500 1359.611328,986.166077 1356.751465,986.991455 
	C1356.751465,972.939453 1356.751465,959.942749 1356.751465,946.571533 
	C1359.036621,946.571533 1360.900757,946.571533 1363.838501,946.571533 
	C1363.838501,958.984558 1363.838501,971.151428 1363.771240,984.151611 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M566.146973,977.195801 
	C566.146973,966.746460 566.146973,957.197144 566.146973,946.902283 
	C568.698486,946.715698 570.747559,946.565918 573.345215,946.375977 
	C573.345215,959.708557 573.345215,972.474670 573.345215,985.868958 
	C571.338501,985.993896 569.221252,986.125732 566.146973,986.317078 
	C566.146973,983.165283 566.146973,980.630554 566.146973,977.195801 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M414.884766,829.915527 
	C413.523590,832.066833 412.228546,833.440430 410.933533,834.814026 
	C410.124237,834.512085 409.314972,834.210144 408.505707,833.908203 
	C408.080872,822.158875 407.684418,810.397339 409.018799,798.624939 
	C409.144012,797.520264 411.082153,796.621033 412.362915,795.459167 
	C413.371582,796.771240 414.446136,797.518738 414.464813,798.291687 
	C414.713226,808.571594 414.813599,818.855164 414.884766,829.915527 
z"
            />
            <path
                fill="#7F7F7F"
                opacity="1.000000"
                stroke="none"
                d="
M109.985550,737.987793 
	C115.628365,733.939026 121.951004,734.743835 127.148499,737.684387 
	C129.742386,739.151917 131.101730,744.175232 131.523453,747.765930 
	C132.068375,752.405579 129.171997,755.964661 124.639351,757.444031 
	C121.267212,758.544739 117.699432,759.046021 113.275795,759.327454 
	C112.558929,756.314819 112.785065,753.789062 113.759018,751.459961 
	C117.137421,751.546509 120.044945,752.079895 122.304604,751.107605 
	C123.902580,750.420044 125.363747,747.737061 125.473404,745.862305 
	C125.545578,744.628235 123.235825,742.336914 121.762993,742.126465 
	C118.919449,741.720093 115.913376,742.451294 112.694160,742.042603 
	C111.604271,740.245544 110.794914,739.116638 109.985550,737.987793 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M370.492188,803.059204 
	C371.066345,800.141174 371.631104,798.097961 372.712921,794.184204 
	C374.632080,797.383728 376.094604,798.799622 376.343445,800.403809 
	C377.880859,810.315125 376.537537,829.485657 373.491913,835.856323 
	C372.160980,833.266541 370.584991,831.591064 370.537750,829.873413 
	C370.300049,821.232971 370.461517,812.581543 370.492188,803.059204 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M668.568115,947.198364 
	C673.199524,945.627747 674.420471,947.550781 674.382019,951.336182 
	C674.267334,962.614929 674.340881,973.895569 674.340881,985.851013 
	C672.100525,986.002075 670.349609,986.120117 667.979492,986.279907 
	C667.979492,973.037231 667.979492,960.475708 668.568115,947.198364 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M2154.346680,962.145752 
	C2154.346680,970.409546 2154.346680,977.701538 2154.346680,985.632324 
	C2152.283936,985.879883 2150.529785,986.090393 2148.181885,986.372192 
	C2148.181885,972.974548 2148.181885,960.169434 2148.181885,946.996155 
	C2151.522949,945.962769 2154.166504,945.625549 2154.303955,950.191040 
	C2154.414062,953.849121 2154.339355,957.512695 2154.346680,962.145752 
z"
            />
            <path
                fill="#030303"
                opacity="1.000000"
                stroke="none"
                d="
M2289.653320,960.211182 
	C2289.689209,955.917480 2289.297119,952.503357 2289.952148,949.303589 
	C2290.253174,947.831421 2292.606201,946.779053 2295.618164,944.148376 
	C2295.618164,959.316772 2295.618164,972.135742 2295.618164,985.696045 
	C2294.310303,985.862183 2292.560303,986.084534 2289.653320,986.453796 
	C2289.653320,977.618286 2289.653320,969.398376 2289.653320,960.211182 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M389.756836,806.054077 
	C390.259552,812.522705 390.762268,818.991333 391.305267,825.978210 
	C394.963776,826.616760 398.412140,827.218628 401.717255,827.795471 
	C403.109650,830.858032 403.352539,833.937317 399.749908,834.168884 
	C394.692780,834.493958 389.558441,833.618408 385.312988,832.536255 
	C390.073578,831.816162 393.978333,831.816162 397.883118,831.816162 
	C394.413513,829.647034 388.663696,830.854431 388.497314,825.192627 
	C388.310425,818.830994 389.286621,812.435059 389.756836,806.054077 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M696.067383,831.088135 
	C694.474731,832.637573 692.795959,833.252014 689.388123,834.499329 
	C689.388123,822.712341 689.388123,812.252991 689.226135,800.867920 
	C689.256958,799.513062 689.449829,799.083740 690.180603,797.770996 
	C690.718506,796.887573 691.180725,796.023499 691.180725,796.023499 
	C695.637451,796.483887 696.230896,799.667969 696.208130,803.228821 
	C696.150757,812.203674 696.059143,821.178406 696.067383,831.088135 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M789.862915,832.337524 
	C789.919922,822.158997 789.976929,811.980530 790.076904,801.124634 
	C790.119995,800.447205 790.682556,800.276489 791.289917,800.267456 
	C793.105957,800.218933 794.314697,800.179382 795.523438,800.139893 
	C795.649048,810.144592 795.774719,820.149292 795.223633,831.424255 
	C792.985596,832.575562 791.424255,832.456543 789.862915,832.337524 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M647.096924,832.077759 
	C647.178223,821.197937 647.259521,810.318176 648.348389,798.654236 
	C650.331726,797.801575 651.307495,797.733093 652.283325,797.664551 
	C652.509460,808.690308 652.735657,819.716125 651.815308,831.697937 
	C649.478149,832.461914 648.287537,832.269836 647.096924,832.077759 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M527.663452,747.768982 
	C532.091736,735.371399 538.687927,732.197327 552.916016,736.957397 
	C552.057312,738.909241 550.742554,739.740601 548.680542,740.498657 
	C540.727600,739.146606 535.983459,743.112915 530.688232,747.946777 
	C529.009705,747.820618 528.336548,747.794800 527.663452,747.768982 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M389.868561,805.317017 
	C389.286621,812.435059 388.310425,818.830994 388.497314,825.192627 
	C388.663696,830.854431 394.413513,829.647034 397.883118,831.816162 
	C393.978333,831.816162 390.073578,831.816162 385.352509,831.814270 
	C384.436920,821.882019 384.337646,811.951721 385.050903,801.129456 
	C387.113281,800.207275 388.363068,800.176941 389.612854,800.146667 
	C389.735321,801.624451 389.857819,803.102234 389.868561,805.317017 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M4338.344727,521.275391 
	C4338.602539,522.150574 4338.372559,522.273010 4338.279785,522.181946 
	C4338.547852,521.023682 4339.265625,519.037476 4339.219238,519.019592 
	C4334.449707,517.168091 4329.718262,513.786804 4324.634766,519.118042 
	C4324.069336,511.649841 4326.135742,509.124908 4331.306641,510.838165 
	C4335.971191,512.383789 4340.260254,514.788086 4344.478027,508.665527 
	C4347.030762,517.175293 4340.761230,517.527649 4338.344727,521.275391 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M199.635193,799.984802 
	C199.659348,796.784668 201.777802,796.496643 205.131470,797.462463 
	C209.951782,799.705139 213.054565,801.824158 212.803650,806.647644 
	C212.774857,814.497559 212.746048,822.347534 211.703308,831.128540 
	C209.598068,832.044800 208.506760,832.029907 207.415466,832.015076 
	C207.293243,824.162781 207.171005,816.310486 207.362732,806.878052 
	C207.278381,800.072632 201.959106,802.295532 199.635193,799.984802 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M286.466370,772.792603 
	C286.598450,765.153809 287.171692,757.969482 287.543488,750.774780 
	C287.730652,747.152649 287.552185,743.511536 287.712067,738.962402 
	C288.977631,737.482056 290.070160,736.918335 291.758789,736.194580 
	C292.566559,747.586304 292.778229,759.138062 293.496124,771.555725 
	C291.609680,772.695374 289.216980,772.969055 286.466370,772.792603 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M4669.962891,690.719116 
	C4665.967285,689.157104 4665.399414,686.533691 4668.415527,684.918030 
	C4670.208008,683.958069 4672.713379,684.051392 4674.881348,684.131958 
	C4678.716797,684.274658 4682.539062,684.768860 4686.545410,685.132141 
	C4686.435547,691.272095 4685.076660,692.332153 4678.632324,690.796753 
	C4676.017090,690.173645 4673.212891,690.342102 4669.962891,690.719116 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M541.421204,772.497314 
	C534.480713,771.819946 530.847961,767.046448 528.548401,760.525146 
	C529.907288,758.741394 530.542603,757.950439 531.616333,757.696289 
	C536.242676,766.799011 543.415955,768.116150 551.947937,767.171509 
	C550.683838,769.283325 549.529907,771.140442 547.895142,771.793274 
	C545.953186,772.568787 543.597534,772.308655 541.421204,772.497314 
z"
            />
            <path
                fill="#4C4C4C"
                opacity="1.000000"
                stroke="none"
                d="
M187.643616,740.696106 
	C187.752548,739.713135 187.861496,738.730225 187.955612,737.005005 
	C193.618896,737.958557 195.811096,743.022156 198.885773,748.029175 
	C198.662186,752.419006 198.259277,756.186096 197.883911,760.882080 
	C196.123505,763.539490 194.335602,765.267944 192.120056,767.471802 
	C190.633957,767.551880 189.575531,767.156677 188.549255,765.624023 
	C196.589493,756.634460 196.337173,750.233643 187.643616,740.696106 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M2176.774902,939.451416 
	C2174.888428,939.806946 2173.644287,939.806946 2171.378418,939.806946 
	C2174.637207,934.957886 2176.186523,929.581238 2182.504395,929.432556 
	C2189.043701,929.278625 2190.414795,935.139709 2193.625488,939.130310 
	C2187.673828,942.246155 2186.368408,935.659607 2180.642090,934.076660 
	C2179.934082,935.178772 2178.675537,937.137329 2176.774902,939.451416 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M957.762573,127.582291 
	C958.122314,118.738396 964.087769,123.722641 967.989258,121.750053 
	C968.325684,125.420479 968.589355,128.296768 968.915527,131.854813 
	C965.916443,132.055679 963.280090,132.685043 960.863403,132.206024 
	C959.626831,131.960907 958.783508,129.731628 957.762573,127.582291 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M958.815125,74.988884 
	C962.088440,74.452477 964.734558,74.452477 968.032227,74.452477 
	C968.313293,77.382500 968.588440,80.250641 968.944885,83.965836 
	C965.325134,84.156044 962.180847,84.321274 958.187866,84.531097 
	C958.187866,81.153191 958.187866,78.339241 958.815125,74.988884 
z"
            />
            <path
                fill="#0E0E0E"
                opacity="1.000000"
                stroke="none"
                d="
M551.864685,61.623520 
	C551.324341,58.585190 551.324341,56.020313 551.324341,52.860054 
	C554.434021,52.860054 557.133606,52.860054 560.239502,52.860054 
	C560.239502,55.941982 560.239502,58.763271 560.239502,62.096970 
	C557.451904,62.096970 554.928467,62.096970 551.864685,61.623520 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M657.813110,746.298828 
	C658.684448,743.630920 659.555847,740.962952 661.166504,738.162415 
	C662.070496,748.105713 662.235229,758.181580 661.505554,769.049133 
	C659.848389,769.863342 659.085571,769.885925 658.322876,769.908447 
	C658.100281,769.106018 657.877686,768.303650 657.751404,766.872620 
	C657.862305,763.945740 657.876953,761.647583 657.877808,757.677673 
	C657.846985,752.770264 657.830017,749.534546 657.813110,746.298828 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M238.348236,751.463074 
	C238.213486,752.514832 238.078720,753.566528 237.957703,756.053589 
	C238.020309,758.332397 238.069183,759.175964 238.118042,760.019470 
	C237.887939,762.747559 237.657852,765.475708 236.604660,768.984741 
	C235.058640,769.825317 234.335709,769.885010 233.612793,769.944702 
	C233.564636,759.890381 233.516495,749.836121 233.676849,738.864502 
	C234.917206,738.476807 235.949066,739.006348 237.401093,740.593872 
	C237.996933,744.922302 238.172592,748.192688 238.348236,751.463074 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M612.565308,740.669556 
	C610.189697,744.228516 606.350830,746.766663 608.960083,752.228394 
	C609.399536,757.844360 609.486816,762.919739 608.802551,768.890381 
	C607.303467,769.875671 606.575989,769.965576 605.848450,770.055542 
	C605.674377,759.958130 605.500305,749.860718 606.365845,738.834839 
	C608.430298,737.844910 609.455017,737.783447 610.479797,737.721924 
	C611.124573,738.535095 611.769348,739.348389 612.565308,740.669556 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M293.709106,54.370396 
	C293.794769,57.357605 293.695099,59.546669 293.578552,62.106602 
	C290.326202,62.106602 287.514282,62.106602 284.315552,62.106602 
	C284.315552,58.926510 284.315552,56.136414 284.315552,52.076832 
	C287.663940,52.620609 290.593903,53.096428 293.709106,54.370396 
z"
            />
            <path
                fill="#7F7F7F"
                opacity="1.000000"
                stroke="none"
                d="
M213.434341,806.353149 
	C213.054565,801.824158 209.951782,799.705139 205.798889,797.547607 
	C210.356583,796.494141 215.144699,796.140076 219.607224,795.810120 
	C222.668365,803.153809 217.712631,804.174438 213.434341,806.353149 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M285.346497,930.136719 
	C286.066040,931.175964 286.465271,931.761902 286.524078,932.380188 
	C286.909668,936.435425 285.033142,939.050964 281.014587,937.987732 
	C279.422302,937.566345 277.341370,934.065186 277.655243,932.368103 
	C278.359406,928.560974 281.154846,927.085205 285.346497,930.136719 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M1362.295410,937.752808 
	C1360.184570,937.871155 1357.737183,938.238953 1357.236206,937.418457 
	C1356.195068,935.713196 1355.495850,933.192566 1355.986938,931.364624 
	C1356.333252,930.075928 1359.292603,928.265137 1360.336548,928.661133 
	C1362.115112,929.335693 1363.771729,931.364929 1364.554321,933.216187 
	C1364.975586,934.212463 1363.474121,936.021667 1362.295410,937.752808 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M573.270508,937.012329 
	C571.283997,937.659241 569.052673,938.580505 568.316101,937.895203 
	C566.887085,936.565613 565.552551,934.311157 565.606018,932.481628 
	C565.646118,931.109985 568.015381,928.640930 569.177979,928.735840 
	C571.004150,928.885132 573.093567,930.479736 574.271057,932.059143 
	C574.922241,932.932495 573.944580,935.020264 573.270508,937.012329 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M560.668213,737.929321 
	C560.671204,740.605713 560.674194,743.282043 560.405273,747.661865 
	C560.381592,753.743469 560.629761,758.121704 560.877869,762.499878 
	C560.800110,764.520386 560.722351,766.540955 559.915771,769.200317 
	C558.366150,768.543762 557.545349,767.248474 556.728516,765.040527 
	C556.658813,757.430786 556.585266,750.733704 556.934937,743.487183 
	C558.461487,741.268372 559.564880,739.598816 560.668213,737.929321 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M556.724609,765.953125 
	C557.545349,767.248474 558.366150,768.543762 559.772827,769.945557 
	C560.558838,770.612122 560.758850,771.172241 560.958862,771.732361 
	C554.797546,773.380310 548.790527,776.522095 541.793091,773.084961 
	C543.597534,772.308655 545.953186,772.568787 547.895142,771.793274 
	C549.529907,771.140442 550.683838,769.283325 552.766113,767.089233 
	C554.562561,766.130432 555.643616,766.041748 556.724609,765.953125 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M797.224915,980.423706 
	C795.539673,987.392395 793.369080,989.226135 790.620178,986.650696 
	C789.163025,985.285522 788.051331,981.675598 788.845398,980.157349 
	C790.748840,976.518066 793.965881,976.669373 797.224915,980.423706 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M109.659286,738.687500 
	C110.794914,739.116638 111.604271,740.245544 112.612762,742.753174 
	C112.878319,746.509094 112.944763,748.886169 113.011200,751.263306 
	C112.785065,753.789062 112.558929,756.314819 112.602951,759.756592 
	C112.532982,763.964844 114.322159,767.801575 110.673927,770.406067 
	C110.000267,769.737732 109.163910,769.294434 109.163933,768.851196 
	C109.164497,759.029907 109.257545,749.208618 109.659286,738.687500 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M797.694092,953.333740 
	C796.374451,955.178833 795.123230,957.248108 794.059143,957.156067 
	C792.117920,956.987976 789.678955,955.972473 788.615540,954.478882 
	C787.851013,953.405090 788.393799,950.426331 789.437317,949.314941 
	C790.469727,948.215332 793.166748,947.643921 794.572937,948.216858 
	C796.017517,948.805481 796.783813,951.058533 797.694092,953.333740 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M666.539185,935.641357 
	C666.744812,933.210388 666.859741,930.975769 668.033997,929.790833 
	C670.868591,926.930176 673.528625,928.494934 675.250610,931.331360 
	C676.930725,934.098633 675.800232,936.830994 672.985718,937.675476 
	C671.258728,938.193665 668.967834,936.832275 666.539185,935.641357 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M2296.314941,930.052368 
	C2297.051025,930.850708 2297.264893,931.117432 2297.373779,931.421814 
	C2298.861084,935.577881 2296.840820,938.173523 2293.020752,938.147522 
	C2291.340820,938.136047 2288.183105,934.974609 2288.300293,933.442871 
	C2288.620850,929.255981 2291.225098,926.966125 2296.314941,930.052368 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M2151.699707,928.476807 
	C2153.394531,929.564209 2155.141113,930.420410 2155.155029,931.304138 
	C2155.187256,933.336182 2155.008789,936.254272 2153.732178,937.179749 
	C2152.415283,938.134399 2148.983398,937.917969 2147.793213,936.805420 
	C2146.622314,935.710876 2146.584473,932.720337 2147.058350,930.812317 
	C2147.333008,929.705811 2149.596436,929.093079 2151.699707,928.476807 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M789.835693,833.066650 
	C791.424255,832.456543 792.985596,832.575562 795.309570,832.355347 
	C797.318420,831.970459 798.564453,831.924683 800.434448,831.883423 
	C802.784241,832.475098 804.510193,833.062134 806.976013,833.629089 
	C807.317749,834.779846 806.929688,836.963989 806.519958,836.968079 
	C801.243469,837.020508 795.960449,836.814697 790.692993,836.464172 
	C790.340515,836.440674 790.100647,834.724609 789.835693,833.066650 
z"
            />
            <path
                fill="#252525"
                opacity="1.000000"
                stroke="none"
                d="
M377.560181,931.208130 
	C378.607697,936.614319 376.430267,939.139893 371.927734,937.897705 
	C370.388306,937.473022 368.312378,933.534180 368.850159,932.072083 
	C370.405640,927.842834 373.688873,927.148987 377.560181,931.208130 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M758.750854,809.900879 
	C759.620117,813.962341 759.885864,818.029907 760.187744,822.969238 
	C758.829346,823.918640 757.434875,823.996338 755.342896,824.088379 
	C754.460815,819.951050 754.276306,815.799316 754.310425,810.780396 
	C755.735107,809.911072 756.941223,809.908997 758.750854,809.900879 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M298.203491,762.207886 
	C297.253998,758.803894 296.904175,755.394043 296.554352,751.984131 
	C297.215759,751.760742 297.877197,751.537415 298.538605,751.314026 
	C300.879242,756.426758 303.219910,761.539490 305.523193,767.366760 
	C303.258301,766.121521 301.030731,764.161743 298.203491,762.207886 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M764.357544,830.270874 
	C769.877563,832.781189 775.564880,834.871887 782.857727,833.344604 
	C783.073608,834.683716 782.824768,836.910461 781.816345,837.335632 
	C776.234131,839.689209 768.375977,836.693115 764.357544,830.270874 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M572.194092,770.664124 
	C578.210449,771.621704 584.425781,772.914368 591.493347,770.255737 
	C585.012634,776.500793 581.973938,776.659851 572.194092,770.664124 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M561.009277,737.471069 
	C559.564880,739.598816 558.461487,741.268372 556.270752,743.253418 
	C553.264893,742.570068 551.346313,741.571045 549.427795,740.572021 
	C550.742554,739.740601 552.057312,738.909241 553.510986,737.477844 
	C556.209412,737.337341 558.891907,730.784485 561.009277,737.471069 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M734.773071,824.911804 
	C733.784119,820.990356 733.784119,817.470642 733.784119,813.950867 
	C734.367554,813.693665 734.950989,813.436523 735.534424,813.179321 
	C737.651978,816.985596 739.769592,820.791870 741.958191,825.292603 
	C739.940125,825.762512 737.851074,825.537964 734.773071,824.911804 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M268.541901,767.901123 
	C272.065094,761.762573 275.936127,761.418640 281.741394,767.322754 
	C277.555328,768.035889 273.487823,768.000977 268.541901,767.901123 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M561.498901,762.247437 
	C560.629761,758.121704 560.381592,753.743469 560.423218,748.463989 
	C561.452698,747.820923 562.192444,748.079163 563.511719,748.224243 
	C564.243774,751.864685 564.396362,755.618347 564.560974,760.160950 
	C563.755249,761.298340 562.937561,761.646667 561.498901,762.247437 
z"
            />
            <path
                fill="#7F7F7F"
                opacity="1.000000"
                stroke="none"
                d="
M199.277573,800.408875 
	C201.959106,802.295532 207.278381,800.072632 207.389404,805.997681 
	C204.848480,804.081665 199.363998,805.973511 199.277573,800.408875 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M339.806519,768.159668 
	C340.489410,762.340881 344.956604,763.426025 349.682800,764.236938 
	C348.410156,769.655334 343.934082,767.317017 339.806519,768.159668 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M318.822266,760.113586 
	C319.230042,757.432312 320.181396,754.755127 321.132751,752.077942 
	C321.676300,752.110718 322.219879,752.143494 322.763428,752.176270 
	C322.900513,754.415039 323.037598,756.653748 322.897247,759.543030 
	C321.535156,760.168274 320.450500,760.143005 318.822266,760.113586 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M812.630737,827.927429 
	C815.331482,823.471863 819.302002,823.458313 823.577515,827.371338 
	C820.200317,828.060364 816.835999,828.042786 812.630737,827.927429 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M238.913727,760.035400 
	C238.069183,759.175964 238.020309,758.332397 238.044006,756.845093 
	C240.693710,756.979736 243.270844,757.758118 245.961945,759.250549 
	C243.953735,759.993408 241.831558,760.022339 238.913727,760.035400 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M847.441223,522.222290 
	C847.284180,526.575317 843.965637,525.657898 840.462280,525.860840 
	C839.920044,520.720093 843.586731,521.826050 847.441223,522.222290 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M746.289917,834.108521 
	C748.298401,833.478760 750.287415,833.602417 753.028931,833.630859 
	C751.721680,839.090820 750.342224,839.334412 746.289917,834.108521 
z"
            />
            <path
                fill="#7F7F7F"
                opacity="1.000000"
                stroke="none"
                d="
M207.083344,832.390503 
	C208.506760,832.029907 209.598068,832.044800 211.507751,832.031677 
	C212.016586,832.966614 211.707047,833.929443 211.397491,834.892334 
	C209.848740,834.183533 208.299988,833.474731 207.083344,832.390503 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M383.053711,761.624634 
	C382.130768,761.429199 381.207855,761.233765 378.937195,760.606567 
	C377.471649,756.002930 377.353882,751.831116 377.618713,746.830017 
	C378.802612,746.550110 379.603882,747.099426 380.745178,749.153809 
	C381.741364,754.314087 382.397552,757.969360 383.053711,761.624634 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M785.634277,801.597290 
	C784.661316,800.546753 784.110901,799.202698 783.252075,797.198730 
	C784.948120,796.639465 786.952515,796.740112 789.617676,797.986633 
	C790.413086,799.513794 790.547852,799.895142 790.682556,800.276489 
	C790.682556,800.276489 790.119995,800.447205 789.977417,800.190125 
	C788.575500,800.390015 787.316162,800.846985 785.634277,801.597290 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M779.967529,805.246948 
	C780.839294,804.341003 781.890686,804.120239 783.491150,803.957642 
	C784.298096,805.029236 784.556030,806.042725 784.813904,807.056213 
	C783.258362,806.681519 781.702820,806.306824 779.967529,805.246948 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M733.036987,833.917969 
	C732.559021,831.929260 732.862793,829.726562 733.575439,827.029663 
	C735.962097,828.971924 736.806213,831.382263 733.036987,833.917969 
z"
            />
            <path
                fill="#3A3A3A"
                opacity="1.000000"
                stroke="none"
                d="
M531.177917,757.159485 
	C530.542603,757.950439 529.907288,758.741394 528.567078,759.821899 
	C527.627686,756.572449 527.393127,753.033569 527.411011,748.631836 
	C528.336548,747.794800 529.009705,747.820618 530.570251,748.701904 
	C531.364441,752.091370 531.271179,754.625427 531.177917,757.159485 
z"
            />
            <path
                fill="#9E9E9D"
                opacity="1.000000"
                stroke="none"
                d="
M646.780640,832.520386 
	C648.287537,832.269836 649.478149,832.461914 651.577637,832.651062 
	C650.690430,836.792786 648.678284,836.805786 646.780640,832.520386 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M726.498291,834.061829 
	C728.004883,833.643066 729.363464,833.918030 731.423096,834.217163 
	C731.206482,835.367554 730.288879,836.493774 729.371338,837.619995 
	C728.364319,836.665161 727.357300,835.710327 726.498291,834.061829 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M824.271729,834.017395 
	C825.741760,833.495605 827.151794,833.691772 829.275696,833.931458 
	C829.138611,835.176270 828.287781,836.377625 827.436890,837.578918 
	C826.361877,836.631042 825.286865,835.683228 824.271729,834.017395 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M389.802368,799.445435 
	C388.363068,800.176941 387.113281,800.207275 385.234406,800.226318 
	C385.385345,798.859375 386.165375,797.503601 386.945374,796.147766 
	C387.960907,797.013245 388.976410,797.878723 389.802368,799.445435 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M808.364136,833.737732 
	C808.634583,831.892395 809.644836,830.076111 811.241821,828.025513 
	C810.920288,829.783081 810.012085,831.774963 808.364136,833.737732 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M760.097229,824.544373 
	C761.520020,825.318054 762.855957,826.844482 764.351990,828.961426 
	C761.121765,830.133057 760.023376,828.289307 760.097229,824.544373 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M331.670288,767.873169 
	C332.203033,768.926575 332.236908,769.784058 332.216431,771.283081 
	C331.052246,771.719727 329.942413,771.514832 328.487457,770.850525 
	C328.118896,769.403503 328.095459,768.415894 328.255127,766.709717 
	C329.349274,766.553223 330.260345,767.115234 331.670288,767.873169 
z"
            />
            <path
                fill="#555555"
                opacity="1.000000"
                stroke="none"
                d="
M791.289917,800.267456 
	C790.547852,799.895142 790.413086,799.513794 790.132629,798.543579 
	C792.305298,796.108276 794.602356,794.400269 795.734985,799.506714 
	C794.314697,800.179382 793.105957,800.218933 791.289917,800.267456 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M233.431961,770.302246 
	C234.335709,769.885010 235.058640,769.825317 236.325806,769.760010 
	C236.637207,770.544983 236.404388,771.335693 236.171570,772.126343 
	C235.198105,771.637451 234.224625,771.148560 233.431961,770.302246 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M746.525574,811.915161 
	C747.385010,813.418274 747.569458,814.955750 747.753845,816.493164 
	C747.088562,817.051941 746.423340,817.610657 745.758057,818.169373 
	C745.018860,816.677063 744.279602,815.184753 743.363647,813.052795 
	C744.074829,812.258606 744.962646,812.104126 746.525574,811.915161 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M658.249451,770.350525 
	C659.085571,769.885925 659.848389,769.863342 661.177002,769.934021 
	C661.522644,770.721008 661.302551,771.414673 661.082397,772.108398 
	C660.113647,771.669800 659.144836,771.231140 658.249451,770.350525 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M605.817261,770.564880 
	C606.575989,769.965576 607.303467,769.875671 608.581543,769.792969 
	C609.115112,773.109375 607.885010,773.232666 605.817261,770.564880 
z"
            />
            <path
                fill="#9E9E9D"
                opacity="1.000000"
                stroke="none"
                d="
M652.288330,797.090759 
	C651.307495,797.733093 650.331726,797.801575 648.622314,797.875977 
	C648.406616,794.359985 649.985352,794.261719 652.288330,797.090759 
z"
            />
            <path
                fill="#616161"
                opacity="1.000000"
                stroke="none"
                d="
M610.348389,737.134399 
	C609.455017,737.783447 608.430298,737.844910 606.635742,737.930359 
	C606.144409,733.862000 607.903625,734.347839 610.348389,737.134399 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M258.348236,771.951904 
	C257.738861,771.026489 257.726013,770.174072 257.766846,768.683289 
	C258.268646,768.057739 258.716766,768.070557 259.831940,768.170288 
	C260.464661,769.079407 260.430298,769.901611 260.269653,771.328796 
	C259.743866,771.964111 259.344330,771.994507 258.348236,771.951904 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M1888.027954,752.951660 
	C1888.979614,752.201294 1889.576050,752.053467 1891.092896,751.959534 
	C1891.078979,753.970825 1890.411865,756.680481 1888.027954,752.951660 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M690.930908,796.060425 
	C691.180725,796.023499 690.718506,796.887573 690.263916,797.070068 
	C689.902771,796.720154 690.193359,796.335083 690.930908,796.060425 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M352.398682,765.692993 
	C352.874786,765.736328 353.259857,766.320312 353.561340,767.460205 
	C353.087708,767.421936 352.697662,766.827759 352.398682,765.692993 
z"
            />
            <path
                fill="#767676"
                opacity="1.000000"
                stroke="none"
                d="
M1887.284668,757.219971 
	C1886.767334,757.290344 1886.584351,757.044434 1886.401245,756.798584 
	C1886.807129,756.833618 1887.213013,756.868652 1887.284668,757.219971 
z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
M542.099854,551.678955 
	C541.020447,584.147888 517.707642,618.630676 480.272430,624.938843 
	C457.501984,628.775940 438.003998,621.815125 421.660309,606.515259 
	C387.202728,574.258484 386.982819,518.693970 424.850159,486.454987 
	C461.646210,455.128052 517.873474,470.769775 536.116699,516.663086 
	C540.476990,527.632080 542.870667,538.908508 542.099854,551.678955 
z"
            />
            <path
                fill="#FDFDFD"
                opacity="1.000000"
                stroke="none"
                d="
M2608.587891,613.205200 
	C2644.390869,635.993164 2657.721436,669.035461 2654.408447,709.273315 
	C2651.630371,743.013977 2635.844238,769.561951 2605.559570,785.812561 
	C2551.404297,814.872070 2484.781982,782.665405 2472.173828,721.612610 
	C2466.580322,694.525940 2469.814941,668.587097 2484.102051,644.524475 
	C2509.403320,601.911377 2560.513184,590.982849 2599.980469,608.699463 
	C2602.708496,609.924133 2605.317139,611.415527 2608.587891,613.205200 
z"
            />
            <path
                fill="#FDFDFD"
                opacity="1.000000"
                stroke="none"
                d="
M3181.668945,685.030396 
	C3183.166748,704.404297 3182.069336,722.558472 3174.331055,739.737366 
	C3158.181152,775.589722 3130.741699,795.735901 3091.113525,795.997192 
	C3051.306885,796.259644 3022.306641,777.267334 3005.999756,740.969727 
	C2992.265625,710.398865 2993.095703,679.161133 3008.729004,649.485901 
	C3026.320312,616.094543 3055.100098,599.275208 3092.758545,600.906006 
	C3132.962891,602.647034 3160.577148,623.817688 3175.580322,661.014099 
	C3178.532959,668.334290 3179.627441,676.403931 3181.668945,685.030396 
z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
M4138.257324,626.000122 
	C4138.257324,698.218628 4138.257324,769.437134 4138.257324,841.137268 
	C3930.254395,841.137268 3723.172607,841.137268 3515.510254,841.137268 
	C3515.510254,702.570923 3515.510254,564.464478 3515.510254,425.683411 
	C3722.860352,425.683411 3929.956543,425.683411 4138.257324,425.683411 
	C4138.257324,491.930237 4138.257324,558.465149 4138.257324,626.000122 
M3907.558350,770.649841 
	C3908.104980,770.821167 3908.651367,770.992493 3909.197998,771.163757 
	C3908.782471,770.790161 3908.366943,770.416565 3908.233643,768.413208 
	C3907.713623,766.854553 3907.353027,765.218750 3906.644287,763.751099 
	C3904.070557,758.420959 3904.827148,754.397522 3910.436523,751.426331 
	C3912.751953,750.199951 3914.482422,747.869019 3917.963379,744.680969 
	C3910.724365,744.274719 3905.624268,743.988525 3900.397705,743.695190 
	C3898.719238,738.895447 3897.150879,734.409790 3894.915039,728.015747 
	C3892.374756,734.429199 3890.607178,738.892334 3888.966797,743.034119 
	C3883.664307,745.797729 3877.641602,742.154663 3872.351074,745.722900 
	C3877.061279,749.697998 3881.234863,753.220337 3884.796143,756.225708 
	C3884.302734,762.005981 3880.445068,766.073608 3882.150879,771.647034 
	C3884.576172,770.012634 3886.697998,769.023315 3888.237305,767.460327 
	C3892.496094,763.136963 3896.281250,762.531738 3900.868896,767.276184 
	C3902.484131,768.946472 3905.715820,769.053711 3907.558350,770.649841 
M3884.063965,523.176331 
	C3883.086426,526.560791 3882.108887,529.945312 3880.549561,535.344421 
	C3886.705322,531.559265 3891.009521,528.912537 3895.351074,526.242859 
	C3899.647217,529.038086 3903.569336,531.589966 3909.429932,535.403137 
	C3908.156982,531.264954 3907.628906,529.475037 3907.056396,527.699402 
	C3904.312012,519.191711 3904.326416,519.216492 3911.124756,513.803650 
	C3912.993896,512.315186 3914.715820,510.641754 3917.834229,507.873627 
	C3911.098389,507.494324 3906.254150,507.221527 3901.259766,506.940277 
	C3899.243164,502.056213 3897.340332,497.447815 3894.800537,491.296814 
	C3892.506104,497.805878 3890.878662,502.422943 3888.915283,507.992676 
	C3883.555908,507.992676 3878.272217,507.992676 3871.015381,507.992676 
	C3876.557617,512.165222 3880.348145,514.798462 3883.817627,517.802307 
	C3884.583252,518.465332 3884.211914,520.441223 3884.063965,523.176331 
M3953.241699,581.613770 
	C3954.571289,582.419922 3955.900879,583.226074 3958.795654,584.981079 
	C3957.691406,580.640564 3957.287842,577.800049 3956.243408,575.218933 
	C3954.280273,570.368652 3955.307373,566.972168 3960.007080,564.428711 
	C3962.460938,563.100586 3964.546631,561.092163 3968.666016,557.980347 
	C3961.413330,557.593384 3956.557129,557.334290 3951.441406,557.061340 
	C3949.395508,552.244690 3947.405273,547.558838 3944.821289,541.475525 
	C3942.336182,547.742188 3940.441650,552.519958 3938.387939,557.699097 
	C3932.743164,557.699097 3927.853760,557.699097 3920.872803,557.699097 
	C3926.872070,562.418335 3931.193359,565.817688 3935.210449,568.977600 
	C3933.843750,573.957397 3932.578125,578.569275 3930.723633,585.326599 
	C3936.500000,581.484619 3940.265381,578.980164 3944.539795,576.137085 
	C3947.000244,577.583923 3949.515137,579.062622 3953.241699,581.613770 
M3769.482178,760.431824 
	C3767.040039,756.623047 3769.152588,754.694519 3772.158447,752.421082 
	C3774.932861,750.322632 3779.792236,749.646729 3779.433594,743.916809 
	C3774.195068,743.916809 3769.278320,743.916809 3764.345703,743.916809 
	C3762.349854,739.161560 3760.534912,734.837585 3758.021484,728.849487 
	C3755.560303,735.168152 3753.836670,739.593018 3752.190186,743.820679 
	C3746.534424,744.092041 3741.491699,744.333984 3734.353516,744.676514 
	C3740.072021,749.307617 3744.042725,752.523438 3748.298340,755.969788 
	C3746.975098,761.173157 3745.703613,766.172485 3744.125488,772.377869 
	C3749.689453,768.752319 3754.285156,765.757507 3758.418945,763.063965 
	C3763.052490,766.174377 3767.126709,768.909180 3773.122559,772.933777 
	C3771.534668,767.622681 3770.702881,764.840210 3769.482178,760.431824 
M3690.086914,694.095703 
	C3688.773193,694.492798 3687.459473,694.889893 3685.280273,695.548523 
	C3690.270264,699.527954 3694.323486,702.760315 3698.299316,705.930847 
	C3696.789062,711.019409 3695.509277,715.330750 3693.482666,722.159485 
	C3699.824951,718.288818 3704.139160,715.655823 3708.417236,713.044861 
	C3712.436768,715.756653 3716.367676,718.408630 3722.334229,722.433838 
	C3720.578125,715.297058 3719.425781,710.613037 3718.228760,705.748352 
	C3722.153076,702.477234 3726.026367,699.248840 3731.508301,694.679626 
	C3724.091064,694.213684 3719.005615,693.894287 3714.070068,693.584229 
	C3712.141113,688.826416 3710.465576,684.693298 3708.020020,678.661804 
	C3705.534424,685.007324 3703.805176,689.421509 3701.976074,694.090820 
	C3698.365234,694.090820 3695.048828,694.090820 3690.086914,694.095703 
M3753.049561,529.159668 
	C3755.013672,528.064087 3756.977539,526.968567 3758.536865,526.098816 
	C3762.974609,529.166992 3766.904053,531.883728 3772.479736,535.738647 
	C3770.532959,528.862549 3769.137695,523.934509 3767.750000,519.033752 
	C3772.210938,515.562683 3776.159180,512.490295 3781.978516,507.962006 
	C3774.426514,507.538025 3769.576416,507.265717 3764.489014,506.980103 
	C3762.499756,502.450653 3760.595703,498.114777 3758.009033,492.224182 
	C3755.565674,498.255493 3753.787109,502.646240 3751.713623,507.764526 
	C3746.433105,507.764526 3741.333740,507.764526 3734.170654,507.764526 
	C3740.005859,512.404541 3744.089844,515.652222 3748.284912,518.988098 
	C3746.792969,524.042480 3745.350342,528.929932 3743.358154,535.679016 
	C3747.450439,533.085754 3749.659424,531.685913 3753.049561,529.159668 
M3696.982422,573.941467 
	C3696.111328,577.337585 3695.240234,580.733704 3694.098877,585.184021 
	C3699.616699,581.704956 3704.035156,578.918884 3708.247314,576.263000 
	C3712.851562,579.277649 3716.849121,581.895020 3722.064209,585.309631 
	C3720.479980,578.772644 3719.266846,573.765930 3718.097168,568.939880 
	C3722.271973,565.537109 3726.077637,562.434998 3729.883301,559.332886 
	C3729.562256,558.676453 3729.241211,558.019958 3728.920166,557.363525 
	C3724.075195,557.363525 3719.230225,557.363525 3714.492188,557.363525 
	C3712.307617,552.286255 3710.458252,547.987671 3707.902344,542.047546 
	C3705.369629,548.551331 3703.634521,553.006836 3702.050781,557.073303 
	C3696.147461,557.416870 3691.182861,557.705750 3684.191162,558.112610 
	C3689.238525,561.919617 3692.311523,564.397766 3695.554688,566.628967 
	C3697.798096,568.172241 3698.589600,569.937134 3696.982422,573.941467 
M3969.879639,626.051086 
	C3967.625244,621.085815 3965.370850,616.120544 3962.508789,609.817383 
	C3960.305664,616.368286 3958.669678,621.232056 3957.043457,626.067383 
	C3951.509521,626.318054 3946.527588,626.543762 3940.161621,626.832092 
	C3945.569824,631.304993 3949.531738,634.581665 3953.139160,637.565002 
	C3951.603516,642.844360 3950.359131,647.122559 3949.114746,651.400757 
	C3949.587891,651.839783 3950.061035,652.278809 3950.534180,652.717896 
	C3954.721191,649.905701 3958.908447,647.093506 3963.020996,644.331421 
	C3967.356445,647.177551 3971.530762,649.918091 3975.705078,652.658569 
	C3976.164551,652.189209 3976.624268,651.719788 3977.083740,651.250427 
	C3975.761230,646.697998 3974.438721,642.145569 3973.041992,637.337585 
	C3977.191650,633.935242 3981.063965,630.760132 3986.479736,626.319702 
	C3980.017090,626.319702 3975.777100,626.319702 3969.879639,626.051086 
M3701.937012,644.747375 
	C3701.193604,642.269348 3700.450195,639.791382 3699.755371,637.475769 
	C3703.810303,634.123657 3707.474121,631.094727 3712.646240,626.819031 
	C3705.567383,626.423279 3700.522217,626.141235 3695.885498,625.882019 
	C3693.741943,620.352783 3691.938477,615.700317 3689.601562,609.671753 
	C3687.106689,616.396973 3685.293701,621.284363 3683.316650,626.613464 
	C3678.292236,626.613464 3673.845947,626.613464 3669.399658,626.613464 
	C3669.142822,627.161377 3668.885986,627.709229 3668.628906,628.257141 
	C3672.307129,631.236023 3675.985107,634.214844 3679.651367,637.184143 
	C3678.415039,642.229065 3677.227783,647.072815 3675.598633,653.720398 
	C3681.552490,649.826599 3685.639648,647.153503 3689.894287,644.370972 
	C3694.112061,647.257385 3698.047607,649.950623 3702.102295,652.725281 
	C3702.832764,651.154907 3703.394043,650.530273 3703.316406,649.999207 
	C3703.128174,648.716187 3702.641846,647.476929 3701.937012,644.747375 
M3935.412109,719.284424 
	C3936.253174,718.761780 3937.124756,718.282104 3937.930908,717.710144 
	C3945.128662,712.603088 3945.107666,712.622986 3952.357178,717.735596 
	C3953.986084,718.884338 3955.784912,719.792114 3958.649658,721.488098 
	C3958.193848,718.624512 3958.144287,717.326111 3957.771240,716.128662 
	C3954.605225,705.968262 3954.611084,706.002197 3962.984619,699.277283 
	C3964.271484,698.243835 3965.233154,696.805481 3967.307373,694.471558 
	C3960.576172,694.158081 3955.438721,693.918823 3950.802734,693.702881 
	C3948.875000,688.550781 3947.242676,684.187805 3945.610107,679.824890 
	C3945.013428,679.903198 3944.416504,679.981506 3943.819824,680.059875 
	C3942.166260,684.595520 3940.512695,689.131165 3938.869873,693.637573 
	C3933.262695,693.985779 3928.222412,694.298767 3921.077393,694.742493 
	C3927.015137,699.473206 3931.227295,702.829041 3935.389893,706.145508 
	C3934.064941,710.056458 3932.713135,713.427246 3931.889404,716.922424 
	C3931.689697,717.769470 3933.232910,719.027161 3935.412109,719.284424 
M3836.568359,788.274963 
	C3837.504150,788.555786 3838.439941,788.836609 3840.043213,789.317810 
	C3838.842041,783.925964 3837.723877,778.907043 3836.639648,774.041565 
	C3840.635742,770.740845 3844.195801,767.800171 3848.884033,763.927795 
	C3842.402832,763.571411 3837.576660,763.305969 3832.888428,763.048157 
	C3830.804199,757.654053 3828.998291,752.979736 3826.375000,746.190125 
	C3823.708008,753.303711 3821.818848,758.342957 3820.017090,763.148987 
	C3815.037842,763.501892 3810.675537,763.811096 3804.376221,764.257568 
	C3809.464355,768.384583 3812.925049,771.191711 3816.708984,774.260925 
	C3815.219482,779.424927 3813.794678,784.364197 3811.954102,790.744995 
	C3817.734863,787.033386 3822.276123,784.117615 3826.878906,781.162415 
	C3830.057373,783.545349 3832.686523,785.516174 3836.568359,788.274963 
M3838.822754,509.925598 
	C3837.914062,506.807739 3837.005615,503.689911 3836.155518,500.773224 
	C3840.360840,497.422241 3844.118164,494.428314 3849.313965,490.288147 
	C3842.654297,489.871887 3837.888916,489.574005 3832.871094,489.260345 
	C3830.930908,484.141602 3829.086426,479.275452 3826.616211,472.758911 
	C3824.161865,479.253784 3822.244385,484.327515 3820.339600,489.367737 
	C3815.063965,489.681305 3810.328369,489.962799 3804.014648,490.338074 
	C3809.124756,494.568817 3812.849365,497.652496 3816.691406,500.833405 
	C3815.148926,506.005280 3813.766602,510.638824 3811.860352,517.030029 
	C3817.974365,513.183105 3822.532959,510.314789 3826.854004,507.595947 
	C3831.248535,510.744476 3835.053711,513.470886 3840.589600,517.437195 
	C3839.818115,513.803467 3839.560547,512.589661 3838.822754,509.925598 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M2368.524170,455.624756 
	C2365.049072,448.594757 2366.439453,441.833221 2366.944824,434.301147 
	C2370.246338,434.132111 2373.130371,433.700409 2375.971436,433.895508 
	C2382.822266,434.365936 2385.936035,437.412964 2386.276611,443.502167 
	C2386.637207,449.953888 2383.432373,454.520813 2377.220459,455.747040 
	C2374.674805,456.249542 2371.962891,455.909119 2368.524170,455.624756 
z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
M2312.139648,482.567261 
	C2295.221924,490.759888 2282.479248,484.462067 2280.573975,466.883911 
	C2279.848389,460.190826 2280.862793,452.861938 2282.936768,446.419159 
	C2285.936768,437.099640 2294.854492,432.753784 2304.426514,434.204926 
	C2312.585693,435.441925 2319.143799,442.182709 2319.999756,451.316315 
	C2321.026367,462.268921 2322.008301,473.437042 2312.139648,482.567261 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M2659.411621,467.202759 
	C2659.692871,462.429535 2660.536865,457.999969 2661.786377,453.688019 
	C2663.157959,448.955902 2664.903809,444.332214 2666.885742,438.482788 
	C2669.007080,444.131348 2670.792969,448.623291 2672.378418,453.185059 
	C2673.860107,457.449371 2675.128662,461.787811 2676.967285,467.598236 
	C2670.430664,467.598236 2665.291748,467.598236 2659.411621,467.202759 
z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
M2229.475830,433.824524 
	C2239.950928,436.405457 2243.424805,440.952393 2241.858398,448.945312 
	C2240.367432,456.553864 2233.316650,460.252411 2222.291504,458.486908 
	C2222.291504,451.803711 2222.257568,444.924591 2222.303711,438.046082 
	C2222.333496,433.624298 2225.587891,433.834167 2229.475830,433.824524 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1478.941895,764.551147 
	C1476.022827,759.265259 1475.637207,754.500549 1477.955688,749.642639 
	C1479.679443,746.030640 1482.504517,744.084045 1486.569214,744.052185 
	C1490.767090,744.019226 1493.598755,746.246826 1494.825684,749.975525 
	C1495.729248,752.721191 1496.275269,755.838135 1495.971191,758.681641 
	C1494.916260,768.544495 1487.633789,771.280396 1478.941895,764.551147 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M658.485962,124.188797 
	C644.183350,118.439194 639.434326,98.615845 648.929504,87.585823 
	C655.513550,79.937386 667.479370,80.825119 672.529236,89.847061 
	C677.339478,98.440994 677.452332,107.709641 673.195923,116.610268 
	C670.527588,122.189888 665.564331,124.684883 658.485962,124.188797 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M805.438538,118.208138 
	C801.105835,110.771873 801.144775,103.448502 802.677490,96.192024 
	C804.376831,88.146690 810.994934,82.507599 817.804504,82.481270 
	C824.947510,82.453651 830.865967,87.636795 832.407715,96.328148 
	C833.201294,100.801659 833.319519,105.669350 832.461182,110.111237 
	C829.636658,124.727928 817.645447,128.528702 805.438538,118.208138 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M583.173889,116.201035 
	C584.309265,110.660187 588.050415,109.175926 592.066345,108.437683 
	C598.584961,107.239357 605.166199,106.381546 611.707275,105.382088 
	C613.582214,114.779106 610.671753,120.279007 602.420959,123.250160 
	C593.983459,126.288551 587.325012,124.151291 583.173889,116.201035 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M388.692078,108.128281 
	C395.327789,107.111679 401.128662,106.209152 407.381439,105.236313 
	C409.016846,112.004898 407.225494,117.221649 401.808960,120.965141 
	C395.970520,125.000175 389.355621,125.436234 382.902710,123.096848 
	C380.871765,122.360580 378.412079,119.301819 378.427002,117.323219 
	C378.445251,114.902039 380.504730,112.162262 382.363281,110.208809 
	C383.560760,108.950241 385.983582,108.857559 388.692078,108.128281 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M482.003815,740.239685 
	C486.643341,741.107666 487.309235,744.681946 485.363159,747.612183 
	C484.148560,749.441040 480.469299,750.226807 477.829559,750.387451 
	C472.884705,750.688232 473.195343,746.854126 474.294037,742.550354 
	C477.473816,741.185181 479.738831,740.712463 482.003815,740.239685 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M510.547668,756.484375 
	C512.087585,752.708923 513.820862,749.680664 516.117004,745.669006 
	C519.089722,750.209961 518.168335,753.748962 517.592102,757.973938 
	C514.998108,757.692810 512.869568,757.462158 510.547668,756.484375 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M481.642029,739.636780 
	C479.738831,740.712463 477.473816,741.185181 474.477020,741.658447 
	C474.925446,736.962219 477.939880,737.530212 481.642029,739.636780 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M225.366638,86.602020 
	C232.471588,94.695000 232.777771,103.398773 230.155609,112.423737 
	C227.732773,120.762711 221.524338,124.827225 212.914520,124.234947 
	C205.232910,123.706512 199.524063,118.571983 198.104126,110.536682 
	C197.588745,107.620216 197.515244,104.577957 197.622986,101.606979 
	C198.228394,84.910446 209.796280,78.337662 225.366638,86.602020 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M866.910156,87.104210 
	C881.832764,78.271706 894.391541,84.562347 895.403992,100.834503 
	C895.665405,105.036125 895.011047,109.507141 893.767944,113.543533 
	C891.526367,120.822105 885.488892,124.501984 877.727112,124.260674 
	C870.228455,124.027557 864.051819,119.703232 862.545654,112.295593 
	C860.817322,103.795135 860.051697,95.084595 866.910156,87.104210 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M738.773071,113.881424 
	C732.659485,123.353638 726.932617,126.022781 718.632935,123.832634 
	C711.970398,122.074486 707.181824,115.990791 706.547668,107.293510 
	C706.240845,103.085495 706.642090,98.629669 707.734802,94.557602 
	C709.850647,86.672356 716.245850,82.221352 723.879272,82.439423 
	C731.708313,82.663078 738.626709,88.189072 739.667725,96.377899 
	C740.364258,101.856422 739.374512,107.549324 738.773071,113.881424 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1560.028809,819.509766 
	C1557.145264,824.340759 1553.599365,826.335205 1548.771606,824.463440 
	C1544.177368,822.682068 1542.461182,818.751953 1542.135010,814.179077 
	C1541.791870,809.368286 1542.405151,804.704651 1546.830322,801.752136 
	C1551.754395,798.466736 1558.966553,801.024597 1560.395142,807.052795 
	C1561.272217,810.753296 1560.386108,814.871704 1560.028809,819.509766 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M4537.998047,534.144287 
	C4538.549805,532.131897 4539.030273,530.150513 4539.650879,530.105652 
	C4543.917480,529.797302 4548.220215,529.727417 4552.496582,529.911255 
	C4556.062500,530.064453 4557.766602,532.461853 4557.820801,535.832764 
	C4557.874512,539.185120 4556.270508,541.753723 4552.741699,541.986206 
	C4548.196777,542.285645 4543.616211,542.059143 4538.440430,542.059143 
	C4538.274902,539.483398 4538.133301,537.277405 4537.998047,534.144287 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M4596.692383,528.563477 
	C4604.860352,528.156250 4609.781250,531.797974 4611.301270,538.784851 
	C4612.948730,546.356079 4613.343262,554.221680 4607.062988,560.299744 
	C4601.656250,565.531738 4593.282715,564.460388 4588.671387,558.303589 
	C4581.985352,549.375366 4585.752930,534.002625 4596.692383,528.563477 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M4391.796875,561.989502 
	C4380.782715,564.595825 4374.440918,561.206360 4372.953613,551.555786 
	C4372.226074,546.831848 4372.797363,541.631287 4373.995605,536.958069 
	C4375.455078,531.266663 4380.412109,528.296997 4385.932617,528.357422 
	C4391.428223,528.417664 4396.273926,531.619995 4397.811035,537.181519 
	C4400.287109,546.140137 4400.675293,554.901001 4391.796875,561.989502 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M180.588760,945.287720 
	C187.831024,935.507996 194.905655,932.643494 203.802612,935.308228 
	C212.620895,937.949402 217.815536,944.969299 217.915512,955.724609 
	C217.960556,960.571716 217.363998,965.736633 215.650909,970.219421 
	C212.620255,978.149841 205.943069,981.722534 197.570740,981.525391 
	C189.616226,981.338135 183.587494,977.597656 180.394577,970.178589 
	C176.965652,962.211121 177.108841,954.079041 180.588760,945.287720 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4756.476074,535.557495 
	C4759.267090,540.195740 4761.679688,545.439148 4764.427246,551.410645 
	C4759.337891,551.410645 4755.742188,551.410645 4750.915039,551.410645 
	C4752.783203,545.914490 4754.440430,541.038574 4756.476074,535.557495 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4333.257324,536.293640 
	C4336.243652,540.562134 4338.728027,545.329834 4341.797363,551.219727 
	C4336.140137,551.219727 4332.377930,551.219727 4327.833496,551.219727 
	C4329.590820,546.068848 4331.172852,541.430847 4333.257324,536.293640 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1031.260498,950.627930 
	C1033.810425,952.606628 1036.313599,954.097839 1037.283447,956.272766 
	C1039.143188,960.443298 1036.701660,965.192505 1032.577271,966.912292 
	C1027.997681,968.821960 1022.753906,966.810242 1020.869568,962.420715 
	C1019.050171,958.182373 1020.478149,953.655212 1024.762817,951.466431 
	C1026.422363,950.618652 1028.586792,950.758972 1031.260498,950.627930 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1037.832153,994.798889 
	C1032.607666,995.420105 1027.950439,996.249023 1023.573669,995.480957 
	C1021.508484,995.118530 1019.980957,991.693115 1018.209778,989.655518 
	C1020.299072,987.896057 1022.175537,985.095825 1024.526367,984.615051 
	C1028.276245,983.848328 1032.430542,984.147766 1036.253174,984.859070 
	C1042.115356,985.949768 1042.548218,988.363647 1037.832153,994.798889 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M840.120361,935.761475 
	C843.352661,935.762573 845.696167,935.600647 847.997070,935.842896 
	C854.976440,936.577637 858.493469,940.103821 858.860840,946.489258 
	C859.221313,952.756348 856.037354,957.648315 849.728516,958.861938 
	C845.678223,959.641052 841.356201,959.008057 836.329956,959.008057 
	C836.329956,951.782288 836.240356,944.880432 836.456604,937.988159 
	C836.480530,937.225159 838.251465,936.516968 840.120361,935.761475 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M509.267883,959.595337 
	C506.117218,959.601379 503.813812,959.601379 500.865051,959.601379 
	C500.865051,951.670776 500.865051,944.215027 500.865051,935.752258 
	C504.216309,935.752258 507.445831,935.616943 510.660278,935.779419 
	C518.118530,936.156433 521.727905,939.051331 522.678833,945.188721 
	C523.712036,951.856934 521.005859,956.205566 514.015198,958.875244 
	C512.801331,959.338806 511.419434,959.362427 509.267883,959.595337 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M4435.159180,707.232544 
	C4435.432617,710.949463 4435.872070,713.991882 4435.325195,716.845215 
	C4434.592773,720.664612 4432.281738,723.750305 4427.911133,723.427734 
	C4424.202637,723.154053 4422.036621,720.575867 4421.561035,716.867554 
	C4421.268555,714.588074 4420.568848,712.025452 4421.284180,710.032166 
	C4422.312500,707.166321 4423.875000,703.628052 4426.270508,702.317505 
	C4429.936523,700.311829 4433.236328,702.486938 4435.159180,707.232544 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M4334.813965,722.257935 
	C4328.771973,724.818420 4326.024414,721.977356 4324.500488,717.365479 
	C4322.722656,711.979797 4324.437012,704.915955 4327.789062,702.756409 
	C4331.616699,700.290771 4336.596680,702.154053 4337.856934,706.950684 
	C4339.217285,712.132141 4339.630371,717.408997 4334.813965,722.257935 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4639.424805,542.956665 
	C4638.976562,538.301941 4638.976562,534.395691 4638.976562,529.853271 
	C4643.327637,529.853271 4646.930664,529.563660 4650.464844,529.931030 
	C4654.350586,530.334839 4656.137695,533.064941 4656.164551,536.852722 
	C4656.191406,540.599304 4654.543945,543.542664 4650.679688,543.964478 
	C4647.129395,544.351807 4643.479004,543.827637 4639.424805,542.956665 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M260.552490,974.015381 
	C257.750336,979.681824 253.483398,980.720276 248.537842,980.151001 
	C247.253784,980.003235 245.779327,979.799683 244.789780,979.077332 
	C237.643127,973.860229 241.662094,966.293884 241.238068,959.806458 
	C240.907501,954.748901 245.288467,952.628906 249.806320,951.868225 
	C256.340851,950.768066 260.884735,953.831055 261.670410,960.580872 
	C262.152893,964.726074 261.219696,969.036072 260.552490,974.015381 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M1319.064453,959.519958 
	C1321.676636,952.281982 1326.820435,950.926758 1332.850708,952.078125 
	C1337.659058,952.996155 1339.927856,957.330994 1340.072754,964.650574 
	C1340.288452,975.543030 1335.683716,981.058411 1327.058960,980.237671 
	C1321.672363,979.724976 1319.360596,977.585205 1319.027344,972.217590 
	C1318.782471,968.273682 1318.983276,964.302063 1319.064453,959.519958 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M2389.761230,978.015137 
	C2379.839111,981.333130 2376.534912,980.621155 2373.774658,975.191406 
	C2370.429443,968.611023 2371.868164,957.821411 2376.677734,953.929993 
	C2380.433350,950.891174 2384.723389,951.106750 2388.881836,952.620789 
	C2392.981201,954.113281 2393.777100,957.743286 2393.294922,961.607849 
	C2392.626709,966.962830 2395.502441,972.975525 2389.761230,978.015137 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M692.967957,971.155396 
	C692.963928,967.682129 692.866821,965.038574 692.982300,962.404297 
	C693.287903,955.433594 696.566528,952.045959 703.166931,951.736511 
	C709.291931,951.449402 713.069580,954.258728 713.661682,960.971863 
	C714.053223,965.411133 713.484314,970.199402 712.153076,974.458679 
	C710.539307,979.621460 705.823669,980.699951 700.821716,980.209106 
	C695.870117,979.723022 692.836914,977.356567 692.967957,971.155396 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M1619.660889,976.054077 
	C1619.192383,970.691772 1618.847900,966.071594 1619.030151,961.472290 
	C1619.262939,955.594116 1622.370483,952.514893 1628.124634,951.809875 
	C1634.122070,951.074951 1637.741333,953.232727 1639.307129,958.997253 
	C1639.984863,961.492737 1640.119751,964.220886 1640.026245,966.826233 
	C1639.565674,979.654175 1631.142334,983.815002 1619.660889,976.054077 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1008.200867,815.730408 
	C1011.330444,803.829956 1020.137207,799.690918 1027.572510,805.884033 
	C1031.421387,809.089966 1033.255737,813.112366 1031.871460,818.163574 
	C1030.525269,823.075806 1027.116943,826.211365 1022.337585,827.213867 
	C1017.868652,828.151123 1013.789062,826.500000 1011.084106,822.670898 
	C1009.798462,820.850891 1009.156433,818.576172 1008.200867,815.730408 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M925.512085,977.852966 
	C919.044189,981.287720 913.374268,981.703979 908.808899,976.226746 
	C904.822449,971.443970 905.077393,960.466064 908.891113,955.584839 
	C913.995483,949.051697 925.258850,950.681152 928.364563,958.577759 
	C930.936218,965.116394 930.503906,971.510986 925.512085,977.852966 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M432.048309,964.381836 
	C433.836914,960.151306 434.798065,955.807495 437.500763,953.535156 
	C443.049316,948.870300 452.256073,951.896484 454.363617,958.941101 
	C455.537903,962.866333 455.655487,967.442810 454.969574,971.510010 
	C453.969116,977.442017 450.314148,979.986755 444.662354,980.240051 
	C438.299988,980.525269 434.703552,978.174927 432.830200,972.046753 
	C432.169373,969.884949 432.261047,967.493042 432.048309,964.381836 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M2751.758301,964.387451 
	C2751.409180,967.793030 2751.395996,970.521362 2750.532959,972.947144 
	C2748.165527,979.598816 2740.605957,982.434814 2734.297119,979.319641 
	C2728.925537,976.667358 2726.334229,967.406494 2728.832764,959.789978 
	C2730.952637,953.326477 2735.875488,950.548645 2742.798340,951.941406 
	C2749.146729,953.218689 2750.810303,958.106995 2751.758301,964.387451 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M2431.194824,952.003052 
	C2439.918945,957.922729 2442.262939,967.632996 2437.599121,975.318237 
	C2433.793457,981.590088 2423.135986,982.345642 2418.932617,976.341614 
	C2415.048096,970.793091 2415.093750,964.542664 2417.431152,958.344849 
	C2419.720459,952.274170 2424.687500,951.270020 2431.194824,952.003052 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M1701.600342,980.185791 
	C1695.207520,980.643372 1691.009888,978.599426 1689.193604,973.097168 
	C1687.134766,966.859985 1687.092285,960.602051 1691.325928,955.195435 
	C1695.295776,950.125854 1704.872437,950.510010 1708.855225,955.574097 
	C1715.059204,963.462341 1711.844238,975.714600 1701.600342,980.185791 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M891.642456,820.081787 
	C891.095947,817.445923 890.436035,815.427856 890.726868,813.557739 
	C891.743103,807.023682 896.861145,802.847656 903.151184,803.040161 
	C908.556946,803.205627 913.192139,807.223938 914.275391,812.683838 
	C915.468933,818.699036 911.996643,825.026184 906.176758,826.993958 
	C899.644592,829.202698 895.432922,825.745667 891.642456,820.081787 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4467.845215,709.662231 
	C4464.759766,709.485657 4462.525879,709.304993 4460.330566,709.127502 
	C4459.590332,704.473145 4461.708496,701.910522 4465.520020,701.960083 
	C4467.679199,701.988098 4470.541016,703.693909 4471.777344,705.527100 
	C4473.520996,708.111450 4471.780762,709.773560 4467.845215,709.662231 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4606.158203,709.665894 
	C4603.734375,709.543213 4602.153320,709.420715 4600.397461,709.284607 
	C4599.521484,704.583496 4601.547852,702.171997 4605.729492,701.811279 
	C4610.083008,701.435669 4612.087402,703.972473 4612.528809,708.910889 
	C4610.495605,709.188782 4608.748535,709.427490 4606.158203,709.665894 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M1800.611328,954.778564 
	C1809.626709,950.590759 1814.506348,951.076843 1818.031860,955.838440 
	C1821.522461,960.553162 1821.368042,971.982300 1817.821167,976.549805 
	C1815.029663,980.144592 1811.181519,980.456421 1807.113159,980.196594 
	C1802.657471,979.912109 1799.641724,977.503845 1798.300781,973.412781 
	C1796.274414,967.229797 1796.314941,961.098145 1800.611328,954.778564 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4682.150391,715.960327 
	C4678.618164,725.169861 4676.105957,725.691833 4670.405273,718.870483 
	C4673.525879,715.159851 4677.007812,712.887146 4682.150391,715.960327 
z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
M1149.709229,971.118713 
	C1149.623413,967.020508 1149.227295,963.669373 1149.888062,960.541504 
	C1151.239136,954.145630 1154.671875,951.710693 1161.061768,951.764832 
	C1167.282959,951.817444 1170.767334,954.607910 1172.014404,960.871277 
	C1172.459229,963.106079 1172.587769,965.461365 1172.466919,967.740845 
	C1172.070190,975.222656 1169.148315,979.146423 1163.521729,980.116943 
	C1156.865479,981.265137 1153.834961,979.454956 1149.709229,971.118713 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1324.259033,827.526306 
	C1319.072021,826.486694 1315.527832,824.455505 1313.695557,819.966187 
	C1311.336182,814.185364 1313.483765,807.528992 1318.876587,804.511780 
	C1324.375122,801.435486 1330.215210,802.455444 1334.102661,807.170715 
	C1338.297974,812.259583 1338.389893,818.912354 1333.612061,823.261841 
	C1331.322876,825.345764 1327.910645,826.196106 1324.259033,827.526306 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1985.724854,970.591187 
	C1984.983276,979.143738 1981.089111,983.010864 1974.189575,982.116272 
	C1972.045898,981.838257 1968.991455,979.948730 1968.469482,978.174561 
	C1967.924438,976.322205 1969.307983,972.521729 1970.939453,971.675110 
	C1975.382812,969.369385 1980.227051,966.596802 1985.724854,970.591187 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M2315.289551,971.134949 
	C2318.814453,969.969299 2321.654541,969.150330 2324.541260,968.559204 
	C2325.792480,968.302979 2327.140137,968.516235 2328.404053,968.516235 
	C2330.689209,977.267090 2328.237549,981.699768 2320.364746,982.064087 
	C2317.823486,982.181702 2314.396240,981.030151 2312.795166,979.209595 
	C2310.655273,976.776917 2311.888672,973.642212 2315.289551,971.134949 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1219.805664,982.257141 
	C1215.282715,982.416626 1212.366943,981.299316 1211.988159,977.135437 
	C1211.626465,973.158813 1214.214478,971.079163 1217.607544,970.145203 
	C1221.037964,969.200867 1224.597168,968.724487 1228.030151,968.056763 
	C1231.111694,977.619629 1230.688599,978.378845 1219.805664,982.257141 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M428.363403,810.445435 
	C429.814026,803.680908 431.423615,802.532898 435.731873,804.300232 
	C443.510162,807.491028 445.475861,818.791382 438.960754,824.060608 
	C436.769165,825.833130 433.838684,826.692078 431.209717,827.986450 
	C426.152252,822.507568 429.311401,816.595520 428.363403,810.445435 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M734.921570,973.275391 
	C740.024292,968.981079 745.307800,968.264771 750.873535,968.594910 
	C752.159058,978.204712 749.563843,981.853455 741.651794,982.261780 
	C735.917908,982.557739 734.764465,981.221985 734.921570,973.275391 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M4568.064453,701.757568 
	C4575.793457,705.478394 4578.670410,712.534363 4575.053711,718.622925 
	C4573.738770,720.836304 4570.552734,723.178040 4568.208496,723.190308 
	C4565.872559,723.202637 4562.712402,720.876770 4561.332520,718.683411 
	C4557.506836,712.602783 4560.163086,705.788391 4568.064453,701.757568 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M4378.834473,705.686035 
	C4379.530762,709.646790 4380.241699,712.972107 4379.878906,716.175781 
	C4379.370605,720.661682 4375.634766,723.826111 4371.896973,723.501404 
	C4367.748047,723.140930 4365.461426,720.432983 4364.337402,716.656494 
	C4362.822266,711.568420 4364.362793,705.169312 4367.872559,703.032349 
	C4371.810059,700.635010 4375.444824,701.270203 4378.834473,705.686035 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1141.947754,802.831543 
	C1146.359131,803.461914 1149.528564,804.885071 1148.055786,809.262939 
	C1146.778442,813.059448 1143.219849,812.270325 1140.392700,811.424805 
	C1136.388062,810.227356 1136.675659,807.544922 1141.947754,802.831543 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1068.930054,827.257385 
	C1067.378174,826.731445 1065.993530,826.170654 1065.981201,825.581116 
	C1065.831421,818.452454 1065.884155,811.319580 1065.884155,804.003845 
	C1073.341187,803.156311 1077.340332,806.035156 1079.461548,811.520325 
	C1081.473022,816.721802 1079.555664,821.469482 1074.256836,825.200012 
	C1072.933716,826.131531 1071.251953,826.553162 1068.930054,827.257385 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1567.812256,961.652283 
	C1563.366211,961.652344 1559.804810,961.652344 1556.124390,961.652344 
	C1557.439087,953.407349 1560.372803,950.384888 1566.402466,950.387207 
	C1572.072876,950.389465 1574.502930,952.882996 1576.221313,961.143616 
	C1573.654785,961.317139 1571.175903,961.484680 1567.812256,961.652283 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1493.780273,958.872437 
	C1495.979736,952.140808 1500.420654,949.650940 1506.344360,950.597412 
	C1511.466431,951.415833 1514.456055,954.678955 1514.348877,961.193848 
	C1507.233643,960.975037 1500.367798,963.859192 1493.780273,958.872437 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M2192.042236,957.059387 
	C2192.648438,960.309326 2191.772461,961.643799 2189.156738,961.630676 
	C2183.551514,961.602539 2177.946533,961.621948 2172.060059,961.621948 
	C2171.288574,955.355652 2174.472412,952.300049 2179.289795,950.900513 
	C2184.678223,949.335022 2189.108398,951.032288 2192.042236,957.059387 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M4706.725586,712.064636 
	C4707.286621,709.412476 4707.558594,707.375183 4708.474121,705.687012 
	C4709.209961,704.331543 4710.547852,703.053467 4711.928711,702.344910 
	C4715.875977,700.319214 4720.358398,702.336365 4722.389648,706.780151 
	C4725.006836,712.505554 4723.182617,720.019836 4718.549805,722.594543 
	C4714.604492,724.787292 4710.471680,723.322815 4708.076660,718.541016 
	C4707.223145,716.837585 4707.145996,714.745056 4706.725586,712.064636 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M349.215820,827.047424 
	C345.904633,823.282715 345.393463,819.788452 350.372253,818.710693 
	C352.503693,818.249268 357.126648,820.214233 357.340515,821.587219 
	C358.163666,826.871826 354.285156,827.845032 349.215820,827.047424 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M346.931183,807.987915 
	C347.351990,802.549316 350.085754,801.718201 353.451477,804.309326 
	C354.643646,805.227112 355.329681,809.148621 354.577087,809.815979 
	C352.105103,812.008240 348.818359,813.616760 346.931183,807.987915 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M500.505249,804.591858 
	C506.619293,808.739807 507.923950,813.973511 505.734497,819.757324 
	C503.621521,825.339050 498.746185,827.044617 492.347626,827.261597 
	C492.347626,819.503906 492.347626,812.159424 492.347626,803.639832 
	C494.970795,803.844360 497.347656,804.029663 500.505249,804.591858 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M984.813477,961.652710 
	C982.321167,961.573242 980.670227,961.493835 979.002991,961.413635 
	C980.197083,953.557251 982.829956,950.666504 988.923096,950.393433 
	C994.869507,950.127014 997.733398,952.991150 999.435547,961.652710 
	C994.738953,961.652710 990.196899,961.652710 984.813477,961.652710 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M2034.813477,961.652710 
	C2032.321167,961.573242 2030.670288,961.493835 2029.003052,961.413696 
	C2030.197021,953.557800 2032.830444,950.666443 2038.923218,950.393494 
	C2044.868774,950.127258 2047.733643,952.992371 2049.435547,961.652710 
	C2044.739014,961.652710 2040.196899,961.652710 2034.813477,961.652710 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1901.357178,960.403809 
	C1894.453613,961.167969 1887.830811,961.167969 1881.219482,961.167969 
	C1881.948608,954.136841 1884.186035,951.306519 1889.754883,950.477417 
	C1895.400024,949.637024 1898.653442,952.145447 1901.357178,960.403809 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1071.895752,961.652344 
	C1067.728760,961.652344 1064.418701,961.652344 1061.063232,961.652344 
	C1062.087036,953.728394 1064.765259,950.729370 1070.819458,950.401001 
	C1076.789795,950.077148 1079.592407,952.812378 1081.419800,961.221252 
	C1078.471924,961.367859 1075.612305,961.510132 1071.895752,961.652344 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1400.598389,955.834656 
	C1401.231567,957.784973 1401.490601,959.040222 1401.897827,961.013245 
	C1394.628296,961.013245 1387.842651,961.013245 1380.707153,961.013245 
	C1380.246338,956.232422 1382.738037,953.062195 1387.092163,951.321045 
	C1392.336548,949.223999 1396.866089,950.362671 1400.598389,955.834656 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M1257.030396,810.993652 
	C1256.782959,808.019470 1256.456055,805.003906 1257.805176,803.386658 
	C1258.628540,802.399841 1262.203369,803.133667 1264.206543,803.934692 
	C1265.300537,804.372192 1266.643921,807.118896 1266.215454,807.846313 
	C1265.191162,809.584412 1263.339355,811.035339 1261.507324,812.013489 
	C1260.574219,812.511719 1258.962646,811.739746 1257.030396,810.993652 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M2548.015137,951.750854 
	C2559.109863,949.771606 2560.928223,950.886780 2563.519531,961.033630 
	C2556.601562,961.033630 2549.805176,961.033630 2541.341797,961.033630 
	C2543.601074,957.647156 2545.460693,954.859619 2548.015137,951.750854 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M306.694550,952.514282 
	C318.290405,948.928589 321.461792,950.683350 323.269318,961.224182 
	C316.413971,961.224182 309.622955,961.224182 301.225159,961.224182 
	C303.231171,957.797058 304.647125,955.378052 306.694550,952.514282 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M326.673706,811.818115 
	C327.979919,816.310181 326.819397,818.467651 321.542999,818.174255 
	C322.369293,814.850159 321.663025,811.509521 326.673706,811.818115 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M466.950500,817.846191 
	C467.086456,815.136719 467.868195,812.890320 469.006073,809.620422 
	C472.320740,816.169006 472.320740,816.169006 466.950500,817.846191 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M144.083893,739.756470 
	C146.231216,739.809570 147.579071,739.810669 148.868164,740.086365 
	C152.259384,740.811951 154.300461,742.835876 153.627213,746.444580 
	C152.971176,749.961060 150.315643,751.287720 146.964584,751.088928 
	C145.002579,750.972595 143.064606,750.451172 140.745102,750.047485 
	C139.832855,746.056763 138.261276,742.255920 144.083893,739.756470 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M383.486755,761.649902 
	C382.397552,757.969360 381.741364,754.314087 381.202667,749.737427 
	C382.831696,747.068604 384.145782,745.086670 385.891357,743.617310 
	C391.442261,738.944763 399.274292,738.988892 404.062683,743.504578 
	C409.119659,748.273682 409.891052,756.061401 405.856415,761.613708 
	C401.136505,768.109070 394.631165,769.390747 387.543579,765.059937 
	C386.162079,764.215759 385.118988,762.817810 383.486755,761.649902 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M568.506226,755.498291 
	C568.399536,750.258606 569.509521,746.301086 573.173096,743.314697 
	C579.138062,738.452148 588.018005,738.919983 592.815735,744.437866 
	C597.615234,749.957825 597.397705,757.871216 592.297729,763.285156 
	C587.000122,768.908813 578.505798,769.333984 572.870605,763.783081 
	C570.885864,761.828064 569.960999,758.796997 568.506226,755.498291 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M435.644653,744.062683 
	C432.489288,752.332214 432.446960,752.349182 422.863739,749.833191 
	C422.863739,747.057373 422.863739,744.205994 422.863739,741.037781 
	C427.842102,739.335876 432.138580,738.304932 435.644653,744.062683 
z"
            />
            <path
                fill="#A1A1A0"
                opacity="1.000000"
                stroke="none"
                d="
M818.438904,816.616333 
	C819.539612,814.084473 820.733398,812.322144 822.169006,810.203003 
	C825.205627,817.782776 825.150146,817.874023 818.438904,816.616333 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M354.469238,750.997192 
	C355.068573,757.880066 352.244659,759.262024 345.702484,756.740540 
	C347.917267,753.245911 349.989655,749.976013 353.195099,744.918213 
	C353.936859,748.073181 354.189270,749.146790 354.469238,750.997192 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M278.706268,749.001953 
	C279.678711,748.137695 280.239746,747.853333 280.800781,747.568970 
	C281.045044,750.565735 281.810303,753.667419 281.240356,756.500427 
	C281.050568,757.443726 277.438324,757.698486 273.026184,758.925659 
	C275.565643,754.421997 276.930237,752.001831 278.706268,749.001953 
z"
            />
            <path
                fill="#F1F1F1"
                opacity="1.000000"
                stroke="none"
                d="
M186.836334,740.547363 
	C196.337173,750.233643 196.589493,756.634460 188.243439,765.130737 
	C178.397720,768.791626 171.689911,766.839722 168.371094,760.090576 
	C164.207230,751.622986 168.830612,742.107239 178.189316,740.341125 
	C180.709213,739.865601 183.410843,740.353149 186.836334,740.547363 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M657.127014,746.332153 
	C657.830017,749.534546 657.846985,752.770264 657.807373,756.813354 
	C655.208435,757.620789 652.666138,757.620789 647.769958,757.620789 
	C651.454041,752.838684 653.947449,749.602051 657.127014,746.332153 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M239.116180,751.384155 
	C238.172592,748.192688 237.996933,744.922302 237.934891,740.830444 
	C240.643860,739.930542 243.436508,739.224426 245.776123,739.959717 
	C247.891434,740.624512 251.165558,743.086914 250.993744,744.360901 
	C250.672028,746.746094 248.633804,749.447388 246.532532,750.866272 
	C244.942459,751.939819 242.144531,751.224487 239.116180,751.384155 
z"
            />
            <path
                fill="#E7E7E7"
                opacity="1.000000"
                stroke="none"
                d="
M113.759018,751.459961 
	C112.944763,748.886169 112.878319,746.509094 112.893280,743.421387 
	C115.913376,742.451294 118.919449,741.720093 121.762993,742.126465 
	C123.235825,742.336914 125.545578,744.628235 125.473404,745.862305 
	C125.363747,747.737061 123.902580,750.420044 122.304604,751.107605 
	C120.044945,752.079895 117.137421,751.546509 113.759018,751.459961 
z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
M531.616333,757.696289 
	C531.271179,754.625427 531.364441,752.091370 531.575684,748.802246 
	C535.983459,743.112915 540.727600,739.146606 548.680542,740.498657 
	C551.346313,741.571045 553.264893,742.570068 555.847534,743.802795 
	C556.585266,750.733704 556.658813,757.430786 556.728516,765.040527 
	C555.643616,766.041748 554.562561,766.130432 552.663391,766.301392 
	C543.415955,768.116150 536.242676,766.799011 531.616333,757.696289 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M3884.214111,522.494446 
	C3884.211914,520.441223 3884.583252,518.465332 3883.817627,517.802307 
	C3880.348145,514.798462 3876.557617,512.165222 3871.015381,507.992676 
	C3878.272217,507.992676 3883.555908,507.992676 3888.915283,507.992676 
	C3890.878662,502.422943 3892.506104,497.805878 3894.800537,491.296814 
	C3897.340332,497.447815 3899.243164,502.056213 3901.259766,506.940277 
	C3906.254150,507.221527 3911.098389,507.494324 3917.834229,507.873627 
	C3914.715820,510.641754 3912.993896,512.315186 3911.124756,513.803650 
	C3904.326416,519.216492 3904.312012,519.191711 3907.056396,527.699402 
	C3907.628906,529.475037 3908.156982,531.264954 3909.429932,535.403137 
	C3903.569336,531.589966 3899.647217,529.038086 3895.351074,526.242859 
	C3891.009521,528.912537 3886.705322,531.559265 3880.549561,535.344421 
	C3882.108887,529.945312 3883.086426,526.560791 3884.214111,522.494446 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M3952.635742,581.077515 
	C3949.515137,579.062622 3947.000244,577.583923 3944.539795,576.137085 
	C3940.265381,578.980164 3936.500000,581.484619 3930.723633,585.326599 
	C3932.578125,578.569275 3933.843750,573.957397 3935.210449,568.977600 
	C3931.193359,565.817688 3926.872070,562.418335 3920.872803,557.699097 
	C3927.853760,557.699097 3932.743164,557.699097 3938.387939,557.699097 
	C3940.441650,552.519958 3942.336182,547.742188 3944.821289,541.475525 
	C3947.405273,547.558838 3949.395508,552.244690 3951.441406,557.061340 
	C3956.557129,557.334290 3961.413330,557.593384 3968.666016,557.980347 
	C3964.546631,561.092163 3962.460938,563.100586 3960.007080,564.428711 
	C3955.307373,566.972168 3954.280273,570.368652 3956.243408,575.218933 
	C3957.287842,577.800049 3957.691406,580.640564 3958.795654,584.981079 
	C3955.900879,583.226074 3954.571289,582.419922 3952.635742,581.077515 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3769.676758,761.244751 
	C3770.702881,764.840210 3771.534668,767.622681 3773.122559,772.933777 
	C3767.126709,768.909180 3763.052490,766.174377 3758.418945,763.063965 
	C3754.285156,765.757507 3749.689453,768.752319 3744.125488,772.377869 
	C3745.703613,766.172485 3746.975098,761.173157 3748.298340,755.969788 
	C3744.042725,752.523438 3740.072021,749.307617 3734.353516,744.676514 
	C3741.491699,744.333984 3746.534424,744.092041 3752.190186,743.820679 
	C3753.836670,739.593018 3755.560303,735.168152 3758.021484,728.849487 
	C3760.534912,734.837585 3762.349854,739.161560 3764.345703,743.916809 
	C3769.278320,743.916809 3774.195068,743.916809 3779.433594,743.916809 
	C3779.792236,749.646729 3774.932861,750.322632 3772.158447,752.421082 
	C3769.152588,754.694519 3767.040039,756.623047 3769.676758,761.244751 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3690.909668,694.093262 
	C3695.048828,694.090820 3698.365234,694.090820 3701.976074,694.090820 
	C3703.805176,689.421509 3705.534424,685.007324 3708.020020,678.661804 
	C3710.465576,684.693298 3712.141113,688.826416 3714.070068,693.584229 
	C3719.005615,693.894287 3724.091064,694.213684 3731.508301,694.679626 
	C3726.026367,699.248840 3722.153076,702.477234 3718.228760,705.748352 
	C3719.425781,710.613037 3720.578125,715.297058 3722.334229,722.433838 
	C3716.367676,718.408630 3712.436768,715.756653 3708.417236,713.044861 
	C3704.139160,715.655823 3699.824951,718.288818 3693.482666,722.159485 
	C3695.509277,715.330750 3696.789062,711.019409 3698.299316,705.930847 
	C3694.323486,702.760315 3690.270264,699.527954 3685.280273,695.548523 
	C3687.459473,694.889893 3688.773193,694.492798 3690.909668,694.093262 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M3752.458984,529.722839 
	C3749.659424,531.685913 3747.450439,533.085754 3743.358154,535.679016 
	C3745.350342,528.929932 3746.792969,524.042480 3748.284912,518.988098 
	C3744.089844,515.652222 3740.005859,512.404541 3734.170654,507.764526 
	C3741.333740,507.764526 3746.433105,507.764526 3751.713623,507.764526 
	C3753.787109,502.646240 3755.565674,498.255493 3758.009033,492.224182 
	C3760.595703,498.114777 3762.499756,502.450653 3764.489014,506.980103 
	C3769.576416,507.265717 3774.426514,507.538025 3781.978516,507.962006 
	C3776.159180,512.490295 3772.210938,515.562683 3767.750000,519.033752 
	C3769.137695,523.934509 3770.532959,528.862549 3772.479736,535.738647 
	C3766.904053,531.883728 3762.974609,529.166992 3758.536865,526.098816 
	C3756.977539,526.968567 3755.013672,528.064087 3752.458984,529.722839 
z"
            />
            <path
                fill="#111111"
                opacity="1.000000"
                stroke="none"
                d="
M3697.222412,573.200439 
	C3698.589600,569.937134 3697.798096,568.172241 3695.554688,566.628967 
	C3692.311523,564.397766 3689.238525,561.919617 3684.191162,558.112610 
	C3691.182861,557.705750 3696.147461,557.416870 3702.050781,557.073303 
	C3703.634521,553.006836 3705.369629,548.551331 3707.902344,542.047546 
	C3710.458252,547.987671 3712.307617,552.286255 3714.492188,557.363525 
	C3719.230225,557.363525 3724.075195,557.363525 3728.920166,557.363525 
	C3729.241211,558.019958 3729.562256,558.676453 3729.883301,559.332886 
	C3726.077637,562.434998 3722.271973,565.537109 3718.097168,568.939880 
	C3719.266846,573.765930 3720.479980,578.772644 3722.064209,585.309631 
	C3716.849121,581.895020 3712.851562,579.277649 3708.247314,576.263000 
	C3704.035156,578.918884 3699.616699,581.704956 3694.098877,585.184021 
	C3695.240234,580.733704 3696.111328,577.337585 3697.222412,573.200439 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M3970.708496,626.185425 
	C3975.777100,626.319702 3980.017090,626.319702 3986.479736,626.319702 
	C3981.063965,630.760132 3977.191650,633.935242 3973.041992,637.337585 
	C3974.438721,642.145569 3975.761230,646.697998 3977.083740,651.250427 
	C3976.624268,651.719788 3976.164551,652.189209 3975.705078,652.658569 
	C3971.530762,649.918091 3967.356445,647.177551 3963.020996,644.331421 
	C3958.908447,647.093506 3954.721191,649.905701 3950.534180,652.717896 
	C3950.061035,652.278809 3949.587891,651.839783 3949.114746,651.400757 
	C3950.359131,647.122559 3951.603516,642.844360 3953.139160,637.565002 
	C3949.531738,634.581665 3945.569824,631.304993 3940.161621,626.832092 
	C3946.527588,626.543762 3951.509521,626.318054 3957.043457,626.067383 
	C3958.669678,621.232056 3960.305664,616.368286 3962.508789,609.817383 
	C3965.370850,616.120544 3967.625244,621.085815 3970.708496,626.185425 
z"
            />
            <path
                fill="#1A1A1A"
                opacity="1.000000"
                stroke="none"
                d="
M3702.106445,645.483704 
	C3702.641846,647.476929 3703.128174,648.716187 3703.316406,649.999207 
	C3703.394043,650.530273 3702.832764,651.154907 3702.102295,652.725281 
	C3698.047607,649.950623 3694.112061,647.257385 3689.894287,644.370972 
	C3685.639648,647.153503 3681.552490,649.826599 3675.598633,653.720398 
	C3677.227783,647.072815 3678.415039,642.229065 3679.651367,637.184143 
	C3675.985107,634.214844 3672.307129,631.236023 3668.628906,628.257141 
	C3668.885986,627.709229 3669.142822,627.161377 3669.399658,626.613464 
	C3673.845947,626.613464 3678.292236,626.613464 3683.316650,626.613464 
	C3685.293701,621.284363 3687.106689,616.396973 3689.601562,609.671753 
	C3691.938477,615.700317 3693.741943,620.352783 3695.885498,625.882019 
	C3700.522217,626.141235 3705.567383,626.423279 3712.646240,626.819031 
	C3707.474121,631.094727 3703.810303,634.123657 3699.755371,637.475769 
	C3700.450195,639.791382 3701.193604,642.269348 3702.106445,645.483704 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3934.693359,719.690186 
	C3933.232910,719.027161 3931.689697,717.769470 3931.889404,716.922424 
	C3932.713135,713.427246 3934.064941,710.056458 3935.389893,706.145508 
	C3931.227295,702.829041 3927.015137,699.473206 3921.077393,694.742493 
	C3928.222412,694.298767 3933.262695,693.985779 3938.869873,693.637573 
	C3940.512695,689.131165 3942.166260,684.595520 3943.819824,680.059875 
	C3944.416504,679.981506 3945.013428,679.903198 3945.610107,679.824890 
	C3947.242676,684.187805 3948.875000,688.550781 3950.802734,693.702881 
	C3955.438721,693.918823 3960.576172,694.158081 3967.307373,694.471558 
	C3965.233154,696.805481 3964.271484,698.243835 3962.984619,699.277283 
	C3954.611084,706.002197 3954.605225,705.968262 3957.771240,716.128662 
	C3958.144287,717.326111 3958.193848,718.624512 3958.649658,721.488098 
	C3955.784912,719.792114 3953.986084,718.884338 3952.357178,717.735596 
	C3945.107666,712.622986 3945.128662,712.603088 3937.930908,717.710144 
	C3937.124756,718.282104 3936.253174,718.761780 3934.693359,719.690186 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3908.209229,769.874756 
	C3905.715820,769.053711 3902.484131,768.946472 3900.868896,767.276184 
	C3896.281250,762.531738 3892.496094,763.136963 3888.237305,767.460327 
	C3886.697998,769.023315 3884.576172,770.012634 3882.150879,771.647034 
	C3880.445068,766.073608 3884.302734,762.005981 3884.796143,756.225708 
	C3881.234863,753.220337 3877.061279,749.697998 3872.351074,745.722900 
	C3877.641602,742.154663 3883.664307,745.797729 3888.966797,743.034119 
	C3890.607178,738.892334 3892.374756,734.429199 3894.915039,728.015747 
	C3897.150879,734.409790 3898.719238,738.895447 3900.397705,743.695190 
	C3905.624268,743.988525 3910.724365,744.274719 3917.963379,744.680969 
	C3914.482422,747.869019 3912.751953,750.199951 3910.436523,751.426331 
	C3904.827148,754.397522 3904.070557,758.420959 3906.644287,763.751099 
	C3907.353027,765.218750 3907.713623,766.854553 3908.154297,769.181763 
	C3908.074707,769.950256 3908.209229,769.874756 3908.209229,769.874756 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3835.941895,787.880981 
	C3832.686523,785.516174 3830.057373,783.545349 3826.878906,781.162415 
	C3822.276123,784.117615 3817.734863,787.033386 3811.954102,790.744995 
	C3813.794678,784.364197 3815.219482,779.424927 3816.708984,774.260925 
	C3812.925049,771.191711 3809.464355,768.384583 3804.376221,764.257568 
	C3810.675537,763.811096 3815.037842,763.501892 3820.017090,763.148987 
	C3821.818848,758.342957 3823.708008,753.303711 3826.375000,746.190125 
	C3828.998291,752.979736 3830.804199,757.654053 3832.888428,763.048157 
	C3837.576660,763.305969 3842.402832,763.571411 3848.884033,763.927795 
	C3844.195801,767.800171 3840.635742,770.740845 3836.639648,774.041565 
	C3837.723877,778.907043 3838.842041,783.925964 3840.043213,789.317810 
	C3838.439941,788.836609 3837.504150,788.555786 3835.941895,787.880981 
z"
            />
            <path
                fill="#141414"
                opacity="1.000000"
                stroke="none"
                d="
M3839.062744,510.650757 
	C3839.560547,512.589661 3839.818115,513.803467 3840.589600,517.437195 
	C3835.053711,513.470886 3831.248535,510.744476 3826.854004,507.595947 
	C3822.532959,510.314789 3817.974365,513.183105 3811.860352,517.030029 
	C3813.766602,510.638824 3815.148926,506.005280 3816.691406,500.833405 
	C3812.849365,497.652496 3809.124756,494.568817 3804.014648,490.338074 
	C3810.328369,489.962799 3815.063965,489.681305 3820.339600,489.367737 
	C3822.244385,484.327515 3824.161865,479.253784 3826.616211,472.758911 
	C3829.086426,479.275452 3830.930908,484.141602 3832.871094,489.260345 
	C3837.888916,489.574005 3842.654297,489.871887 3849.313965,490.288147 
	C3844.118164,494.428314 3840.360840,497.422241 3836.155518,500.773224 
	C3837.005615,503.689911 3837.914062,506.807739 3839.062744,510.650757 
z"
            />
            <path
                fill="#171717"
                opacity="1.000000"
                stroke="none"
                d="
M3908.013184,769.996582 
	C3908.366943,770.416565 3908.782471,770.790161 3909.197998,771.163818 
	C3908.651367,770.992493 3908.104980,770.821167 3907.883789,770.262329 
	C3908.209229,769.874756 3908.074707,769.950256 3908.013184,769.996582 
z"
            />
        </svg>
    );
}
